webpackJsonp([216468464745311],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isPlaceholder = __webpack_require__(55);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(55);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _curry2 = __webpack_require__(1);
	var _isPlaceholder = __webpack_require__(55);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GraphQLError = __webpack_require__(43);
	
	Object.defineProperty(exports, 'GraphQLError', {
	  enumerable: true,
	  get: function get() {
	    return _GraphQLError.GraphQLError;
	  }
	});
	
	var _syntaxError = __webpack_require__(457);
	
	Object.defineProperty(exports, 'syntaxError', {
	  enumerable: true,
	  get: function get() {
	    return _syntaxError.syntaxError;
	  }
	});
	
	var _locatedError = __webpack_require__(185);
	
	Object.defineProperty(exports, 'locatedError', {
	  enumerable: true,
	  get: function get() {
	    return _locatedError.locatedError;
	  }
	});
	
	var _formatError = __webpack_require__(456);
	
	Object.defineProperty(exports, 'formatError', {
	  enumerable: true,
	  get: function get() {
	    return _formatError.formatError;
	  }
	});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLNonNull = exports.GraphQLList = exports.GraphQLInputObjectType = exports.GraphQLEnumType = exports.GraphQLUnionType = exports.GraphQLInterfaceType = exports.GraphQLObjectType = exports.GraphQLScalarType = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isType = isType;
	exports.assertType = assertType;
	exports.isInputType = isInputType;
	exports.assertInputType = assertInputType;
	exports.isOutputType = isOutputType;
	exports.assertOutputType = assertOutputType;
	exports.isLeafType = isLeafType;
	exports.assertLeafType = assertLeafType;
	exports.isCompositeType = isCompositeType;
	exports.assertCompositeType = assertCompositeType;
	exports.isAbstractType = isAbstractType;
	exports.assertAbstractType = assertAbstractType;
	exports.getNullableType = getNullableType;
	exports.isNamedType = isNamedType;
	exports.assertNamedType = assertNamedType;
	exports.getNamedType = getNamedType;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _assertValidName = __webpack_require__(107);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	// Predicates & Assertions
	
	/**
	 * These are all of the possible kinds of types.
	 */
	function isType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType || type instanceof GraphQLEnumType || type instanceof GraphQLInputObjectType || type instanceof GraphQLList || type instanceof GraphQLNonNull;
	}
	
	function assertType(type) {
	  !isType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL type.') : void 0;
	  return type;
	}
	
	/**
	 * These types may be used as input types for arguments and directives.
	 */
	function isInputType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLEnumType || type instanceof GraphQLInputObjectType || type instanceof GraphQLNonNull && isInputType(type.ofType) || type instanceof GraphQLList && isInputType(type.ofType);
	}
	
	function assertInputType(type) {
	  !isInputType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL input type.') : void 0;
	  return type;
	}
	
	/**
	 * These types may be used as output types as the result of fields.
	 */
	function isOutputType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType || type instanceof GraphQLEnumType || type instanceof GraphQLNonNull && isOutputType(type.ofType) || type instanceof GraphQLList && isOutputType(type.ofType);
	}
	
	function assertOutputType(type) {
	  !isOutputType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL output type.') : void 0;
	  return type;
	}
	
	/**
	 * These types may describe types which may be leaf values.
	 */
	function isLeafType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLEnumType;
	}
	
	function assertLeafType(type) {
	  !isLeafType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL leaf type.') : void 0;
	  return type;
	}
	
	/**
	 * These types may describe the parent context of a selection set.
	 */
	function isCompositeType(type) {
	  return type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType;
	}
	
	function assertCompositeType(type) {
	  !isCompositeType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL composite type.') : void 0;
	  return type;
	}
	
	/**
	 * These types may describe the parent context of a selection set.
	 */
	function isAbstractType(type) {
	  return type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType;
	}
	
	function assertAbstractType(type) {
	  !isAbstractType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL abstract type.') : void 0;
	  return type;
	}
	
	/**
	 * These types can all accept null as a value.
	 */
	function getNullableType(type) {
	  return type instanceof GraphQLNonNull ? type.ofType : type;
	}
	
	/**
	 * These named types do not include modifiers like List or NonNull.
	 */
	function isNamedType(type) {
	  return type instanceof GraphQLScalarType || type instanceof GraphQLObjectType || type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType || type instanceof GraphQLEnumType || type instanceof GraphQLInputObjectType;
	}
	
	function assertNamedType(type) {
	  !isNamedType(type) ? (0, _invariant2.default)(0, 'Expected ' + String(type) + ' to be a GraphQL named type.') : void 0;
	  return type;
	}
	
	/* eslint-disable no-redeclare */
	function getNamedType(type) {
	  /* eslint-enable no-redeclare */
	  if (type) {
	    var unmodifiedType = type;
	    while (unmodifiedType instanceof GraphQLList || unmodifiedType instanceof GraphQLNonNull) {
	      unmodifiedType = unmodifiedType.ofType;
	    }
	    return unmodifiedType;
	  }
	}
	
	/**
	 * Used while defining GraphQL types to allow for circular references in
	 * otherwise immutable type definitions.
	 */
	
	
	function resolveThunk(thunk) {
	  return typeof thunk === 'function' ? thunk() : thunk;
	}
	
	/**
	 * Scalar Type Definition
	 *
	 * The leaf values of any request and input values to arguments are
	 * Scalars (or Enums) and are defined with a name and a series of functions
	 * used to parse input from ast or variables and to ensure validity.
	 *
	 * Example:
	 *
	 *     const OddType = new GraphQLScalarType({
	 *       name: 'Odd',
	 *       serialize(value) {
	 *         return value % 2 === 1 ? value : null;
	 *       }
	 *     });
	 *
	 */
	
	var GraphQLScalarType = exports.GraphQLScalarType = function () {
	  function GraphQLScalarType(config) {
	    _classCallCheck(this, GraphQLScalarType);
	
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    !(typeof config.serialize === 'function') ? (0, _invariant2.default)(0, this.name + ' must provide "serialize" function. If this custom Scalar ' + 'is also used as an input type, ensure "parseValue" and "parseLiteral" ' + 'functions are also provided.') : void 0;
	    if (config.parseValue || config.parseLiteral) {
	      !(typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function') ? (0, _invariant2.default)(0, this.name + ' must provide both "parseValue" and "parseLiteral" ' + 'functions.') : void 0;
	    }
	    this._scalarConfig = config;
	  }
	
	  // Serializes an internal value to include in a response.
	
	
	  GraphQLScalarType.prototype.serialize = function serialize(value) {
	    var serializer = this._scalarConfig.serialize;
	    return serializer(value);
	  };
	
	  // Determines if an internal value is valid for this type.
	  // Equivalent to checking for if the parsedValue is nullish.
	
	
	  GraphQLScalarType.prototype.isValidValue = function isValidValue(value) {
	    return !(0, _isNullish2.default)(this.parseValue(value));
	  };
	
	  // Parses an externally provided value to use as an input.
	
	
	  GraphQLScalarType.prototype.parseValue = function parseValue(value) {
	    var parser = this._scalarConfig.parseValue;
	    return parser && !(0, _isNullish2.default)(value) ? parser(value) : undefined;
	  };
	
	  // Determines if an internal value is valid for this type.
	  // Equivalent to checking for if the parsedLiteral is nullish.
	
	
	  GraphQLScalarType.prototype.isValidLiteral = function isValidLiteral(valueNode) {
	    return !(0, _isNullish2.default)(this.parseLiteral(valueNode));
	  };
	
	  // Parses an externally provided literal value to use as an input.
	
	
	  GraphQLScalarType.prototype.parseLiteral = function parseLiteral(valueNode) {
	    var parser = this._scalarConfig.parseLiteral;
	    return parser ? parser(valueNode) : undefined;
	  };
	
	  GraphQLScalarType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLScalarType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLScalarType.prototype.toJSON = GraphQLScalarType.prototype.inspect = GraphQLScalarType.prototype.toString;
	
	/**
	 * Object Type Definition
	 *
	 * Almost all of the GraphQL types you define will be object types. Object types
	 * have a name, but most importantly describe their fields.
	 *
	 * Example:
	 *
	 *     const AddressType = new GraphQLObjectType({
	 *       name: 'Address',
	 *       fields: {
	 *         street: { type: GraphQLString },
	 *         number: { type: GraphQLInt },
	 *         formatted: {
	 *           type: GraphQLString,
	 *           resolve(obj) {
	 *             return obj.number + ' ' + obj.street
	 *           }
	 *         }
	 *       }
	 *     });
	 *
	 * When two types need to refer to each other, or a type needs to refer to
	 * itself in a field, you can use a function expression (aka a closure or a
	 * thunk) to supply the fields lazily.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         name: { type: GraphQLString },
	 *         bestFriend: { type: PersonType },
	 *       })
	 *     });
	 *
	 */
	var GraphQLObjectType = exports.GraphQLObjectType = function () {
	  function GraphQLObjectType(config) {
	    _classCallCheck(this, GraphQLObjectType);
	
	    (0, _assertValidName.assertValidName)(config.name, config.isIntrospection);
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this.extensionASTNodes = config.extensionASTNodes || [];
	    if (config.isTypeOf) {
	      !(typeof config.isTypeOf === 'function') ? (0, _invariant2.default)(0, this.name + ' must provide "isTypeOf" as a function.') : void 0;
	    }
	    this.isTypeOf = config.isTypeOf;
	    this._typeConfig = config;
	  }
	
	  GraphQLObjectType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
	  };
	
	  GraphQLObjectType.prototype.getInterfaces = function getInterfaces() {
	    return this._interfaces || (this._interfaces = defineInterfaces(this, this._typeConfig.interfaces));
	  };
	
	  GraphQLObjectType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLObjectType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLObjectType.prototype.toJSON = GraphQLObjectType.prototype.inspect = GraphQLObjectType.prototype.toString;
	
	function defineInterfaces(type, interfacesThunk) {
	  var interfaces = resolveThunk(interfacesThunk);
	  if (!interfaces) {
	    return [];
	  }
	  !Array.isArray(interfaces) ? (0, _invariant2.default)(0, type.name + ' interfaces must be an Array or a function which returns ' + 'an Array.') : void 0;
	
	  var implementedTypeNames = Object.create(null);
	  interfaces.forEach(function (iface) {
	    !(iface instanceof GraphQLInterfaceType) ? (0, _invariant2.default)(0, type.name + ' may only implement Interface types, it cannot ' + ('implement: ' + String(iface) + '.')) : void 0;
	    !!implementedTypeNames[iface.name] ? (0, _invariant2.default)(0, type.name + ' may declare it implements ' + iface.name + ' only once.') : void 0;
	    implementedTypeNames[iface.name] = true;
	    if (typeof iface.resolveType !== 'function') {
	      !(typeof type.isTypeOf === 'function') ? (0, _invariant2.default)(0, 'Interface Type ' + iface.name + ' does not provide a "resolveType" ' + ('function and implementing Type ' + type.name + ' does not provide a ') + '"isTypeOf" function. There is no way to resolve this implementing ' + 'type during execution.') : void 0;
	    }
	  });
	  return interfaces;
	}
	
	function defineFieldMap(type, fieldsThunk) {
	  var fieldMap = resolveThunk(fieldsThunk);
	  !isPlainObj(fieldMap) ? (0, _invariant2.default)(0, type.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;
	
	  var fieldNames = Object.keys(fieldMap);
	  !(fieldNames.length > 0) ? (0, _invariant2.default)(0, type.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;
	
	  var resultFieldMap = Object.create(null);
	  fieldNames.forEach(function (fieldName) {
	    (0, _assertValidName.assertValidName)(fieldName);
	    var fieldConfig = fieldMap[fieldName];
	    !isPlainObj(fieldConfig) ? (0, _invariant2.default)(0, type.name + '.' + fieldName + ' field config must be an object') : void 0;
	    !!fieldConfig.hasOwnProperty('isDeprecated') ? (0, _invariant2.default)(0, type.name + '.' + fieldName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".') : void 0;
	    var field = _extends({}, fieldConfig, {
	      isDeprecated: Boolean(fieldConfig.deprecationReason),
	      name: fieldName
	    });
	    !isOutputType(field.type) ? (0, _invariant2.default)(0, type.name + '.' + fieldName + ' field type must be Output Type but ' + ('got: ' + String(field.type) + '.')) : void 0;
	    !isValidResolver(field.resolve) ? (0, _invariant2.default)(0, type.name + '.' + fieldName + ' field resolver must be a function if ' + ('provided, but got: ' + String(field.resolve) + '.')) : void 0;
	    var argsConfig = fieldConfig.args;
	    if (!argsConfig) {
	      field.args = [];
	    } else {
	      !isPlainObj(argsConfig) ? (0, _invariant2.default)(0, type.name + '.' + fieldName + ' args must be an object with argument ' + 'names as keys.') : void 0;
	      field.args = Object.keys(argsConfig).map(function (argName) {
	        (0, _assertValidName.assertValidName)(argName);
	        var arg = argsConfig[argName];
	        !isInputType(arg.type) ? (0, _invariant2.default)(0, type.name + '.' + fieldName + '(' + argName + ':) argument type must be ' + ('Input Type but got: ' + String(arg.type) + '.')) : void 0;
	        return {
	          name: argName,
	          description: arg.description === undefined ? null : arg.description,
	          type: arg.type,
	          defaultValue: arg.defaultValue,
	          astNode: arg.astNode
	        };
	      });
	    }
	    resultFieldMap[fieldName] = field;
	  });
	  return resultFieldMap;
	}
	
	function isPlainObj(obj) {
	  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
	}
	
	// If a resolver is defined, it must be a function.
	function isValidResolver(resolver) {
	  return resolver == null || typeof resolver === 'function';
	}
	
	/**
	 * Interface Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Interface type
	 * is used to describe what types are possible, what fields are in common across
	 * all types, as well as a function to determine which type is actually used
	 * when the field is resolved.
	 *
	 * Example:
	 *
	 *     const EntityType = new GraphQLInterfaceType({
	 *       name: 'Entity',
	 *       fields: {
	 *         name: { type: GraphQLString }
	 *       }
	 *     });
	 *
	 */
	var GraphQLInterfaceType = exports.GraphQLInterfaceType = function () {
	  function GraphQLInterfaceType(config) {
	    _classCallCheck(this, GraphQLInterfaceType);
	
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    if (config.resolveType) {
	      !(typeof config.resolveType === 'function') ? (0, _invariant2.default)(0, this.name + ' must provide "resolveType" as a function.') : void 0;
	    }
	    this.resolveType = config.resolveType;
	    this._typeConfig = config;
	  }
	
	  GraphQLInterfaceType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
	  };
	
	  GraphQLInterfaceType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInterfaceType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLInterfaceType.prototype.toJSON = GraphQLInterfaceType.prototype.inspect = GraphQLInterfaceType.prototype.toString;
	
	/**
	 * Union Type Definition
	 *
	 * When a field can return one of a heterogeneous set of types, a Union type
	 * is used to describe what types are possible as well as providing a function
	 * to determine which type is actually used when the field is resolved.
	 *
	 * Example:
	 *
	 *     const PetType = new GraphQLUnionType({
	 *       name: 'Pet',
	 *       types: [ DogType, CatType ],
	 *       resolveType(value) {
	 *         if (value instanceof Dog) {
	 *           return DogType;
	 *         }
	 *         if (value instanceof Cat) {
	 *           return CatType;
	 *         }
	 *       }
	 *     });
	 *
	 */
	var GraphQLUnionType = exports.GraphQLUnionType = function () {
	  function GraphQLUnionType(config) {
	    _classCallCheck(this, GraphQLUnionType);
	
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    if (config.resolveType) {
	      !(typeof config.resolveType === 'function') ? (0, _invariant2.default)(0, this.name + ' must provide "resolveType" as a function.') : void 0;
	    }
	    this.resolveType = config.resolveType;
	    this._typeConfig = config;
	  }
	
	  GraphQLUnionType.prototype.getTypes = function getTypes() {
	    return this._types || (this._types = defineTypes(this, this._typeConfig.types));
	  };
	
	  GraphQLUnionType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLUnionType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLUnionType.prototype.toJSON = GraphQLUnionType.prototype.inspect = GraphQLUnionType.prototype.toString;
	
	function defineTypes(unionType, typesThunk) {
	  var types = resolveThunk(typesThunk);
	
	  !(Array.isArray(types) && types.length > 0) ? (0, _invariant2.default)(0, 'Must provide Array of types or a function which returns ' + ('such an array for Union ' + unionType.name + '.')) : void 0;
	  var includedTypeNames = Object.create(null);
	  types.forEach(function (objType) {
	    !(objType instanceof GraphQLObjectType) ? (0, _invariant2.default)(0, unionType.name + ' may only contain Object types, it cannot contain: ' + (String(objType) + '.')) : void 0;
	    !!includedTypeNames[objType.name] ? (0, _invariant2.default)(0, unionType.name + ' can include ' + objType.name + ' type only once.') : void 0;
	    includedTypeNames[objType.name] = true;
	    if (typeof unionType.resolveType !== 'function') {
	      !(typeof objType.isTypeOf === 'function') ? (0, _invariant2.default)(0, 'Union type "' + unionType.name + '" does not provide a "resolveType" ' + ('function and possible type "' + objType.name + '" does not provide an ') + '"isTypeOf" function. There is no way to resolve this possible type ' + 'during execution.') : void 0;
	    }
	  });
	
	  return types;
	}
	
	/**
	 * Enum Type Definition
	 *
	 * Some leaf values of requests and input values are Enums. GraphQL serializes
	 * Enum values as strings, however internally Enums can be represented by any
	 * kind of type, often integers.
	 *
	 * Example:
	 *
	 *     const RGBType = new GraphQLEnumType({
	 *       name: 'RGB',
	 *       values: {
	 *         RED: { value: 0 },
	 *         GREEN: { value: 1 },
	 *         BLUE: { value: 2 }
	 *       }
	 *     });
	 *
	 * Note: If a value is not provided in a definition, the name of the enum value
	 * will be used as its internal value.
	 */
	var GraphQLEnumType /* <T> */ = exports.GraphQLEnumType = function () {
	  function GraphQLEnumType(config /* <T> */) {
	    _classCallCheck(this, GraphQLEnumType);
	
	    this.name = config.name;
	    (0, _assertValidName.assertValidName)(config.name, config.isIntrospection);
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this._values = defineEnumValues(this, config.values);
	    this._enumConfig = config;
	  }
	
	  GraphQLEnumType.prototype.getValues = function getValues() {
	    return this._values;
	  };
	
	  GraphQLEnumType.prototype.getValue = function getValue(name) {
	    return this._getNameLookup()[name];
	  };
	
	  GraphQLEnumType.prototype.serialize = function serialize(value /* T */) {
	    var enumValue = this._getValueLookup().get(value);
	    return enumValue ? enumValue.name : null;
	  };
	
	  GraphQLEnumType.prototype.isValidValue = function isValidValue(value) {
	    return typeof value === 'string' && this._getNameLookup()[value] !== undefined;
	  };
	
	  GraphQLEnumType.prototype.parseValue = function parseValue(value) /* T */{
	    if (typeof value === 'string') {
	      var enumValue = this._getNameLookup()[value];
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  GraphQLEnumType.prototype.isValidLiteral = function isValidLiteral(valueNode) {
	    return valueNode.kind === Kind.ENUM && this._getNameLookup()[valueNode.value] !== undefined;
	  };
	
	  GraphQLEnumType.prototype.parseLiteral = function parseLiteral(valueNode) /* T */{
	    if (valueNode.kind === Kind.ENUM) {
	      var enumValue = this._getNameLookup()[valueNode.value];
	      if (enumValue) {
	        return enumValue.value;
	      }
	    }
	  };
	
	  GraphQLEnumType.prototype._getValueLookup = function _getValueLookup() {
	    if (!this._valueLookup) {
	      var lookup = new Map();
	      this.getValues().forEach(function (value) {
	        lookup.set(value.value, value);
	      });
	      this._valueLookup = lookup;
	    }
	    return this._valueLookup;
	  };
	
	  GraphQLEnumType.prototype._getNameLookup = function _getNameLookup() {
	    if (!this._nameLookup) {
	      var lookup = Object.create(null);
	      this.getValues().forEach(function (value) {
	        lookup[value.name] = value;
	      });
	      this._nameLookup = lookup;
	    }
	    return this._nameLookup;
	  };
	
	  GraphQLEnumType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLEnumType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLEnumType.prototype.toJSON = GraphQLEnumType.prototype.inspect = GraphQLEnumType.prototype.toString;
	
	function defineEnumValues(type, valueMap /* <T> */
	) {
	  !isPlainObj(valueMap) ? (0, _invariant2.default)(0, type.name + ' values must be an object with value names as keys.') : void 0;
	  var valueNames = Object.keys(valueMap);
	  !(valueNames.length > 0) ? (0, _invariant2.default)(0, type.name + ' values must be an object with value names as keys.') : void 0;
	  return valueNames.map(function (valueName) {
	    (0, _assertValidName.assertValidName)(valueName);
	    !(['true', 'false', 'null'].indexOf(valueName) === -1) ? (0, _invariant2.default)(0, 'Name "' + valueName + '" can not be used as an Enum value.') : void 0;
	
	    var value = valueMap[valueName];
	    !isPlainObj(value) ? (0, _invariant2.default)(0, type.name + '.' + valueName + ' must refer to an object with a "value" key ' + ('representing an internal value but got: ' + String(value) + '.')) : void 0;
	    !!value.hasOwnProperty('isDeprecated') ? (0, _invariant2.default)(0, type.name + '.' + valueName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".') : void 0;
	    return {
	      name: valueName,
	      description: value.description,
	      isDeprecated: Boolean(value.deprecationReason),
	      deprecationReason: value.deprecationReason,
	      astNode: value.astNode,
	      value: value.hasOwnProperty('value') ? value.value : valueName
	    };
	  });
	} /* <T> */
	
	
	/**
	 * Input Object Type Definition
	 *
	 * An input object defines a structured collection of fields which may be
	 * supplied to a field argument.
	 *
	 * Using `NonNull` will ensure that a value must be provided by the query
	 *
	 * Example:
	 *
	 *     const GeoPoint = new GraphQLInputObjectType({
	 *       name: 'GeoPoint',
	 *       fields: {
	 *         lat: { type: new GraphQLNonNull(GraphQLFloat) },
	 *         lon: { type: new GraphQLNonNull(GraphQLFloat) },
	 *         alt: { type: GraphQLFloat, defaultValue: 0 },
	 *       }
	 *     });
	 *
	 */
	var GraphQLInputObjectType = exports.GraphQLInputObjectType = function () {
	  function GraphQLInputObjectType(config) {
	    _classCallCheck(this, GraphQLInputObjectType);
	
	    (0, _assertValidName.assertValidName)(config.name);
	    this.name = config.name;
	    this.description = config.description;
	    this.astNode = config.astNode;
	    this._typeConfig = config;
	  }
	
	  GraphQLInputObjectType.prototype.getFields = function getFields() {
	    return this._fields || (this._fields = this._defineFieldMap());
	  };
	
	  GraphQLInputObjectType.prototype._defineFieldMap = function _defineFieldMap() {
	    var _this = this;
	
	    var fieldMap = resolveThunk(this._typeConfig.fields);
	    !isPlainObj(fieldMap) ? (0, _invariant2.default)(0, this.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;
	    var fieldNames = Object.keys(fieldMap);
	    !(fieldNames.length > 0) ? (0, _invariant2.default)(0, this.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;
	    var resultFieldMap = Object.create(null);
	    fieldNames.forEach(function (fieldName) {
	      (0, _assertValidName.assertValidName)(fieldName);
	      var field = _extends({}, fieldMap[fieldName], {
	        name: fieldName
	      });
	      !isInputType(field.type) ? (0, _invariant2.default)(0, _this.name + '.' + fieldName + ' field type must be Input Type but ' + ('got: ' + String(field.type) + '.')) : void 0;
	      !(field.resolve == null) ? (0, _invariant2.default)(0, _this.name + '.' + fieldName + ' field type has a resolve property, but ' + 'Input Types cannot define resolvers.') : void 0;
	      resultFieldMap[fieldName] = field;
	    });
	    return resultFieldMap;
	  };
	
	  GraphQLInputObjectType.prototype.toString = function toString() {
	    return this.name;
	  };
	
	  return GraphQLInputObjectType;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLInputObjectType.prototype.toJSON = GraphQLInputObjectType.prototype.inspect = GraphQLInputObjectType.prototype.toString;
	
	/**
	 * List Modifier
	 *
	 * A list is a kind of type marker, a wrapping type which points to another
	 * type. Lists are often created within the context of defining the fields of
	 * an object type.
	 *
	 * Example:
	 *
	 *     const PersonType = new GraphQLObjectType({
	 *       name: 'Person',
	 *       fields: () => ({
	 *         parents: { type: new GraphQLList(Person) },
	 *         children: { type: new GraphQLList(Person) },
	 *       })
	 *     })
	 *
	 */
	var GraphQLList = exports.GraphQLList = function () {
	  function GraphQLList(type) {
	    _classCallCheck(this, GraphQLList);
	
	    !isType(type) ? (0, _invariant2.default)(0, 'Can only create List of a GraphQLType but got: ' + String(type) + '.') : void 0;
	    this.ofType = type;
	  }
	
	  GraphQLList.prototype.toString = function toString() {
	    return '[' + String(this.ofType) + ']';
	  };
	
	  return GraphQLList;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLList.prototype.toJSON = GraphQLList.prototype.inspect = GraphQLList.prototype.toString;
	
	/**
	 * Non-Null Modifier
	 *
	 * A non-null is a kind of type marker, a wrapping type which points to another
	 * type. Non-null types enforce that their values are never null and can ensure
	 * an error is raised if this ever occurs during a request. It is useful for
	 * fields which you can make a strong guarantee on non-nullability, for example
	 * usually the id field of a database row will never be null.
	 *
	 * Example:
	 *
	 *     const RowType = new GraphQLObjectType({
	 *       name: 'Row',
	 *       fields: () => ({
	 *         id: { type: new GraphQLNonNull(GraphQLString) },
	 *       })
	 *     })
	 *
	 * Note: the enforcement of non-nullability occurs within the executor.
	 */
	
	var GraphQLNonNull = exports.GraphQLNonNull = function () {
	  function GraphQLNonNull(type) {
	    _classCallCheck(this, GraphQLNonNull);
	
	    !(isType(type) && !(type instanceof GraphQLNonNull)) ? (0, _invariant2.default)(0, 'Can only create NonNull of a Nullable GraphQLType but got: ' + (String(type) + '.')) : void 0;
	    this.ofType = type;
	  }
	
	  GraphQLNonNull.prototype.toString = function toString() {
	    return this.ofType.toString() + '!';
	  };
	
	  return GraphQLNonNull;
	}();
	
	// Also provide toJSON and inspect aliases for toString.
	
	
	GraphQLNonNull.prototype.toJSON = GraphQLNonNull.prototype.inspect = GraphQLNonNull.prototype.toString;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(21);
	var _isTransformer = __webpack_require__(82);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry1 = __webpack_require__(2);
	var _curry2 = __webpack_require__(1);
	var _curryN = __webpack_require__(52);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invariant;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	// Name
	
	var NAME = exports.NAME = 'Name';
	
	// Document
	
	var DOCUMENT = exports.DOCUMENT = 'Document';
	var OPERATION_DEFINITION = exports.OPERATION_DEFINITION = 'OperationDefinition';
	var VARIABLE_DEFINITION = exports.VARIABLE_DEFINITION = 'VariableDefinition';
	var VARIABLE = exports.VARIABLE = 'Variable';
	var SELECTION_SET = exports.SELECTION_SET = 'SelectionSet';
	var FIELD = exports.FIELD = 'Field';
	var ARGUMENT = exports.ARGUMENT = 'Argument';
	
	// Fragments
	
	var FRAGMENT_SPREAD = exports.FRAGMENT_SPREAD = 'FragmentSpread';
	var INLINE_FRAGMENT = exports.INLINE_FRAGMENT = 'InlineFragment';
	var FRAGMENT_DEFINITION = exports.FRAGMENT_DEFINITION = 'FragmentDefinition';
	
	// Values
	
	var INT = exports.INT = 'IntValue';
	var FLOAT = exports.FLOAT = 'FloatValue';
	var STRING = exports.STRING = 'StringValue';
	var BOOLEAN = exports.BOOLEAN = 'BooleanValue';
	var NULL = exports.NULL = 'NullValue';
	var ENUM = exports.ENUM = 'EnumValue';
	var LIST = exports.LIST = 'ListValue';
	var OBJECT = exports.OBJECT = 'ObjectValue';
	var OBJECT_FIELD = exports.OBJECT_FIELD = 'ObjectField';
	
	// Directives
	
	var DIRECTIVE = exports.DIRECTIVE = 'Directive';
	
	// Types
	
	var NAMED_TYPE = exports.NAMED_TYPE = 'NamedType';
	var LIST_TYPE = exports.LIST_TYPE = 'ListType';
	var NON_NULL_TYPE = exports.NON_NULL_TYPE = 'NonNullType';
	
	// Type System Definitions
	
	var SCHEMA_DEFINITION = exports.SCHEMA_DEFINITION = 'SchemaDefinition';
	var OPERATION_TYPE_DEFINITION = exports.OPERATION_TYPE_DEFINITION = 'OperationTypeDefinition';
	
	// Type Definitions
	
	var SCALAR_TYPE_DEFINITION = exports.SCALAR_TYPE_DEFINITION = 'ScalarTypeDefinition';
	var OBJECT_TYPE_DEFINITION = exports.OBJECT_TYPE_DEFINITION = 'ObjectTypeDefinition';
	var FIELD_DEFINITION = exports.FIELD_DEFINITION = 'FieldDefinition';
	var INPUT_VALUE_DEFINITION = exports.INPUT_VALUE_DEFINITION = 'InputValueDefinition';
	var INTERFACE_TYPE_DEFINITION = exports.INTERFACE_TYPE_DEFINITION = 'InterfaceTypeDefinition';
	var UNION_TYPE_DEFINITION = exports.UNION_TYPE_DEFINITION = 'UnionTypeDefinition';
	var ENUM_TYPE_DEFINITION = exports.ENUM_TYPE_DEFINITION = 'EnumTypeDefinition';
	var ENUM_VALUE_DEFINITION = exports.ENUM_VALUE_DEFINITION = 'EnumValueDefinition';
	var INPUT_OBJECT_TYPE_DEFINITION = exports.INPUT_OBJECT_TYPE_DEFINITION = 'InputObjectTypeDefinition';
	
	// Type Extensions
	
	var TYPE_EXTENSION_DEFINITION = exports.TYPE_EXTENSION_DEFINITION = 'TypeExtensionDefinition';
	
	// Directive Definitions
	
	var DIRECTIVE_DEFINITION = exports.DIRECTIVE_DEFINITION = 'DirectiveDefinition';

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _map = __webpack_require__(56);
	var _reduce = __webpack_require__(15);
	var _xmap = __webpack_require__(316);
	var curryN = __webpack_require__(9);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _equals = __webpack_require__(291);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = __webpack_require__(53);
	var _xwrap = __webpack_require__(138);
	var bind = __webpack_require__(116);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj, methodName) {
	    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (_isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list['fantasy-land/reduce'] === 'function') {
	      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list, 'reduce');
	    }
	
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _has = __webpack_require__(12);
	var _isArguments = __webpack_require__(133);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var _reduce = __webpack_require__(15);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.print = print;
	
	var _visitor = __webpack_require__(67);
	
	/**
	 * Converts an AST into a string, using one set of reasonable
	 * formatting rules.
	 */
	function print(ast) {
	  return (0, _visitor.visit)(ast, { leave: printDocASTReducer });
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   */
	
	var printDocASTReducer = {
	  Name: function Name(node) {
	    return node.value;
	  },
	  Variable: function Variable(node) {
	    return '$' + node.name;
	  },
	
	  // Document
	
	  Document: function Document(node) {
	    return join(node.definitions, '\n\n') + '\n';
	  },
	
	  OperationDefinition: function OperationDefinition(node) {
	    var op = node.operation;
	    var name = node.name;
	    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
	    var directives = join(node.directives, ' ');
	    var selectionSet = node.selectionSet;
	    // Anonymous queries with no directives or variable definitions can use
	    // the query short form.
	    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
	  },
	
	
	  VariableDefinition: function VariableDefinition(_ref) {
	    var variable = _ref.variable,
	        type = _ref.type,
	        defaultValue = _ref.defaultValue;
	    return variable + ': ' + type + wrap(' = ', defaultValue);
	  },
	
	  SelectionSet: function SelectionSet(_ref2) {
	    var selections = _ref2.selections;
	    return block(selections);
	  },
	
	  Field: function Field(_ref3) {
	    var alias = _ref3.alias,
	        name = _ref3.name,
	        args = _ref3.arguments,
	        directives = _ref3.directives,
	        selectionSet = _ref3.selectionSet;
	    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
	  },
	
	  Argument: function Argument(_ref4) {
	    var name = _ref4.name,
	        value = _ref4.value;
	    return name + ': ' + value;
	  },
	
	  // Fragments
	
	  FragmentSpread: function FragmentSpread(_ref5) {
	    var name = _ref5.name,
	        directives = _ref5.directives;
	    return '...' + name + wrap(' ', join(directives, ' '));
	  },
	
	  InlineFragment: function InlineFragment(_ref6) {
	    var typeCondition = _ref6.typeCondition,
	        directives = _ref6.directives,
	        selectionSet = _ref6.selectionSet;
	    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
	  },
	
	  FragmentDefinition: function FragmentDefinition(_ref7) {
	    var name = _ref7.name,
	        typeCondition = _ref7.typeCondition,
	        directives = _ref7.directives,
	        selectionSet = _ref7.selectionSet;
	    return 'fragment ' + name + ' on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ') + selectionSet;
	  },
	
	  // Value
	
	  IntValue: function IntValue(_ref8) {
	    var value = _ref8.value;
	    return value;
	  },
	  FloatValue: function FloatValue(_ref9) {
	    var value = _ref9.value;
	    return value;
	  },
	  StringValue: function StringValue(_ref10) {
	    var value = _ref10.value;
	    return JSON.stringify(value);
	  },
	  BooleanValue: function BooleanValue(_ref11) {
	    var value = _ref11.value;
	    return JSON.stringify(value);
	  },
	  NullValue: function NullValue() {
	    return 'null';
	  },
	  EnumValue: function EnumValue(_ref12) {
	    var value = _ref12.value;
	    return value;
	  },
	  ListValue: function ListValue(_ref13) {
	    var values = _ref13.values;
	    return '[' + join(values, ', ') + ']';
	  },
	  ObjectValue: function ObjectValue(_ref14) {
	    var fields = _ref14.fields;
	    return '{' + join(fields, ', ') + '}';
	  },
	  ObjectField: function ObjectField(_ref15) {
	    var name = _ref15.name,
	        value = _ref15.value;
	    return name + ': ' + value;
	  },
	
	  // Directive
	
	  Directive: function Directive(_ref16) {
	    var name = _ref16.name,
	        args = _ref16.arguments;
	    return '@' + name + wrap('(', join(args, ', '), ')');
	  },
	
	  // Type
	
	  NamedType: function NamedType(_ref17) {
	    var name = _ref17.name;
	    return name;
	  },
	  ListType: function ListType(_ref18) {
	    var type = _ref18.type;
	    return '[' + type + ']';
	  },
	  NonNullType: function NonNullType(_ref19) {
	    var type = _ref19.type;
	    return type + '!';
	  },
	
	  // Type System Definitions
	
	  SchemaDefinition: function SchemaDefinition(_ref20) {
	    var directives = _ref20.directives,
	        operationTypes = _ref20.operationTypes;
	    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	
	  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
	    var operation = _ref21.operation,
	        type = _ref21.type;
	    return operation + ': ' + type;
	  },
	
	  ScalarTypeDefinition: function ScalarTypeDefinition(_ref22) {
	    var name = _ref22.name,
	        directives = _ref22.directives;
	    return join(['scalar', name, join(directives, ' ')], ' ');
	  },
	
	  ObjectTypeDefinition: function ObjectTypeDefinition(_ref23) {
	    var name = _ref23.name,
	        interfaces = _ref23.interfaces,
	        directives = _ref23.directives,
	        fields = _ref23.fields;
	    return join(['type', name, wrap('implements ', join(interfaces, ', ')), join(directives, ' '), block(fields)], ' ');
	  },
	
	  FieldDefinition: function FieldDefinition(_ref24) {
	    var name = _ref24.name,
	        args = _ref24.arguments,
	        type = _ref24.type,
	        directives = _ref24.directives;
	    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
	  },
	
	  InputValueDefinition: function InputValueDefinition(_ref25) {
	    var name = _ref25.name,
	        type = _ref25.type,
	        defaultValue = _ref25.defaultValue,
	        directives = _ref25.directives;
	    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
	  },
	
	  InterfaceTypeDefinition: function InterfaceTypeDefinition(_ref26) {
	    var name = _ref26.name,
	        directives = _ref26.directives,
	        fields = _ref26.fields;
	    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
	  },
	
	  UnionTypeDefinition: function UnionTypeDefinition(_ref27) {
	    var name = _ref27.name,
	        directives = _ref27.directives,
	        types = _ref27.types;
	    return join(['union', name, join(directives, ' '), '= ' + join(types, ' | ')], ' ');
	  },
	
	  EnumTypeDefinition: function EnumTypeDefinition(_ref28) {
	    var name = _ref28.name,
	        directives = _ref28.directives,
	        values = _ref28.values;
	    return join(['enum', name, join(directives, ' '), block(values)], ' ');
	  },
	
	  EnumValueDefinition: function EnumValueDefinition(_ref29) {
	    var name = _ref29.name,
	        directives = _ref29.directives;
	    return join([name, join(directives, ' ')], ' ');
	  },
	
	  InputObjectTypeDefinition: function InputObjectTypeDefinition(_ref30) {
	    var name = _ref30.name,
	        directives = _ref30.directives,
	        fields = _ref30.fields;
	    return join(['input', name, join(directives, ' '), block(fields)], ' ');
	  },
	
	  TypeExtensionDefinition: function TypeExtensionDefinition(_ref31) {
	    var definition = _ref31.definition;
	    return 'extend ' + definition;
	  },
	
	  DirectiveDefinition: function DirectiveDefinition(_ref32) {
	    var name = _ref32.name,
	        args = _ref32.arguments,
	        locations = _ref32.locations;
	    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
	  }
	};
	
	/**
	 * Given maybeArray, print an empty string if it is null or empty, otherwise
	 * print all items together separated by separator if provided
	 */
	function join(maybeArray, separator) {
	  return maybeArray ? maybeArray.filter(function (x) {
	    return x;
	  }).join(separator || '') : '';
	}
	
	/**
	 * Given array, print each item on its own line, wrapped in an
	 * indented "{ }" block.
	 */
	function block(array) {
	  return array && array.length !== 0 ? indent('{\n' + join(array, '\n')) + '\n}' : '{}';
	}
	
	/**
	 * If maybeString is not null or empty, then wrap with start and end, otherwise
	 * print an empty string.
	 */
	function wrap(start, maybeString, end) {
	  return maybeString ? start + maybeString + (end || '') : '';
	}
	
	function indent(maybeString) {
	  return maybeString && maybeString.replace(/\n/g, '\n  ');
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(132);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(36);
	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specifiedDirectives = exports.GraphQLDeprecatedDirective = exports.DEFAULT_DEPRECATION_REASON = exports.GraphQLSkipDirective = exports.GraphQLIncludeDirective = exports.GraphQLDirective = exports.DirectiveLocation = undefined;
	
	var _definition = __webpack_require__(6);
	
	var _scalars = __webpack_require__(32);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _assertValidName = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	var DirectiveLocation = exports.DirectiveLocation = {
	  // Operations
	  QUERY: 'QUERY',
	  MUTATION: 'MUTATION',
	  SUBSCRIPTION: 'SUBSCRIPTION',
	  FIELD: 'FIELD',
	  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
	  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
	  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
	  // Schema Definitions
	  SCHEMA: 'SCHEMA',
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  FIELD_DEFINITION: 'FIELD_DEFINITION',
	  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  ENUM_VALUE: 'ENUM_VALUE',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
	};
	
	// eslint-disable-line
	
	/**
	 * Directives are used by the GraphQL runtime as a way of modifying execution
	 * behavior. Type system creators will usually not create these directly.
	 */
	var GraphQLDirective = exports.GraphQLDirective = function GraphQLDirective(config) {
	  _classCallCheck(this, GraphQLDirective);
	
	  !config.name ? (0, _invariant2.default)(0, 'Directive must be named.') : void 0;
	  (0, _assertValidName.assertValidName)(config.name);
	  !Array.isArray(config.locations) ? (0, _invariant2.default)(0, 'Must provide locations for directive.') : void 0;
	  this.name = config.name;
	  this.description = config.description;
	  this.locations = config.locations;
	  this.astNode = config.astNode;
	
	  var args = config.args;
	  if (!args) {
	    this.args = [];
	  } else {
	    !!Array.isArray(args) ? (0, _invariant2.default)(0, '@' + config.name + ' args must be an object with argument names as keys.') : void 0;
	    this.args = Object.keys(args).map(function (argName) {
	      (0, _assertValidName.assertValidName)(argName);
	      var arg = args[argName];
	      !(0, _definition.isInputType)(arg.type) ? (0, _invariant2.default)(0, '@' + config.name + '(' + argName + ':) argument type must be ' + ('Input Type but got: ' + String(arg.type) + '.')) : void 0;
	      return {
	        name: argName,
	        description: arg.description === undefined ? null : arg.description,
	        type: arg.type,
	        defaultValue: arg.defaultValue,
	        astNode: arg.astNode
	      };
	    });
	  }
	};
	
	/**
	 * Used to conditionally include fields or fragments.
	 */
	var GraphQLIncludeDirective = exports.GraphQLIncludeDirective = new GraphQLDirective({
	  name: 'include',
	  description: 'Directs the executor to include this field or fragment only when ' + 'the `if` argument is true.',
	  locations: [DirectiveLocation.FIELD, DirectiveLocation.FRAGMENT_SPREAD, DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	      description: 'Included when true.'
	    }
	  }
	});
	
	/**
	 * Used to conditionally skip (exclude) fields or fragments.
	 */
	var GraphQLSkipDirective = exports.GraphQLSkipDirective = new GraphQLDirective({
	  name: 'skip',
	  description: 'Directs the executor to skip this field or fragment when the `if` ' + 'argument is true.',
	  locations: [DirectiveLocation.FIELD, DirectiveLocation.FRAGMENT_SPREAD, DirectiveLocation.INLINE_FRAGMENT],
	  args: {
	    if: {
	      type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	      description: 'Skipped when true.'
	    }
	  }
	});
	
	/**
	 * Constant string used for default reason for a deprecation.
	 */
	var DEFAULT_DEPRECATION_REASON = exports.DEFAULT_DEPRECATION_REASON = 'No longer supported';
	
	/**
	 * Used to declare element of a GraphQL schema as deprecated.
	 */
	var GraphQLDeprecatedDirective = exports.GraphQLDeprecatedDirective = new GraphQLDirective({
	  name: 'deprecated',
	  description: 'Marks an element of a GraphQL schema as no longer supported.',
	  locations: [DirectiveLocation.FIELD_DEFINITION, DirectiveLocation.ENUM_VALUE],
	  args: {
	    reason: {
	      type: _scalars.GraphQLString,
	      description: 'Explains why this element was deprecated, usually also including a ' + 'suggestion for how to access supported similar data. Formatted ' + 'in [Markdown](https://daringfireball.net/projects/markdown/).',
	      defaultValue: DEFAULT_DEPRECATION_REASON
	    }
	  }
	});
	
	/**
	 * The full list of specified directives.
	 */
	var specifiedDirectives = exports.specifiedDirectives = [GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLSchema = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _definition = __webpack_require__(6);
	
	var _directives = __webpack_require__(27);
	
	var _introspection = __webpack_require__(34);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _typeComparators = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * Schema Definition
	 *
	 * A Schema is created by supplying the root types of each type of operation,
	 * query and mutation (optional). A schema definition is then supplied to the
	 * validator and executor.
	 *
	 * Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       query: MyAppQueryRootType,
	 *       mutation: MyAppMutationRootType,
	 *     })
	 *
	 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
	 * the exact list of directives represented and allowed. If `directives` is not
	 * provided then a default set of the specified directives (e.g. @include and
	 * @skip) will be used. If you wish to provide *additional* directives to these
	 * specified directives, you must explicitly declare them. Example:
	 *
	 *     const MyAppSchema = new GraphQLSchema({
	 *       ...
	 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
	 *     })
	 *
	 */
	var GraphQLSchema = exports.GraphQLSchema = function () {
	  function GraphQLSchema(config) {
	    var _this = this;
	
	    _classCallCheck(this, GraphQLSchema);
	
	    !((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') ? (0, _invariant2.default)(0, 'Must provide configuration object.') : void 0;
	
	    !(config.query instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Schema query must be Object Type but got: ' + String(config.query) + '.') : void 0;
	    this._queryType = config.query;
	
	    !(!config.mutation || config.mutation instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Schema mutation must be Object Type if provided but got: ' + String(config.mutation) + '.') : void 0;
	    this._mutationType = config.mutation;
	
	    !(!config.subscription || config.subscription instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Schema subscription must be Object Type if provided but got: ' + String(config.subscription) + '.') : void 0;
	    this._subscriptionType = config.subscription;
	
	    !(!config.types || Array.isArray(config.types)) ? (0, _invariant2.default)(0, 'Schema types must be Array if provided but got: ' + String(config.types) + '.') : void 0;
	
	    !(!config.directives || Array.isArray(config.directives) && config.directives.every(function (directive) {
	      return directive instanceof _directives.GraphQLDirective;
	    })) ? (0, _invariant2.default)(0, 'Schema directives must be Array<GraphQLDirective> if provided but got: ' + String(config.directives) + '.') : void 0;
	    // Provide specified directives (e.g. @include and @skip) by default.
	    this._directives = config.directives || _directives.specifiedDirectives;
	    this.astNode = config.astNode || null;
	
	    // Build type map now to detect any errors within this schema.
	    var initialTypes = [this.getQueryType(), this.getMutationType(), this.getSubscriptionType(), _introspection.__Schema];
	
	    var types = config.types;
	    if (types) {
	      initialTypes = initialTypes.concat(types);
	    }
	
	    this._typeMap = initialTypes.reduce(typeMapReducer, Object.create(null));
	
	    // Keep track of all implementations by interface name.
	    this._implementations = Object.create(null);
	    Object.keys(this._typeMap).forEach(function (typeName) {
	      var type = _this._typeMap[typeName];
	      if (type instanceof _definition.GraphQLObjectType) {
	        type.getInterfaces().forEach(function (iface) {
	          var impls = _this._implementations[iface.name];
	          if (impls) {
	            impls.push(type);
	          } else {
	            _this._implementations[iface.name] = [type];
	          }
	        });
	      }
	    });
	
	    // Enforce correct interface implementations.
	    Object.keys(this._typeMap).forEach(function (typeName) {
	      var type = _this._typeMap[typeName];
	      if (type instanceof _definition.GraphQLObjectType) {
	        type.getInterfaces().forEach(function (iface) {
	          return assertObjectImplementsInterface(_this, type, iface);
	        });
	      }
	    });
	  }
	
	  GraphQLSchema.prototype.getQueryType = function getQueryType() {
	    return this._queryType;
	  };
	
	  GraphQLSchema.prototype.getMutationType = function getMutationType() {
	    return this._mutationType;
	  };
	
	  GraphQLSchema.prototype.getSubscriptionType = function getSubscriptionType() {
	    return this._subscriptionType;
	  };
	
	  GraphQLSchema.prototype.getTypeMap = function getTypeMap() {
	    return this._typeMap;
	  };
	
	  GraphQLSchema.prototype.getType = function getType(name) {
	    return this.getTypeMap()[name];
	  };
	
	  GraphQLSchema.prototype.getPossibleTypes = function getPossibleTypes(abstractType) {
	    if (abstractType instanceof _definition.GraphQLUnionType) {
	      return abstractType.getTypes();
	    }
	    !(abstractType instanceof _definition.GraphQLInterfaceType) ? (0, _invariant2.default)(0) : void 0;
	    return this._implementations[abstractType.name];
	  };
	
	  GraphQLSchema.prototype.isPossibleType = function isPossibleType(abstractType, possibleType) {
	    var possibleTypeMap = this._possibleTypeMap;
	    if (!possibleTypeMap) {
	      this._possibleTypeMap = possibleTypeMap = Object.create(null);
	    }
	
	    if (!possibleTypeMap[abstractType.name]) {
	      var possibleTypes = this.getPossibleTypes(abstractType);
	      !Array.isArray(possibleTypes) ? (0, _invariant2.default)(0, 'Could not find possible implementing types for ' + abstractType.name + ' ' + 'in schema. Check that schema.types is defined and is an array of ' + 'all possible types in the schema.') : void 0;
	      possibleTypeMap[abstractType.name] = possibleTypes.reduce(function (map, type) {
	        return map[type.name] = true, map;
	      }, Object.create(null));
	    }
	
	    return Boolean(possibleTypeMap[abstractType.name][possibleType.name]);
	  };
	
	  GraphQLSchema.prototype.getDirectives = function getDirectives() {
	    return this._directives;
	  };
	
	  GraphQLSchema.prototype.getDirective = function getDirective(name) {
	    return (0, _find2.default)(this.getDirectives(), function (directive) {
	      return directive.name === name;
	    });
	  };
	
	  return GraphQLSchema;
	}();
	
	function typeMapReducer(map, type) {
	  if (!type) {
	    return map;
	  }
	  if (type instanceof _definition.GraphQLList || type instanceof _definition.GraphQLNonNull) {
	    return typeMapReducer(map, type.ofType);
	  }
	  if (map[type.name]) {
	    !(map[type.name] === type) ? (0, _invariant2.default)(0, 'Schema must contain unique named types but contains multiple ' + ('types named "' + type.name + '".')) : void 0;
	    return map;
	  }
	  map[type.name] = type;
	
	  var reducedMap = map;
	
	  if (type instanceof _definition.GraphQLUnionType) {
	    reducedMap = type.getTypes().reduce(typeMapReducer, reducedMap);
	  }
	
	  if (type instanceof _definition.GraphQLObjectType) {
	    reducedMap = type.getInterfaces().reduce(typeMapReducer, reducedMap);
	  }
	
	  if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	    var fieldMap = type.getFields();
	    Object.keys(fieldMap).forEach(function (fieldName) {
	      var field = fieldMap[fieldName];
	
	      if (field.args) {
	        var fieldArgTypes = field.args.map(function (arg) {
	          return arg.type;
	        });
	        reducedMap = fieldArgTypes.reduce(typeMapReducer, reducedMap);
	      }
	      reducedMap = typeMapReducer(reducedMap, field.type);
	    });
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    var _fieldMap = type.getFields();
	    Object.keys(_fieldMap).forEach(function (fieldName) {
	      var field = _fieldMap[fieldName];
	      reducedMap = typeMapReducer(reducedMap, field.type);
	    });
	  }
	
	  return reducedMap;
	}
	
	function assertObjectImplementsInterface(schema, object, iface) {
	  var objectFieldMap = object.getFields();
	  var ifaceFieldMap = iface.getFields();
	
	  // Assert each interface field is implemented.
	  Object.keys(ifaceFieldMap).forEach(function (fieldName) {
	    var objectField = objectFieldMap[fieldName];
	    var ifaceField = ifaceFieldMap[fieldName];
	
	    // Assert interface field exists on object.
	    !objectField ? (0, _invariant2.default)(0, '"' + iface.name + '" expects field "' + fieldName + '" but "' + object.name + '" ' + 'does not provide it.') : void 0;
	
	    // Assert interface field type is satisfied by object field type, by being
	    // a valid subtype. (covariant)
	    !(0, _typeComparators.isTypeSubTypeOf)(schema, objectField.type, ifaceField.type) ? (0, _invariant2.default)(0, iface.name + '.' + fieldName + ' expects type "' + String(ifaceField.type) + '" ' + 'but ' + (object.name + '.' + fieldName + ' provides type "' + String(objectField.type) + '".')) : void 0;
	
	    // Assert each interface field arg is implemented.
	    ifaceField.args.forEach(function (ifaceArg) {
	      var argName = ifaceArg.name;
	      var objectArg = (0, _find2.default)(objectField.args, function (arg) {
	        return arg.name === argName;
	      });
	
	      // Assert interface field arg exists on object field.
	      !objectArg ? (0, _invariant2.default)(0, iface.name + '.' + fieldName + ' expects argument "' + argName + '" but ' + (object.name + '.' + fieldName + ' does not provide it.')) : void 0;
	
	      // Assert interface field arg type matches object field arg type.
	      // (invariant)
	      !(0, _typeComparators.isEqualType)(ifaceArg.type, objectArg.type) ? (0, _invariant2.default)(0, iface.name + '.' + fieldName + '(' + argName + ':) expects type ' + ('"' + String(ifaceArg.type) + '" but ') + (object.name + '.' + fieldName + '(' + argName + ':) provides type ') + ('"' + String(objectArg.type) + '".')) : void 0;
	    });
	
	    // Assert additional arguments must not be required.
	    objectField.args.forEach(function (objectArg) {
	      var argName = objectArg.name;
	      var ifaceArg = (0, _find2.default)(ifaceField.args, function (arg) {
	        return arg.name === argName;
	      });
	      if (!ifaceArg) {
	        !!(objectArg.type instanceof _definition.GraphQLNonNull) ? (0, _invariant2.default)(0, object.name + '.' + fieldName + '(' + argName + ':) is of required type ' + ('"' + String(objectArg.type) + '" but is not also provided by the ') + ('interface ' + iface.name + '.' + fieldName + '.')) : void 0;
	      }
	    });
	  });
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeFromAST = undefined;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a Schema and an AST node describing a type, return a GraphQLType
	 * definition which applies to that type. For example, if provided the parsed
	 * AST node for `[User]`, a GraphQLList instance will be returned, containing
	 * the type called "User" found in the schema. If a type called "User" is not
	 * found in the schema, then undefined will be returned.
	 */
	/* eslint-disable no-redeclare */
	function typeFromASTImpl(schema, typeNode) {
	  /* eslint-enable no-redeclare */
	  var innerType = void 0;
	  if (typeNode.kind === Kind.LIST_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && new _definition.GraphQLList(innerType);
	  }
	  if (typeNode.kind === Kind.NON_NULL_TYPE) {
	    innerType = typeFromAST(schema, typeNode.type);
	    return innerType && new _definition.GraphQLNonNull(innerType);
	  }
	  !(typeNode.kind === Kind.NAMED_TYPE) ? (0, _invariant2.default)(0, 'Must be a named type.') : void 0;
	  return schema.getType(typeNode.name.value);
	}
	// This will export typeFromAST with the correct type, but currently exposes
	// ~26 errors: https://gist.github.com/4a29403a99a8186fcb15064d69c5f3ae
	// export var typeFromAST: typeof typeFromASTType = typeFromASTImpl;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var typeFromAST = exports.typeFromAST = typeFromASTImpl;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLID = exports.GraphQLBoolean = exports.GraphQLString = exports.GraphQLFloat = exports.GraphQLInt = undefined;
	
	var _definition = __webpack_require__(6);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// As per the GraphQL Spec, Integers are only treated as valid when a valid
	// 32-bit signed integer, providing the broadest support across platforms.
	//
	// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
	// they are internally represented as IEEE 754 doubles.
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var MAX_INT = 2147483647;
	var MIN_INT = -2147483648;
	
	function coerceInt(value) {
	  if (value === '') {
	    throw new TypeError('Int cannot represent non 32-bit signed integer value: (empty string)');
	  }
	  var num = Number(value);
	  if (num !== num || num > MAX_INT || num < MIN_INT) {
	    throw new TypeError('Int cannot represent non 32-bit signed integer value: ' + String(value));
	  }
	  var int = Math.floor(num);
	  if (int !== num) {
	    throw new TypeError('Int cannot represent non-integer value: ' + String(value));
	  }
	  return int;
	}
	
	var GraphQLInt = exports.GraphQLInt = new _definition.GraphQLScalarType({
	  name: 'Int',
	  description: 'The `Int` scalar type represents non-fractional signed whole numeric ' + 'values. Int can represent values between -(2^31) and 2^31 - 1. ',
	  serialize: coerceInt,
	  parseValue: coerceInt,
	  parseLiteral: function parseLiteral(ast) {
	    if (ast.kind === Kind.INT) {
	      var num = parseInt(ast.value, 10);
	      if (num <= MAX_INT && num >= MIN_INT) {
	        return num;
	      }
	    }
	    return null;
	  }
	});
	
	function coerceFloat(value) {
	  if (value === '') {
	    throw new TypeError('Float cannot represent non numeric value: (empty string)');
	  }
	  var num = Number(value);
	  if (num === num) {
	    return num;
	  }
	  throw new TypeError('Float cannot represent non numeric value: ' + String(value));
	}
	
	var GraphQLFloat = exports.GraphQLFloat = new _definition.GraphQLScalarType({
	  name: 'Float',
	  description: 'The `Float` scalar type represents signed double-precision fractional ' + 'values as specified by ' + '[IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). ',
	  serialize: coerceFloat,
	  parseValue: coerceFloat,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.FLOAT || ast.kind === Kind.INT ? parseFloat(ast.value) : null;
	  }
	});
	
	function coerceString(value) {
	  if (Array.isArray(value)) {
	    throw new TypeError('String cannot represent an array value: [' + String(value) + ']');
	  }
	  return String(value);
	}
	
	var GraphQLString = exports.GraphQLString = new _definition.GraphQLScalarType({
	  name: 'String',
	  description: 'The `String` scalar type represents textual data, represented as UTF-8 ' + 'character sequences. The String type is most often used by GraphQL to ' + 'represent free-form human-readable text.',
	  serialize: coerceString,
	  parseValue: coerceString,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.STRING ? ast.value : null;
	  }
	});
	
	var GraphQLBoolean = exports.GraphQLBoolean = new _definition.GraphQLScalarType({
	  name: 'Boolean',
	  description: 'The `Boolean` scalar type represents `true` or `false`.',
	  serialize: Boolean,
	  parseValue: Boolean,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.BOOLEAN ? ast.value : null;
	  }
	});
	
	var GraphQLID = exports.GraphQLID = new _definition.GraphQLScalarType({
	  name: 'ID',
	  description: 'The `ID` scalar type represents a unique identifier, often used to ' + 'refetch an object or as key for a cache. The ID type appears in a JSON ' + 'response as a String; however, it is not intended to be human-readable. ' + 'When expected as an input type, any string (such as `"4"`) or integer ' + '(such as `4`) input value will be accepted as an ID.',
	  serialize: String,
	  parseValue: String,
	  parseLiteral: function parseLiteral(ast) {
	    return ast.kind === Kind.STRING || ast.kind === Kind.INT ? ast.value : null;
	  }
	});

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNullish;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	/**
	 * Returns true if a value is null, undefined, or NaN.
	 */
	function isNullish(value) {
	  return value === null || value === undefined || value !== value;
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TypeNameMetaFieldDef = exports.TypeMetaFieldDef = exports.SchemaMetaFieldDef = exports.__TypeKind = exports.TypeKind = exports.__EnumValue = exports.__InputValue = exports.__Field = exports.__Type = exports.__DirectiveLocation = exports.__Directive = exports.__Schema = undefined;
	
	var _isInvalid = __webpack_require__(66);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _astFromValue = __webpack_require__(108);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _scalars = __webpack_require__(32);
	
	var _directives = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var __Schema = exports.__Schema = new _definition.GraphQLObjectType({
	  name: '__Schema',
	  isIntrospection: true,
	  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It ' + 'exposes all available types and directives on the server, as well as ' + 'the entry points for query, mutation, and subscription operations.',
	  fields: function fields() {
	    return {
	      types: {
	        description: 'A list of all types supported by this server.',
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type))),
	        resolve: function resolve(schema) {
	          var typeMap = schema.getTypeMap();
	          return Object.keys(typeMap).map(function (key) {
	            return typeMap[key];
	          });
	        }
	      },
	      queryType: {
	        description: 'The type that query operations will be rooted at.',
	        type: new _definition.GraphQLNonNull(__Type),
	        resolve: function resolve(schema) {
	          return schema.getQueryType();
	        }
	      },
	      mutationType: {
	        description: 'If this server supports mutation, the type that ' + 'mutation operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getMutationType();
	        }
	      },
	      subscriptionType: {
	        description: 'If this server support subscription, the type that ' + 'subscription operations will be rooted at.',
	        type: __Type,
	        resolve: function resolve(schema) {
	          return schema.getSubscriptionType();
	        }
	      },
	      directives: {
	        description: 'A list of all directives supported by this server.',
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__Directive))),
	        resolve: function resolve(schema) {
	          return schema.getDirectives();
	        }
	      }
	    };
	  }
	});
	
	var __Directive = exports.__Directive = new _definition.GraphQLObjectType({
	  name: '__Directive',
	  isIntrospection: true,
	  description: 'A Directive provides a way to describe alternate runtime execution and ' + 'type validation behavior in a GraphQL document.' + '\n\nIn some cases, you need to provide options to alter GraphQL\'s ' + 'execution behavior in ways field arguments will not suffice, such as ' + 'conditionally including or skipping a field. Directives provide this by ' + 'describing additional information to the executor.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      locations: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__DirectiveLocation)))
	      },
	      args: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue))),
	        resolve: function resolve(directive) {
	          return directive.args || [];
	        }
	      },
	      // NOTE: the following three fields are deprecated and are no longer part
	      // of the GraphQL specification.
	      onOperation: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.QUERY) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.MUTATION) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.SUBSCRIPTION) !== -1;
	        }
	      },
	      onFragment: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.FRAGMENT_SPREAD) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.INLINE_FRAGMENT) !== -1 || d.locations.indexOf(_directives.DirectiveLocation.FRAGMENT_DEFINITION) !== -1;
	        }
	      },
	      onField: {
	        deprecationReason: 'Use `locations`.',
	        type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean),
	        resolve: function resolve(d) {
	          return d.locations.indexOf(_directives.DirectiveLocation.FIELD) !== -1;
	        }
	      }
	    };
	  }
	});
	
	var __DirectiveLocation = exports.__DirectiveLocation = new _definition.GraphQLEnumType({
	  name: '__DirectiveLocation',
	  isIntrospection: true,
	  description: 'A Directive can be adjacent to many parts of the GraphQL language, a ' + '__DirectiveLocation describes one such possible adjacencies.',
	  values: {
	    QUERY: {
	      value: _directives.DirectiveLocation.QUERY,
	      description: 'Location adjacent to a query operation.'
	    },
	    MUTATION: {
	      value: _directives.DirectiveLocation.MUTATION,
	      description: 'Location adjacent to a mutation operation.'
	    },
	    SUBSCRIPTION: {
	      value: _directives.DirectiveLocation.SUBSCRIPTION,
	      description: 'Location adjacent to a subscription operation.'
	    },
	    FIELD: {
	      value: _directives.DirectiveLocation.FIELD,
	      description: 'Location adjacent to a field.'
	    },
	    FRAGMENT_DEFINITION: {
	      value: _directives.DirectiveLocation.FRAGMENT_DEFINITION,
	      description: 'Location adjacent to a fragment definition.'
	    },
	    FRAGMENT_SPREAD: {
	      value: _directives.DirectiveLocation.FRAGMENT_SPREAD,
	      description: 'Location adjacent to a fragment spread.'
	    },
	    INLINE_FRAGMENT: {
	      value: _directives.DirectiveLocation.INLINE_FRAGMENT,
	      description: 'Location adjacent to an inline fragment.'
	    },
	    SCHEMA: {
	      value: _directives.DirectiveLocation.SCHEMA,
	      description: 'Location adjacent to a schema definition.'
	    },
	    SCALAR: {
	      value: _directives.DirectiveLocation.SCALAR,
	      description: 'Location adjacent to a scalar definition.'
	    },
	    OBJECT: {
	      value: _directives.DirectiveLocation.OBJECT,
	      description: 'Location adjacent to an object type definition.'
	    },
	    FIELD_DEFINITION: {
	      value: _directives.DirectiveLocation.FIELD_DEFINITION,
	      description: 'Location adjacent to a field definition.'
	    },
	    ARGUMENT_DEFINITION: {
	      value: _directives.DirectiveLocation.ARGUMENT_DEFINITION,
	      description: 'Location adjacent to an argument definition.'
	    },
	    INTERFACE: {
	      value: _directives.DirectiveLocation.INTERFACE,
	      description: 'Location adjacent to an interface definition.'
	    },
	    UNION: {
	      value: _directives.DirectiveLocation.UNION,
	      description: 'Location adjacent to a union definition.'
	    },
	    ENUM: {
	      value: _directives.DirectiveLocation.ENUM,
	      description: 'Location adjacent to an enum definition.'
	    },
	    ENUM_VALUE: {
	      value: _directives.DirectiveLocation.ENUM_VALUE,
	      description: 'Location adjacent to an enum value definition.'
	    },
	    INPUT_OBJECT: {
	      value: _directives.DirectiveLocation.INPUT_OBJECT,
	      description: 'Location adjacent to an input object type definition.'
	    },
	    INPUT_FIELD_DEFINITION: {
	      value: _directives.DirectiveLocation.INPUT_FIELD_DEFINITION,
	      description: 'Location adjacent to an input object field definition.'
	    }
	  }
	});
	
	var __Type = exports.__Type = new _definition.GraphQLObjectType({
	  name: '__Type',
	  isIntrospection: true,
	  description: 'The fundamental unit of any GraphQL Schema is the type. There are ' + 'many kinds of types in GraphQL as represented by the `__TypeKind` enum.' + '\n\nDepending on the kind of a type, certain fields describe ' + 'information about that type. Scalar types provide no information ' + 'beyond a name and description, while Enum types provide their values. ' + 'Object and Interface types provide the fields they describe. Abstract ' + 'types, Union and Interface, provide the Object types possible ' + 'at runtime. List and NonNull types compose other types.',
	  fields: function fields() {
	    return {
	      kind: {
	        type: new _definition.GraphQLNonNull(__TypeKind),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLScalarType) {
	            return TypeKind.SCALAR;
	          } else if (type instanceof _definition.GraphQLObjectType) {
	            return TypeKind.OBJECT;
	          } else if (type instanceof _definition.GraphQLInterfaceType) {
	            return TypeKind.INTERFACE;
	          } else if (type instanceof _definition.GraphQLUnionType) {
	            return TypeKind.UNION;
	          } else if (type instanceof _definition.GraphQLEnumType) {
	            return TypeKind.ENUM;
	          } else if (type instanceof _definition.GraphQLInputObjectType) {
	            return TypeKind.INPUT_OBJECT;
	          } else if (type instanceof _definition.GraphQLList) {
	            return TypeKind.LIST;
	          } else if (type instanceof _definition.GraphQLNonNull) {
	            return TypeKind.NON_NULL;
	          }
	          throw new Error('Unknown kind of type: ' + type);
	        }
	      },
	      name: { type: _scalars.GraphQLString },
	      description: { type: _scalars.GraphQLString },
	      fields: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Field)),
	        args: {
	          includeDeprecated: { type: _scalars.GraphQLBoolean, defaultValue: false }
	        },
	        resolve: function resolve(type, _ref) {
	          var includeDeprecated = _ref.includeDeprecated;
	
	          if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	            var fieldMap = type.getFields();
	            var fields = Object.keys(fieldMap).map(function (fieldName) {
	              return fieldMap[fieldName];
	            });
	            if (!includeDeprecated) {
	              fields = fields.filter(function (field) {
	                return !field.deprecationReason;
	              });
	            }
	            return fields;
	          }
	          return null;
	        }
	      },
	      interfaces: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type)),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLObjectType) {
	            return type.getInterfaces();
	          }
	        }
	      },
	      possibleTypes: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__Type)),
	        resolve: function resolve(type, args, context, _ref2) {
	          var schema = _ref2.schema;
	
	          if ((0, _definition.isAbstractType)(type)) {
	            return schema.getPossibleTypes(type);
	          }
	        }
	      },
	      enumValues: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__EnumValue)),
	        args: {
	          includeDeprecated: { type: _scalars.GraphQLBoolean, defaultValue: false }
	        },
	        resolve: function resolve(type, _ref3) {
	          var includeDeprecated = _ref3.includeDeprecated;
	
	          if (type instanceof _definition.GraphQLEnumType) {
	            var values = type.getValues();
	            if (!includeDeprecated) {
	              values = values.filter(function (value) {
	                return !value.deprecationReason;
	              });
	            }
	            return values;
	          }
	        }
	      },
	      inputFields: {
	        type: new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue)),
	        resolve: function resolve(type) {
	          if (type instanceof _definition.GraphQLInputObjectType) {
	            var fieldMap = type.getFields();
	            return Object.keys(fieldMap).map(function (fieldName) {
	              return fieldMap[fieldName];
	            });
	          }
	        }
	      },
	      ofType: { type: __Type }
	    };
	  }
	});
	
	var __Field = exports.__Field = new _definition.GraphQLObjectType({
	  name: '__Field',
	  isIntrospection: true,
	  description: 'Object and Interface types are described by a list of Fields, each of ' + 'which has a name, potentially a list of arguments, and a return type.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      args: {
	        type: new _definition.GraphQLNonNull(new _definition.GraphQLList(new _definition.GraphQLNonNull(__InputValue))),
	        resolve: function resolve(field) {
	          return field.args || [];
	        }
	      },
	      type: { type: new _definition.GraphQLNonNull(__Type) },
	      isDeprecated: { type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean) },
	      deprecationReason: {
	        type: _scalars.GraphQLString
	      }
	    };
	  }
	});
	
	var __InputValue = exports.__InputValue = new _definition.GraphQLObjectType({
	  name: '__InputValue',
	  isIntrospection: true,
	  description: 'Arguments provided to Fields or Directives and the input fields of an ' + 'InputObject are represented as Input Values which describe their type ' + 'and optionally a default value.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      type: { type: new _definition.GraphQLNonNull(__Type) },
	      defaultValue: {
	        type: _scalars.GraphQLString,
	        description: 'A GraphQL-formatted string representing the default value for this ' + 'input value.',
	        resolve: function resolve(inputVal) {
	          return (0, _isInvalid2.default)(inputVal.defaultValue) ? null : (0, _printer.print)((0, _astFromValue.astFromValue)(inputVal.defaultValue, inputVal.type));
	        }
	      }
	    };
	  }
	});
	
	var __EnumValue = exports.__EnumValue = new _definition.GraphQLObjectType({
	  name: '__EnumValue',
	  isIntrospection: true,
	  description: 'One possible value for a given Enum. Enum values are unique values, not ' + 'a placeholder for a string or numeric value. However an Enum value is ' + 'returned in a JSON response as a string.',
	  fields: function fields() {
	    return {
	      name: { type: new _definition.GraphQLNonNull(_scalars.GraphQLString) },
	      description: { type: _scalars.GraphQLString },
	      isDeprecated: { type: new _definition.GraphQLNonNull(_scalars.GraphQLBoolean) },
	      deprecationReason: {
	        type: _scalars.GraphQLString
	      }
	    };
	  }
	});
	
	var TypeKind = exports.TypeKind = {
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  LIST: 'LIST',
	  NON_NULL: 'NON_NULL'
	};
	
	var __TypeKind = exports.__TypeKind = new _definition.GraphQLEnumType({
	  name: '__TypeKind',
	  isIntrospection: true,
	  description: 'An enum describing what kind of type a given `__Type` is.',
	  values: {
	    SCALAR: {
	      value: TypeKind.SCALAR,
	      description: 'Indicates this type is a scalar.'
	    },
	    OBJECT: {
	      value: TypeKind.OBJECT,
	      description: 'Indicates this type is an object. ' + '`fields` and `interfaces` are valid fields.'
	    },
	    INTERFACE: {
	      value: TypeKind.INTERFACE,
	      description: 'Indicates this type is an interface. ' + '`fields` and `possibleTypes` are valid fields.'
	    },
	    UNION: {
	      value: TypeKind.UNION,
	      description: 'Indicates this type is a union. ' + '`possibleTypes` is a valid field.'
	    },
	    ENUM: {
	      value: TypeKind.ENUM,
	      description: 'Indicates this type is an enum. ' + '`enumValues` is a valid field.'
	    },
	    INPUT_OBJECT: {
	      value: TypeKind.INPUT_OBJECT,
	      description: 'Indicates this type is an input object. ' + '`inputFields` is a valid field.'
	    },
	    LIST: {
	      value: TypeKind.LIST,
	      description: 'Indicates this type is a list. ' + '`ofType` is a valid field.'
	    },
	    NON_NULL: {
	      value: TypeKind.NON_NULL,
	      description: 'Indicates this type is a non-null. ' + '`ofType` is a valid field.'
	    }
	  }
	});
	
	/**
	 * Note that these are GraphQLField and not GraphQLFieldConfig,
	 * so the format for args is different.
	 */
	
	var SchemaMetaFieldDef = exports.SchemaMetaFieldDef = {
	  name: '__schema',
	  type: new _definition.GraphQLNonNull(__Schema),
	  description: 'Access the current type schema of this server.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref4) {
	    var schema = _ref4.schema;
	    return schema;
	  }
	};
	
	var TypeMetaFieldDef = exports.TypeMetaFieldDef = {
	  name: '__type',
	  type: __Type,
	  description: 'Request the type information of a single type.',
	  args: [{ name: 'name', type: new _definition.GraphQLNonNull(_scalars.GraphQLString) }],
	  resolve: function resolve(source, _ref5, context, _ref6) {
	    var name = _ref5.name;
	    var schema = _ref6.schema;
	    return schema.getType(name);
	  }
	};
	
	var TypeNameMetaFieldDef = exports.TypeNameMetaFieldDef = {
	  name: '__typename',
	  type: new _definition.GraphQLNonNull(_scalars.GraphQLString),
	  description: 'The name of the current Object type at runtime.',
	  args: [],
	  resolve: function resolve(source, args, context, _ref7) {
	    var parentType = _ref7.parentType;
	    return parentType.name;
	  }
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(227),
	  T: __webpack_require__(228),
	  __: __webpack_require__(229),
	  add: __webpack_require__(47),
	  addIndex: __webpack_require__(230),
	  adjust: __webpack_require__(111),
	  all: __webpack_require__(231),
	  allPass: __webpack_require__(232),
	  always: __webpack_require__(30),
	  and: __webpack_require__(112),
	  any: __webpack_require__(113),
	  anyPass: __webpack_require__(233),
	  ap: __webpack_require__(71),
	  aperture: __webpack_require__(234),
	  append: __webpack_require__(235),
	  apply: __webpack_require__(114),
	  applySpec: __webpack_require__(236),
	  ascend: __webpack_require__(237),
	  assoc: __webpack_require__(48),
	  assocPath: __webpack_require__(115),
	  binary: __webpack_require__(238),
	  bind: __webpack_require__(116),
	  both: __webpack_require__(239),
	  call: __webpack_require__(240),
	  chain: __webpack_require__(72),
	  clamp: __webpack_require__(241),
	  clone: __webpack_require__(242),
	  comparator: __webpack_require__(243),
	  complement: __webpack_require__(244),
	  compose: __webpack_require__(73),
	  composeK: __webpack_require__(117),
	  composeP: __webpack_require__(245),
	  concat: __webpack_require__(74),
	  cond: __webpack_require__(246),
	  construct: __webpack_require__(247),
	  constructN: __webpack_require__(118),
	  contains: __webpack_require__(248),
	  converge: __webpack_require__(119),
	  countBy: __webpack_require__(249),
	  curry: __webpack_require__(49),
	  curryN: __webpack_require__(9),
	  dec: __webpack_require__(250),
	  defaultTo: __webpack_require__(120),
	  descend: __webpack_require__(251),
	  difference: __webpack_require__(121),
	  differenceWith: __webpack_require__(122),
	  dissoc: __webpack_require__(123),
	  dissocPath: __webpack_require__(252),
	  divide: __webpack_require__(253),
	  drop: __webpack_require__(124),
	  dropLast: __webpack_require__(254),
	  dropLastWhile: __webpack_require__(255),
	  dropRepeats: __webpack_require__(256),
	  dropRepeatsWith: __webpack_require__(125),
	  dropWhile: __webpack_require__(257),
	  either: __webpack_require__(258),
	  empty: __webpack_require__(126),
	  endsWith: __webpack_require__(259),
	  eqBy: __webpack_require__(260),
	  eqProps: __webpack_require__(261),
	  equals: __webpack_require__(14),
	  evolve: __webpack_require__(262),
	  filter: __webpack_require__(75),
	  find: __webpack_require__(263),
	  findIndex: __webpack_require__(264),
	  findLast: __webpack_require__(265),
	  findLastIndex: __webpack_require__(266),
	  flatten: __webpack_require__(267),
	  flip: __webpack_require__(50),
	  forEach: __webpack_require__(268),
	  forEachObjIndexed: __webpack_require__(269),
	  fromPairs: __webpack_require__(270),
	  groupBy: __webpack_require__(271),
	  groupWith: __webpack_require__(272),
	  gt: __webpack_require__(273),
	  gte: __webpack_require__(274),
	  has: __webpack_require__(275),
	  hasIn: __webpack_require__(276),
	  head: __webpack_require__(277),
	  identical: __webpack_require__(127),
	  identity: __webpack_require__(76),
	  ifElse: __webpack_require__(278),
	  inc: __webpack_require__(279),
	  indexBy: __webpack_require__(280),
	  indexOf: __webpack_require__(281),
	  init: __webpack_require__(282),
	  innerJoin: __webpack_require__(283),
	  insert: __webpack_require__(284),
	  insertAll: __webpack_require__(285),
	  intersection: __webpack_require__(320),
	  intersectionWith: __webpack_require__(321),
	  intersperse: __webpack_require__(322),
	  into: __webpack_require__(323),
	  invert: __webpack_require__(324),
	  invertObj: __webpack_require__(325),
	  invoker: __webpack_require__(38),
	  is: __webpack_require__(139),
	  isEmpty: __webpack_require__(326),
	  isNil: __webpack_require__(140),
	  join: __webpack_require__(327),
	  juxt: __webpack_require__(141),
	  keys: __webpack_require__(18),
	  keysIn: __webpack_require__(328),
	  last: __webpack_require__(142),
	  lastIndexOf: __webpack_require__(329),
	  length: __webpack_require__(143),
	  lens: __webpack_require__(57),
	  lensIndex: __webpack_require__(330),
	  lensPath: __webpack_require__(331),
	  lensProp: __webpack_require__(332),
	  lift: __webpack_require__(58),
	  liftN: __webpack_require__(144),
	  lt: __webpack_require__(333),
	  lte: __webpack_require__(334),
	  map: __webpack_require__(13),
	  mapAccum: __webpack_require__(335),
	  mapAccumRight: __webpack_require__(336),
	  mapObjIndexed: __webpack_require__(337),
	  match: __webpack_require__(338),
	  mathMod: __webpack_require__(339),
	  max: __webpack_require__(31),
	  maxBy: __webpack_require__(340),
	  mean: __webpack_require__(145),
	  median: __webpack_require__(341),
	  memoize: __webpack_require__(342),
	  memoizeWith: __webpack_require__(146),
	  merge: __webpack_require__(343),
	  mergeAll: __webpack_require__(344),
	  mergeDeepLeft: __webpack_require__(345),
	  mergeDeepRight: __webpack_require__(346),
	  mergeDeepWith: __webpack_require__(347),
	  mergeDeepWithKey: __webpack_require__(59),
	  mergeWith: __webpack_require__(348),
	  mergeWithKey: __webpack_require__(83),
	  min: __webpack_require__(349),
	  minBy: __webpack_require__(350),
	  modulo: __webpack_require__(351),
	  multiply: __webpack_require__(147),
	  nAry: __webpack_require__(60),
	  negate: __webpack_require__(352),
	  none: __webpack_require__(353),
	  not: __webpack_require__(148),
	  nth: __webpack_require__(39),
	  nthArg: __webpack_require__(354),
	  o: __webpack_require__(355),
	  objOf: __webpack_require__(149),
	  of: __webpack_require__(356),
	  omit: __webpack_require__(357),
	  once: __webpack_require__(358),
	  or: __webpack_require__(150),
	  over: __webpack_require__(151),
	  pair: __webpack_require__(359),
	  partial: __webpack_require__(360),
	  partialRight: __webpack_require__(361),
	  partition: __webpack_require__(362),
	  path: __webpack_require__(40),
	  pathEq: __webpack_require__(363),
	  pathOr: __webpack_require__(364),
	  pathSatisfies: __webpack_require__(365),
	  pick: __webpack_require__(366),
	  pickAll: __webpack_require__(152),
	  pickBy: __webpack_require__(367),
	  pipe: __webpack_require__(153),
	  pipeK: __webpack_require__(368),
	  pipeP: __webpack_require__(154),
	  pluck: __webpack_require__(41),
	  prepend: __webpack_require__(155),
	  product: __webpack_require__(369),
	  project: __webpack_require__(370),
	  prop: __webpack_require__(84),
	  propEq: __webpack_require__(371),
	  propIs: __webpack_require__(372),
	  propOr: __webpack_require__(373),
	  propSatisfies: __webpack_require__(374),
	  props: __webpack_require__(375),
	  range: __webpack_require__(376),
	  reduce: __webpack_require__(19),
	  reduceBy: __webpack_require__(61),
	  reduceRight: __webpack_require__(156),
	  reduceWhile: __webpack_require__(377),
	  reduced: __webpack_require__(378),
	  reject: __webpack_require__(62),
	  remove: __webpack_require__(157),
	  repeat: __webpack_require__(379),
	  replace: __webpack_require__(380),
	  reverse: __webpack_require__(63),
	  scan: __webpack_require__(381),
	  sequence: __webpack_require__(158),
	  set: __webpack_require__(382),
	  slice: __webpack_require__(26),
	  sort: __webpack_require__(383),
	  sortBy: __webpack_require__(384),
	  sortWith: __webpack_require__(385),
	  split: __webpack_require__(386),
	  splitAt: __webpack_require__(387),
	  splitEvery: __webpack_require__(388),
	  splitWhen: __webpack_require__(389),
	  startsWith: __webpack_require__(390),
	  subtract: __webpack_require__(391),
	  sum: __webpack_require__(159),
	  symmetricDifference: __webpack_require__(392),
	  symmetricDifferenceWith: __webpack_require__(393),
	  tail: __webpack_require__(85),
	  take: __webpack_require__(86),
	  takeLast: __webpack_require__(160),
	  takeLastWhile: __webpack_require__(394),
	  takeWhile: __webpack_require__(395),
	  tap: __webpack_require__(396),
	  test: __webpack_require__(397),
	  times: __webpack_require__(161),
	  toLower: __webpack_require__(398),
	  toPairs: __webpack_require__(399),
	  toPairsIn: __webpack_require__(400),
	  toString: __webpack_require__(42),
	  toUpper: __webpack_require__(401),
	  transduce: __webpack_require__(402),
	  transpose: __webpack_require__(403),
	  traverse: __webpack_require__(404),
	  trim: __webpack_require__(405),
	  tryCatch: __webpack_require__(406),
	  type: __webpack_require__(87),
	  unapply: __webpack_require__(407),
	  unary: __webpack_require__(408),
	  uncurryN: __webpack_require__(409),
	  unfold: __webpack_require__(410),
	  union: __webpack_require__(411),
	  unionWith: __webpack_require__(412),
	  uniq: __webpack_require__(88),
	  uniqBy: __webpack_require__(162),
	  uniqWith: __webpack_require__(89),
	  unless: __webpack_require__(413),
	  unnest: __webpack_require__(414),
	  until: __webpack_require__(415),
	  update: __webpack_require__(90),
	  useWith: __webpack_require__(163),
	  values: __webpack_require__(164),
	  valuesIn: __webpack_require__(416),
	  view: __webpack_require__(417),
	  when: __webpack_require__(418),
	  where: __webpack_require__(165),
	  whereEq: __webpack_require__(419),
	  without: __webpack_require__(420),
	  xprod: __webpack_require__(421),
	  zip: __webpack_require__(422),
	  zipObj: __webpack_require__(423),
	  zipWith: __webpack_require__(424)
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(21);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(54);
	var curryN = __webpack_require__(9);
	var toString = __webpack_require__(42);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @see R.construct
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isString = __webpack_require__(37);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var map = __webpack_require__(13);
	var prop = __webpack_require__(84);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * `pluck` will work on
	 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
	 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => k -> f {k: v} -> f v
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} f The array or functor to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _toString = __webpack_require__(303);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLError = GraphQLError;
	
	var _location = __webpack_require__(105);
	
	/**
	 * A GraphQLError describes an Error found during the parse, validate, or
	 * execute phases of performing a GraphQL operation. In addition to a message
	 * and stack trace, it also includes information about the locations in a
	 * GraphQL document and/or execution result that correspond to the Error.
	 */
	function GraphQLError( // eslint-disable-line no-redeclare
	message, nodes, source, positions, path, originalError) {
	  // Compute locations in the source for the given nodes/positions.
	  var _source = source;
	  if (!_source && nodes && nodes.length > 0) {
	    var node = nodes[0];
	    _source = node && node.loc && node.loc.source;
	  }
	
	  var _positions = positions;
	  if (!_positions && nodes) {
	    _positions = nodes.filter(function (node) {
	      return Boolean(node.loc);
	    }).map(function (node) {
	      return node.loc.start;
	    });
	  }
	  if (_positions && _positions.length === 0) {
	    _positions = undefined;
	  }
	
	  var _locations = void 0;
	  var _source2 = _source; // seems here Flow need a const to resolve type.
	  if (_source2 && _positions) {
	    _locations = _positions.map(function (pos) {
	      return (0, _location.getLocation)(_source2, pos);
	    });
	  }
	
	  Object.defineProperties(this, {
	    message: {
	      value: message,
	      // By being enumerable, JSON.stringify will include `message` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: true,
	      writable: true
	    },
	    locations: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _locations || undefined,
	      // By being enumerable, JSON.stringify will include `locations` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: true
	    },
	    path: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: path || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: true
	    },
	    nodes: {
	      value: nodes || undefined
	    },
	    source: {
	      value: _source || undefined
	    },
	    positions: {
	      value: _positions || undefined
	    },
	    originalError: {
	      value: originalError
	    }
	  });
	
	  // Include (non-enumerable) stack trace.
	  if (originalError && originalError.stack) {
	    Object.defineProperty(this, 'stack', {
	      value: originalError.stack,
	      writable: true,
	      configurable: true
	    });
	  } else if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, GraphQLError);
	  } else {
	    Object.defineProperty(this, 'stack', {
	      value: Error().stack,
	      writable: true,
	      configurable: true
	    });
	  }
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	GraphQLError.prototype = Object.create(Error.prototype, {
	  constructor: { value: GraphQLError },
	  name: { value: 'GraphQLError' }
	});

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = find;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function find(list, predicate) {
	  for (var i = 0; i < list.length; i++) {
	    if (predicate(list[i])) {
	      return list[i];
	    }
	  }
	}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyMap;
	
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * for each value in the array.
	 *
	 * This provides a convenient lookup for the array items if the key function
	 * produces unique results.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: { name: 'Jon', num: '555-1234' },
	 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
	 *     const entriesByName = keyMap(
	 *       phoneBook,
	 *       entry => entry.name
	 *     )
	 *
	 *     // { name: 'Jenny', num: '857-6309' }
	 *     const jennyEntry = entriesByName['Jenny']
	 *
	 */
	function keyMap(list, keyFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = item, map;
	  }, Object.create(null));
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016, Lee Byron
	 * All rights reserved.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @ignore
	 */
	
	/**
	 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
	 * is a *protocol* which describes a standard way to produce a sequence of
	 * values, typically the values of the Iterable represented by this Iterator.
	 *
	 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} Iterator
	 * @template T The type of each iterated value
	 * @property {function (): { value: T, done: boolean }} next
	 *   A method which produces either the next value in a sequence or a result
	 *   where the `done` property is `true` indicating the end of the Iterator.
	 */
	
	/**
	 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	 * is a *protocol* which when implemented allows a JavaScript object to define
	 * their iteration behavior, such as what values are looped over in a `for..of`
	 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
	 * implement the Iterable protocol, including `Array` and `Map`.
	 *
	 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} Iterable
	 * @template T The type of each iterated value
	 * @property {function (): Iterator<T>} Symbol.iterator
	 *   A method which produces an Iterator for this Iterable.
	 */
	
	// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
	var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator
	
	/**
	 * A property name to be used as the name of an Iterable's method responsible
	 * for producing an Iterator, referred to as `@@iterator`. Typically represents
	 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
	 * `Symbol.iterator` is not defined.
	 *
	 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
	 * but do not use it for accessing existing Iterables, instead use
	 * `getIterator()` or `isIterable()`.
	 *
	 * @example
	 *
	 * var $$iterator = require('iterall').$$iterator
	 *
	 * function Counter (to) {
	 *   this.to = to
	 * }
	 *
	 * Counter.prototype[$$iterator] = function () {
	 *   return {
	 *     to: this.to,
	 *     num: 0,
	 *     next () {
	 *       if (this.num >= this.to) {
	 *         return { value: undefined, done: true }
	 *       }
	 *       return { value: this.num++, done: false }
	 *     }
	 *   }
	 * }
	 *
	 * var counter = new Counter(3)
	 * for (var number of counter) {
	 *   console.log(number) // 0 ... 1 ... 2
	 * }
	 *
	 * @type {Symbol|string}
	 */
	var $$iterator = SYMBOL_ITERATOR || '@@iterator'
	exports.$$iterator = $$iterator
	
	/**
	 * Returns true if the provided object implements the Iterator protocol via
	 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
	 *
	 * @example
	 *
	 * var isIterable = require('iterall').isIterable
	 * isIterable([ 1, 2, 3 ]) // true
	 * isIterable('ABC') // true
	 * isIterable({ length: 1, 0: 'Alpha' }) // false
	 * isIterable({ key: 'value' }) // false
	 * isIterable(new Map()) // true
	 *
	 * @param obj
	 *   A value which might implement the Iterable protocol.
	 * @return {boolean} true if Iterable.
	 */
	function isIterable(obj) {
	  return !!getIteratorMethod(obj)
	}
	exports.isIterable = isIterable
	
	/**
	 * Returns true if the provided object implements the Array-like protocol via
	 * defining a positive-integer `length` property.
	 *
	 * @example
	 *
	 * var isArrayLike = require('iterall').isArrayLike
	 * isArrayLike([ 1, 2, 3 ]) // true
	 * isArrayLike('ABC') // true
	 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
	 * isArrayLike({ key: 'value' }) // false
	 * isArrayLike(new Map()) // false
	 *
	 * @param obj
	 *   A value which might implement the Array-like protocol.
	 * @return {boolean} true if Array-like.
	 */
	function isArrayLike(obj) {
	  var length = obj != null && obj.length
	  return typeof length === 'number' && length >= 0 && length % 1 === 0
	}
	exports.isArrayLike = isArrayLike
	
	/**
	 * Returns true if the provided object is an Object (i.e. not a string literal)
	 * and is either Iterable or Array-like.
	 *
	 * This may be used in place of [Array.isArray()][isArray] to determine if an
	 * object should be iterated-over. It always excludes string literals and
	 * includes Arrays (regardless of if it is Iterable). It also includes other
	 * Array-like objects such as NodeList, TypedArray, and Buffer.
	 *
	 * @example
	 *
	 * var isCollection = require('iterall').isCollection
	 * isCollection([ 1, 2, 3 ]) // true
	 * isCollection('ABC') // false
	 * isCollection({ length: 1, 0: 'Alpha' }) // true
	 * isCollection({ key: 'value' }) // false
	 * isCollection(new Map()) // true
	 *
	 * @example
	 *
	 * var forEach = require('iterall').forEach
	 * if (isCollection(obj)) {
	 *   forEach(obj, function (value) {
	 *     console.log(value)
	 *   })
	 * }
	 *
	 * @param obj
	 *   An Object value which might implement the Iterable or Array-like protocols.
	 * @return {boolean} true if Iterable or Array-like Object.
	 */
	function isCollection(obj) {
	  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
	}
	exports.isCollection = isCollection
	
	/**
	 * If the provided object implements the Iterator protocol, its Iterator object
	 * is returned. Otherwise returns undefined.
	 *
	 * @example
	 *
	 * var getIterator = require('iterall').getIterator
	 * var iterator = getIterator([ 1, 2, 3 ])
	 * iterator.next() // { value: 1, done: false }
	 * iterator.next() // { value: 2, done: false }
	 * iterator.next() // { value: 3, done: false }
	 * iterator.next() // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>} iterable
	 *   An Iterable object which is the source of an Iterator.
	 * @return {Iterator<T>} new Iterator instance.
	 */
	function getIterator(iterable) {
	  var method = getIteratorMethod(iterable)
	  if (method) {
	    return method.call(iterable)
	  }
	}
	exports.getIterator = getIterator
	
	/**
	 * If the provided object implements the Iterator protocol, the method
	 * responsible for producing its Iterator object is returned.
	 *
	 * This is used in rare cases for performance tuning. This method must be called
	 * with obj as the contextual this-argument.
	 *
	 * @example
	 *
	 * var getIteratorMethod = require('iterall').getIteratorMethod
	 * var myArray = [ 1, 2, 3 ]
	 * var method = getIteratorMethod(myArray)
	 * if (method) {
	 *   var iterator = method.call(myArray)
	 * }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>} iterable
	 *   An Iterable object which defines an `@@iterator` method.
	 * @return {function(): Iterator<T>} `@@iterator` method.
	 */
	function getIteratorMethod(iterable) {
	  if (iterable != null) {
	    var method =
	      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
	    if (typeof method === 'function') {
	      return method
	    }
	  }
	}
	exports.getIteratorMethod = getIteratorMethod
	
	/**
	 * Similar to `getIterator()`, this method returns a new Iterator given an
	 * Iterable. However it will also create an Iterator for a non-Iterable
	 * Array-like collection, such as Array in a non-ES2015 environment.
	 *
	 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
	 * iteration as opposed to `forEach`'s "push"-based iteration.
	 *
	 * `createIterator` produces an Iterator for Array-likes with the same behavior
	 * as ArrayIteratorPrototype described in the ECMAScript specification, and
	 * does *not* skip over "holes".
	 *
	 * @example
	 *
	 * var createIterator = require('iterall').createIterator
	 *
	 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
	 * var iterator = createIterator(myArraylike)
	 * iterator.next() // { value: 'Alpha', done: false }
	 * iterator.next() // { value: 'Bravo', done: false }
	 * iterator.next() // { value: 'Charlie', done: false }
	 * iterator.next() // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>|{ length: number }} collection
	 *   An Iterable or Array-like object to produce an Iterator.
	 * @return {Iterator<T>} new Iterator instance.
	 */
	function createIterator(collection) {
	  if (collection != null) {
	    var iterator = getIterator(collection)
	    if (iterator) {
	      return iterator
	    }
	    if (isArrayLike(collection)) {
	      return new ArrayLikeIterator(collection)
	    }
	  }
	}
	exports.createIterator = createIterator
	
	// When the object provided to `createIterator` is not Iterable but is
	// Array-like, this simple Iterator is created.
	function ArrayLikeIterator(obj) {
	  this._o = obj
	  this._i = 0
	}
	
	// Note: all Iterators are themselves Iterable.
	ArrayLikeIterator.prototype[$$iterator] = function() {
	  return this
	}
	
	// A simple state-machine determines the IteratorResult returned, yielding
	// each value in the Array-like object in order of their indicies.
	ArrayLikeIterator.prototype.next = function() {
	  if (this._o === void 0 || this._i >= this._o.length) {
	    this._o = void 0
	    return { value: void 0, done: true }
	  }
	  return { value: this._o[this._i++], done: false }
	}
	
	/**
	 * Given an object which either implements the Iterable protocol or is
	 * Array-like, iterate over it, calling the `callback` at each iteration.
	 *
	 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
	 * However `forEach` adheres to the behavior of [Array#forEach][] described in
	 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
	 * also delegate to a `forEach` method on `collection` if one is defined,
	 * ensuring native performance for `Arrays`.
	 *
	 * Similar to [Array#forEach][], the `callback` function accepts three
	 * arguments, and is provided with `thisArg` as the calling context.
	 *
	 * Note: providing an infinite Iterator to forEach will produce an error.
	 *
	 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	 *
	 * @example
	 *
	 * var forEach = require('iterall').forEach
	 *
	 * forEach(myIterable, function (value, index, iterable) {
	 *   console.log(value, index, iterable === myIterable)
	 * })
	 *
	 * @example
	 *
	 * // ES6:
	 * for (let value of myIterable) {
	 *   console.log(value)
	 * }
	 *
	 * // Any JavaScript environment:
	 * forEach(myIterable, function (value) {
	 *   console.log(value)
	 * })
	 *
	 * @template T the type of each iterated value
	 * @param {Iterable<T>|{ length: number }} collection
	 *   The Iterable or array to iterate over.
	 * @param {function(T, number, object)} callback
	 *   Function to execute for each iteration, taking up to three arguments
	 * @param [thisArg]
	 *   Optional. Value to use as `this` when executing `callback`.
	 */
	function forEach(collection, callback, thisArg) {
	  if (collection != null) {
	    if (typeof collection.forEach === 'function') {
	      return collection.forEach(callback, thisArg)
	    }
	    var i = 0
	    var iterator = getIterator(collection)
	    if (iterator) {
	      var step
	      while (!(step = iterator.next()).done) {
	        callback.call(thisArg, step.value, i++, collection)
	        // Infinite Iterators could cause forEach to run forever.
	        // After a very large number of iterations, produce an error.
	        /* istanbul ignore if */
	        if (i > 9999999) {
	          throw new TypeError('Near-infinite iteration.')
	        }
	      }
	    } else if (isArrayLike(collection)) {
	      for (; i < collection.length; i++) {
	        if (collection.hasOwnProperty(i)) {
	          callback.call(thisArg, collection[i], i, collection)
	        }
	      }
	    }
	  }
	}
	exports.forEach = forEach
	
	/////////////////////////////////////////////////////
	//                                                 //
	//                 ASYNC ITERATORS                 //
	//                                                 //
	/////////////////////////////////////////////////////
	
	/**
	 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/)
	 * is a *protocol* which describes a standard way to produce and consume an
	 * asynchronous sequence of values, typically the values of the AsyncIterable
	 * represented by this AsyncIterator.
	 *
	 * AsyncIterator is similar to Observable or Stream.
	 *
	 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} AsyncIterator
	 * @template T The type of each iterated value
	 * @property {function (): Promise<{ value: T, done: boolean }>} next
	 *   A method which produces a Promise which resolves to either the next value
	 *   in a sequence or a result where the `done` property is `true` indicating
	 *   the end of the sequence of values. It may also produce a Promise which
	 *   becomes rejected, indicating a failure.
	 */
	
	/**
	 * AsyncIterable is a *protocol* which when implemented allows a JavaScript
	 * object to define their asynchronous iteration behavior, such as what values
	 * are looped over in a `for-await-of` loop or `iterall`'s `forAwaitEach`
	 * function.
	 *
	 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
	 * it can be utilized by any version of JavaScript.
	 *
	 * @typedef {Object} AsyncIterable
	 * @template T The type of each iterated value
	 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
	 *   A method which produces an AsyncIterator for this AsyncIterable.
	 */
	
	// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
	var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator
	
	/**
	 * A property name to be used as the name of an AsyncIterable's method
	 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
	 * Typically represents the value `Symbol.asyncIterator` but falls back to the
	 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
	 *
	 * Use `$$asyncIterator` for defining new AsyncIterables instead of
	 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
	 * instead use `getAsyncIterator()` or `isAsyncIterable()`.
	 *
	 * @example
	 *
	 * var $$asyncIterator = require('iterall').$$asyncIterator
	 *
	 * function Chirper (to) {
	 *   this.to = to
	 * }
	 *
	 * Chirper.prototype[$$asyncIterator] = function () {
	 *   return {
	 *     to: this.to,
	 *     num: 0,
	 *     next () {
	 *       return new Promise(function (resolve) {
	 *         if (this.num >= this.to) {
	 *           resolve({ value: undefined, done: true })
	 *         } else {
	 *           setTimeout(function () {
	 *             resolve({ value: this.num++, done: false })
	 *           }, 1000)
	 *         }
	 *       }
	 *     }
	 *   }
	 * }
	 *
	 * var chirper = new Chirper(3)
	 * for await (var number of chirper) {
	 *   console.log(number) // 0 ...wait... 1 ...wait... 2
	 * }
	 *
	 * @type {Symbol|string}
	 */
	var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'
	exports.$$asyncIterator = $$asyncIterator
	
	/**
	 * Returns true if the provided object implements the AsyncIterator protocol via
	 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
	 *
	 * @example
	 *
	 * var isAsyncIterable = require('iterall').isAsyncIterable
	 * isAsyncIterable(myStream) // true
	 * isAsyncIterable('ABC') // false
	 *
	 * @param obj
	 *   A value which might implement the AsyncIterable protocol.
	 * @return {boolean} true if AsyncIterable.
	 */
	function isAsyncIterable(obj) {
	  return !!getAsyncIteratorMethod(obj)
	}
	exports.isAsyncIterable = isAsyncIterable
	
	/**
	 * If the provided object implements the AsyncIterator protocol, its
	 * AsyncIterator object is returned. Otherwise returns undefined.
	 *
	 * @example
	 *
	 * var getAsyncIterator = require('iterall').getAsyncIterator
	 * var asyncIterator = getAsyncIterator(myStream)
	 * asyncIterator.next().then(console.log) // { value: 1, done: false }
	 * asyncIterator.next().then(console.log) // { value: 2, done: false }
	 * asyncIterator.next().then(console.log) // { value: 3, done: false }
	 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {AsyncIterable<T>} asyncIterable
	 *   An AsyncIterable object which is the source of an AsyncIterator.
	 * @return {AsyncIterator<T>} new AsyncIterator instance.
	 */
	function getAsyncIterator(asyncIterable) {
	  var method = getAsyncIteratorMethod(asyncIterable)
	  if (method) {
	    return method.call(asyncIterable)
	  }
	}
	exports.getAsyncIterator = getAsyncIterator
	
	/**
	 * If the provided object implements the AsyncIterator protocol, the method
	 * responsible for producing its AsyncIterator object is returned.
	 *
	 * This is used in rare cases for performance tuning. This method must be called
	 * with obj as the contextual this-argument.
	 *
	 * @example
	 *
	 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
	 * var method = getAsyncIteratorMethod(myStream)
	 * if (method) {
	 *   var asyncIterator = method.call(myStream)
	 * }
	 *
	 * @template T the type of each iterated value
	 * @param {AsyncIterable<T>} asyncIterable
	 *   An AsyncIterable object which defines an `@@asyncIterator` method.
	 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
	 */
	function getAsyncIteratorMethod(asyncIterable) {
	  if (asyncIterable != null) {
	    var method =
	      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
	      asyncIterable['@@asyncIterator']
	    if (typeof method === 'function') {
	      return method
	    }
	  }
	}
	exports.getAsyncIteratorMethod = getAsyncIteratorMethod
	
	/**
	 * Similar to `getAsyncIterator()`, this method returns a new AsyncIterator
	 * given an AsyncIterable. However it will also create an AsyncIterator for a
	 * non-async Iterable as well as non-Iterable Array-like collection, such as
	 * Array in a pre-ES2015 environment.
	 *
	 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
	 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
	 * "push"-based iteration.
	 *
	 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
	 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
	 *
	 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
	 * > While `Promise` has been available in modern browsers for a number of
	 * > years, legacy browsers (like IE 11) may require a polyfill.
	 *
	 * @example
	 *
	 * var createAsyncIterator = require('iterall').createAsyncIterator
	 *
	 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
	 * var iterator = createAsyncIterator(myArraylike)
	 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
	 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
	 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
	 * iterator.next().then(console.log) // { value: undefined, done: true }
	 *
	 * @template T the type of each iterated value
	 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
	 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
	 * @return {AsyncIterator<T>} new AsyncIterator instance.
	 */
	function createAsyncIterator(source) {
	  if (source != null) {
	    var asyncIterator = getAsyncIterator(source)
	    if (asyncIterator) {
	      return asyncIterator
	    }
	    var iterator = createIterator(source)
	    if (iterator) {
	      return new AsyncFromSyncIterator(iterator)
	    }
	  }
	}
	exports.createAsyncIterator = createAsyncIterator
	
	// When the object provided to `createAsyncIterator` is not AsyncIterable but is
	// sync Iterable, this simple wrapper is created.
	function AsyncFromSyncIterator(iterator) {
	  this._i = iterator
	}
	
	// Note: all AsyncIterators are themselves AsyncIterable.
	AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
	  return this
	}
	
	// A simple state-machine determines the IteratorResult returned, yielding
	// each value in the Array-like object in order of their indicies.
	AsyncFromSyncIterator.prototype.next = function() {
	  var step = this._i.next()
	  return Promise.resolve(step.value).then(function(value) {
	    return { value: value, done: step.done }
	  })
	}
	
	/**
	 * Given an object which either implements the AsyncIterable protocol or is
	 * Array-like, iterate over it, calling the `callback` at each iteration.
	 *
	 * Use `forAwaitEach` where you would expect to use a `for-await-of` loop.
	 *
	 * Similar to [Array#forEach][], the `callback` function accepts three
	 * arguments, and is provided with `thisArg` as the calling context.
	 *
	 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
	 * > While `Promise` has been available in modern browsers for a number of
	 * > years, legacy browsers (like IE 11) may require a polyfill.
	 *
	 * @example
	 *
	 * var forAwaitEach = require('iterall').forAwaitEach
	 *
	 * forAwaitEach(myIterable, function (value, index, iterable) {
	 *   console.log(value, index, iterable === myIterable)
	 * })
	 *
	 * @example
	 *
	 * // ES2017:
	 * for await (let value of myAsyncIterable) {
	 *   console.log(await doSomethingAsync(value))
	 * }
	 * console.log('done')
	 *
	 * // Any JavaScript environment:
	 * forAwaitEach(myAsyncIterable, function (value) {
	 *   return doSomethingAsync(value).then(console.log)
	 * }).then(function () {
	 *   console.log('done')
	 * })
	 *
	 * @template T the type of each iterated value
	 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
	 *   The AsyncIterable or array to iterate over.
	 * @param {function(T, number, object)} callback
	 *   Function to execute for each iteration, taking up to three arguments
	 * @param [thisArg]
	 *   Optional. Value to use as `this` when executing `callback`.
	 */
	function forAwaitEach(source, callback, thisArg) {
	  var asyncIterator = createAsyncIterator(source)
	  if (asyncIterator) {
	    var i = 0
	    return new Promise(function(resolve, reject) {
	      function next() {
	        return asyncIterator
	          .next()
	          .then(function(step) {
	            if (!step.done) {
	              Promise.resolve(callback.call(thisArg, step.value, i++, source))
	                .then(next)
	                .catch(reject)
	            } else {
	              resolve()
	            }
	          })
	          .catch(reject)
	      }
	      next()
	    })
	  }
	}
	exports.forAwaitEach = forAwaitEach


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curry = __webpack_require__(49);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _isPlaceholder = __webpack_require__(55);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isArray = __webpack_require__(21);
	var _isString = __webpack_require__(37);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var map = __webpack_require__(13);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var liftN = __webpack_require__(144);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var _isObject = __webpack_require__(81);
	var mergeWithKey = __webpack_require__(83);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to the key and associated values
	 *   using the resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeDeepWithKey(concatValues,
	 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
	 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
	 */
	module.exports = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
	  return mergeWithKey(function(k, lVal, rVal) {
	    if (_isObject(lVal) && _isObject(rVal)) {
	      return mergeDeepWithKey(fn, lVal, rVal);
	    } else {
	      return fn(k, lVal, rVal);
	    }
	  }, lObj, rObj);
	});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @see R.binary, R.unary
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(52);
	var _dispatchable = __webpack_require__(7);
	var _has = __webpack_require__(12);
	var _reduce = __webpack_require__(15);
	var _xreduceBy = __webpack_require__(317);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general [`groupBy`](#groupBy) function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(130);
	var _curry2 = __webpack_require__(1);
	var filter = __webpack_require__(75);
	
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isString = __webpack_require__(37);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInvalid;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	/**
	 * Returns true if a value is undefined, or NaN.
	 */
	function isInvalid(value) {
	  return value === undefined || value !== value;
	}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visit = visit;
	exports.visitInParallel = visitInParallel;
	exports.visitWithTypeInfo = visitWithTypeInfo;
	exports.getVisitFn = getVisitFn;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var QueryDocumentKeys = exports.QueryDocumentKeys = {
	  Name: [],
	
	  Document: ['definitions'],
	  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
	  VariableDefinition: ['variable', 'type', 'defaultValue'],
	  Variable: ['name'],
	  SelectionSet: ['selections'],
	  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
	  Argument: ['name', 'value'],
	
	  FragmentSpread: ['name', 'directives'],
	  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
	  FragmentDefinition: ['name', 'typeCondition', 'directives', 'selectionSet'],
	
	  IntValue: [],
	  FloatValue: [],
	  StringValue: [],
	  BooleanValue: [],
	  NullValue: [],
	  EnumValue: [],
	  ListValue: ['values'],
	  ObjectValue: ['fields'],
	  ObjectField: ['name', 'value'],
	
	  Directive: ['name', 'arguments'],
	
	  NamedType: ['name'],
	  ListType: ['type'],
	  NonNullType: ['type'],
	
	  SchemaDefinition: ['directives', 'operationTypes'],
	  OperationTypeDefinition: ['type'],
	
	  ScalarTypeDefinition: ['name', 'directives'],
	  ObjectTypeDefinition: ['name', 'interfaces', 'directives', 'fields'],
	  FieldDefinition: ['name', 'arguments', 'type', 'directives'],
	  InputValueDefinition: ['name', 'type', 'defaultValue', 'directives'],
	  InterfaceTypeDefinition: ['name', 'directives', 'fields'],
	  UnionTypeDefinition: ['name', 'directives', 'types'],
	  EnumTypeDefinition: ['name', 'directives', 'values'],
	  EnumValueDefinition: ['name', 'directives'],
	  InputObjectTypeDefinition: ['name', 'directives', 'fields'],
	
	  TypeExtensionDefinition: ['definition'],
	
	  DirectiveDefinition: ['name', 'arguments', 'locations']
	};
	
	var BREAK = exports.BREAK = {};
	
	/**
	 * visit() will walk through an AST using a depth first traversal, calling
	 * the visitor's enter function at each node in the traversal, and calling the
	 * leave function after visiting that node and all of its child nodes.
	 *
	 * By returning different values from the enter and leave functions, the
	 * behavior of the visitor can be altered, including skipping over a sub-tree of
	 * the AST (by returning false), editing the AST by returning a value or null
	 * to remove the value, or to stop the whole traversal by returning BREAK.
	 *
	 * When using visit() to edit an AST, the original AST will not be modified, and
	 * a new version of the AST with the changes applied will be returned from the
	 * visit function.
	 *
	 *     const editedAST = visit(ast, {
	 *       enter(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: skip visiting this node
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       },
	 *       leave(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: no action
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       }
	 *     });
	 *
	 * Alternatively to providing enter() and leave() functions, a visitor can
	 * instead provide functions named the same as the kinds of AST nodes, or
	 * enter/leave visitors at a named key, leading to four permutations of
	 * visitor API:
	 *
	 * 1) Named visitors triggered when entering a node a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind(node) {
	 *         // enter the "Kind" node
	 *       }
	 *     })
	 *
	 * 2) Named visitors that trigger upon entering and leaving a node of
	 *    a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind: {
	 *         enter(node) {
	 *           // enter the "Kind" node
	 *         }
	 *         leave(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 *
	 * 3) Generic visitors that trigger upon entering and leaving any node.
	 *
	 *     visit(ast, {
	 *       enter(node) {
	 *         // enter any node
	 *       },
	 *       leave(node) {
	 *         // leave any node
	 *       }
	 *     })
	 *
	 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
	 *
	 *     visit(ast, {
	 *       enter: {
	 *         Kind(node) {
	 *           // enter the "Kind" node
	 *         }
	 *       },
	 *       leave: {
	 *         Kind(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 */
	function visit(root, visitor, keyMap) {
	  var visitorKeys = keyMap || QueryDocumentKeys;
	
	  var stack = void 0;
	  var inArray = Array.isArray(root);
	  var keys = [root];
	  var index = -1;
	  var edits = [];
	  var parent = void 0;
	  var path = [];
	  var ancestors = [];
	  var newRoot = root;
	
	  do {
	    index++;
	    var isLeaving = index === keys.length;
	    var key = void 0;
	    var node = void 0;
	    var isEdited = isLeaving && edits.length !== 0;
	    if (isLeaving) {
	      key = ancestors.length === 0 ? undefined : path.pop();
	      node = parent;
	      parent = ancestors.pop();
	      if (isEdited) {
	        if (inArray) {
	          node = node.slice();
	        } else {
	          var clone = {};
	          for (var k in node) {
	            if (node.hasOwnProperty(k)) {
	              clone[k] = node[k];
	            }
	          }
	          node = clone;
	        }
	        var editOffset = 0;
	        for (var ii = 0; ii < edits.length; ii++) {
	          var editKey = edits[ii][0];
	          var editValue = edits[ii][1];
	          if (inArray) {
	            editKey -= editOffset;
	          }
	          if (inArray && editValue === null) {
	            node.splice(editKey, 1);
	            editOffset++;
	          } else {
	            node[editKey] = editValue;
	          }
	        }
	      }
	      index = stack.index;
	      keys = stack.keys;
	      edits = stack.edits;
	      inArray = stack.inArray;
	      stack = stack.prev;
	    } else {
	      key = parent ? inArray ? index : keys[index] : undefined;
	      node = parent ? parent[key] : newRoot;
	      if (node === null || node === undefined) {
	        continue;
	      }
	      if (parent) {
	        path.push(key);
	      }
	    }
	
	    var result = void 0;
	    if (!Array.isArray(node)) {
	      if (!isNode(node)) {
	        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
	      }
	      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
	      if (visitFn) {
	        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
	        if (result === BREAK) {
	          break;
	        }
	
	        if (result === false) {
	          if (!isLeaving) {
	            path.pop();
	            continue;
	          }
	        } else if (result !== undefined) {
	          edits.push([key, result]);
	          if (!isLeaving) {
	            if (isNode(result)) {
	              node = result;
	            } else {
	              path.pop();
	              continue;
	            }
	          }
	        }
	      }
	    }
	
	    if (result === undefined && isEdited) {
	      edits.push([key, node]);
	    }
	
	    if (!isLeaving) {
	      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
	      inArray = Array.isArray(node);
	      keys = inArray ? node : visitorKeys[node.kind] || [];
	      index = -1;
	      edits = [];
	      if (parent) {
	        ancestors.push(parent);
	      }
	      parent = node;
	    }
	  } while (stack !== undefined);
	
	  if (edits.length !== 0) {
	    newRoot = edits[edits.length - 1][1];
	  }
	
	  return newRoot;
	}
	
	function isNode(maybeNode) {
	  return maybeNode && typeof maybeNode.kind === 'string';
	}
	
	/**
	 * Creates a new visitor instance which delegates to many visitors to run in
	 * parallel. Each visitor will be visited for each node before moving on.
	 *
	 * If a prior visitor edits a node, no following visitors will see that node.
	 */
	function visitInParallel(visitors) {
	  var skipping = new Array(visitors.length);
	
	  return {
	    enter: function enter(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	            if (result === false) {
	              skipping[i] = node;
	            } else if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined) {
	              return result;
	            }
	          }
	        }
	      }
	    },
	    leave: function leave(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	            if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined && result !== false) {
	              return result;
	            }
	          }
	        } else if (skipping[i] === node) {
	          skipping[i] = null;
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Creates a new visitor instance which maintains a provided TypeInfo instance
	 * along with visiting visitor.
	 */
	function visitWithTypeInfo(typeInfo, visitor) {
	  return {
	    enter: function enter(node) {
	      typeInfo.enter(node);
	      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
	      if (fn) {
	        var result = fn.apply(visitor, arguments);
	        if (result !== undefined) {
	          typeInfo.leave(node);
	          if (isNode(result)) {
	            typeInfo.enter(result);
	          }
	        }
	        return result;
	      }
	    },
	    leave: function leave(node) {
	      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
	      var result = void 0;
	      if (fn) {
	        result = fn.apply(visitor, arguments);
	      }
	      typeInfo.leave(node);
	      return result;
	    }
	  };
	}
	
	/**
	 * Given a visitor instance, if it is leaving or not, and a node kind, return
	 * the function the visitor runtime should call.
	 */
	function getVisitFn(visitor, kind, isLeaving) {
	  var kindVisitor = visitor[kind];
	  if (kindVisitor) {
	    if (!isLeaving && typeof kindVisitor === 'function') {
	      // { Kind() {} }
	      return kindVisitor;
	    }
	    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
	    if (typeof kindSpecificVisitor === 'function') {
	      // { Kind: { enter() {}, leave() {} } }
	      return kindSpecificVisitor;
	    }
	  } else {
	    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
	    if (specificVisitor) {
	      if (typeof specificVisitor === 'function') {
	        // { enter() {}, leave() {} }
	        return specificVisitor;
	      }
	      var specificKindVisitor = specificVisitor[kind];
	      if (typeof specificKindVisitor === 'function') {
	        // { enter: { Kind() {} }, leave: { Kind() {} } }
	        return specificKindVisitor;
	      }
	    }
	  }
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.valueFromAST = valueFromAST;
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__(66);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a JavaScript value given a GraphQL Value AST.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * GraphQL Value literals.
	 *
	 * Returns `undefined` when the value could not be validly coerced according to
	 * the provided type.
	 *
	 * | GraphQL Value        | JSON Value    |
	 * | -------------------- | ------------- |
	 * | Input Object         | Object        |
	 * | List                 | Array         |
	 * | Boolean              | Boolean       |
	 * | String               | String        |
	 * | Int / Float          | Number        |
	 * | Enum Value           | Mixed         |
	 * | NullValue            | null          |
	 *
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function valueFromAST(valueNode, type, variables) {
	  if (!valueNode) {
	    // When there is no node, then there is also no value.
	    // Importantly, this is different from returning the value null.
	    return;
	  }
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (valueNode.kind === Kind.NULL) {
	      return; // Invalid: intentionally return no value.
	    }
	    return valueFromAST(valueNode, type.ofType, variables);
	  }
	
	  if (valueNode.kind === Kind.NULL) {
	    // This is explicitly returning the value null.
	    return null;
	  }
	
	  if (valueNode.kind === Kind.VARIABLE) {
	    var variableName = valueNode.name.value;
	    if (!variables || (0, _isInvalid2.default)(variables[variableName])) {
	      // No valid return value.
	      return;
	    }
	    // Note: we're not doing any checking that this variable is correct. We're
	    // assuming that this query has been validated and the variable usage here
	    // is of the correct type.
	    return variables[variableName];
	  }
	
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if (valueNode.kind === Kind.LIST) {
	      var coercedValues = [];
	      var itemNodes = valueNode.values;
	      for (var i = 0; i < itemNodes.length; i++) {
	        if (isMissingVariable(itemNodes[i], variables)) {
	          // If an array contains a missing variable, it is either coerced to
	          // null or if the item type is non-null, it considered invalid.
	          if (itemType instanceof _definition.GraphQLNonNull) {
	            return; // Invalid: intentionally return no value.
	          }
	          coercedValues.push(null);
	        } else {
	          var itemValue = valueFromAST(itemNodes[i], itemType, variables);
	          if ((0, _isInvalid2.default)(itemValue)) {
	            return; // Invalid: intentionally return no value.
	          }
	          coercedValues.push(itemValue);
	        }
	      }
	      return coercedValues;
	    }
	    var coercedValue = valueFromAST(valueNode, itemType, variables);
	    if ((0, _isInvalid2.default)(coercedValue)) {
	      return; // Invalid: intentionally return no value.
	    }
	    return [coercedValue];
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if (valueNode.kind !== Kind.OBJECT) {
	      return; // Invalid: intentionally return no value.
	    }
	    var coercedObj = Object.create(null);
	    var fields = type.getFields();
	    var fieldNodes = (0, _keyMap2.default)(valueNode.fields, function (field) {
	      return field.name.value;
	    });
	    var fieldNames = Object.keys(fields);
	    for (var _i = 0; _i < fieldNames.length; _i++) {
	      var fieldName = fieldNames[_i];
	      var field = fields[fieldName];
	      var fieldNode = fieldNodes[fieldName];
	      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
	        if (!(0, _isInvalid2.default)(field.defaultValue)) {
	          coercedObj[fieldName] = field.defaultValue;
	        } else if (field.type instanceof _definition.GraphQLNonNull) {
	          return; // Invalid: intentionally return no value.
	        }
	        continue;
	      }
	      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);
	      if ((0, _isInvalid2.default)(fieldValue)) {
	        return; // Invalid: intentionally return no value.
	      }
	      coercedObj[fieldName] = fieldValue;
	    }
	    return coercedObj;
	  }
	
	  !(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType) ? (0, _invariant2.default)(0, 'Must be input type') : void 0;
	
	  var parsed = type.parseLiteral(valueNode);
	  if ((0, _isNullish2.default)(parsed) && !type.isValidLiteral(valueNode)) {
	    // Invalid values represent a failure to parse correctly, in which case
	    // no value is returned.
	    return;
	  }
	
	  return parsed;
	}
	
	// Returns true if the provided valueNode is a variable which is not defined
	// in the set of variables.
	function isMissingVariable(valueNode, variables) {
	  return valueNode.kind === Kind.VARIABLE && (!variables || (0, _isInvalid2.default)(variables[valueNode.name.value]));
	}

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ramda = __webpack_require__(35);
	
	/**
	 * Get valid langKey in langs or return defaultLangKey
	 * @func
	 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
	 * @param {String} defaultLangKey default browser language key
	 * @returns {String} valid langKey
	 */
	var getValidLangKey = (0, _ramda.curry)(function (langs, defaultLangKey, langKey) {
	  if ((0, _ramda.isNil)(langKey)) {
	    return defaultLangKey;
	  }
	
	  var currentLangKey = (0, _ramda.filter)(function (l) {
	    return (0, _ramda.startsWith)(l, langKey);
	  }, langs);
	  return currentLangKey[0] || defaultLangKey;
	});
	
	exports.default = getValidLangKey;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(15);
	var map = __webpack_require__(13);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {*} applyF
	 * @param {*} applyX
	 * @return {*}
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applyF, applyX) {
	  return (
	    typeof applyX['fantasy-land/ap'] === 'function' ?
	      applyX['fantasy-land/ap'](applyF) :
	    typeof applyF.ap === 'function' ?
	      applyF.ap(applyX) :
	    typeof applyF === 'function' ?
	      function(x) { return applyF(x)(applyX(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, applyX)); }, [], applyF)
	  );
	});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _makeFlat = __webpack_require__(135);
	var _xchain = __webpack_require__(306);
	var map = __webpack_require__(13);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(153);
	var reverse = __webpack_require__(63);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isArray = __webpack_require__(21);
	var _isFunction = __webpack_require__(54);
	var _isString = __webpack_require__(37);
	var toString = __webpack_require__(42);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (_isArray(a)) {
	    if (_isArray(b)) {
	      return a.concat(b);
	    }
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  if (_isString(a)) {
	    if (_isString(b)) {
	      return a + b;
	    }
	    throw new TypeError(toString(b) + ' is not a string');
	  }
	  if (a != null && _isFunction(a['fantasy-land/concat'])) {
	    return a['fantasy-land/concat'](b);
	  }
	  if (a != null && _isFunction(a.concat)) {
	    return a.concat(b);
	  }
	  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
	});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _filter = __webpack_require__(78);
	var _isObject = __webpack_require__(81);
	var _reduce = __webpack_require__(15);
	var _xfilter = __webpack_require__(311);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _identity = __webpack_require__(79);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(296);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var _has = __webpack_require__(12);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(36);
	var _curry1 = __webpack_require__(2);
	var slice = __webpack_require__(26);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xtake = __webpack_require__(318);
	var slice = __webpack_require__(26);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(76);
	var uniqBy = __webpack_require__(162);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. [`R.equals`](#equals) is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(51);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var adjust = __webpack_require__(111);
	var always = __webpack_require__(30);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parse = parse;
	exports.parseValue = parseValue;
	exports.parseType = parseType;
	exports.parseConstValue = parseConstValue;
	exports.parseTypeReference = parseTypeReference;
	exports.parseNamedType = parseNamedType;
	
	var _source = __webpack_require__(186);
	
	var _error = __webpack_require__(5);
	
	var _lexer = __webpack_require__(104);
	
	var _kinds = __webpack_require__(11);
	
	/**
	 * Given a GraphQL source, parses it into a Document.
	 * Throws GraphQLError if a syntax error is encountered.
	 */
	
	
	/**
	 * Configuration options to control parser behavior
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function parse(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  if (!(sourceObj instanceof _source.Source)) {
	    throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
	  }
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  return parseDocument(lexer);
	}
	
	/**
	 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
	 * that value.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Values directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: valueFromAST().
	 */
	function parseValue(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var value = parseValueLiteral(lexer, false);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return value;
	}
	
	/**
	 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
	 * that type.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Types directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: typeFromAST().
	 */
	function parseType(source, options) {
	  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
	  expect(lexer, _lexer.TokenKind.SOF);
	  var type = parseTypeReference(lexer);
	  expect(lexer, _lexer.TokenKind.EOF);
	  return type;
	}
	
	/**
	 * Converts a name lex token into a name parse node.
	 */
	function parseName(lexer) {
	  var token = expect(lexer, _lexer.TokenKind.NAME);
	  return {
	    kind: _kinds.NAME,
	    value: token.value,
	    loc: loc(lexer, token)
	  };
	}
	
	// Implements the parsing rules in the Document section.
	
	/**
	 * Document : Definition+
	 */
	function parseDocument(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.SOF);
	  var definitions = [];
	  do {
	    definitions.push(parseDefinition(lexer));
	  } while (!skip(lexer, _lexer.TokenKind.EOF));
	
	  return {
	    kind: _kinds.DOCUMENT,
	    definitions: definitions,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Definition :
	 *   - OperationDefinition
	 *   - FragmentDefinition
	 *   - TypeSystemDefinition
	 */
	function parseDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return parseOperationDefinition(lexer);
	  }
	
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      // Note: subscription is an experimental non-spec addition.
	      case 'query':
	      case 'mutation':
	      case 'subscription':
	        return parseOperationDefinition(lexer);
	
	      case 'fragment':
	        return parseFragmentDefinition(lexer);
	
	      // Note: the Type System IDL is an experimental non-spec addition.
	      case 'schema':
	      case 'scalar':
	      case 'type':
	      case 'interface':
	      case 'union':
	      case 'enum':
	      case 'input':
	      case 'extend':
	      case 'directive':
	        return parseTypeSystemDefinition(lexer);
	    }
	  }
	
	  throw unexpected(lexer);
	}
	
	// Implements the parsing rules in the Operations section.
	
	/**
	 * OperationDefinition :
	 *  - SelectionSet
	 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
	 */
	function parseOperationDefinition(lexer) {
	  var start = lexer.token;
	  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
	    return {
	      kind: _kinds.OPERATION_DEFINITION,
	      operation: 'query',
	      name: null,
	      variableDefinitions: null,
	      directives: [],
	      selectionSet: parseSelectionSet(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	  var operation = parseOperationType(lexer);
	  var name = void 0;
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    name = parseName(lexer);
	  }
	  return {
	    kind: _kinds.OPERATION_DEFINITION,
	    operation: operation,
	    name: name,
	    variableDefinitions: parseVariableDefinitions(lexer),
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * OperationType : one of query mutation subscription
	 */
	function parseOperationType(lexer) {
	  var operationToken = expect(lexer, _lexer.TokenKind.NAME);
	  switch (operationToken.value) {
	    case 'query':
	      return 'query';
	    case 'mutation':
	      return 'mutation';
	    // Note: subscription is an experimental non-spec addition.
	    case 'subscription':
	      return 'subscription';
	  }
	
	  throw unexpected(lexer, operationToken);
	}
	
	/**
	 * VariableDefinitions : ( VariableDefinition+ )
	 */
	function parseVariableDefinitions(lexer) {
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
	}
	
	/**
	 * VariableDefinition : Variable : Type DefaultValue?
	 */
	function parseVariableDefinition(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.VARIABLE_DEFINITION,
	    variable: parseVariable(lexer),
	    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
	    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : null,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Variable : $ Name
	 */
	function parseVariable(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.DOLLAR);
	  return {
	    kind: _kinds.VARIABLE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * SelectionSet : { Selection+ }
	 */
	function parseSelectionSet(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.SELECTION_SET,
	    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Selection :
	 *   - Field
	 *   - FragmentSpread
	 *   - InlineFragment
	 */
	function parseSelection(lexer) {
	  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
	}
	
	/**
	 * Field : Alias? Name Arguments? Directives? SelectionSet?
	 *
	 * Alias : Name :
	 */
	function parseField(lexer) {
	  var start = lexer.token;
	
	  var nameOrAlias = parseName(lexer);
	  var alias = void 0;
	  var name = void 0;
	  if (skip(lexer, _lexer.TokenKind.COLON)) {
	    alias = nameOrAlias;
	    name = parseName(lexer);
	  } else {
	    alias = null;
	    name = nameOrAlias;
	  }
	
	  return {
	    kind: _kinds.FIELD,
	    alias: alias,
	    name: name,
	    arguments: parseArguments(lexer),
	    directives: parseDirectives(lexer),
	    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : null,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * Arguments : ( Argument+ )
	 */
	function parseArguments(lexer) {
	  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseArgument, _lexer.TokenKind.PAREN_R) : [];
	}
	
	/**
	 * Argument : Name : Value
	 */
	function parseArgument(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.ARGUMENT,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Fragments section.
	
	/**
	 * Corresponds to both FragmentSpread and InlineFragment in the spec.
	 *
	 * FragmentSpread : ... FragmentName Directives?
	 *
	 * InlineFragment : ... TypeCondition? Directives? SelectionSet
	 */
	function parseFragment(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.SPREAD);
	  if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
	    return {
	      kind: _kinds.FRAGMENT_SPREAD,
	      name: parseFragmentName(lexer),
	      directives: parseDirectives(lexer),
	      loc: loc(lexer, start)
	    };
	  }
	  var typeCondition = null;
	  if (lexer.token.value === 'on') {
	    lexer.advance();
	    typeCondition = parseNamedType(lexer);
	  }
	  return {
	    kind: _kinds.INLINE_FRAGMENT,
	    typeCondition: typeCondition,
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * FragmentDefinition :
	 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
	 *
	 * TypeCondition : NamedType
	 */
	function parseFragmentDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'fragment');
	  return {
	    kind: _kinds.FRAGMENT_DEFINITION,
	    name: parseFragmentName(lexer),
	    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
	    directives: parseDirectives(lexer),
	    selectionSet: parseSelectionSet(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * FragmentName : Name but not `on`
	 */
	function parseFragmentName(lexer) {
	  if (lexer.token.value === 'on') {
	    throw unexpected(lexer);
	  }
	  return parseName(lexer);
	}
	
	// Implements the parsing rules in the Values section.
	
	/**
	 * Value[Const] :
	 *   - [~Const] Variable
	 *   - IntValue
	 *   - FloatValue
	 *   - StringValue
	 *   - BooleanValue
	 *   - NullValue
	 *   - EnumValue
	 *   - ListValue[?Const]
	 *   - ObjectValue[?Const]
	 *
	 * BooleanValue : one of `true` `false`
	 *
	 * NullValue : `null`
	 *
	 * EnumValue : Name but not `true`, `false` or `null`
	 */
	function parseValueLiteral(lexer, isConst) {
	  var token = lexer.token;
	  switch (token.kind) {
	    case _lexer.TokenKind.BRACKET_L:
	      return parseList(lexer, isConst);
	    case _lexer.TokenKind.BRACE_L:
	      return parseObject(lexer, isConst);
	    case _lexer.TokenKind.INT:
	      lexer.advance();
	      return {
	        kind: _kinds.INT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.FLOAT:
	      lexer.advance();
	      return {
	        kind: _kinds.FLOAT,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.STRING:
	      lexer.advance();
	      return {
	        kind: _kinds.STRING,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.NAME:
	      if (token.value === 'true' || token.value === 'false') {
	        lexer.advance();
	        return {
	          kind: _kinds.BOOLEAN,
	          value: token.value === 'true',
	          loc: loc(lexer, token)
	        };
	      } else if (token.value === 'null') {
	        lexer.advance();
	        return {
	          kind: _kinds.NULL,
	          loc: loc(lexer, token)
	        };
	      }
	      lexer.advance();
	      return {
	        kind: _kinds.ENUM,
	        value: token.value,
	        loc: loc(lexer, token)
	      };
	    case _lexer.TokenKind.DOLLAR:
	      if (!isConst) {
	        return parseVariable(lexer);
	      }
	      break;
	  }
	  throw unexpected(lexer);
	}
	
	function parseConstValue(lexer) {
	  return parseValueLiteral(lexer, true);
	}
	
	function parseValueValue(lexer) {
	  return parseValueLiteral(lexer, false);
	}
	
	/**
	 * ListValue[Const] :
	 *   - [ ]
	 *   - [ Value[?Const]+ ]
	 */
	function parseList(lexer, isConst) {
	  var start = lexer.token;
	  var item = isConst ? parseConstValue : parseValueValue;
	  return {
	    kind: _kinds.LIST,
	    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectValue[Const] :
	 *   - { }
	 *   - { ObjectField[?Const]+ }
	 */
	function parseObject(lexer, isConst) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.BRACE_L);
	  var fields = [];
	  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
	    fields.push(parseObjectField(lexer, isConst));
	  }
	  return {
	    kind: _kinds.OBJECT,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectField[Const] : Name : Value[?Const]
	 */
	function parseObjectField(lexer, isConst) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.OBJECT_FIELD,
	    name: parseName(lexer),
	    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Directives section.
	
	/**
	 * Directives : Directive+
	 */
	function parseDirectives(lexer) {
	  var directives = [];
	  while (peek(lexer, _lexer.TokenKind.AT)) {
	    directives.push(parseDirective(lexer));
	  }
	  return directives;
	}
	
	/**
	 * Directive : @ Name Arguments?
	 */
	function parseDirective(lexer) {
	  var start = lexer.token;
	  expect(lexer, _lexer.TokenKind.AT);
	  return {
	    kind: _kinds.DIRECTIVE,
	    name: parseName(lexer),
	    arguments: parseArguments(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Types section.
	
	/**
	 * Type :
	 *   - NamedType
	 *   - ListType
	 *   - NonNullType
	 */
	function parseTypeReference(lexer) {
	  var start = lexer.token;
	  var type = void 0;
	  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
	    type = parseTypeReference(lexer);
	    expect(lexer, _lexer.TokenKind.BRACKET_R);
	    type = {
	      kind: _kinds.LIST_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  } else {
	    type = parseNamedType(lexer);
	  }
	  if (skip(lexer, _lexer.TokenKind.BANG)) {
	    return {
	      kind: _kinds.NON_NULL_TYPE,
	      type: type,
	      loc: loc(lexer, start)
	    };
	  }
	  return type;
	}
	
	/**
	 * NamedType : Name
	 */
	function parseNamedType(lexer) {
	  var start = lexer.token;
	  return {
	    kind: _kinds.NAMED_TYPE,
	    name: parseName(lexer),
	    loc: loc(lexer, start)
	  };
	}
	
	// Implements the parsing rules in the Type Definition section.
	
	/**
	 * TypeSystemDefinition :
	 *   - SchemaDefinition
	 *   - TypeDefinition
	 *   - TypeExtensionDefinition
	 *   - DirectiveDefinition
	 *
	 * TypeDefinition :
	 *   - ScalarTypeDefinition
	 *   - ObjectTypeDefinition
	 *   - InterfaceTypeDefinition
	 *   - UnionTypeDefinition
	 *   - EnumTypeDefinition
	 *   - InputObjectTypeDefinition
	 */
	function parseTypeSystemDefinition(lexer) {
	  if (peek(lexer, _lexer.TokenKind.NAME)) {
	    switch (lexer.token.value) {
	      case 'schema':
	        return parseSchemaDefinition(lexer);
	      case 'scalar':
	        return parseScalarTypeDefinition(lexer);
	      case 'type':
	        return parseObjectTypeDefinition(lexer);
	      case 'interface':
	        return parseInterfaceTypeDefinition(lexer);
	      case 'union':
	        return parseUnionTypeDefinition(lexer);
	      case 'enum':
	        return parseEnumTypeDefinition(lexer);
	      case 'input':
	        return parseInputObjectTypeDefinition(lexer);
	      case 'extend':
	        return parseTypeExtensionDefinition(lexer);
	      case 'directive':
	        return parseDirectiveDefinition(lexer);
	    }
	  }
	
	  throw unexpected(lexer);
	}
	
	/**
	 * SchemaDefinition : schema Directives? { OperationTypeDefinition+ }
	 *
	 * OperationTypeDefinition : OperationType : NamedType
	 */
	function parseSchemaDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'schema');
	  var directives = parseDirectives(lexer);
	  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.SCHEMA_DEFINITION,
	    directives: directives,
	    operationTypes: operationTypes,
	    loc: loc(lexer, start)
	  };
	}
	
	function parseOperationTypeDefinition(lexer) {
	  var start = lexer.token;
	  var operation = parseOperationType(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseNamedType(lexer);
	  return {
	    kind: _kinds.OPERATION_TYPE_DEFINITION,
	    operation: operation,
	    type: type,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ScalarTypeDefinition : scalar Name Directives?
	 */
	function parseScalarTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'scalar');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.SCALAR_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ObjectTypeDefinition :
	 *   - type Name ImplementsInterfaces? Directives? { FieldDefinition+ }
	 */
	function parseObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'type');
	  var name = parseName(lexer);
	  var interfaces = parseImplementsInterfaces(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.OBJECT_TYPE_DEFINITION,
	    name: name,
	    interfaces: interfaces,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ImplementsInterfaces : implements NamedType+
	 */
	function parseImplementsInterfaces(lexer) {
	  var types = [];
	  if (lexer.token.value === 'implements') {
	    lexer.advance();
	    do {
	      types.push(parseNamedType(lexer));
	    } while (peek(lexer, _lexer.TokenKind.NAME));
	  }
	  return types;
	}
	
	/**
	 * FieldDefinition : Name ArgumentsDefinition? : Type Directives?
	 */
	function parseFieldDefinition(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.FIELD_DEFINITION,
	    name: name,
	    arguments: args,
	    type: type,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * ArgumentsDefinition : ( InputValueDefinition+ )
	 */
	function parseArgumentDefs(lexer) {
	  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
	    return [];
	  }
	  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
	}
	
	/**
	 * InputValueDefinition : Name : Type DefaultValue? Directives?
	 */
	function parseInputValueDef(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  expect(lexer, _lexer.TokenKind.COLON);
	  var type = parseTypeReference(lexer);
	  var defaultValue = null;
	  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
	    defaultValue = parseConstValue(lexer);
	  }
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.INPUT_VALUE_DEFINITION,
	    name: name,
	    type: type,
	    defaultValue: defaultValue,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * InterfaceTypeDefinition : interface Name Directives? { FieldDefinition+ }
	 */
	function parseInterfaceTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'interface');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.INTERFACE_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * UnionTypeDefinition : union Name Directives? = UnionMembers
	 */
	function parseUnionTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'union');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  expect(lexer, _lexer.TokenKind.EQUALS);
	  var types = parseUnionMembers(lexer);
	  return {
	    kind: _kinds.UNION_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    types: types,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * UnionMembers :
	 *   - `|`? NamedType
	 *   - UnionMembers | NamedType
	 */
	function parseUnionMembers(lexer) {
	  // Optional leading pipe
	  skip(lexer, _lexer.TokenKind.PIPE);
	  var members = [];
	  do {
	    members.push(parseNamedType(lexer));
	  } while (skip(lexer, _lexer.TokenKind.PIPE));
	  return members;
	}
	
	/**
	 * EnumTypeDefinition : enum Name Directives? { EnumValueDefinition+ }
	 */
	function parseEnumTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'enum');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var values = many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.ENUM_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    values: values,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * EnumValueDefinition : EnumValue Directives?
	 *
	 * EnumValue : Name
	 */
	function parseEnumValueDefinition(lexer) {
	  var start = lexer.token;
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  return {
	    kind: _kinds.ENUM_VALUE_DEFINITION,
	    name: name,
	    directives: directives,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * InputObjectTypeDefinition : input Name Directives? { InputValueDefinition+ }
	 */
	function parseInputObjectTypeDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'input');
	  var name = parseName(lexer);
	  var directives = parseDirectives(lexer);
	  var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R);
	  return {
	    kind: _kinds.INPUT_OBJECT_TYPE_DEFINITION,
	    name: name,
	    directives: directives,
	    fields: fields,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * TypeExtensionDefinition : extend ObjectTypeDefinition
	 */
	function parseTypeExtensionDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'extend');
	  var definition = parseObjectTypeDefinition(lexer);
	  return {
	    kind: _kinds.TYPE_EXTENSION_DEFINITION,
	    definition: definition,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * DirectiveDefinition :
	 *   - directive @ Name ArgumentsDefinition? on DirectiveLocations
	 */
	function parseDirectiveDefinition(lexer) {
	  var start = lexer.token;
	  expectKeyword(lexer, 'directive');
	  expect(lexer, _lexer.TokenKind.AT);
	  var name = parseName(lexer);
	  var args = parseArgumentDefs(lexer);
	  expectKeyword(lexer, 'on');
	  var locations = parseDirectiveLocations(lexer);
	  return {
	    kind: _kinds.DIRECTIVE_DEFINITION,
	    name: name,
	    arguments: args,
	    locations: locations,
	    loc: loc(lexer, start)
	  };
	}
	
	/**
	 * DirectiveLocations :
	 *   - `|`? Name
	 *   - DirectiveLocations | Name
	 */
	function parseDirectiveLocations(lexer) {
	  // Optional leading pipe
	  skip(lexer, _lexer.TokenKind.PIPE);
	  var locations = [];
	  do {
	    locations.push(parseName(lexer));
	  } while (skip(lexer, _lexer.TokenKind.PIPE));
	  return locations;
	}
	
	// Core parsing utility functions
	
	/**
	 * Returns a location object, used to identify the place in
	 * the source that created a given parsed object.
	 */
	function loc(lexer, startToken) {
	  if (!lexer.options.noLocation) {
	    return new Loc(startToken, lexer.lastToken, lexer.source);
	  }
	}
	
	function Loc(startToken, endToken, source) {
	  this.start = startToken.start;
	  this.end = endToken.end;
	  this.startToken = startToken;
	  this.endToken = endToken;
	  this.source = source;
	}
	
	// Print a simplified form when appearing in JSON/util.inspect.
	Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
	  return { start: this.start, end: this.end };
	};
	
	/**
	 * Determines if the next token is of a given kind
	 */
	function peek(lexer, kind) {
	  return lexer.token.kind === kind;
	}
	
	/**
	 * If the next token is of the given kind, return true after advancing
	 * the lexer. Otherwise, do not change the parser state and return false.
	 */
	function skip(lexer, kind) {
	  var match = lexer.token.kind === kind;
	  if (match) {
	    lexer.advance();
	  }
	  return match;
	}
	
	/**
	 * If the next token is of the given kind, return that token after advancing
	 * the lexer. Otherwise, do not change the parser state and throw an error.
	 */
	function expect(lexer, kind) {
	  var token = lexer.token;
	  if (token.kind === kind) {
	    lexer.advance();
	    return token;
	  }
	  throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected ' + kind + ', found ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * If the next token is a keyword with the given value, return that token after
	 * advancing the lexer. Otherwise, do not change the parser state and return
	 * false.
	 */
	function expectKeyword(lexer, value) {
	  var token = lexer.token;
	  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
	    lexer.advance();
	    return token;
	  }
	  throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected "' + value + '", found ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * Helper function for creating an error when an unexpected lexed token
	 * is encountered.
	 */
	function unexpected(lexer, atToken) {
	  var token = atToken || lexer.token;
	  return (0, _error.syntaxError)(lexer.source, token.start, 'Unexpected ' + (0, _lexer.getTokenDesc)(token));
	}
	
	/**
	 * Returns a possibly empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	function any(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [];
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	  return nodes;
	}
	
	/**
	 * Returns a non-empty list of parse nodes, determined by
	 * the parseFn. This list begins with a lex token of openKind
	 * and ends with a lex token of closeKind. Advances the parser
	 * to the next lex token after the closing token.
	 */
	function many(lexer, openKind, parseFn, closeKind) {
	  expect(lexer, openKind);
	  var nodes = [parseFn(lexer)];
	  while (!skip(lexer, closeKind)) {
	    nodes.push(parseFn(lexer));
	  }
	  return nodes;
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidLiteralValue = isValidLiteralValue;
	
	var _printer = __webpack_require__(24);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__(6);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Utility for validators which determines if a value literal node is valid
	 * given an input type.
	 *
	 * Note that this only validates literal values, variables are assumed to
	 * provide values of the correct type.
	 */
	function isValidLiteralValue(type, valueNode) {
	  // A value must be provided if the type is non-null.
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (!valueNode || valueNode.kind === Kind.NULL) {
	      return ['Expected "' + String(type) + '", found null.'];
	    }
	    return isValidLiteralValue(type.ofType, valueNode);
	  }
	
	  if (!valueNode || valueNode.kind === Kind.NULL) {
	    return [];
	  }
	
	  // This function only tests literals, and assumes variables will provide
	  // values of the correct type.
	  if (valueNode.kind === Kind.VARIABLE) {
	    return [];
	  }
	
	  // Lists accept a non-list value as a list of one.
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if (valueNode.kind === Kind.LIST) {
	      return valueNode.values.reduce(function (acc, item, index) {
	        var errors = isValidLiteralValue(itemType, item);
	        return acc.concat(errors.map(function (error) {
	          return 'In element #' + index + ': ' + error;
	        }));
	      }, []);
	    }
	    return isValidLiteralValue(itemType, valueNode);
	  }
	
	  // Input objects check each defined field and look for undefined fields.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if (valueNode.kind !== Kind.OBJECT) {
	      return ['Expected "' + type.name + '", found not an object.'];
	    }
	    var fields = type.getFields();
	
	    var errors = [];
	
	    // Ensure every provided field is defined.
	    var fieldNodes = valueNode.fields;
	    fieldNodes.forEach(function (providedFieldNode) {
	      if (!fields[providedFieldNode.name.value]) {
	        errors.push('In field "' + providedFieldNode.name.value + '": Unknown field.');
	      }
	    });
	
	    // Ensure every defined field is valid.
	    var fieldNodeMap = (0, _keyMap2.default)(fieldNodes, function (fieldNode) {
	      return fieldNode.name.value;
	    });
	    Object.keys(fields).forEach(function (fieldName) {
	      var result = isValidLiteralValue(fields[fieldName].type, fieldNodeMap[fieldName] && fieldNodeMap[fieldName].value);
	      errors.push.apply(errors, result.map(function (error) {
	        return 'In field "' + fieldName + '": ' + error;
	      }));
	    });
	
	    return errors;
	  }
	
	  !(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType) ? (0, _invariant2.default)(0, 'Must be input type') : void 0;
	
	  // Scalars determine if a literal values is valid.
	  if (!type.isValidLiteral(valueNode)) {
	    return ['Expected type "' + type.name + '", found ' + (0, _printer.print)(valueNode) + '.'];
	  }
	
	  return [];
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isEqualType = isEqualType;
	exports.isTypeSubTypeOf = isTypeSubTypeOf;
	exports.doTypesOverlap = doTypesOverlap;
	
	var _definition = __webpack_require__(6);
	
	/**
	 * Provided two types, return true if the types are equal (invariant).
	 */
	function isEqualType(typeA, typeB) {
	  // Equivalent types are equal.
	  if (typeA === typeB) {
	    return true;
	  }
	
	  // If either type is non-null, the other must also be non-null.
	  if (typeA instanceof _definition.GraphQLNonNull && typeB instanceof _definition.GraphQLNonNull) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  }
	
	  // If either type is a list, the other must also be a list.
	  if (typeA instanceof _definition.GraphQLList && typeB instanceof _definition.GraphQLList) {
	    return isEqualType(typeA.ofType, typeB.ofType);
	  }
	
	  // Otherwise the types are not equal.
	  return false;
	}
	
	/**
	 * Provided a type and a super type, return true if the first type is either
	 * equal or a subset of the second super type (covariant).
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function isTypeSubTypeOf(schema, maybeSubType, superType) {
	  // Equivalent type is a valid subtype
	  if (maybeSubType === superType) {
	    return true;
	  }
	
	  // If superType is non-null, maybeSubType must also be non-null.
	  if (superType instanceof _definition.GraphQLNonNull) {
	    if (maybeSubType instanceof _definition.GraphQLNonNull) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	    return false;
	  } else if (maybeSubType instanceof _definition.GraphQLNonNull) {
	    // If superType is nullable, maybeSubType may be non-null or nullable.
	    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
	  }
	
	  // If superType type is a list, maybeSubType type must also be a list.
	  if (superType instanceof _definition.GraphQLList) {
	    if (maybeSubType instanceof _definition.GraphQLList) {
	      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
	    }
	    return false;
	  } else if (maybeSubType instanceof _definition.GraphQLList) {
	    // If superType is not a list, maybeSubType must also be not a list.
	    return false;
	  }
	
	  // If superType type is an abstract type, maybeSubType type may be a currently
	  // possible object type.
	  if ((0, _definition.isAbstractType)(superType) && maybeSubType instanceof _definition.GraphQLObjectType && schema.isPossibleType(superType, maybeSubType)) {
	    return true;
	  }
	
	  // Otherwise, the child type is not a valid subtype of the parent type.
	  return false;
	}
	
	/**
	 * Provided two composite types, determine if they "overlap". Two composite
	 * types overlap when the Sets of possible concrete types for each intersect.
	 *
	 * This is often used to determine if a fragment of a given type could possibly
	 * be visited in a context of another type.
	 *
	 * This function is commutative.
	 */
	function doTypesOverlap(schema, typeA, typeB) {
	  // So flow is aware this is constant
	  var _typeB = typeB;
	
	  // Equivalent types overlap
	  if (typeA === _typeB) {
	    return true;
	  }
	
	  if ((0, _definition.isAbstractType)(typeA)) {
	    if ((0, _definition.isAbstractType)(_typeB)) {
	      // If both types are abstract, then determine if there is any intersection
	      // between possible concrete types of each.
	      return schema.getPossibleTypes(typeA).some(function (type) {
	        return schema.isPossibleType(_typeB, type);
	      });
	    }
	    // Determine if the latter type is a possible concrete type of the former.
	    return schema.isPossibleType(typeA, _typeB);
	  }
	
	  if ((0, _definition.isAbstractType)(_typeB)) {
	    // Determine if the former type is a possible concrete type of the latter.
	    return schema.isPossibleType(_typeB, typeA);
	  }
	
	  // Otherwise the types do not overlap.
	  return false;
	}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flatten;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = {
	  angry: [">:(", ">:-("],
	  blush: [':")', ':-")'],
	  broken_heart: ["</3", "<\\3"],
	  confused: [":/", ":-/"],
	  cry: [":'(", ":'-(", ":,(", ":,-("],
	  frowning: [":(", ":-("],
	  heart: ["<3"],
	  imp: ["]:(", "]:-("],
	  innocent: ["o:)", "O:)", "o:-)", "O:-)", "0:)", "0:-)"],
	  joy: [":')", ":'-)", ":,)", ":,-)", ":'D", ":'-D", ":,D", ":,-D"],
	  kissing: [":*", ":-*"],
	  laughing: ["x-)", "X-)"],
	  neutral_face: [":|", ":-|"],
	  open_mouth: [":o", ":-o", ":O", ":-O"],
	  rage: [":@", ":-@"],
	  smile: [":D", ":-D"],
	  smiley: [":)", ":-)"],
	  smiling_imp: ["]:)", "]:-)"],
	  sob: [":,'(", ":,'-(", ";(", ";-("],
	  stuck_out_tongue: [":P", ":-P", ":p", ":-p"],
	  sunglasses: ["8-)", "B-)"],
	  sweat: [",:(", ",:-("],
	  sweat_smile: [",:)", ",:-)"],
	  unamused: [":s", ":-S", ":z", ":-Z", ":$", ":-$"],
	  wink: [";)", ";-)"]
	};


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultFieldResolver = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.execute = execute;
	exports.responsePathAsArray = responsePathAsArray;
	exports.addPath = addPath;
	exports.assertValidExecutionArguments = assertValidExecutionArguments;
	exports.buildExecutionContext = buildExecutionContext;
	exports.getOperationRootType = getOperationRootType;
	exports.collectFields = collectFields;
	exports.buildResolveInfo = buildResolveInfo;
	exports.resolveFieldValueOrError = resolveFieldValueOrError;
	exports.getFieldDef = getFieldDef;
	
	var _iterall = __webpack_require__(46);
	
	var _error = __webpack_require__(5);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _values = __webpack_require__(100);
	
	var _definition = __webpack_require__(6);
	
	var _schema = __webpack_require__(28);
	
	var _introspection = __webpack_require__(34);
	
	var _directives = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Terminology
	 *
	 * "Definitions" are the generic name for top-level statements in the document.
	 * Examples of this include:
	 * 1) Operations (such as a query)
	 * 2) Fragments
	 *
	 * "Operations" are a generic name for requests in the document.
	 * Examples of this include:
	 * 1) query,
	 * 2) mutation
	 *
	 * "Selections" are the definitions that can appear legally and at
	 * single level of the query. These include:
	 * 1) field references e.g "a"
	 * 2) fragment "spreads" e.g. "...c"
	 * 3) inline fragment "spreads" e.g. "...on Type { a }"
	 */
	
	/**
	 * Data that must be available at all points during query execution.
	 *
	 * Namely, schema of the type system that is currently executing,
	 * and the fragments defined in the query document
	 */
	
	
	/**
	 * The result of GraphQL execution.
	 *
	 *   - `errors` is included when any errors occurred as a non-empty array.
	 *   - `data` is the result of a successful execution of the query.
	 */
	
	
	/**
	 * Implements the "Evaluating requests" section of the GraphQL specification.
	 *
	 * Returns a Promise that will eventually be resolved and never rejected.
	 *
	 * If the arguments to this function do not result in a legal execution context,
	 * a GraphQLError will be thrown immediately explaining the invalid input.
	 *
	 * Accepts either an object with named arguments, or individual arguments.
	 */
	
	/* eslint-disable no-redeclare */
	function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // Extract arguments from object args if provided.
	  return arguments.length === 1 ? executeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : executeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
	}
	
	function executeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // If arguments are missing or incorrect, throw an error.
	  assertValidExecutionArguments(schema, document, variableValues);
	
	  // If a valid context cannot be created due to incorrect arguments,
	  // a "Response" with only errors is returned.
	  var context = void 0;
	  try {
	    context = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
	  } catch (error) {
	    return Promise.resolve({ errors: [error] });
	  }
	
	  // Return a Promise that will eventually resolve to the data described by
	  // The "Response" section of the GraphQL specification.
	  //
	  // If errors are encountered while executing a GraphQL field, only that
	  // field and its descendants will be omitted, and sibling fields will still
	  // be executed. An execution which encounters errors will still result in a
	  // resolved Promise.
	  return Promise.resolve(executeOperation(context, context.operation, rootValue)).then(function (data) {
	    return context.errors.length === 0 ? { data: data } : { errors: context.errors, data: data };
	  });
	}
	
	/**
	 * Given a ResponsePath (found in the `path` entry in the information provided
	 * as the last argument to a field resolver), return an Array of the path keys.
	 */
	function responsePathAsArray(path) {
	  var flattened = [];
	  var curr = path;
	  while (curr) {
	    flattened.push(curr.key);
	    curr = curr.prev;
	  }
	  return flattened.reverse();
	}
	
	/**
	 * Given a ResponsePath and a key, return a new ResponsePath containing the
	 * new key.
	 */
	function addPath(prev, key) {
	  return { prev: prev, key: key };
	}
	
	/**
	 * Essential assertions before executing to provide developer feedback for
	 * improper use of the GraphQL library.
	 */
	function assertValidExecutionArguments(schema, document, rawVariableValues) {
	  !schema ? (0, _invariant2.default)(0, 'Must provide schema') : void 0;
	  !document ? (0, _invariant2.default)(0, 'Must provide document') : void 0;
	  !(schema instanceof _schema.GraphQLSchema) ? (0, _invariant2.default)(0, 'Schema must be an instance of GraphQLSchema. Also ensure that there are ' + 'not multiple versions of GraphQL installed in your node_modules directory.') : void 0;
	
	  // Variables, if provided, must be an object.
	  !(!rawVariableValues || (typeof rawVariableValues === 'undefined' ? 'undefined' : _typeof(rawVariableValues)) === 'object') ? (0, _invariant2.default)(0, 'Variables must be provided as an Object where each property is a ' + 'variable value. Perhaps look to see if an unparsed JSON string ' + 'was provided.') : void 0;
	}
	
	/**
	 * Constructs a ExecutionContext object from the arguments passed to
	 * execute, which we will pass throughout the other execution methods.
	 *
	 * Throws a GraphQLError if a valid execution context cannot be created.
	 */
	function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver) {
	  var errors = [];
	  var operation = void 0;
	  var fragments = Object.create(null);
	  document.definitions.forEach(function (definition) {
	    switch (definition.kind) {
	      case Kind.OPERATION_DEFINITION:
	        if (!operationName && operation) {
	          throw new _error.GraphQLError('Must provide operation name if query contains multiple operations.');
	        }
	        if (!operationName || definition.name && definition.name.value === operationName) {
	          operation = definition;
	        }
	        break;
	      case Kind.FRAGMENT_DEFINITION:
	        fragments[definition.name.value] = definition;
	        break;
	      default:
	        throw new _error.GraphQLError('GraphQL cannot execute a request containing a ' + definition.kind + '.', [definition]);
	    }
	  });
	  if (!operation) {
	    if (operationName) {
	      throw new _error.GraphQLError('Unknown operation named "' + operationName + '".');
	    } else {
	      throw new _error.GraphQLError('Must provide an operation.');
	    }
	  }
	  var variableValues = (0, _values.getVariableValues)(schema, operation.variableDefinitions || [], rawVariableValues || {});
	
	  return {
	    schema: schema,
	    fragments: fragments,
	    rootValue: rootValue,
	    contextValue: contextValue,
	    operation: operation,
	    variableValues: variableValues,
	    fieldResolver: fieldResolver || defaultFieldResolver,
	    errors: errors
	  };
	}
	
	/**
	 * Implements the "Evaluating operations" section of the spec.
	 */
	function executeOperation(exeContext, operation, rootValue) {
	  var type = getOperationRootType(exeContext.schema, operation);
	  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
	
	  var path = undefined;
	
	  // Errors from sub-fields of a NonNull type may propagate to the top level,
	  // at which point we still log the error and null the parent field, which
	  // in this case is the entire response.
	  //
	  // Similar to completeValueCatchingError.
	  try {
	    var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);
	    var promise = getPromise(result);
	    if (promise) {
	      return promise.then(undefined, function (error) {
	        exeContext.errors.push(error);
	        return Promise.resolve(null);
	      });
	    }
	    return result;
	  } catch (error) {
	    exeContext.errors.push(error);
	    return null;
	  }
	}
	
	/**
	 * Extracts the root type of the operation from the schema.
	 */
	function getOperationRootType(schema, operation) {
	  switch (operation.operation) {
	    case 'query':
	      return schema.getQueryType();
	    case 'mutation':
	      var mutationType = schema.getMutationType();
	      if (!mutationType) {
	        throw new _error.GraphQLError('Schema is not configured for mutations', [operation]);
	      }
	      return mutationType;
	    case 'subscription':
	      var subscriptionType = schema.getSubscriptionType();
	      if (!subscriptionType) {
	        throw new _error.GraphQLError('Schema is not configured for subscriptions', [operation]);
	      }
	      return subscriptionType;
	    default:
	      throw new _error.GraphQLError('Can only execute queries, mutations and subscriptions', [operation]);
	  }
	}
	
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "write" mode.
	 */
	function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
	  return Object.keys(fields).reduce(function (prevPromise, responseName) {
	    return prevPromise.then(function (results) {
	      var fieldNodes = fields[responseName];
	      var fieldPath = addPath(path, responseName);
	      var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	      if (result === undefined) {
	        return results;
	      }
	      var promise = getPromise(result);
	      if (promise) {
	        return promise.then(function (resolvedResult) {
	          results[responseName] = resolvedResult;
	          return results;
	        });
	      }
	      results[responseName] = result;
	      return results;
	    });
	  }, Promise.resolve({}));
	}
	
	/**
	 * Implements the "Evaluating selection sets" section of the spec
	 * for "read" mode.
	 */
	function executeFields(exeContext, parentType, sourceValue, path, fields) {
	  var containsPromise = false;
	
	  var finalResults = Object.keys(fields).reduce(function (results, responseName) {
	    var fieldNodes = fields[responseName];
	    var fieldPath = addPath(path, responseName);
	    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
	    if (result === undefined) {
	      return results;
	    }
	    results[responseName] = result;
	    if (getPromise(result)) {
	      containsPromise = true;
	    }
	    return results;
	  }, Object.create(null));
	
	  // If there are no promises, we can just return the object
	  if (!containsPromise) {
	    return finalResults;
	  }
	
	  // Otherwise, results is a map from field name to the result
	  // of resolving that field, which is possibly a promise. Return
	  // a promise that will return this same map, but with any
	  // promises replaced with the values they resolved to.
	  return promiseForObject(finalResults);
	}
	
	/**
	 * Given a selectionSet, adds all of the fields in that selection to
	 * the passed in map of fields, and returns it at the end.
	 *
	 * CollectFields requires the "runtime type" of an object. For a field which
	 * returns an Interface or Union type, the "runtime type" will be the actual
	 * Object type returned by that field.
	 */
	function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	    switch (selection.kind) {
	      case Kind.FIELD:
	        if (!shouldIncludeNode(exeContext, selection)) {
	          continue;
	        }
	        var name = getFieldEntryKey(selection);
	        if (!fields[name]) {
	          fields[name] = [];
	        }
	        fields[name].push(selection);
	        break;
	      case Kind.INLINE_FRAGMENT:
	        if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
	          continue;
	        }
	        collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
	        break;
	      case Kind.FRAGMENT_SPREAD:
	        var fragName = selection.name.value;
	        if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) {
	          continue;
	        }
	        visitedFragmentNames[fragName] = true;
	        var fragment = exeContext.fragments[fragName];
	        if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
	          continue;
	        }
	        collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
	        break;
	    }
	  }
	  return fields;
	}
	
	/**
	 * Determines if a field should be included based on the @include and @skip
	 * directives, where @skip has higher precidence than @include.
	 */
	function shouldIncludeNode(exeContext, node) {
	  var skip = (0, _values.getDirectiveValues)(_directives.GraphQLSkipDirective, node, exeContext.variableValues);
	  if (skip && skip.if === true) {
	    return false;
	  }
	
	  var include = (0, _values.getDirectiveValues)(_directives.GraphQLIncludeDirective, node, exeContext.variableValues);
	  if (include && include.if === false) {
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Determines if a fragment is applicable to the given type.
	 */
	function doesFragmentConditionMatch(exeContext, fragment, type) {
	  var typeConditionNode = fragment.typeCondition;
	  if (!typeConditionNode) {
	    return true;
	  }
	  var conditionalType = (0, _typeFromAST.typeFromAST)(exeContext.schema, typeConditionNode);
	  if (conditionalType === type) {
	    return true;
	  }
	  if ((0, _definition.isAbstractType)(conditionalType)) {
	    return exeContext.schema.isPossibleType(conditionalType, type);
	  }
	  return false;
	}
	
	/**
	 * This function transforms a JS object `ObjMap<Promise<T>>` into
	 * a `Promise<ObjMap<T>>`
	 *
	 * This is akin to bluebird's `Promise.props`, but implemented only using
	 * `Promise.all` so it will work with any implementation of ES6 promises.
	 */
	function promiseForObject(object) {
	  var keys = Object.keys(object);
	  var valuesAndPromises = keys.map(function (name) {
	    return object[name];
	  });
	  return Promise.all(valuesAndPromises).then(function (values) {
	    return values.reduce(function (resolvedObject, value, i) {
	      resolvedObject[keys[i]] = value;
	      return resolvedObject;
	    }, Object.create(null));
	  });
	}
	
	/**
	 * Implements the logic to compute the key of a given field's entry
	 */
	function getFieldEntryKey(node) {
	  return node.alias ? node.alias.value : node.name.value;
	}
	
	/**
	 * Resolves the field on the given source object. In particular, this
	 * figures out the value that the field returns by calling its resolve function,
	 * then calls completeValue to complete promises, serialize scalars, or execute
	 * the sub-selection-set for objects.
	 */
	function resolveField(exeContext, parentType, source, fieldNodes, path) {
	  var fieldNode = fieldNodes[0];
	  var fieldName = fieldNode.name.value;
	
	  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);
	  if (!fieldDef) {
	    return;
	  }
	
	  var resolveFn = fieldDef.resolve || exeContext.fieldResolver;
	
	  var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path);
	
	  // Get the resolve function, regardless of if its result is normal
	  // or abrupt (error).
	  var result = resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info);
	
	  return completeValueCatchingError(exeContext, fieldDef.type, fieldNodes, info, path, result);
	}
	
	function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
	  // The resolve function's optional fourth argument is a collection of
	  // information about the current execution state.
	  return {
	    fieldName: fieldNodes[0].name.value,
	    fieldNodes: fieldNodes,
	    returnType: fieldDef.type,
	    parentType: parentType,
	    path: path,
	    schema: exeContext.schema,
	    fragments: exeContext.fragments,
	    rootValue: exeContext.rootValue,
	    operation: exeContext.operation,
	    variableValues: exeContext.variableValues
	  };
	}
	
	// Isolates the "ReturnOrAbrupt" behavior to not de-opt the `resolveField`
	// function. Returns the result of resolveFn or the abrupt-return Error object.
	function resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info) {
	  try {
	    // Build a JS object of arguments from the field.arguments AST, using the
	    // variables scope to fulfill any variable references.
	    // TODO: find a way to memoize, in case this field is within a List type.
	    var args = (0, _values.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues);
	
	    // The resolve function's optional third argument is a context value that
	    // is provided to every resolve function within an execution. It is commonly
	    // used to represent an authenticated user, or request-specific caches.
	    var context = exeContext.contextValue;
	
	    return resolveFn(source, args, context, info);
	  } catch (error) {
	    // Sometimes a non-error is thrown, wrap it as an Error for a
	    // consistent interface.
	    return error instanceof Error ? error : new Error(error);
	  }
	}
	
	// This is a small wrapper around completeValue which detects and logs errors
	// in the execution context.
	function completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result) {
	  // If the field type is non-nullable, then it is resolved without any
	  // protection from errors, however it still properly locates the error.
	  if (returnType instanceof _definition.GraphQLNonNull) {
	    return completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // Otherwise, error protection is applied, logging the error and resolving
	  // a null value for this field if one is encountered.
	  try {
	    var completed = completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
	    var promise = getPromise(completed);
	    if (promise) {
	      // If `completeValueWithLocatedError` returned a rejected promise, log
	      // the rejection error and resolve to null.
	      // Note: we don't rely on a `catch` method, but we do expect "thenable"
	      // to take a second callback for the error case.
	      return promise.then(undefined, function (error) {
	        exeContext.errors.push(error);
	        return Promise.resolve(null);
	      });
	    }
	    return completed;
	  } catch (error) {
	    // If `completeValueWithLocatedError` returned abruptly (threw an error),
	    // log the error and return null.
	    exeContext.errors.push(error);
	    return null;
	  }
	}
	
	// This is a small wrapper around completeValue which annotates errors with
	// location information.
	function completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result) {
	  try {
	    var completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
	    var promise = getPromise(completed);
	    if (promise) {
	      return promise.then(undefined, function (error) {
	        return Promise.reject((0, _error.locatedError)(error, fieldNodes, responsePathAsArray(path)));
	      });
	    }
	    return completed;
	  } catch (error) {
	    throw (0, _error.locatedError)(error, fieldNodes, responsePathAsArray(path));
	  }
	}
	
	/**
	 * Implements the instructions for completeValue as defined in the
	 * "Field entries" section of the spec.
	 *
	 * If the field type is Non-Null, then this recursively completes the value
	 * for the inner type. It throws a field error if that completion returns null,
	 * as per the "Nullability" section of the spec.
	 *
	 * If the field type is a List, then this recursively completes the value
	 * for the inner type on each item in the list.
	 *
	 * If the field type is a Scalar or Enum, ensures the completed value is a legal
	 * value of the type by calling the `serialize` method of GraphQL type
	 * definition.
	 *
	 * If the field is an abstract type, determine the runtime type of the value
	 * and then complete based on that type
	 *
	 * Otherwise, the field type expects a sub-selection set, and will complete the
	 * value by evaluating all sub-selections.
	 */
	function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If result is a Promise, apply-lift over completeValue.
	  var promise = getPromise(result);
	  if (promise) {
	    return promise.then(function (resolved) {
	      return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
	    });
	  }
	
	  // If result is an Error, throw a located error.
	  if (result instanceof Error) {
	    throw result;
	  }
	
	  // If field type is NonNull, complete for inner type, and throw field error
	  // if result is null.
	  if (returnType instanceof _definition.GraphQLNonNull) {
	    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
	    if (completed === null) {
	      throw new Error('Cannot return null for non-nullable field ' + info.parentType.name + '.' + info.fieldName + '.');
	    }
	    return completed;
	  }
	
	  // If result value is null-ish (null, undefined, or NaN) then return null.
	  if ((0, _isNullish2.default)(result)) {
	    return null;
	  }
	
	  // If field type is List, complete each item in the list with the inner type
	  if (returnType instanceof _definition.GraphQLList) {
	    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
	  // returning null if serialization is not possible.
	  if ((0, _definition.isLeafType)(returnType)) {
	    return completeLeafValue(returnType, result);
	  }
	
	  // If field type is an abstract type, Interface or Union, determine the
	  // runtime Object type and complete for that type.
	  if ((0, _definition.isAbstractType)(returnType)) {
	    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // If field type is Object, execute and complete all sub-selections.
	  if (returnType instanceof _definition.GraphQLObjectType) {
	    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
	  }
	
	  // Not reachable. All possible output types have been considered.
	  throw new Error('Cannot complete value of unexpected type "' + String(returnType) + '".');
	}
	
	/**
	 * Complete a list value by completing each item in the list with the
	 * inner type
	 */
	function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
	  !(0, _iterall.isCollection)(result) ? (0, _invariant2.default)(0, 'Expected Iterable, but did not find one for field ' + info.parentType.name + '.' + info.fieldName + '.') : void 0;
	
	  // This is specified as a simple map, however we're optimizing the path
	  // where the list contains no Promises by avoiding creating another Promise.
	  var itemType = returnType.ofType;
	  var containsPromise = false;
	  var completedResults = [];
	  (0, _iterall.forEach)(result, function (item, index) {
	    // No need to modify the info object containing the path,
	    // since from here on it is not ever accessed by resolver functions.
	    var fieldPath = addPath(path, index);
	    var completedItem = completeValueCatchingError(exeContext, itemType, fieldNodes, info, fieldPath, item);
	
	    if (!containsPromise && getPromise(completedItem)) {
	      containsPromise = true;
	    }
	    completedResults.push(completedItem);
	  });
	
	  return containsPromise ? Promise.all(completedResults) : completedResults;
	}
	
	/**
	 * Complete a Scalar or Enum by serializing to a valid value, returning
	 * null if serialization is not possible.
	 */
	function completeLeafValue(returnType, result) {
	  !returnType.serialize ? (0, _invariant2.default)(0, 'Missing serialize method on type') : void 0;
	  var serializedResult = returnType.serialize(result);
	  if ((0, _isNullish2.default)(serializedResult)) {
	    throw new Error('Expected a value of type "' + String(returnType) + '" but ' + ('received: ' + String(result)));
	  }
	  return serializedResult;
	}
	
	/**
	 * Complete a value of an abstract type by determining the runtime object type
	 * of that value, then complete the value for that type.
	 */
	function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
	  var runtimeType = returnType.resolveType ? returnType.resolveType(result, exeContext.contextValue, info) : defaultResolveTypeFn(result, exeContext.contextValue, info, returnType);
	
	  var promise = getPromise(runtimeType);
	  if (promise) {
	    return promise.then(function (resolvedRuntimeType) {
	      return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
	    });
	  }
	
	  return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
	}
	
	function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
	  var runtimeType = typeof runtimeTypeOrName === 'string' ? exeContext.schema.getType(runtimeTypeOrName) : runtimeTypeOrName;
	
	  if (!(runtimeType instanceof _definition.GraphQLObjectType)) {
	    throw new _error.GraphQLError('Abstract type ' + returnType.name + ' must resolve to an Object type at ' + ('runtime for field ' + info.parentType.name + '.' + info.fieldName + ' with ') + ('value "' + String(result) + '", received "' + String(runtimeType) + '".'), fieldNodes);
	  }
	
	  if (!exeContext.schema.isPossibleType(returnType, runtimeType)) {
	    throw new _error.GraphQLError('Runtime Object type "' + runtimeType.name + '" is not a possible type ' + ('for "' + returnType.name + '".'), fieldNodes);
	  }
	
	  return runtimeType;
	}
	
	/**
	 * Complete an Object value by executing all sub-selections.
	 */
	function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
	  // If there is an isTypeOf predicate function, call it with the
	  // current result. If isTypeOf returns false, then raise an error rather
	  // than continuing execution.
	  if (returnType.isTypeOf) {
	    var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
	
	    var promise = getPromise(isTypeOf);
	    if (promise) {
	      return promise.then(function (isTypeOfResult) {
	        if (!isTypeOfResult) {
	          throw invalidReturnTypeError(returnType, result, fieldNodes);
	        }
	        return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result);
	      });
	    }
	
	    if (!isTypeOf) {
	      throw invalidReturnTypeError(returnType, result, fieldNodes);
	    }
	  }
	
	  return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result);
	}
	
	function invalidReturnTypeError(returnType, result, fieldNodes) {
	  return new _error.GraphQLError('Expected value of type "' + returnType.name + '" but got: ' + String(result) + '.', fieldNodes);
	}
	
	function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result) {
	  // Collect sub-fields to execute to complete this value.
	  var subFieldNodes = Object.create(null);
	  var visitedFragmentNames = Object.create(null);
	  for (var i = 0; i < fieldNodes.length; i++) {
	    var selectionSet = fieldNodes[i].selectionSet;
	    if (selectionSet) {
	      subFieldNodes = collectFields(exeContext, returnType, selectionSet, subFieldNodes, visitedFragmentNames);
	    }
	  }
	
	  return executeFields(exeContext, returnType, result, path, subFieldNodes);
	}
	
	/**
	 * If a resolveType function is not given, then a default resolve behavior is
	 * used which tests each possible type for the abstract type by calling
	 * isTypeOf for the object being coerced, returning the first type that matches.
	 */
	function defaultResolveTypeFn(value, context, info, abstractType) {
	  var possibleTypes = info.schema.getPossibleTypes(abstractType);
	  var promisedIsTypeOfResults = [];
	
	  for (var i = 0; i < possibleTypes.length; i++) {
	    var type = possibleTypes[i];
	
	    if (type.isTypeOf) {
	      var isTypeOfResult = type.isTypeOf(value, context, info);
	
	      var promise = getPromise(isTypeOfResult);
	      if (promise) {
	        promisedIsTypeOfResults[i] = promise;
	      } else if (isTypeOfResult) {
	        return type;
	      }
	    }
	  }
	
	  if (promisedIsTypeOfResults.length) {
	    return Promise.all(promisedIsTypeOfResults).then(function (isTypeOfResults) {
	      for (var _i = 0; _i < isTypeOfResults.length; _i++) {
	        if (isTypeOfResults[_i]) {
	          return possibleTypes[_i];
	        }
	      }
	    });
	  }
	}
	
	/**
	 * If a resolve function is not given, then a default resolve behavior is used
	 * which takes the property of the source object of the same name as the field
	 * and returns it as the result, or if it's a function, returns the result
	 * of calling that function while passing along args and context.
	 */
	var defaultFieldResolver = exports.defaultFieldResolver = function defaultFieldResolver(source, args, context, info) {
	  // ensure source is a value for which property access is acceptable.
	  if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' || typeof source === 'function') {
	    var property = source[info.fieldName];
	    if (typeof property === 'function') {
	      return source[info.fieldName](args, context, info);
	    }
	    return property;
	  }
	};
	
	/**
	 * Only returns the value if it acts like a Promise, i.e. has a "then" function,
	 * otherwise returns void.
	 */
	function getPromise(value) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && typeof value.then === 'function') {
	    return value;
	  }
	}
	
	/**
	 * This method looks up the field on the given type defintion.
	 * It has special casing for the two introspection fields, __schema
	 * and __typename. __typename is special because it can always be
	 * queried as a field, even in situations where no other fields
	 * are allowed, like on a Union. __schema could get automatically
	 * added to the query type, but that would require mutating type
	 * definitions, which would cause issues.
	 */
	function getFieldDef(schema, parentType, fieldName) {
	  if (fieldName === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  } else if (fieldName === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  } else if (fieldName === _introspection.TypeNameMetaFieldDef.name) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	  return parentType.getFields()[fieldName];
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.getVariableValues = getVariableValues;
	exports.getArgumentValues = getArgumentValues;
	exports.getDirectiveValues = getDirectiveValues;
	exports.coerceValue = coerceValue;
	
	var _iterall = __webpack_require__(46);
	
	var _error = __webpack_require__(5);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__(66);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _isValidJSValue = __webpack_require__(188);
	
	var _isValidLiteralValue = __webpack_require__(92);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Prepares an object map of variableValues of the correct type based on the
	 * provided variable definitions and arbitrary input. If the input cannot be
	 * parsed to match the variable definitions, a GraphQLError will be thrown.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	function getVariableValues(schema, varDefNodes, inputs) {
	  var coercedValues = {};
	  for (var i = 0; i < varDefNodes.length; i++) {
	    var varDefNode = varDefNodes[i];
	    var varName = varDefNode.variable.name.value;
	    var varType = (0, _typeFromAST.typeFromAST)(schema, varDefNode.type);
	    if (!(0, _definition.isInputType)(varType)) {
	      throw new _error.GraphQLError('Variable "$' + varName + '" expected value of type ' + ('"' + (0, _printer.print)(varDefNode.type) + '" which cannot be used as an input type.'), [varDefNode.type]);
	    }
	
	    var value = inputs[varName];
	    if ((0, _isInvalid2.default)(value)) {
	      var defaultValue = varDefNode.defaultValue;
	      if (defaultValue) {
	        coercedValues[varName] = (0, _valueFromAST.valueFromAST)(defaultValue, varType);
	      }
	      if (varType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Variable "$' + varName + '" of required type ' + ('"' + String(varType) + '" was not provided.'), [varDefNode]);
	      }
	    } else {
	      var errors = (0, _isValidJSValue.isValidJSValue)(value, varType);
	      if (errors.length) {
	        var message = errors ? '\n' + errors.join('\n') : '';
	        throw new _error.GraphQLError('Variable "$' + varName + '" got invalid value ' + (JSON.stringify(value) + '.' + message), [varDefNode]);
	      }
	
	      var coercedValue = coerceValue(varType, value);
	      !!(0, _isInvalid2.default)(coercedValue) ? (0, _invariant2.default)(0, 'Should have reported error.') : void 0;
	      coercedValues[varName] = coercedValue;
	    }
	  }
	  return coercedValues;
	}
	
	/**
	 * Prepares an object map of argument values given a list of argument
	 * definitions and list of argument AST nodes.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	function getArgumentValues(def, node, variableValues) {
	  var coercedValues = {};
	  var argDefs = def.args;
	  var argNodes = node.arguments;
	  if (!argDefs || !argNodes) {
	    return coercedValues;
	  }
	  var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	    return arg.name.value;
	  });
	  for (var i = 0; i < argDefs.length; i++) {
	    var argDef = argDefs[i];
	    var name = argDef.name;
	    var argType = argDef.type;
	    var argumentNode = argNodeMap[name];
	    var defaultValue = argDef.defaultValue;
	    if (!argumentNode) {
	      if (!(0, _isInvalid2.default)(defaultValue)) {
	        coercedValues[name] = defaultValue;
	      } else if (argType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Argument "' + name + '" of required type ' + ('"' + String(argType) + '" was not provided.'), [node]);
	      }
	    } else if (argumentNode.value.kind === Kind.VARIABLE) {
	      var variableName = argumentNode.value.name.value;
	      if (variableValues && Object.prototype.hasOwnProperty.call(variableValues, variableName) && !(0, _isInvalid2.default)(variableValues[variableName])) {
	        // Note: this does not check that this variable value is correct.
	        // This assumes that this query has been validated and the variable
	        // usage here is of the correct type.
	        coercedValues[name] = variableValues[variableName];
	      } else if (!(0, _isInvalid2.default)(defaultValue)) {
	        coercedValues[name] = defaultValue;
	      } else if (argType instanceof _definition.GraphQLNonNull) {
	        throw new _error.GraphQLError('Argument "' + name + '" of required type "' + String(argType) + '" was ' + ('provided the variable "$' + variableName + '" which was not provided ') + 'a runtime value.', [argumentNode.value]);
	      }
	    } else {
	      var valueNode = argumentNode.value;
	      var coercedValue = (0, _valueFromAST.valueFromAST)(valueNode, argType, variableValues);
	      if ((0, _isInvalid2.default)(coercedValue)) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(argType, valueNode);
	        var message = errors ? '\n' + errors.join('\n') : '';
	        throw new _error.GraphQLError('Argument "' + name + '" got invalid value ' + (0, _printer.print)(valueNode) + '.' + message, [argumentNode.value]);
	      }
	      coercedValues[name] = coercedValue;
	    }
	  }
	  return coercedValues;
	}
	
	/**
	 * Prepares an object map of argument values given a directive definition
	 * and a AST node which may contain directives. Optionally also accepts a map
	 * of variable values.
	 *
	 * If the directive does not exist on the node, returns undefined.
	 *
	 * Note: The returned value is a plain Object with a prototype, since it is
	 * exposed to user code. Care should be taken to not pull values from the
	 * Object prototype.
	 */
	function getDirectiveValues(directiveDef, node, variableValues) {
	  var directiveNode = node.directives && (0, _find2.default)(node.directives, function (directive) {
	    return directive.name.value === directiveDef.name;
	  });
	
	  if (directiveNode) {
	    return getArgumentValues(directiveDef, directiveNode, variableValues);
	  }
	}
	
	/**
	 * Given a type and any value, return a runtime value coerced to match the type.
	 */
	function coerceValue(type, value) {
	  // Ensure flow knows that we treat function params as const.
	  var _value = value;
	
	  if ((0, _isInvalid2.default)(_value)) {
	    return; // Intentionally return no value.
	  }
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    if (_value === null) {
	      return; // Intentionally return no value.
	    }
	    return coerceValue(type.ofType, _value);
	  }
	
	  if (_value === null) {
	    // Intentionally return the value null.
	    return null;
	  }
	
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if ((0, _iterall.isCollection)(_value)) {
	      var coercedValues = [];
	      var valueIter = (0, _iterall.createIterator)(_value);
	      if (!valueIter) {
	        return; // Intentionally return no value.
	      }
	      var step = void 0;
	      while (!(step = valueIter.next()).done) {
	        var itemValue = coerceValue(itemType, step.value);
	        if ((0, _isInvalid2.default)(itemValue)) {
	          return; // Intentionally return no value.
	        }
	        coercedValues.push(itemValue);
	      }
	      return coercedValues;
	    }
	    var coercedValue = coerceValue(itemType, _value);
	    if ((0, _isInvalid2.default)(coercedValue)) {
	      return; // Intentionally return no value.
	    }
	    return [coerceValue(itemType, _value)];
	  }
	
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if ((typeof _value === 'undefined' ? 'undefined' : _typeof(_value)) !== 'object') {
	      return; // Intentionally return no value.
	    }
	    var coercedObj = Object.create(null);
	    var fields = type.getFields();
	    var fieldNames = Object.keys(fields);
	    for (var i = 0; i < fieldNames.length; i++) {
	      var fieldName = fieldNames[i];
	      var field = fields[fieldName];
	      if ((0, _isInvalid2.default)(_value[fieldName])) {
	        if (!(0, _isInvalid2.default)(field.defaultValue)) {
	          coercedObj[fieldName] = field.defaultValue;
	        } else if (field.type instanceof _definition.GraphQLNonNull) {
	          return; // Intentionally return no value.
	        }
	        continue;
	      }
	      var fieldValue = coerceValue(field.type, _value[fieldName]);
	      if ((0, _isInvalid2.default)(fieldValue)) {
	        return; // Intentionally return no value.
	      }
	      coercedObj[fieldName] = fieldValue;
	    }
	    return coercedObj;
	  }
	
	  !(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType) ? (0, _invariant2.default)(0, 'Must be input type') : void 0;
	
	  var parsed = type.parseValue(_value);
	  if ((0, _isNullish2.default)(parsed)) {
	    // null or invalid values represent a failure to parse correctly,
	    // in which case no value is returned.
	    return;
	  }
	
	  return parsed;
	}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyValMap;
	
	
	/**
	 * Creates a keyed JS object from an array, given a function to produce the keys
	 * and a function to produce the values from each item in the array.
	 *
	 *     const phoneBook = [
	 *       { name: 'Jon', num: '555-1234' },
	 *       { name: 'Jenny', num: '867-5309' }
	 *     ]
	 *
	 *     // { Jon: '555-1234', Jenny: '867-5309' }
	 *     const phonesByName = keyValMap(
	 *       phoneBook,
	 *       entry => entry.name,
	 *       entry => entry.num
	 *     )
	 *
	 */
	function keyValMap(list, keyFn, valFn) {
	  return list.reduce(function (map, item) {
	    return map[keyFn(item)] = valFn(item), map;
	  }, Object.create(null));
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quotedOrList;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var MAX_LENGTH = 5;
	
	/**
	 * Given [ A, B, C ] return '"A", "B", or "C"'.
	 */
	function quotedOrList(items) {
	  var selected = items.slice(0, MAX_LENGTH);
	  return selected.map(function (item) {
	    return '"' + item + '"';
	  }).reduce(function (list, quoted, index) {
	    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
	  });
	}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = suggestionList;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	/**
	 * Given an invalid input string and a list of valid options, returns a filtered
	 * list of valid options sorted based on their similarity with the input.
	 */
	function suggestionList(input, options) {
	  var optionsByDistance = Object.create(null);
	  var oLength = options.length;
	  var inputThreshold = input.length / 2;
	  for (var i = 0; i < oLength; i++) {
	    var distance = lexicalDistance(input, options[i]);
	    var threshold = Math.max(inputThreshold, options[i].length / 2, 1);
	    if (distance <= threshold) {
	      optionsByDistance[options[i]] = distance;
	    }
	  }
	  return Object.keys(optionsByDistance).sort(function (a, b) {
	    return optionsByDistance[a] - optionsByDistance[b];
	  });
	}
	
	/**
	 * Computes the lexical distance between strings A and B.
	 *
	 * The "distance" between two strings is given by counting the minimum number
	 * of edits needed to transform string A into string B. An edit can be an
	 * insertion, deletion, or substitution of a single character, or a swap of two
	 * adjacent characters.
	 *
	 * This distance can be useful for detecting typos in input or sorting
	 *
	 * @param {string} a
	 * @param {string} b
	 * @return {int} distance in number of edits
	 */
	function lexicalDistance(a, b) {
	  var i = void 0;
	  var j = void 0;
	  var d = [];
	  var aLength = a.length;
	  var bLength = b.length;
	
	  for (i = 0; i <= aLength; i++) {
	    d[i] = [i];
	  }
	
	  for (j = 1; j <= bLength; j++) {
	    d[0][j] = j;
	  }
	
	  for (i = 1; i <= aLength; i++) {
	    for (j = 1; j <= bLength; j++) {
	      var cost = a[i - 1] === b[j - 1] ? 0 : 1;
	
	      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
	
	      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
	        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
	      }
	    }
	  }
	
	  return d[aLength][bLength];
	}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TokenKind = undefined;
	exports.createLexer = createLexer;
	exports.getTokenDesc = getTokenDesc;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Given a Source object, this returns a Lexer for that source.
	 * A Lexer is a stateful stream generator in that every time
	 * it is advanced, it returns the next token in the Source. Assuming the
	 * source lexes, the final Token emitted by the lexer will be of kind
	 * EOF, after which the lexer will repeatedly return the same EOF token
	 * whenever called.
	 */
	function createLexer(source, options) {
	  var startOfFileToken = new Tok(SOF, 0, 0, 0, 0, null);
	  var lexer = {
	    source: source,
	    options: options,
	    lastToken: startOfFileToken,
	    token: startOfFileToken,
	    line: 1,
	    lineStart: 0,
	    advance: advanceLexer
	  };
	  return lexer;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function advanceLexer() {
	  var token = this.lastToken = this.token;
	  if (token.kind !== EOF) {
	    do {
	      token = token.next = readToken(this, token);
	    } while (token.kind === COMMENT);
	    this.token = token;
	  }
	  return token;
	}
	
	/**
	 * The return type of createLexer.
	 */
	
	
	// Each kind of token.
	var SOF = '<SOF>';
	var EOF = '<EOF>';
	var BANG = '!';
	var DOLLAR = '$';
	var PAREN_L = '(';
	var PAREN_R = ')';
	var SPREAD = '...';
	var COLON = ':';
	var EQUALS = '=';
	var AT = '@';
	var BRACKET_L = '[';
	var BRACKET_R = ']';
	var BRACE_L = '{';
	var PIPE = '|';
	var BRACE_R = '}';
	var NAME = 'Name';
	var INT = 'Int';
	var FLOAT = 'Float';
	var STRING = 'String';
	var COMMENT = 'Comment';
	
	/**
	 * An exported enum describing the different kinds of tokens that the
	 * lexer emits.
	 */
	var TokenKind = exports.TokenKind = {
	  SOF: SOF,
	  EOF: EOF,
	  BANG: BANG,
	  DOLLAR: DOLLAR,
	  PAREN_L: PAREN_L,
	  PAREN_R: PAREN_R,
	  SPREAD: SPREAD,
	  COLON: COLON,
	  EQUALS: EQUALS,
	  AT: AT,
	  BRACKET_L: BRACKET_L,
	  BRACKET_R: BRACKET_R,
	  BRACE_L: BRACE_L,
	  PIPE: PIPE,
	  BRACE_R: BRACE_R,
	  NAME: NAME,
	  INT: INT,
	  FLOAT: FLOAT,
	  STRING: STRING,
	  COMMENT: COMMENT
	};
	
	/**
	 * A helper function to describe a token as a string for debugging
	 */
	function getTokenDesc(token) {
	  var value = token.value;
	  return value ? token.kind + ' "' + value + '"' : token.kind;
	}
	
	var charCodeAt = String.prototype.charCodeAt;
	var slice = String.prototype.slice;
	
	/**
	 * Helper function for constructing the Token object.
	 */
	function Tok(kind, start, end, line, column, prev, value) {
	  this.kind = kind;
	  this.start = start;
	  this.end = end;
	  this.line = line;
	  this.column = column;
	  this.value = value;
	  this.prev = prev;
	  this.next = null;
	}
	
	// Print a simplified form when appearing in JSON/util.inspect.
	Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
	  return {
	    kind: this.kind,
	    value: this.value,
	    line: this.line,
	    column: this.column
	  };
	};
	
	function printCharCode(code) {
	  return (
	    // NaN/undefined represents access beyond the end of the file.
	    isNaN(code) ? EOF :
	    // Trust JSON for ASCII.
	    code < 0x007F ? JSON.stringify(String.fromCharCode(code)) :
	    // Otherwise print the escaped form.
	    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
	  );
	}
	
	/**
	 * Gets the next token from the source starting at the given position.
	 *
	 * This skips over whitespace and comments until it finds the next lexable
	 * token, then lexes punctuators immediately or calls the appropriate helper
	 * function for more complicated tokens.
	 */
	function readToken(lexer, prev) {
	  var source = lexer.source;
	  var body = source.body;
	  var bodyLength = body.length;
	
	  var position = positionAfterWhitespace(body, prev.end, lexer);
	  var line = lexer.line;
	  var col = 1 + position - lexer.lineStart;
	
	  if (position >= bodyLength) {
	    return new Tok(EOF, bodyLength, bodyLength, line, col, prev);
	  }
	
	  var code = charCodeAt.call(body, position);
	
	  // SourceCharacter
	  if (code < 0x0020 && code !== 0x0009 && code !== 0x000A && code !== 0x000D) {
	    throw (0, _error.syntaxError)(source, position, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
	  }
	
	  switch (code) {
	    // !
	    case 33:
	      return new Tok(BANG, position, position + 1, line, col, prev);
	    // #
	    case 35:
	      return readComment(source, position, line, col, prev);
	    // $
	    case 36:
	      return new Tok(DOLLAR, position, position + 1, line, col, prev);
	    // (
	    case 40:
	      return new Tok(PAREN_L, position, position + 1, line, col, prev);
	    // )
	    case 41:
	      return new Tok(PAREN_R, position, position + 1, line, col, prev);
	    // .
	    case 46:
	      if (charCodeAt.call(body, position + 1) === 46 && charCodeAt.call(body, position + 2) === 46) {
	        return new Tok(SPREAD, position, position + 3, line, col, prev);
	      }
	      break;
	    // :
	    case 58:
	      return new Tok(COLON, position, position + 1, line, col, prev);
	    // =
	    case 61:
	      return new Tok(EQUALS, position, position + 1, line, col, prev);
	    // @
	    case 64:
	      return new Tok(AT, position, position + 1, line, col, prev);
	    // [
	    case 91:
	      return new Tok(BRACKET_L, position, position + 1, line, col, prev);
	    // ]
	    case 93:
	      return new Tok(BRACKET_R, position, position + 1, line, col, prev);
	    // {
	    case 123:
	      return new Tok(BRACE_L, position, position + 1, line, col, prev);
	    // |
	    case 124:
	      return new Tok(PIPE, position, position + 1, line, col, prev);
	    // }
	    case 125:
	      return new Tok(BRACE_R, position, position + 1, line, col, prev);
	    // A-Z _ a-z
	    case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:
	    case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:
	    case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:
	    case 89:case 90:
	    case 95:
	    case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:
	    case 105:case 106:case 107:case 108:case 109:case 110:case 111:
	    case 112:case 113:case 114:case 115:case 116:case 117:case 118:
	    case 119:case 120:case 121:case 122:
	      return readName(source, position, line, col, prev);
	    // - 0-9
	    case 45:
	    case 48:case 49:case 50:case 51:case 52:
	    case 53:case 54:case 55:case 56:case 57:
	      return readNumber(source, position, code, line, col, prev);
	    // "
	    case 34:
	      return readString(source, position, line, col, prev);
	  }
	
	  throw (0, _error.syntaxError)(source, position, unexpectedCharacterMessage(code));
	}
	
	/**
	 * Report a message that an unexpected character was encountered.
	 */
	function unexpectedCharacterMessage(code) {
	  if (code === 39) {
	    // '
	    return 'Unexpected single quote character (\'), did you mean to use ' + 'a double quote (")?';
	  }
	
	  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
	}
	
	/**
	 * Reads from body starting at startPosition until it finds a non-whitespace
	 * or commented character, then returns the position of that character for
	 * lexing.
	 */
	function positionAfterWhitespace(body, startPosition, lexer) {
	  var bodyLength = body.length;
	  var position = startPosition;
	  while (position < bodyLength) {
	    var code = charCodeAt.call(body, position);
	    // tab | space | comma | BOM
	    if (code === 9 || code === 32 || code === 44 || code === 0xFEFF) {
	      ++position;
	    } else if (code === 10) {
	      // new line
	      ++position;
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if (code === 13) {
	      // carriage return
	      if (charCodeAt.call(body, position + 1) === 10) {
	        position += 2;
	      } else {
	        ++position;
	      }
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else {
	      break;
	    }
	  }
	  return position;
	}
	
	/**
	 * Reads a comment token from the source file.
	 *
	 * #[\u0009\u0020-\uFFFF]*
	 */
	function readComment(source, start, line, col, prev) {
	  var body = source.body;
	  var code = void 0;
	  var position = start;
	
	  do {
	    code = charCodeAt.call(body, ++position);
	  } while (code !== null && (
	  // SourceCharacter but not LineTerminator
	  code > 0x001F || code === 0x0009));
	
	  return new Tok(COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
	}
	
	/**
	 * Reads a number token from the source file, either a float
	 * or an int depending on whether a decimal point appears.
	 *
	 * Int:   -?(0|[1-9][0-9]*)
	 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
	 */
	function readNumber(source, start, firstCode, line, col, prev) {
	  var body = source.body;
	  var code = firstCode;
	  var position = start;
	  var isFloat = false;
	
	  if (code === 45) {
	    // -
	    code = charCodeAt.call(body, ++position);
	  }
	
	  if (code === 48) {
	    // 0
	    code = charCodeAt.call(body, ++position);
	    if (code >= 48 && code <= 57) {
	      throw (0, _error.syntaxError)(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
	    }
	  } else {
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 46) {
	    // .
	    isFloat = true;
	
	    code = charCodeAt.call(body, ++position);
	    position = readDigits(source, position, code);
	    code = charCodeAt.call(body, position);
	  }
	
	  if (code === 69 || code === 101) {
	    // E e
	    isFloat = true;
	
	    code = charCodeAt.call(body, ++position);
	    if (code === 43 || code === 45) {
	      // + -
	      code = charCodeAt.call(body, ++position);
	    }
	    position = readDigits(source, position, code);
	  }
	
	  return new Tok(isFloat ? FLOAT : INT, start, position, line, col, prev, slice.call(body, start, position));
	}
	
	/**
	 * Returns the new position in the source after reading digits.
	 */
	function readDigits(source, start, firstCode) {
	  var body = source.body;
	  var position = start;
	  var code = firstCode;
	  if (code >= 48 && code <= 57) {
	    // 0 - 9
	    do {
	      code = charCodeAt.call(body, ++position);
	    } while (code >= 48 && code <= 57); // 0 - 9
	    return position;
	  }
	  throw (0, _error.syntaxError)(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
	}
	
	/**
	 * Reads a string token from the source file.
	 *
	 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
	 */
	function readString(source, start, line, col, prev) {
	  var body = source.body;
	  var position = start + 1;
	  var chunkStart = position;
	  var code = 0;
	  var value = '';
	
	  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
	  // not LineTerminator
	  code !== 0x000A && code !== 0x000D &&
	  // not Quote (")
	  code !== 34) {
	    // SourceCharacter
	    if (code < 0x0020 && code !== 0x0009) {
	      throw (0, _error.syntaxError)(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
	    }
	
	    ++position;
	    if (code === 92) {
	      // \
	      value += slice.call(body, chunkStart, position - 1);
	      code = charCodeAt.call(body, position);
	      switch (code) {
	        case 34:
	          value += '"';break;
	        case 47:
	          value += '/';break;
	        case 92:
	          value += '\\';break;
	        case 98:
	          value += '\b';break;
	        case 102:
	          value += '\f';break;
	        case 110:
	          value += '\n';break;
	        case 114:
	          value += '\r';break;
	        case 116:
	          value += '\t';break;
	        case 117:
	          // u
	          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
	          if (charCode < 0) {
	            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
	          }
	          value += String.fromCharCode(charCode);
	          position += 4;
	          break;
	        default:
	          throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
	      }
	      ++position;
	      chunkStart = position;
	    }
	  }
	
	  if (code !== 34) {
	    // quote (")
	    throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
	  }
	
	  value += slice.call(body, chunkStart, position);
	  return new Tok(STRING, start, position + 1, line, col, prev, value);
	}
	
	/**
	 * Converts four hexidecimal chars to the integer that the
	 * string represents. For example, uniCharCode('0','0','0','f')
	 * will return 15, and uniCharCode('0','0','f','f') returns 255.
	 *
	 * Returns a negative number on error, if a char was invalid.
	 *
	 * This is implemented by noting that char2hex() returns -1 on error,
	 * which means the result of ORing the char2hex() will also be negative.
	 */
	function uniCharCode(a, b, c, d) {
	  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
	}
	
	/**
	 * Converts a hex character to its integer value.
	 * '0' becomes 0, '9' becomes 9
	 * 'A' becomes 10, 'F' becomes 15
	 * 'a' becomes 10, 'f' becomes 15
	 *
	 * Returns -1 on error.
	 */
	function char2hex(a) {
	  return a >= 48 && a <= 57 ? a - 48 : // 0-9
	  a >= 65 && a <= 70 ? a - 55 : // A-F
	  a >= 97 && a <= 102 ? a - 87 : // a-f
	  -1;
	}
	
	/**
	 * Reads an alphanumeric + underscore name from the source.
	 *
	 * [_A-Za-z][_0-9A-Za-z]*
	 */
	function readName(source, position, line, col, prev) {
	  var body = source.body;
	  var bodyLength = body.length;
	  var end = position + 1;
	  var code = 0;
	  while (end !== bodyLength && (code = charCodeAt.call(body, end)) !== null && (code === 95 || // _
	  code >= 48 && code <= 57 || // 0-9
	  code >= 65 && code <= 90 || // A-Z
	  code >= 97 && code <= 122 // a-z
	  )) {
	    ++end;
	  }
	  return new Tok(NAME, position, end, line, col, prev, slice.call(body, position, end));
	}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = getLocation;
	
	
	/**
	 * Takes a Source and a UTF-8 character offset, and returns the corresponding
	 * line and column as a SourceLocation.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function getLocation(source, position) {
	  var lineRegexp = /\r\n|[\n\r]/g;
	  var line = 1;
	  var column = position + 1;
	  var match = void 0;
	  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
	    line += 1;
	    column = position + 1 - (match.index + match[0].length);
	  }
	  return { line: line, column: column };
	}
	
	/**
	 * Represents a location in a Source.
	 */

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TypeInfo = undefined;
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__(6);
	
	var _introspection = __webpack_require__(34);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
	 * of the current field and type definitions at any point in a GraphQL document
	 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
	 */
	var TypeInfo = exports.TypeInfo = function () {
	  function TypeInfo(schema,
	  // NOTE: this experimental optional second parameter is only needed in order
	  // to support non-spec-compliant codebases. You should never need to use it.
	  getFieldDefFn) {
	    _classCallCheck(this, TypeInfo);
	
	    this._schema = schema;
	    this._typeStack = [];
	    this._parentTypeStack = [];
	    this._inputTypeStack = [];
	    this._fieldDefStack = [];
	    this._directive = null;
	    this._argument = null;
	    this._enumValue = null;
	    this._getFieldDef = getFieldDefFn || getFieldDef;
	  }
	
	  TypeInfo.prototype.getType = function getType() {
	    if (this._typeStack.length > 0) {
	      return this._typeStack[this._typeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getParentType = function getParentType() {
	    if (this._parentTypeStack.length > 0) {
	      return this._parentTypeStack[this._parentTypeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getInputType = function getInputType() {
	    if (this._inputTypeStack.length > 0) {
	      return this._inputTypeStack[this._inputTypeStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getFieldDef = function getFieldDef() {
	    if (this._fieldDefStack.length > 0) {
	      return this._fieldDefStack[this._fieldDefStack.length - 1];
	    }
	  };
	
	  TypeInfo.prototype.getDirective = function getDirective() {
	    return this._directive;
	  };
	
	  TypeInfo.prototype.getArgument = function getArgument() {
	    return this._argument;
	  };
	
	  TypeInfo.prototype.getEnumValue = function getEnumValue() {
	    return this._enumValue;
	  };
	
	  // Flow does not yet handle this case.
	
	
	  TypeInfo.prototype.enter = function enter(node /* ASTNode */) {
	    var schema = this._schema;
	    switch (node.kind) {
	      case Kind.SELECTION_SET:
	        var namedType = (0, _definition.getNamedType)(this.getType());
	        this._parentTypeStack.push((0, _definition.isCompositeType)(namedType) ? namedType : undefined);
	        break;
	      case Kind.FIELD:
	        var parentType = this.getParentType();
	        var fieldDef = void 0;
	        if (parentType) {
	          fieldDef = this._getFieldDef(schema, parentType, node);
	        }
	        this._fieldDefStack.push(fieldDef);
	        this._typeStack.push(fieldDef && fieldDef.type);
	        break;
	      case Kind.DIRECTIVE:
	        this._directive = schema.getDirective(node.name.value);
	        break;
	      case Kind.OPERATION_DEFINITION:
	        var type = void 0;
	        if (node.operation === 'query') {
	          type = schema.getQueryType();
	        } else if (node.operation === 'mutation') {
	          type = schema.getMutationType();
	        } else if (node.operation === 'subscription') {
	          type = schema.getSubscriptionType();
	        }
	        this._typeStack.push(type);
	        break;
	      case Kind.INLINE_FRAGMENT:
	      case Kind.FRAGMENT_DEFINITION:
	        var typeConditionAST = node.typeCondition;
	        var outputType = typeConditionAST ? (0, _typeFromAST.typeFromAST)(schema, typeConditionAST) : this.getType();
	        this._typeStack.push((0, _definition.isOutputType)(outputType) ? outputType : undefined);
	        break;
	      case Kind.VARIABLE_DEFINITION:
	        var inputType = (0, _typeFromAST.typeFromAST)(schema, node.type);
	        this._inputTypeStack.push((0, _definition.isInputType)(inputType) ? inputType : undefined);
	        break;
	      case Kind.ARGUMENT:
	        var argDef = void 0;
	        var argType = void 0;
	        var fieldOrDirective = this.getDirective() || this.getFieldDef();
	        if (fieldOrDirective) {
	          argDef = (0, _find2.default)(fieldOrDirective.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (argDef) {
	            argType = argDef.type;
	          }
	        }
	        this._argument = argDef;
	        this._inputTypeStack.push(argType);
	        break;
	      case Kind.LIST:
	        var listType = (0, _definition.getNullableType)(this.getInputType());
	        this._inputTypeStack.push(listType instanceof _definition.GraphQLList ? listType.ofType : undefined);
	        break;
	      case Kind.OBJECT_FIELD:
	        var objectType = (0, _definition.getNamedType)(this.getInputType());
	        var fieldType = void 0;
	        if (objectType instanceof _definition.GraphQLInputObjectType) {
	          var inputField = objectType.getFields()[node.name.value];
	          fieldType = inputField ? inputField.type : undefined;
	        }
	        this._inputTypeStack.push(fieldType);
	        break;
	      case Kind.ENUM:
	        var enumType = (0, _definition.getNamedType)(this.getInputType());
	        var enumValue = void 0;
	        if (enumType instanceof _definition.GraphQLEnumType) {
	          enumValue = enumType.getValue(node.value);
	        }
	        this._enumValue = enumValue;
	        break;
	    }
	  };
	
	  TypeInfo.prototype.leave = function leave(node) {
	    switch (node.kind) {
	      case Kind.SELECTION_SET:
	        this._parentTypeStack.pop();
	        break;
	      case Kind.FIELD:
	        this._fieldDefStack.pop();
	        this._typeStack.pop();
	        break;
	      case Kind.DIRECTIVE:
	        this._directive = null;
	        break;
	      case Kind.OPERATION_DEFINITION:
	      case Kind.INLINE_FRAGMENT:
	      case Kind.FRAGMENT_DEFINITION:
	        this._typeStack.pop();
	        break;
	      case Kind.VARIABLE_DEFINITION:
	        this._inputTypeStack.pop();
	        break;
	      case Kind.ARGUMENT:
	        this._argument = null;
	        this._inputTypeStack.pop();
	        break;
	      case Kind.LIST:
	      case Kind.OBJECT_FIELD:
	        this._inputTypeStack.pop();
	        break;
	      case Kind.ENUM:
	        this._enumValue = null;
	        break;
	    }
	  };
	
	  return TypeInfo;
	}();
	
	/**
	 * Not exactly the same as the executor's definition of getFieldDef, in this
	 * statically evaluated environment we do not always have an Object type,
	 * and need to handle Interface and Union types.
	 */
	
	
	function getFieldDef(schema, parentType, fieldNode) {
	  var name = fieldNode.name.value;
	  if (name === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.SchemaMetaFieldDef;
	  }
	  if (name === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
	    return _introspection.TypeMetaFieldDef;
	  }
	  if (name === _introspection.TypeNameMetaFieldDef.name && (0, _definition.isCompositeType)(parentType)) {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	  if (parentType instanceof _definition.GraphQLObjectType || parentType instanceof _definition.GraphQLInterfaceType) {
	    return parentType.getFields()[name];
	  }
	}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertValidName = assertValidName;
	exports.formatWarning = formatWarning;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	var ERROR_PREFIX_RX = /^Error: /;
	
	// Silences warnings if an environment flag is enabled
	var noNameWarning = Boolean(process && ({"NODE_ENV":"production","PUBLIC_DIR":"/var/www/html/public"}) && ({"NODE_ENV":"production","PUBLIC_DIR":"/var/www/html/public"}).GRAPHQL_NO_NAME_WARNING);
	
	// Ensures console warnings are only issued once.
	var hasWarnedAboutDunder = false;
	
	/**
	 * Upholds the spec rules about naming.
	 */
	function assertValidName(name, isIntrospection) {
	  if (!name || typeof name !== 'string') {
	    throw new Error('Must be named. Unexpected name: ' + name + '.');
	  }
	  if (!isIntrospection && !hasWarnedAboutDunder && !noNameWarning && name.slice(0, 2) === '__') {
	    hasWarnedAboutDunder = true;
	    /* eslint-disable no-console */
	    if (console && console.warn) {
	      var error = new Error('Name "' + name + '" must not begin with "__", which is reserved by ' + 'GraphQL introspection. In a future release of graphql this will ' + 'become a hard error.');
	      console.warn(formatWarning(error));
	    }
	    /* eslint-enable no-console */
	  }
	  if (!NAME_RX.test(name)) {
	    throw new Error('Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but "' + name + '" does not.');
	  }
	}
	
	/**
	 * Returns a human-readable warning based an the supplied Error object,
	 * including stack trace information if available.
	 */
	function formatWarning(error) {
	  var formatted = '';
	  var errorString = String(error).replace(ERROR_PREFIX_RX, '');
	  var stack = error.stack;
	  if (stack) {
	    formatted = stack.replace(ERROR_PREFIX_RX, '');
	  }
	  if (formatted.indexOf(errorString) === -1) {
	    formatted = errorString + '\n' + formatted;
	  }
	  return formatted.trim();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(222)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.astFromValue = astFromValue;
	
	var _iterall = __webpack_require__(46);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__(66);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _definition = __webpack_require__(6);
	
	var _scalars = __webpack_require__(32);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a GraphQL Value AST given a JavaScript value.
	 *
	 * A GraphQL type must be provided, which will be used to interpret different
	 * JavaScript values.
	 *
	 * | JSON Value    | GraphQL Value        |
	 * | ------------- | -------------------- |
	 * | Object        | Input Object         |
	 * | Array         | List                 |
	 * | Boolean       | Boolean              |
	 * | String        | String / Enum Value  |
	 * | Number        | Int / Float          |
	 * | Mixed         | Enum Value           |
	 * | null          | NullValue            |
	 *
	 */
	function astFromValue(value, type) {
	  // Ensure flow knows that we treat function params as const.
	  var _value = value;
	
	  if (type instanceof _definition.GraphQLNonNull) {
	    var astValue = astFromValue(_value, type.ofType);
	    if (astValue && astValue.kind === Kind.NULL) {
	      return null;
	    }
	    return astValue;
	  }
	
	  // only explicit null, not undefined, NaN
	  if (_value === null) {
	    return { kind: Kind.NULL };
	  }
	
	  // undefined, NaN
	  if ((0, _isInvalid2.default)(_value)) {
	    return null;
	  }
	
	  // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
	  // the value is not an array, convert the value using the list's item type.
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if ((0, _iterall.isCollection)(_value)) {
	      var valuesNodes = [];
	      (0, _iterall.forEach)(_value, function (item) {
	        var itemNode = astFromValue(item, itemType);
	        if (itemNode) {
	          valuesNodes.push(itemNode);
	        }
	      });
	      return { kind: Kind.LIST, values: valuesNodes };
	    }
	    return astFromValue(_value, itemType);
	  }
	
	  // Populate the fields of the input object by creating ASTs from each value
	  // in the JavaScript object according to the fields in the input type.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if (_value === null || (typeof _value === 'undefined' ? 'undefined' : _typeof(_value)) !== 'object') {
	      return null;
	    }
	    var fields = type.getFields();
	    var fieldNodes = [];
	    Object.keys(fields).forEach(function (fieldName) {
	      var fieldType = fields[fieldName].type;
	      var fieldValue = astFromValue(_value[fieldName], fieldType);
	      if (fieldValue) {
	        fieldNodes.push({
	          kind: Kind.OBJECT_FIELD,
	          name: { kind: Kind.NAME, value: fieldName },
	          value: fieldValue
	        });
	      }
	    });
	    return { kind: Kind.OBJECT, fields: fieldNodes };
	  }
	
	  !(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType) ? (0, _invariant2.default)(0, 'Must provide Input Type, cannot use: ' + String(type)) : void 0;
	
	  // Since value is an internally represented value, it must be serialized
	  // to an externally represented value before converting into an AST.
	  var serialized = type.serialize(_value);
	  if ((0, _isNullish2.default)(serialized)) {
	    return null;
	  }
	
	  // Others serialize based on their corresponding JavaScript scalar types.
	  if (typeof serialized === 'boolean') {
	    return { kind: Kind.BOOLEAN, value: serialized };
	  }
	
	  // JavaScript numbers can be Int or Float values.
	  if (typeof serialized === 'number') {
	    var stringNum = String(serialized);
	    return (/^[0-9]+$/.test(stringNum) ? { kind: Kind.INT, value: stringNum } : { kind: Kind.FLOAT, value: stringNum }
	    );
	  }
	
	  if (typeof serialized === 'string') {
	    // Enum types use Enum literals.
	    if (type instanceof _definition.GraphQLEnumType) {
	      return { kind: Kind.ENUM, value: serialized };
	    }
	
	    // ID types can use Int literals.
	    if (type === _scalars.GraphQLID && /^[0-9]+$/.test(serialized)) {
	      return { kind: Kind.INT, value: serialized };
	    }
	
	    // Use JSON stringify, which uses the same string encoding as GraphQL,
	    // then remove the quotes.
	    return {
	      kind: Kind.STRING,
	      value: JSON.stringify(serialized).slice(1, -1)
	    };
	  }
	
	  throw new TypeError('Cannot convert value to AST: ' + String(serialized));
	}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Get browser language.
	 *
	 * @return {String} langKey
	 */
	var getBrowserLanguage = function getBrowserLanguage() {
	  if (typeof window === 'undefined') {
	    return null;
	  }
	
	  var first = window.navigator.languages ? window.navigator.languages[0] : null;
	
	  var lang = first || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	
	  return lang;
	};
	
	exports.default = getBrowserLanguage;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrowserLanguage = __webpack_require__(109);
	
	var _getBrowserLanguage2 = _interopRequireDefault(_getBrowserLanguage);
	
	var _getValidLangKey = __webpack_require__(70);
	
	var _getValidLangKey2 = _interopRequireDefault(_getValidLangKey);
	
	var _ramda = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get user browser valid langKey
	 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
	 * @param {String} defaultLangKey default browser language key
	 * @return {string} valid langKey
	 */
	var getUserLangKey = function getUserLangKey(langs, defaultLangKey) {
	  return (0, _ramda.pipe)(_getBrowserLanguage2.default, (0, _getValidLangKey2.default)(langs, defaultLangKey))();
	};
	
	exports.default = getUserLangKey;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xany = __webpack_require__(136);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var _has = __webpack_require__(12);
	var _isArray = __webpack_require__(21);
	var _isInteger = __webpack_require__(80);
	var assoc = __webpack_require__(48);
	var isNil = __webpack_require__(140);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = (!isNil(obj) && _has(idx, obj)) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(72);
	var compose = __webpack_require__(73);
	var map = __webpack_require__(13);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curry = __webpack_require__(49);
	var nAry = __webpack_require__(60);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _map = __webpack_require__(56);
	var curryN = __webpack_require__(9);
	var max = __webpack_require__(31);
	var pluck = __webpack_require__(41);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared in terms of
	 * value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(51);
	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xdrop = __webpack_require__(307);
	var slice = __webpack_require__(26);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xdropRepeatsWith = __webpack_require__(137);
	var last = __webpack_require__(142);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isArguments = __webpack_require__(133);
	var _isArray = __webpack_require__(21);
	var _isObject = __webpack_require__(81);
	var _isString = __webpack_require__(37);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x['fantasy-land/empty'] === 'function') ?
	      x['fantasy-land/empty']() :
	    (x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function') ?
	      x.constructor['fantasy-land/empty']() :
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(129);
	var type = __webpack_require__(87);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry2 = __webpack_require__(1);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(14);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(12);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = __webpack_require__(53);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (_isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var converge = __webpack_require__(119);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(39);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isNumber = __webpack_require__(134);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(15);
	var ap = __webpack_require__(71);
	var curryN = __webpack_require__(9);
	var map = __webpack_require__(13);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var sum = __webpack_require__(159);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.median
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry2 = __webpack_require__(1);
	var _has = __webpack_require__(12);
	
	
	/**
	 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
	 * additional function that will be applied to a given argument set and used to
	 * create the cache key under which the results of the function to be memoized
	 * will be stored. Care must be taken when implementing key generation to avoid
	 * clashes that may overwrite previous entries erroneously.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to generate the cache key.
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoize
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoizeWith(R.identity, n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry2(function memoizeWith(mFn, fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = mFn.apply(this, arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _pipe = __webpack_require__(298);
	var reduce = __webpack_require__(19);
	var tail = __webpack_require__(85);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _pipeP = __webpack_require__(299);
	var reduce = __webpack_require__(19);
	var tail = __webpack_require__(85);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to [`reduce`](#reduce), except moves through the input list from the
	 * right to the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var ap = __webpack_require__(71);
	var map = __webpack_require__(13);
	var prepend = __webpack_require__(155);
	var reduceRight = __webpack_require__(156);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(47);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var drop = __webpack_require__(124);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @see R.repeat
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(286);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. [`R.equals`](#equals) is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @see R.valuesIn, R.keys
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _has = __webpack_require__(12);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as [`filter`](#filter) and [`find`](#find).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(R.__, 10),
	 *        y: R.lt(R.__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ }),
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectLanguage = __webpack_require__(171);
	
	var _SelectLanguage2 = _interopRequireDefault(_SelectLanguage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuButton = function MenuButton(_ref) {
	  var onClick = _ref.onClick,
	      langs = _ref.langs,
	      language = _ref.language;
	  return _react2.default.createElement(
	    "nav",
	    null,
	    _react2.default.createElement(_SelectLanguage2.default, { language: language, langs: langs }),
	    _react2.default.createElement(
	      "a",
	      { href: "#menu", onClick: onClick },
	      "Menu"
	    )
	  );
	};
	
	exports.default = MenuButton;
	module.exports = exports["default"];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SiteTitle = __webpack_require__(172);
	
	var _SiteTitle2 = _interopRequireDefault(_SiteTitle);
	
	var _MenuButton = __webpack_require__(168);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationBar = function NavigationBar(_ref) {
	  var siteTitle = _ref.siteTitle,
	      openMenu = _ref.openMenu,
	      className = _ref.className,
	      language = _ref.language,
	      langs = _ref.langs;
	  return _react2.default.createElement(
	    "header",
	    { id: "header", className: className },
	    _react2.default.createElement(
	      _SiteTitle2.default,
	      { language: language },
	      siteTitle
	    ),
	    _react2.default.createElement(_MenuButton2.default, { onClick: openMenu, language: language, langs: langs })
	  );
	};
	
	exports.default = NavigationBar;
	module.exports = exports["default"];

/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(64);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmojiRender = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectLanguage = function SelectLanguage(props) {
	  var link = props.langs.map(function (lang) {
	    if (!lang.selected) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: "/" + lang.langKey + "/",
	          key: lang.langKey,
	          style: {
	            padding: "0 20px",
	            border: "0",
	            color: "White",
	            textAlign: "center",
	            textDecoration: "none",
	            display: "inline-block",
	            lineHeight: "26px"
	          }
	        },
	        _react2.default.createElement(
	          "li",
	          {
	            selected: lang.selected,
	            style: {
	              listStyleType: "none",
	              padding: 0,
	              margin: 0,
	              display: "inline-block"
	            }
	          },
	          _react2.default.createElement(
	            "p",
	            { style: { fontSize: "12px", display: "inline" } },
	            lang.langKey === "es" ? "Cambiar " : "Change "
	          ),
	          lang.langKey === "es" ? _react2.default.createElement(_reactEmojiRender.Emojione, { svg: true, text: "\uD83C\uDDEA\uD83C\uDDF8" }) : _react2.default.createElement(_reactEmojiRender.Emojione, { svg: true, text: "\uD83C\uDDFA\uD83C\uDDF8" })
	        )
	      );
	    }
	  });
	
	  return _react2.default.createElement(
	    "section",
	    {
	      style: {
	        fontFamily: "Raleway, Helvetica, sans-serif",
	        display: "inline-block"
	      }
	    },
	    _react2.default.createElement(
	      "ul",
	      {
	        style: {
	          padding: 0,
	          listStyleType: "none",
	          height: "26px",
	          width: "100%",
	          display: "block",
	          alignContent: "space-between",
	          margin: "5px 0"
	        }
	      },
	      link
	    )
	  );
	};
	
	SelectLanguage.propTypes = {
	  langs: _propTypes2.default.array
	};
	
	exports.default = SelectLanguage;
	module.exports = exports["default"];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(64);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SiteTitle = function SiteTitle(_ref) {
	  var children = _ref.children,
	      language = _ref.language;
	  return _react2.default.createElement(
	    "h1",
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/" + language + "/" },
	      children
	    )
	  );
	};
	
	exports.default = SiteTitle;
	module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function () {
		// https://mathiasbynens.be/notes/es-unicode-property-escapes#emoji
		return (/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]\uFE0F|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F/g
		);
	};


/***/ }),
/* 175 */,
/* 176 */
/***/ (function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = {
	  "skin-tone-2": "🏻",
	  "skin-tone-3": "🏿",
	  "skin-tone-4": "🏽",
	  "skin-tone-5": "🏾",
	  "skin-tone-6": "🏿",
	  "100": "💯",
	  "1234": "🔢",
	  smile: "😄",
	  smiley: "😃",
	  grinning: "😀",
	  slightly_smiling_face: "🙂",
	  blush: "😊",
	  relaxed: "☺️",
	  wink: "😉",
	  heart_eyes: "😍",
	  kissing_heart: "😘",
	  kissing_closed_eyes: "😚",
	  kissing: "😗",
	  kissing_smiling_eyes: "😙",
	  stuck_out_tongue_winking_eye: "😜",
	  stuck_out_tongue_closed_eyes: "😝",
	  stuck_out_tongue: "😛",
	  flushed: "😳",
	  grin: "😁",
	  pensive: "😔",
	  relieved: "😌",
	  unamused: "😒",
	  disappointed: "😞",
	  persevere: "😣",
	  cry: "😢",
	  joy: "😂",
	  sob: "😭",
	  sleepy: "😪",
	  disappointed_relieved: "😥",
	  cold_sweat: "😰",
	  sweat_smile: "😅",
	  sweat: "😓",
	  weary: "😩",
	  tired_face: "😫",
	  fearful: "😨",
	  scream: "😱",
	  angry: "😠",
	  rage: "😡",
	  pout: "😡",
	  triumph: "😤",
	  confounded: "😖",
	  laughing: "😆",
	  satisfied: "😆",
	  yum: "😋",
	  mask: "😷",
	  sunglasses: "😎",
	  sleeping: "😴",
	  dizzy_face: "😵",
	  astonished: "😲",
	  worried: "😟",
	  frowning: "😦",
	  anguished: "😧",
	  smiling_imp: "😈",
	  imp: "👿",
	  open_mouth: "😮",
	  grimacing: "😬",
	  neutral_face: "😐",
	  confused: "😕",
	  hushed: "😯",
	  no_mouth: "😶",
	  innocent: "😇",
	  smirk: "😏",
	  expressionless: "😑",
	  man_with_gua_pi_mao: "👲",
	  man_with_turban: "👳",
	  cop: "👮",
	  construction_worker: "👷",
	  guardsman: "💂",
	  baby: "👶",
	  boy: "👦",
	  girl: "👧",
	  man: "👨",
	  woman: "👩",
	  older_man: "👴",
	  older_woman: "👵",
	  person_with_blond_hair: "👱",
	  angel: "👼",
	  princess: "👸",
	  smiley_cat: "😺",
	  smile_cat: "😸",
	  heart_eyes_cat: "😻",
	  kissing_cat: "😽",
	  smirk_cat: "😼",
	  scream_cat: "🙀",
	  crying_cat_face: "😿",
	  joy_cat: "😹",
	  pouting_cat: "😾",
	  japanese_ogre: "👹",
	  japanese_goblin: "👺",
	  see_no_evil: "🙈",
	  hear_no_evil: "🙉",
	  speak_no_evil: "🙊",
	  skull: "💀",
	  alien: "👽",
	  hankey: "💩",
	  poop: "💩",
	  shit: "💩",
	  fire: "🔥",
	  sparkles: "✨",
	  star2: "🌟",
	  dizzy: "💫",
	  boom: "💥",
	  collision: "💥",
	  anger: "💢",
	  sweat_drops: "💦",
	  droplet: "💧",
	  zzz: "💤",
	  dash: "💨",
	  ear: "👂",
	  eyes: "👀",
	  nose: "👃",
	  tongue: "👅",
	  lips: "👄",
	  "+1": "👍",
	  thumbsup: "👍",
	  "-1": "👎",
	  thumbsdown: "👎",
	  ok_hand: "👌",
	  facepunch: "👊",
	  punch: "👊",
	  fist: "✊",
	  v: "✌️",
	  wave: "👋",
	  hand: "✋",
	  raised_hand: "✋",
	  open_hands: "👐",
	  point_up_2: "👆",
	  point_down: "👇",
	  point_right: "👉",
	  point_left: "👈",
	  raised_hands: "🙌",
	  pray: "🙏",
	  point_up: "☝️",
	  clap: "👏",
	  muscle: "💪",
	  walking: "🚶",
	  runner: "🏃",
	  running: "🏃",
	  dancer: "💃",
	  couple: "👫",
	  family: "👪",
	  two_men_holding_hands: "👬",
	  two_women_holding_hands: "👭",
	  couplekiss: "💏",
	  couple_with_heart: "💑",
	  dancers: "👯",
	  ok_woman: "🙆",
	  no_good: "🙅",
	  ng_woman: "🙅",
	  information_desk_person: "💁",
	  raising_hand: "🙋",
	  massage: "💆",
	  haircut: "💇",
	  nail_care: "💅",
	  bride_with_veil: "👰",
	  person_with_pouting_face: "🙎",
	  person_frowning: "🙍",
	  bow: "🙇",
	  tophat: "🎩",
	  crown: "👑",
	  womans_hat: "👒",
	  athletic_shoe: "👟",
	  mans_shoe: "👞",
	  shoe: "👞",
	  sandal: "👡",
	  high_heel: "👠",
	  boot: "👢",
	  shirt: "👕",
	  tshirt: "👕",
	  necktie: "👔",
	  womans_clothes: "👚",
	  dress: "👗",
	  running_shirt_with_sash: "🎽",
	  jeans: "👖",
	  kimono: "👘",
	  bikini: "👙",
	  briefcase: "💼",
	  handbag: "👜",
	  pouch: "👝",
	  purse: "👛",
	  eyeglasses: "👓",
	  ribbon: "🎀",
	  closed_umbrella: "🌂",
	  lipstick: "💄",
	  yellow_heart: "💛",
	  blue_heart: "💙",
	  purple_heart: "💜",
	  green_heart: "💚",
	  heart: "❤️",
	  broken_heart: "💔",
	  heartpulse: "💗",
	  heartbeat: "💓",
	  two_hearts: "💕",
	  sparkling_heart: "💖",
	  revolving_hearts: "💞",
	  cupid: "💘",
	  love_letter: "💌",
	  kiss: "💋",
	  ring: "💍",
	  gem: "💎",
	  bust_in_silhouette: "👤",
	  busts_in_silhouette: "👥",
	  speech_balloon: "💬",
	  footprints: "👣",
	  thought_balloon: "💭",
	  dog: "🐶",
	  wolf: "🐺",
	  cat: "🐱",
	  mouse: "🐭",
	  hamster: "🐹",
	  rabbit: "🐰",
	  frog: "🐸",
	  tiger: "🐯",
	  koala: "🐨",
	  bear: "🐻",
	  pig: "🐷",
	  pig_nose: "🐽",
	  cow: "🐮",
	  boar: "🐗",
	  monkey_face: "🐵",
	  monkey: "🐒",
	  horse: "🐴",
	  sheep: "🐑",
	  elephant: "🐘",
	  panda_face: "🐼",
	  penguin: "🐧",
	  bird: "🐦",
	  baby_chick: "🐤",
	  hatched_chick: "🐥",
	  hatching_chick: "🐣",
	  chicken: "🐔",
	  snake: "🐍",
	  turtle: "🐢",
	  bug: "🐛",
	  bee: "🐝",
	  honeybee: "🐝",
	  ant: "🐜",
	  beetle: "🐞",
	  snail: "🐌",
	  octopus: "🐙",
	  shell: "🐚",
	  tropical_fish: "🐠",
	  fish: "🐟",
	  dolphin: "🐬",
	  flipper: "🐬",
	  whale: "🐳",
	  whale2: "🐋",
	  cow2: "🐄",
	  ram: "🐏",
	  rat: "🐀",
	  water_buffalo: "🐃",
	  tiger2: "🐅",
	  rabbit2: "🐇",
	  dragon: "🐉",
	  racehorse: "🐎",
	  goat: "🐐",
	  rooster: "🐓",
	  dog2: "🐕",
	  pig2: "🐖",
	  mouse2: "🐁",
	  ox: "🐂",
	  dragon_face: "🐲",
	  blowfish: "🐡",
	  crocodile: "🐊",
	  camel: "🐫",
	  dromedary_camel: "🐪",
	  leopard: "🐆",
	  cat2: "🐈",
	  poodle: "🐩",
	  feet: "🐾",
	  paw_prints: "🐾",
	  bouquet: "💐",
	  cherry_blossom: "🌸",
	  tulip: "🌷",
	  four_leaf_clover: "🍀",
	  rose: "🌹",
	  sunflower: "🌻",
	  hibiscus: "🌺",
	  maple_leaf: "🍁",
	  leaves: "🍃",
	  fallen_leaf: "🍂",
	  herb: "🌿",
	  ear_of_rice: "🌾",
	  mushroom: "🍄",
	  cactus: "🌵",
	  palm_tree: "🌴",
	  evergreen_tree: "🌲",
	  deciduous_tree: "🌳",
	  chestnut: "🌰",
	  seedling: "🌱",
	  blossom: "🌼",
	  globe_with_meridians: "🌐",
	  sun_with_face: "🌞",
	  full_moon_with_face: "🌝",
	  new_moon_with_face: "🌚",
	  new_moon: "🌑",
	  waxing_crescent_moon: "🌒",
	  first_quarter_moon: "🌓",
	  moon: "🌔",
	  waxing_gibbous_moon: "🌔",
	  full_moon: "🌕",
	  waning_gibbous_moon: "🌖",
	  last_quarter_moon: "🌗",
	  waning_crescent_moon: "🌘",
	  last_quarter_moon_with_face: "🌜",
	  first_quarter_moon_with_face: "🌛",
	  crescent_moon: "🌙",
	  earth_africa: "🌍",
	  earth_americas: "🌎",
	  earth_asia: "🌏",
	  volcano: "🌋",
	  milky_way: "🌌",
	  stars: "🌠",
	  star: "⭐",
	  sunny: "☀️",
	  partly_sunny: "⛅",
	  cloud: "☁️",
	  zap: "⚡",
	  umbrella: "☔",
	  snowflake: "❄️",
	  snowman: "⛄",
	  cyclone: "🌀",
	  foggy: "🌁",
	  rainbow: "🌈",
	  ocean: "🌊",
	  bamboo: "🎍",
	  gift_heart: "💝",
	  dolls: "🎎",
	  school_satchel: "🎒",
	  mortar_board: "🎓",
	  flags: "🎏",
	  fireworks: "🎆",
	  sparkler: "🎇",
	  wind_chime: "🎐",
	  rice_scene: "🎑",
	  jack_o_lantern: "🎃",
	  ghost: "👻",
	  santa: "🎅",
	  christmas_tree: "🎄",
	  gift: "🎁",
	  tanabata_tree: "🎋",
	  tada: "🎉",
	  confetti_ball: "🎊",
	  balloon: "🎈",
	  crossed_flags: "🎌",
	  crystal_ball: "🔮",
	  movie_camera: "🎥",
	  camera: "📷",
	  video_camera: "📹",
	  vhs: "📼",
	  cd: "💿",
	  dvd: "📀",
	  minidisc: "💽",
	  floppy_disk: "💾",
	  computer: "💻",
	  iphone: "📱",
	  phone: "☎️",
	  telephone: "☎️",
	  telephone_receiver: "📞",
	  pager: "📟",
	  fax: "📠",
	  satellite: "📡",
	  tv: "📺",
	  radio: "📻",
	  loud_sound: "🔊",
	  sound: "🔉",
	  speaker: "🔈",
	  mute: "🔇",
	  bell: "🔔",
	  no_bell: "🔕",
	  loudspeaker: "📢",
	  mega: "📣",
	  hourglass_flowing_sand: "⏳",
	  hourglass: "⌛",
	  alarm_clock: "⏰",
	  watch: "⌚",
	  unlock: "🔓",
	  lock: "🔒",
	  lock_with_ink_pen: "🔏",
	  closed_lock_with_key: "🔐",
	  key: "🔑",
	  mag_right: "🔎",
	  bulb: "💡",
	  flashlight: "🔦",
	  high_brightness: "🔆",
	  low_brightness: "🔅",
	  electric_plug: "🔌",
	  battery: "🔋",
	  mag: "🔍",
	  bathtub: "🛁",
	  bath: "🛀",
	  shower: "🚿",
	  toilet: "🚽",
	  wrench: "🔧",
	  nut_and_bolt: "🔩",
	  hammer: "🔨",
	  door: "🚪",
	  smoking: "🚬",
	  bomb: "💣",
	  gun: "🔫",
	  hocho: "🔪",
	  knife: "🔪",
	  pill: "💊",
	  syringe: "💉",
	  moneybag: "💰",
	  yen: "💴",
	  dollar: "💵",
	  pound: "💷",
	  euro: "💶",
	  credit_card: "💳",
	  money_with_wings: "💸",
	  calling: "📲",
	  "e-mail": "📧",
	  inbox_tray: "📥",
	  outbox_tray: "📤",
	  email: "✉️",
	  envelope: "✉️",
	  envelope_with_arrow: "📩",
	  incoming_envelope: "📨",
	  postal_horn: "📯",
	  mailbox: "📫",
	  mailbox_closed: "📪",
	  mailbox_with_mail: "📬",
	  mailbox_with_no_mail: "📭",
	  postbox: "📮",
	  package: "📦",
	  memo: "📝",
	  pencil: "📝",
	  page_facing_up: "📄",
	  page_with_curl: "📃",
	  bookmark_tabs: "📑",
	  bar_chart: "📊",
	  chart_with_upwards_trend: "📈",
	  chart_with_downwards_trend: "📉",
	  scroll: "📜",
	  clipboard: "📋",
	  date: "📅",
	  calendar: "📆",
	  card_index: "📇",
	  file_folder: "📁",
	  open_file_folder: "📂",
	  scissors: "✂️",
	  pushpin: "📌",
	  paperclip: "📎",
	  black_nib: "✒️",
	  pencil2: "✏️",
	  straight_ruler: "📏",
	  triangular_ruler: "📐",
	  closed_book: "📕",
	  green_book: "📗",
	  blue_book: "📘",
	  orange_book: "📙",
	  notebook: "📓",
	  notebook_with_decorative_cover: "📔",
	  ledger: "📒",
	  books: "📚",
	  book: "📖",
	  open_book: "📖",
	  bookmark: "🔖",
	  name_badge: "📛",
	  microscope: "🔬",
	  telescope: "🔭",
	  newspaper: "📰",
	  art: "🎨",
	  clapper: "🎬",
	  microphone: "🎤",
	  headphones: "🎧",
	  musical_score: "🎼",
	  musical_note: "🎵",
	  notes: "🎶",
	  musical_keyboard: "🎹",
	  violin: "🎻",
	  trumpet: "🎺",
	  saxophone: "🎷",
	  guitar: "🎸",
	  space_invader: "👾",
	  video_game: "🎮",
	  black_joker: "🃏",
	  flower_playing_cards: "🎴",
	  mahjong: "🀄",
	  game_die: "🎲",
	  dart: "🎯",
	  football: "🏈",
	  basketball: "🏀",
	  soccer: "⚽",
	  baseball: "⚾️",
	  tennis: "🎾",
	  "8ball": "🎱",
	  rugby_football: "🏉",
	  bowling: "🎳",
	  golf: "⛳",
	  mountain_bicyclist: "🚵",
	  bicyclist: "🚴",
	  checkered_flag: "🏁",
	  horse_racing: "🏇",
	  trophy: "🏆",
	  ski: "🎿",
	  snowboarder: "🏂",
	  swimmer: "🏊",
	  surfer: "🏄",
	  fishing_pole_and_fish: "🎣",
	  coffee: "☕",
	  tea: "🍵",
	  sake: "🍶",
	  baby_bottle: "🍼",
	  beer: "🍺",
	  beers: "🍻",
	  cocktail: "🍸",
	  tropical_drink: "🍹",
	  wine_glass: "🍷",
	  fork_and_knife: "🍴",
	  pizza: "🍕",
	  hamburger: "🍔",
	  fries: "🍟",
	  poultry_leg: "🍗",
	  meat_on_bone: "🍖",
	  spaghetti: "🍝",
	  curry: "🍛",
	  fried_shrimp: "🍤",
	  bento: "🍱",
	  sushi: "🍣",
	  fish_cake: "🍥",
	  rice_ball: "🍙",
	  rice_cracker: "🍘",
	  rice: "🍚",
	  ramen: "🍜",
	  stew: "🍲",
	  oden: "🍢",
	  dango: "🍡",
	  egg: "🍳",
	  bread: "🍞",
	  doughnut: "🍩",
	  custard: "🍮",
	  icecream: "🍦",
	  ice_cream: "🍨",
	  shaved_ice: "🍧",
	  birthday: "🎂",
	  cake: "🍰",
	  cookie: "🍪",
	  chocolate_bar: "🍫",
	  candy: "🍬",
	  lollipop: "🍭",
	  honey_pot: "🍯",
	  apple: "🍎",
	  green_apple: "🍏",
	  tangerine: "🍊",
	  orange: "🍊",
	  mandarin: "🍊",
	  lemon: "🍋",
	  cherries: "🍒",
	  grapes: "🍇",
	  watermelon: "🍉",
	  strawberry: "🍓",
	  peach: "🍑",
	  melon: "🍈",
	  banana: "🍌",
	  pear: "🍐",
	  pineapple: "🍍",
	  sweet_potato: "🍠",
	  eggplant: "🍆",
	  tomato: "🍅",
	  corn: "🌽",
	  house: "🏠",
	  house_with_garden: "🏡",
	  school: "🏫",
	  office: "🏢",
	  post_office: "🏣",
	  hospital: "🏥",
	  bank: "🏦",
	  convenience_store: "🏪",
	  love_hotel: "🏩",
	  hotel: "🏨",
	  wedding: "💒",
	  church: "⛪",
	  department_store: "🏬",
	  european_post_office: "🏤",
	  city_sunrise: "🌇",
	  city_sunset: "🌆",
	  japanese_castle: "🏯",
	  european_castle: "🏰",
	  tent: "⛺",
	  factory: "🏭",
	  tokyo_tower: "🗼",
	  japan: "🗾",
	  mount_fuji: "🗻",
	  sunrise_over_mountains: "🌄",
	  sunrise: "🌅",
	  night_with_stars: "🌃",
	  statue_of_liberty: "🗽",
	  bridge_at_night: "🌉",
	  carousel_horse: "🎠",
	  ferris_wheel: "🎡",
	  fountain: "⛲",
	  roller_coaster: "🎢",
	  ship: "🚢",
	  boat: "⛵",
	  sailboat: "⛵",
	  speedboat: "🚤",
	  rowboat: "🚣",
	  anchor: "⚓",
	  rocket: "🚀",
	  airplane: "✈️",
	  seat: "💺",
	  helicopter: "🚁",
	  steam_locomotive: "🚂",
	  tram: "🚊",
	  station: "🚉",
	  mountain_railway: "🚞",
	  train2: "🚆",
	  bullettrain_side: "🚄",
	  bullettrain_front: "🚅",
	  light_rail: "🚈",
	  metro: "🚇",
	  monorail: "🚝",
	  train: "🚋",
	  railway_car: "🚃",
	  trolleybus: "🚎",
	  bus: "🚌",
	  oncoming_bus: "🚍",
	  blue_car: "🚙",
	  oncoming_automobile: "🚘",
	  car: "🚗",
	  red_car: "🚗",
	  taxi: "🚕",
	  oncoming_taxi: "🚖",
	  articulated_lorry: "🚛",
	  truck: "🚚",
	  rotating_light: "🚨",
	  police_car: "🚓",
	  oncoming_police_car: "🚔",
	  fire_engine: "🚒",
	  ambulance: "🚑",
	  minibus: "🚐",
	  bike: "🚲",
	  aerial_tramway: "🚡",
	  suspension_railway: "🚟",
	  mountain_cableway: "🚠",
	  tractor: "🚜",
	  barber: "💈",
	  busstop: "🚏",
	  ticket: "🎫",
	  vertical_traffic_light: "🚦",
	  traffic_light: "🚥",
	  warning: "⚠️",
	  construction: "🚧",
	  beginner: "🔰",
	  fuelpump: "⛽",
	  izakaya_lantern: "🏮",
	  lantern: "🏮",
	  slot_machine: "🎰",
	  hotsprings: "♨️",
	  moyai: "🗿",
	  circus_tent: "🎪",
	  performing_arts: "🎭",
	  round_pushpin: "📍",
	  triangular_flag_on_post: "🚩",
	  jp: "🇯🇵",
	  kr: "🇰🇷",
	  de: "🇩🇪",
	  cn: "🇨🇳",
	  us: "🇺🇸",
	  fr: "🇫🇷",
	  es: "🇪🇸",
	  it: "🇮🇹",
	  ru: "🇷🇺",
	  gb: "🇬🇧",
	  uk: "🇬🇧",
	  one: "1️⃣",
	  two: "2️⃣",
	  three: "3️⃣",
	  four: "4️⃣",
	  five: "5️⃣",
	  six: "6️⃣",
	  seven: "7️⃣",
	  eight: "8️⃣",
	  nine: "9️⃣",
	  zero: "0️⃣",
	  keycap_ten: "🔟",
	  hash: "#️⃣",
	  symbols: "🔣",
	  arrow_up: "⬆️",
	  arrow_down: "⬇️",
	  arrow_left: "⬅️",
	  arrow_right: "➡️",
	  capital_abcd: "🔠",
	  abcd: "🔡",
	  abc: "🔤",
	  arrow_upper_right: "↗️",
	  arrow_upper_left: "↖️",
	  arrow_lower_right: "↘️",
	  arrow_lower_left: "↙️",
	  left_right_arrow: "↔️",
	  arrow_up_down: "↕️",
	  arrows_counterclockwise: "🔄",
	  arrow_backward: "◀️",
	  arrow_forward: "▶️",
	  arrow_up_small: "🔼",
	  arrow_down_small: "🔽",
	  leftwards_arrow_with_hook: "↩️",
	  arrow_right_hook: "↪️",
	  information_source: "ℹ️",
	  rewind: "⏪",
	  fast_forward: "⏩",
	  arrow_double_up: "⏫",
	  arrow_double_down: "⏬",
	  arrow_heading_down: "⤵️",
	  arrow_heading_up: "⤴️",
	  ok: "🆗",
	  twisted_rightwards_arrows: "🔀",
	  repeat: "🔁",
	  repeat_one: "🔂",
	  new: "🆕",
	  up: "🆙",
	  cool: "🆒",
	  free: "🆓",
	  ng: "🆖",
	  signal_strength: "📶",
	  cinema: "🎦",
	  koko: "🈁",
	  u6307: "🈯",
	  u7a7a: "🈳",
	  u6e80: "🈵",
	  u5408: "🈴",
	  u7981: "🈲",
	  ideograph_advantage: "🉐",
	  u5272: "🈹",
	  u55b6: "🈺",
	  u6709: "🈶",
	  u7121: "🈚",
	  restroom: "🚻",
	  mens: "🚹",
	  womens: "🚺",
	  baby_symbol: "🚼",
	  wc: "🚾",
	  potable_water: "🚰",
	  put_litter_in_its_place: "🚮",
	  parking: "🅿️",
	  wheelchair: "♿",
	  no_smoking: "🚭",
	  u6708: "🈷️",
	  u7533: "🈸",
	  sa: "🈂️",
	  m: "Ⓜ️",
	  passport_control: "🛂",
	  baggage_claim: "🛄",
	  left_luggage: "🛅",
	  customs: "🛃",
	  accept: "🉑",
	  secret: "㊙️",
	  congratulations: "㊗️",
	  cl: "🆑",
	  sos: "🆘",
	  id: "🆔",
	  no_entry_sign: "🚫",
	  underage: "🔞",
	  no_mobile_phones: "📵",
	  do_not_litter: "🚯",
	  "non-potable_water": "🚱",
	  no_bicycles: "🚳",
	  no_pedestrians: "🚷",
	  children_crossing: "🚸",
	  no_entry: "⛔",
	  eight_spoked_asterisk: "✳️",
	  sparkle: "❇️",
	  negative_squared_cross_mark: "❎",
	  white_check_mark: "✅",
	  eight_pointed_black_star: "✴️",
	  heart_decoration: "💟",
	  vs: "🆚",
	  vibration_mode: "📳",
	  mobile_phone_off: "📴",
	  a: "🅰️",
	  b: "🅱️",
	  ab: "🆎",
	  o2: "🅾️",
	  diamond_shape_with_a_dot_inside: "💠",
	  loop: "➿",
	  recycle: "♻️",
	  aries: "♈",
	  taurus: "♉",
	  gemini: "♊",
	  cancer: "♋",
	  leo: "♌",
	  virgo: "♍",
	  libra: "♎",
	  scorpius: "♏",
	  sagittarius: "♐",
	  capricorn: "♑",
	  aquarius: "♒",
	  pisces: "♓",
	  ophiuchus: "⛎",
	  six_pointed_star: "🔯",
	  atm: "🏧",
	  chart: "💹",
	  heavy_dollar_sign: "💲",
	  currency_exchange: "💱",
	  copyright: "©️",
	  registered: "®️",
	  tm: "™️",
	  x: "❌",
	  bangbang: "‼️",
	  interrobang: "⁉️",
	  exclamation: "❗",
	  heavy_exclamation_mark: "❗",
	  question: "❓",
	  grey_exclamation: "❕",
	  grey_question: "❔",
	  o: "⭕",
	  top: "🔝",
	  end: "🔚",
	  back: "🔙",
	  on: "🔛",
	  soon: "🔜",
	  arrows_clockwise: "🔃",
	  clock12: "🕛",
	  clock1230: "🕧",
	  clock1: "🕐",
	  clock130: "🕜",
	  clock2: "🕑",
	  clock230: "🕝",
	  clock3: "🕒",
	  clock330: "🕞",
	  clock4: "🕓",
	  clock430: "🕟",
	  clock5: "🕔",
	  clock530: "🕠",
	  clock6: "🕕",
	  clock7: "🕖",
	  clock8: "🕗",
	  clock9: "🕘",
	  clock10: "🕙",
	  clock11: "🕚",
	  clock630: "🕡",
	  clock730: "🕢",
	  clock830: "🕣",
	  clock930: "🕤",
	  clock1030: "🕥",
	  clock1130: "🕦",
	  heavy_multiplication_x: "✖️",
	  heavy_plus_sign: "➕",
	  heavy_minus_sign: "➖",
	  heavy_division_sign: "➗",
	  spades: "♠️",
	  hearts: "♥️",
	  clubs: "♣️",
	  diamonds: "♦️",
	  white_flower: "💮",
	  heavy_check_mark: "✔️",
	  ballot_box_with_check: "☑️",
	  radio_button: "🔘",
	  link: "🔗",
	  curly_loop: "➰",
	  wavy_dash: "〰️",
	  part_alternation_mark: "〽️",
	  trident: "🔱",
	  black_medium_square: "◼️",
	  white_medium_square: "◻️",
	  black_medium_small_square: "◾",
	  white_medium_small_square: "◽",
	  black_small_square: "▪️",
	  white_small_square: "▫️",
	  small_red_triangle: "🔺",
	  black_square_button: "🔲",
	  white_square_button: "🔳",
	  black_circle: "⚫",
	  white_circle: "⚪",
	  red_circle: "🔴",
	  large_blue_circle: "🔵",
	  small_red_triangle_down: "🔻",
	  white_large_square: "⬜",
	  black_large_square: "⬛",
	  large_orange_diamond: "🔶",
	  large_blue_diamond: "🔷",
	  small_orange_diamond: "🔸",
	  small_blue_diamond: "🔹"
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return new RegExp("(" + edgeCases + ")?(" + names + ")((?!(" + edgeCases + "))[a-z0-9_\\-\\+]+:)?", "g");
	};
	
	var _asciiAliases = __webpack_require__(95);
	
	var _asciiAliases2 = _interopRequireDefault(_asciiAliases);
	
	var _lodash = __webpack_require__(94);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function quoteRE(str) {
	  return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
	}
	
	var names = (0, _lodash2.default)(Object.keys(_asciiAliases2.default).map(function (name) {
	  return _asciiAliases2.default[name].map(function (alias) {
	    return quoteRE(alias);
	  });
	})).join("|");
	
	var edgeCases = ["http", "https"].join("|");
	
	// Regex reads as following:
	//
	// Match ascii aliases with optional edge cases before it (to know if parsing is needed)
	// Additionally, after the ascii alias:
	//    - Forbid edge cases
	//    - Allow characters included in normal aliases (to check later cases like :s and :smile:)

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArray = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _renderer = __webpack_require__(181);
	
	Object.defineProperty(exports, "toArray", {
	  enumerable: true,
	  get: function get() {
	    return _renderer.toArray;
	  }
	});
	exports.Twemoji = Twemoji;
	exports.Emojione = Emojione;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderer2 = _interopRequireDefault(_renderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var protocol = "https";
	
	if (typeof location !== "undefined" && location.protocol === "http:") {
	  protocol = "http";
	}
	
	exports.default = _renderer2.default;
	function Twemoji(_ref) {
	  var svg = _ref.svg,
	      options = _ref.options,
	      rest = _objectWithoutProperties(_ref, ["svg", "options"]);
	
	  var size = svg ? "" : "72x72";
	  var ext = svg ? "svg" : "png";
	
	  options = _extends({
	    protocol: protocol,
	    baseUrl: "//twemoji.maxcdn.com/2/" + (svg ? "svg/" : ""),
	    size: size,
	    ext: ext
	  }, options);
	
	  return _react2.default.createElement(_renderer2.default, _extends({ options: options }, rest));
	}
	
	Twemoji.propTypes = {
	  text: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  svg: _propTypes2.default.bool
	};
	
	function Emojione(_ref2) {
	  var svg = _ref2.svg,
	      options = _ref2.options,
	      rest = _objectWithoutProperties(_ref2, ["svg", "options"]);
	
	  var ext = svg ? "svg" : "png";
	
	  options = _extends({
	    protocol: protocol,
	    baseUrl: "//cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/assets/" + ext + "/",
	    size: "",
	    ext: ext
	  }, options);
	
	  return _react2.default.createElement(_renderer2.default, _extends({ options: options }, rest));
	}
	
	Emojione.propTypes = {
	  text: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  svg: _propTypes2.default.bool
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeProtocol;
	// ensure protocol has trailing : if missing
	function normalizeProtocol(protocol) {
	  if (protocol && !protocol.endsWith(":")) return protocol + ":";
	  return protocol;
	}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.toArray = toArray;
	exports.default = Emoji;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(173);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _stringReplaceToArray = __webpack_require__(183);
	
	var _stringReplaceToArray2 = _interopRequireDefault(_stringReplaceToArray);
	
	var _emojiRegex = __webpack_require__(174);
	
	var _emojiRegex2 = _interopRequireDefault(_emojiRegex);
	
	var _asciiRegex = __webpack_require__(178);
	
	var _asciiRegex2 = _interopRequireDefault(_asciiRegex);
	
	var _normalizeProtocol = __webpack_require__(180);
	
	var _normalizeProtocol2 = _interopRequireDefault(_normalizeProtocol);
	
	var _unicodeToCodepoint = __webpack_require__(182);
	
	var _unicodeToCodepoint2 = _interopRequireDefault(_unicodeToCodepoint);
	
	var _aliases = __webpack_require__(177);
	
	var _aliases2 = _interopRequireDefault(_aliases);
	
	var _asciiAliases = __webpack_require__(95);
	
	var _asciiAliases2 = _interopRequireDefault(_asciiAliases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var asciiAliasesRegex = (0, _asciiRegex2.default)();
	var unicodeEmojiRegex = (0, _emojiRegex2.default)();
	var aliasesRegex = /:([\w\-\_\+]+):/g;
	
	// using em's we can ensure size matches surrounding font
	var style = {
	  width: "1em",
	  height: "1em",
	  margin: "0 .05em 0 .1em",
	  verticalAlign: "-0.1em"
	};
	
	function toArray(text) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var protocol = (0, _normalizeProtocol2.default)(options.protocol);
	
	  function replaceUnicodeEmoji(match, i) {
	    if (!options.baseUrl) {
	      return _react2.default.createElement(
	        "span",
	        { key: i, style: style, className: options.className },
	        match
	      );
	    }
	
	    var separator = options.size ? "/" : "";
	    var codepoint = (0, _unicodeToCodepoint2.default)(match);
	    var src = "" + protocol + options.baseUrl + options.size + separator + codepoint + "." + options.ext;
	
	    return _react2.default.createElement("img", _extends({
	      key: i,
	      alt: match,
	      src: src,
	      style: style,
	      className: options.className
	    }, options.props));
	  }
	
	  function replaceAsciiAliases() {
	    var asciiAliasKeys = Object.keys(_asciiAliases2.default);
	
	    for (var _len = arguments.length, match = Array(_len), _key = 0; _key < _len; _key++) {
	      match[_key] = arguments[_key];
	    }
	
	    for (var i in asciiAliasKeys) {
	      var alias = asciiAliasKeys[i];
	      var data = _asciiAliases2.default[alias];
	      var aliasFound = match[2];
	
	      if (data.includes(aliasFound)) {
	        var isEdgeCase = match[1];
	        var fullMatchContent = match[0].slice(1, -1); // remove ":" at the beginning and end
	        var validAsciiAlias = !_aliases2.default[fullMatchContent]; // ":" + fullMatchContent + ":" alias doesn't exist
	
	        if (!isEdgeCase && validAsciiAlias) {
	          return ":" + alias + ":";
	        }
	
	        // return the original word to replace its value in aliasesRegex
	        return match[0];
	      }
	    }
	  }
	
	  function replaceAliases() {
	    for (var _len2 = arguments.length, match = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      match[_key2] = arguments[_key2];
	    }
	
	    return _aliases2.default[match[1]] || match[0];
	  }
	
	  return (0, _stringReplaceToArray2.default)(text.replace(asciiAliasesRegex, replaceAsciiAliases).replace(aliasesRegex, replaceAliases), unicodeEmojiRegex, replaceUnicodeEmoji);
	}
	
	function Emoji(_ref) {
	  var text = _ref.text,
	      onlyEmojiClassName = _ref.onlyEmojiClassName,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? {} : _ref$options,
	      className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ["text", "onlyEmojiClassName", "options", "className"]);
	
	  function isOnlyEmoji(output) {
	    if (output.length > 3) return false;
	
	    for (var i = 0; i < output.length; i++) {
	      if (typeof output[i] === "string") return false;
	    }
	
	    return true;
	  }
	
	  var output = toArray(text, options);
	  var classes = (0, _classnames3.default)(className, _defineProperty({}, onlyEmojiClassName, isOnlyEmoji(output)));
	
	  return _react2.default.createElement(
	    "span",
	    _extends({}, rest, { className: classes }),
	    output
	  );
	}
	
	Emoji.propTypes = {
	  text: _propTypes2.default.string,
	  props: _propTypes2.default.object,
	  onlyEmojiClassName: _propTypes2.default.string,
	  options: _propTypes2.default.shape({
	    baseUrl: _propTypes2.default.string,
	    size: _propTypes2.default.string,
	    ext: _propTypes2.default.string,
	    className: _propTypes2.default.string
	  })
	};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unicodeToCodepoint;
	// avoid runtime RegExp creation for not so smart,
	// not JIT based, and old browsers / engines
	// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L232
	var UFE0Fg = /\uFE0F/g;
	
	// \u200D is a zero-width joiner character
	// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L235
	var U200D = String.fromCharCode(0x200d);
	
	// convert utf16 into code points
	function toCodePoint(input) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
	
	  var codePoints = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var codePoint = _step.value;
	
	      codePoints.push(codePoint.codePointAt(0).toString(16));
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return codePoints.join(separator);
	}
	
	function unicodeToCodepoint(input) {
	  return toCodePoint(input.indexOf(U200D) < 0 ? input.replace(UFE0Fg, "") : input);
	}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// Inspiration: https://github.com/facebook/react/issues/3386
	
	var invariant = __webpack_require__(69),
		isString = __webpack_require__(176),
		flatten = __webpack_require__(94)
	
	function replace (string, regexpOrSubstr, newValueOrFn) {
		invariant(typeof string === 'string', 'First param must be a string')
		invariant(typeof regexpOrSubstr === 'string' || regexpOrSubstr instanceof RegExp, 'Second param must be a string pattern or a regular expression')
	
		var fn = (typeof regexpOrSubstr === 'string') ? replaceUsingString : replaceUsingRegexp
	
		return fn(string, regexpOrSubstr, newValueOrFn)
	}
	
	function replaceUsingString (string, patternString, newValueOrFn) {
		var index = string.indexOf(patternString)
	
		if (index >= 0) {
			var arr = []
			var endIndex = index + patternString.length
	
			if (index > 0) {
				arr.push(string.substring(0, index))
			}
	
			arr.push(
				(typeof newValueOrFn === 'function') ?
					newValueOrFn(
						string.substring(index, endIndex),
						index,
						string
					) :
					newValueOrFn
			)
	
			if (endIndex < string.length) {
				arr.push(string.substring(endIndex))
			}
	
			return arr
		} else {
			return [string]
		}
	}
	
	function replaceUsingRegexp (string, regexp, newValueOrFn) {
		var output = []
	
		var replacerIsFn = (typeof newValueOrFn === 'function')
	
		var storedLastIndex = regexp.lastIndex
		regexp.lastIndex = 0
	
		var result
		var lastIndex = 0
		while (result = regexp.exec(string)) {
			var index = result.index
	
			if (result[0] === '') {
				// When the regexp is an empty string
				// we still want to advance our cursor to the next item.
				// This is the behavior of String.replace.
				regexp.lastIndex++
			}
	
			if (index !== lastIndex) {
				output.push(string.substring(lastIndex, index))
			}
	
			var match = result[0]
			lastIndex = index + match.length
			
			var out = replacerIsFn ?
				newValueOrFn.apply(this, result.concat(index, result.input)) :
				newValueOrFn
			output.push(out)
	
			if (!regexp.global) {
				break
			}
		}
	
		if (lastIndex < string.length) {
			output.push(string.substring(lastIndex))
		}
	
		regexp.lastIndex = storedLastIndex
		return output
	}
	
	module.exports = function stringReplaceToArray (string, regexpOrSubstr, newSubStrOrFn) {
		if (isString(string)) {
			return replace(string, regexpOrSubstr, newSubStrOrFn)
		} else if (!Array.isArray(string) || !string[0]) {
			throw new TypeError('First argument must be an array or non-empty string');
		} else {
			return flatten(string.map(function (string) {
				if (!isString(string)) return string
				return replace(string, regexpOrSubstr, newSubStrOrFn)
			}))
		}
	}

/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locatedError = locatedError;
	
	var _GraphQLError = __webpack_require__(43);
	
	/**
	 * Given an arbitrary Error, presumably thrown while attempting to execute a
	 * GraphQL operation, produce a new GraphQLError aware of the location in the
	 * document responsible for the original Error.
	 */
	function locatedError(originalError, nodes, path) {
	  // Note: this uses a brand-check to support GraphQL errors originating from
	  // other contexts.
	  if (originalError && originalError.path) {
	    return originalError;
	  }
	
	  var message = originalError ? originalError.message || String(originalError) : 'An unknown error occurred.';
	  return new _GraphQLError.GraphQLError(message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Source = undefined;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * A representation of source input to GraphQL.
	 * `name` and `locationOffset` are optional. They are useful for clients who
	 * store GraphQL documents in source files; for example, if the GraphQL input
	 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
	 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
	 * line and column in locationOffset are 1-indexed
	 */
	var Source = exports.Source = function Source(body, name, locationOffset) {
	  _classCallCheck(this, Source);
	
	  this.body = body;
	  this.name = name || 'GraphQL request';
	  this.locationOffset = locationOffset || { line: 1, column: 1 };
	  !(this.locationOffset.line > 0) ? (0, _invariant2.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
	  !(this.locationOffset.column > 0) ? (0, _invariant2.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildASTSchema = buildASTSchema;
	exports.getDeprecationReason = getDeprecationReason;
	exports.getDescription = getDescription;
	exports.buildSchema = buildSchema;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyValMap = __webpack_require__(101);
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _lexer = __webpack_require__(104);
	
	var _parser = __webpack_require__(91);
	
	var _values = __webpack_require__(100);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _schema = __webpack_require__(28);
	
	var _scalars = __webpack_require__(32);
	
	var _definition = __webpack_require__(6);
	
	var _directives = __webpack_require__(27);
	
	var _introspection = __webpack_require__(34);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function buildWrappedType(innerType, inputTypeNode) {
	  if (inputTypeNode.kind === Kind.LIST_TYPE) {
	    return new _definition.GraphQLList(buildWrappedType(innerType, inputTypeNode.type));
	  }
	  if (inputTypeNode.kind === Kind.NON_NULL_TYPE) {
	    var wrappedType = buildWrappedType(innerType, inputTypeNode.type);
	    !!(wrappedType instanceof _definition.GraphQLNonNull) ? (0, _invariant2.default)(0, 'No nesting nonnull.') : void 0;
	    return new _definition.GraphQLNonNull(wrappedType);
	  }
	  return innerType;
	}
	
	function getNamedTypeNode(typeNode) {
	  var namedType = typeNode;
	  while (namedType.kind === Kind.LIST_TYPE || namedType.kind === Kind.NON_NULL_TYPE) {
	    namedType = namedType.type;
	  }
	  return namedType;
	}
	
	/**
	 * This takes the ast of a schema document produced by the parse function in
	 * src/language/parser.js.
	 *
	 * If no schema definition is provided, then it will look for types named Query
	 * and Mutation.
	 *
	 * Given that AST it constructs a GraphQLSchema. The resulting schema
	 * has no resolve methods, so execution will use default resolvers.
	 */
	function buildASTSchema(ast) {
	  if (!ast || ast.kind !== Kind.DOCUMENT) {
	    throw new Error('Must provide a document ast.');
	  }
	
	  var schemaDef = void 0;
	
	  var typeDefs = [];
	  var nodeMap = Object.create(null);
	  var directiveDefs = [];
	  for (var i = 0; i < ast.definitions.length; i++) {
	    var d = ast.definitions[i];
	    switch (d.kind) {
	      case Kind.SCHEMA_DEFINITION:
	        if (schemaDef) {
	          throw new Error('Must provide only one schema definition.');
	        }
	        schemaDef = d;
	        break;
	      case Kind.SCALAR_TYPE_DEFINITION:
	      case Kind.OBJECT_TYPE_DEFINITION:
	      case Kind.INTERFACE_TYPE_DEFINITION:
	      case Kind.ENUM_TYPE_DEFINITION:
	      case Kind.UNION_TYPE_DEFINITION:
	      case Kind.INPUT_OBJECT_TYPE_DEFINITION:
	        var typeName = d.name.value;
	        if (nodeMap[typeName]) {
	          throw new Error('Type "' + typeName + '" was defined more than once.');
	        }
	        typeDefs.push(d);
	        nodeMap[typeName] = d;
	        break;
	      case Kind.DIRECTIVE_DEFINITION:
	        directiveDefs.push(d);
	        break;
	    }
	  }
	
	  var queryTypeName = void 0;
	  var mutationTypeName = void 0;
	  var subscriptionTypeName = void 0;
	  if (schemaDef) {
	    schemaDef.operationTypes.forEach(function (operationType) {
	      var typeName = operationType.type.name.value;
	      if (operationType.operation === 'query') {
	        if (queryTypeName) {
	          throw new Error('Must provide only one query type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified query type "' + typeName + '" not found in document.');
	        }
	        queryTypeName = typeName;
	      } else if (operationType.operation === 'mutation') {
	        if (mutationTypeName) {
	          throw new Error('Must provide only one mutation type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified mutation type "' + typeName + '" not found in document.');
	        }
	        mutationTypeName = typeName;
	      } else if (operationType.operation === 'subscription') {
	        if (subscriptionTypeName) {
	          throw new Error('Must provide only one subscription type in schema.');
	        }
	        if (!nodeMap[typeName]) {
	          throw new Error('Specified subscription type "' + typeName + '" not found in document.');
	        }
	        subscriptionTypeName = typeName;
	      }
	    });
	  } else {
	    if (nodeMap.Query) {
	      queryTypeName = 'Query';
	    }
	    if (nodeMap.Mutation) {
	      mutationTypeName = 'Mutation';
	    }
	    if (nodeMap.Subscription) {
	      subscriptionTypeName = 'Subscription';
	    }
	  }
	
	  if (!queryTypeName) {
	    throw new Error('Must provide schema definition with query type or a type named Query.');
	  }
	
	  var innerTypeMap = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  var types = typeDefs.map(function (def) {
	    return typeDefNamed(def.name.value);
	  });
	
	  var directives = directiveDefs.map(getDirective);
	
	  // If specified directives were not explicitly declared, add them.
	  if (!directives.some(function (directive) {
	    return directive.name === 'skip';
	  })) {
	    directives.push(_directives.GraphQLSkipDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'include';
	  })) {
	    directives.push(_directives.GraphQLIncludeDirective);
	  }
	
	  if (!directives.some(function (directive) {
	    return directive.name === 'deprecated';
	  })) {
	    directives.push(_directives.GraphQLDeprecatedDirective);
	  }
	
	  return new _schema.GraphQLSchema({
	    query: getObjectType(nodeMap[queryTypeName]),
	    mutation: mutationTypeName ? getObjectType(nodeMap[mutationTypeName]) : null,
	    subscription: subscriptionTypeName ? getObjectType(nodeMap[subscriptionTypeName]) : null,
	    types: types,
	    directives: directives,
	    astNode: schemaDef
	  });
	
	  function getDirective(directiveNode) {
	    return new _directives.GraphQLDirective({
	      name: directiveNode.name.value,
	      description: getDescription(directiveNode),
	      locations: directiveNode.locations.map(function (node) {
	        return node.value;
	      }),
	      args: directiveNode.arguments && makeInputValues(directiveNode.arguments),
	      astNode: directiveNode
	    });
	  }
	
	  function getObjectType(typeNode) {
	    var type = typeDefNamed(typeNode.name.value);
	    !(type instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'AST must provide object type.') : void 0;
	    return type;
	  }
	
	  function produceType(typeNode) {
	    var typeName = getNamedTypeNode(typeNode).name.value;
	    var typeDef = typeDefNamed(typeName);
	    return buildWrappedType(typeDef, typeNode);
	  }
	
	  function produceInputType(typeNode) {
	    return (0, _definition.assertInputType)(produceType(typeNode));
	  }
	
	  function produceOutputType(typeNode) {
	    return (0, _definition.assertOutputType)(produceType(typeNode));
	  }
	
	  function produceObjectType(typeNode) {
	    var type = produceType(typeNode);
	    !(type instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Expected Object type.') : void 0;
	    return type;
	  }
	
	  function produceInterfaceType(typeNode) {
	    var type = produceType(typeNode);
	    !(type instanceof _definition.GraphQLInterfaceType) ? (0, _invariant2.default)(0, 'Expected Interface type.') : void 0;
	    return type;
	  }
	
	  function typeDefNamed(typeName) {
	    if (!innerTypeMap[typeName]) {
	      if (!nodeMap[typeName]) {
	        throw new Error('Type "' + typeName + '" not found in document.');
	      }
	      innerTypeMap[typeName] = makeSchemaDef(nodeMap[typeName]);
	    }
	    return innerTypeMap[typeName];
	  }
	
	  function makeSchemaDef(def) {
	    switch (def.kind) {
	      case Kind.OBJECT_TYPE_DEFINITION:
	        return makeTypeDef(def);
	      case Kind.INTERFACE_TYPE_DEFINITION:
	        return makeInterfaceDef(def);
	      case Kind.ENUM_TYPE_DEFINITION:
	        return makeEnumDef(def);
	      case Kind.UNION_TYPE_DEFINITION:
	        return makeUnionDef(def);
	      case Kind.SCALAR_TYPE_DEFINITION:
	        return makeScalarDef(def);
	      case Kind.INPUT_OBJECT_TYPE_DEFINITION:
	        return makeInputObjectDef(def);
	      default:
	        throw new Error('Type kind "' + def.kind + '" not supported.');
	    }
	  }
	
	  function makeTypeDef(def) {
	    var typeName = def.name.value;
	    return new _definition.GraphQLObjectType({
	      name: typeName,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeFieldDefMap(def);
	      },
	      interfaces: function interfaces() {
	        return makeImplementedInterfaces(def);
	      },
	      astNode: def
	    });
	  }
	
	  function makeFieldDefMap(def) {
	    return (0, _keyValMap2.default)(def.fields, function (field) {
	      return field.name.value;
	    }, function (field) {
	      return {
	        type: produceOutputType(field.type),
	        description: getDescription(field),
	        args: makeInputValues(field.arguments),
	        deprecationReason: getDeprecationReason(field),
	        astNode: field
	      };
	    });
	  }
	
	  function makeImplementedInterfaces(def) {
	    return def.interfaces && def.interfaces.map(function (iface) {
	      return produceInterfaceType(iface);
	    });
	  }
	
	  function makeInputValues(values) {
	    return (0, _keyValMap2.default)(values, function (value) {
	      return value.name.value;
	    }, function (value) {
	      var type = produceInputType(value.type);
	      return {
	        type: type,
	        description: getDescription(value),
	        defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type),
	        astNode: value
	      };
	    });
	  }
	
	  function makeInterfaceDef(def) {
	    return new _definition.GraphQLInterfaceType({
	      name: def.name.value,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeFieldDefMap(def);
	      },
	      astNode: def,
	      resolveType: cannotExecuteSchema
	    });
	  }
	
	  function makeEnumDef(def) {
	    return new _definition.GraphQLEnumType({
	      name: def.name.value,
	      description: getDescription(def),
	      values: (0, _keyValMap2.default)(def.values, function (enumValue) {
	        return enumValue.name.value;
	      }, function (enumValue) {
	        return {
	          description: getDescription(enumValue),
	          deprecationReason: getDeprecationReason(enumValue),
	          astNode: enumValue
	        };
	      }),
	      astNode: def
	    });
	  }
	
	  function makeUnionDef(def) {
	    return new _definition.GraphQLUnionType({
	      name: def.name.value,
	      description: getDescription(def),
	      types: def.types.map(function (t) {
	        return produceObjectType(t);
	      }),
	      resolveType: cannotExecuteSchema,
	      astNode: def
	    });
	  }
	
	  function makeScalarDef(def) {
	    return new _definition.GraphQLScalarType({
	      name: def.name.value,
	      description: getDescription(def),
	      astNode: def,
	      serialize: function serialize() {
	        return null;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function makeInputObjectDef(def) {
	    return new _definition.GraphQLInputObjectType({
	      name: def.name.value,
	      description: getDescription(def),
	      fields: function fields() {
	        return makeInputValues(def.fields);
	      },
	      astNode: def
	    });
	  }
	}
	
	/**
	 * Given a field or enum value node, returns the string value for the
	 * deprecation reason.
	 */
	function getDeprecationReason(node) {
	  var deprecated = (0, _values.getDirectiveValues)(_directives.GraphQLDeprecatedDirective, node);
	  return deprecated && deprecated.reason;
	}
	
	/**
	 * Given an ast node, returns its string description based on a contiguous
	 * block full-line of comments preceding it.
	 */
	function getDescription(node) {
	  var loc = node.loc;
	  if (!loc) {
	    return;
	  }
	  var comments = [];
	  var minSpaces = void 0;
	  var token = loc.startToken.prev;
	  while (token && token.kind === _lexer.TokenKind.COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
	    var value = String(token.value);
	    var spaces = leadingSpaces(value);
	    if (minSpaces === undefined || spaces < minSpaces) {
	      minSpaces = spaces;
	    }
	    comments.push(value);
	    token = token.prev;
	  }
	  return comments.reverse().map(function (comment) {
	    return comment.slice(minSpaces);
	  }).join('\n');
	}
	
	/**
	 * A helper function to build a GraphQLSchema directly from a source
	 * document.
	 */
	function buildSchema(source) {
	  return buildASTSchema((0, _parser.parse)(source));
	}
	
	// Count the number of spaces on the starting side of a string.
	function leadingSpaces(str) {
	  var i = 0;
	  for (; i < str.length; i++) {
	    if (str[i] !== ' ') {
	      break;
	    }
	  }
	  return i;
	}
	
	function cannotExecuteSchema() {
	  throw new Error('Generated Schema cannot use Interface or Union types for execution.');
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.isValidJSValue = isValidJSValue;
	
	var _iterall = __webpack_require__(46);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a JavaScript value and a GraphQL type, determine if the value will be
	 * accepted for that type. This is primarily useful for validating the
	 * runtime values of query variables.
	 */
	function isValidJSValue(value, type) {
	  // A value must be provided if the type is non-null.
	  if (type instanceof _definition.GraphQLNonNull) {
	    if ((0, _isNullish2.default)(value)) {
	      return ['Expected "' + String(type) + '", found null.'];
	    }
	    return isValidJSValue(value, type.ofType);
	  }
	
	  if ((0, _isNullish2.default)(value)) {
	    return [];
	  }
	
	  // Lists accept a non-list value as a list of one.
	  if (type instanceof _definition.GraphQLList) {
	    var itemType = type.ofType;
	    if ((0, _iterall.isCollection)(value)) {
	      var errors = [];
	      (0, _iterall.forEach)(value, function (item, index) {
	        errors.push.apply(errors, isValidJSValue(item, itemType).map(function (error) {
	          return 'In element #' + index + ': ' + error;
	        }));
	      });
	      return errors;
	    }
	    return isValidJSValue(value, itemType);
	  }
	
	  // Input objects check each defined field.
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	      return ['Expected "' + type.name + '", found not an object.'];
	    }
	    var fields = type.getFields();
	
	    var _errors = [];
	
	    // Ensure every provided field is defined.
	    Object.keys(value).forEach(function (providedField) {
	      if (!fields[providedField]) {
	        _errors.push('In field "' + providedField + '": Unknown field.');
	      }
	    });
	
	    // Ensure every defined field is valid.
	    Object.keys(fields).forEach(function (fieldName) {
	      var newErrors = isValidJSValue(value[fieldName], fields[fieldName].type);
	      _errors.push.apply(_errors, newErrors.map(function (error) {
	        return 'In field "' + fieldName + '": ' + error;
	      }));
	    });
	
	    return _errors;
	  }
	
	  !(type instanceof _definition.GraphQLScalarType || type instanceof _definition.GraphQLEnumType) ? (0, _invariant2.default)(0, 'Must be input type') : void 0;
	
	  // Scalar/Enum input checks to ensure the type can parse the value to
	  // a non-null value.
	  try {
	    var parseResult = type.parseValue(value);
	    if ((0, _isNullish2.default)(parseResult) && !type.isValidValue(value)) {
	      return ['Expected type "' + type.name + '", found ' + JSON.stringify(value) + '.'];
	    }
	  } catch (error) {
	    return ['Expected type "' + type.name + '", found ' + JSON.stringify(value) + ': ' + error.message];
	  }
	
	  return [];
	}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badValueMessage = badValueMessage;
	exports.ArgumentsOfCorrectType = ArgumentsOfCorrectType;
	
	var _error = __webpack_require__(5);
	
	var _printer = __webpack_require__(24);
	
	var _isValidLiteralValue = __webpack_require__(92);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function badValueMessage(argName, type, value, verboseErrors) {
	  var message = verboseErrors ? '\n' + verboseErrors.join('\n') : '';
	  return 'Argument "' + argName + '" has invalid value ' + value + '.' + message;
	}
	
	/**
	 * Argument values of correct type
	 *
	 * A GraphQL document is only valid if all field argument literal values are
	 * of the type expected by their position.
	 */
	function ArgumentsOfCorrectType(context) {
	  return {
	    Argument: function Argument(node) {
	      var argDef = context.getArgument();
	      if (argDef) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(argDef.type, node.value);
	        if (errors && errors.length > 0) {
	          context.reportError(new _error.GraphQLError(badValueMessage(node.name.value, argDef.type, (0, _printer.print)(node.value), errors), [node.value]));
	        }
	      }
	      return false;
	    }
	  };
	}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultForNonNullArgMessage = defaultForNonNullArgMessage;
	exports.badValueForDefaultArgMessage = badValueForDefaultArgMessage;
	exports.DefaultValuesOfCorrectType = DefaultValuesOfCorrectType;
	
	var _error = __webpack_require__(5);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _isValidLiteralValue = __webpack_require__(92);
	
	function defaultForNonNullArgMessage(varName, type, guessType) {
	  return 'Variable "$' + varName + '" of type "' + String(type) + '" is required and ' + 'will not use the default value. ' + ('Perhaps you meant to use type "' + String(guessType) + '".');
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function badValueForDefaultArgMessage(varName, type, value, verboseErrors) {
	  var message = verboseErrors ? '\n' + verboseErrors.join('\n') : '';
	  return 'Variable "$' + varName + '" of type "' + String(type) + '" has invalid ' + ('default value ' + value + '.' + message);
	}
	
	/**
	 * Variable default values of correct type
	 *
	 * A GraphQL document is only valid if all variable default values are of the
	 * type expected by their definition.
	 */
	function DefaultValuesOfCorrectType(context) {
	  return {
	    VariableDefinition: function VariableDefinition(node) {
	      var name = node.variable.name.value;
	      var defaultValue = node.defaultValue;
	      var type = context.getInputType();
	      if (type instanceof _definition.GraphQLNonNull && defaultValue) {
	        context.reportError(new _error.GraphQLError(defaultForNonNullArgMessage(name, type, type.ofType), [defaultValue]));
	      }
	      if (type && defaultValue) {
	        var errors = (0, _isValidLiteralValue.isValidLiteralValue)(type, defaultValue);
	        if (errors && errors.length > 0) {
	          context.reportError(new _error.GraphQLError(badValueForDefaultArgMessage(name, type, (0, _printer.print)(defaultValue), errors), [defaultValue]));
	        }
	      }
	      return false;
	    },
	
	    SelectionSet: function SelectionSet() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition() {
	      return false;
	    }
	  };
	}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedFieldMessage = undefinedFieldMessage;
	exports.FieldsOnCorrectType = FieldsOnCorrectType;
	
	var _error = __webpack_require__(5);
	
	var _suggestionList = __webpack_require__(103);
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__(102);
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function undefinedFieldMessage(fieldName, type, suggestedTypeNames, suggestedFieldNames) {
	  var message = 'Cannot query field "' + fieldName + '" on type "' + type + '".';
	  if (suggestedTypeNames.length !== 0) {
	    var suggestions = (0, _quotedOrList2.default)(suggestedTypeNames);
	    message += ' Did you mean to use an inline fragment on ' + suggestions + '?';
	  } else if (suggestedFieldNames.length !== 0) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedFieldNames) + '?';
	  }
	  return message;
	}
	
	/**
	 * Fields on correct type
	 *
	 * A GraphQL document is only valid if all fields selected are defined by the
	 * parent type, or are an allowed meta field such as __typename.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function FieldsOnCorrectType(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getParentType();
	      if (type) {
	        var fieldDef = context.getFieldDef();
	        if (!fieldDef) {
	          // This field doesn't exist, lets look for suggestions.
	          var schema = context.getSchema();
	          var fieldName = node.name.value;
	          // First determine if there are any suggested types to condition on.
	          var suggestedTypeNames = getSuggestedTypeNames(schema, type, fieldName);
	          // If there are no suggested types, then perhaps this was a typo?
	          var suggestedFieldNames = suggestedTypeNames.length !== 0 ? [] : getSuggestedFieldNames(schema, type, fieldName);
	
	          // Report an error, including helpful suggestions.
	          context.reportError(new _error.GraphQLError(undefinedFieldMessage(fieldName, type.name, suggestedTypeNames, suggestedFieldNames), [node]));
	        }
	      }
	    }
	  };
	}
	
	/**
	 * Go through all of the implementations of type, as well as the interfaces
	 * that they implement. If any of those types include the provided field,
	 * suggest them, sorted by how often the type is referenced,  starting
	 * with Interfaces.
	 */
	function getSuggestedTypeNames(schema, type, fieldName) {
	  if ((0, _definition.isAbstractType)(type)) {
	    var suggestedObjectTypes = [];
	    var interfaceUsageCount = Object.create(null);
	    schema.getPossibleTypes(type).forEach(function (possibleType) {
	      if (!possibleType.getFields()[fieldName]) {
	        return;
	      }
	      // This object type defines this field.
	      suggestedObjectTypes.push(possibleType.name);
	      possibleType.getInterfaces().forEach(function (possibleInterface) {
	        if (!possibleInterface.getFields()[fieldName]) {
	          return;
	        }
	        // This interface type defines this field.
	        interfaceUsageCount[possibleInterface.name] = (interfaceUsageCount[possibleInterface.name] || 0) + 1;
	      });
	    });
	
	    // Suggest interface types based on how common they are.
	    var suggestedInterfaceTypes = Object.keys(interfaceUsageCount).sort(function (a, b) {
	      return interfaceUsageCount[b] - interfaceUsageCount[a];
	    });
	
	    // Suggest both interface and object types.
	    return suggestedInterfaceTypes.concat(suggestedObjectTypes);
	  }
	
	  // Otherwise, must be an Object type, which does not have possible fields.
	  return [];
	}
	
	/**
	 * For the field name provided, determine if there are any similar field names
	 * that may be the result of a typo.
	 */
	function getSuggestedFieldNames(schema, type, fieldName) {
	  if (type instanceof _definition.GraphQLObjectType || type instanceof _definition.GraphQLInterfaceType) {
	    var possibleFieldNames = Object.keys(type.getFields());
	    return (0, _suggestionList2.default)(fieldName, possibleFieldNames);
	  }
	  // Otherwise, must be a Union type, which does not define fields.
	  return [];
	}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inlineFragmentOnNonCompositeErrorMessage = inlineFragmentOnNonCompositeErrorMessage;
	exports.fragmentOnNonCompositeErrorMessage = fragmentOnNonCompositeErrorMessage;
	exports.FragmentsOnCompositeTypes = FragmentsOnCompositeTypes;
	
	var _error = __webpack_require__(5);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _typeFromAST = __webpack_require__(29);
	
	function inlineFragmentOnNonCompositeErrorMessage(type) {
	  return 'Fragment cannot condition on non composite type "' + String(type) + '".';
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function fragmentOnNonCompositeErrorMessage(fragName, type) {
	  return 'Fragment "' + fragName + '" cannot condition on non composite ' + ('type "' + String(type) + '".');
	}
	
	/**
	 * Fragments on composite type
	 *
	 * Fragments use a type condition to determine if they apply, since fragments
	 * can only be spread into a composite type (object, interface, or union), the
	 * type condition must also be a composite type.
	 */
	function FragmentsOnCompositeTypes(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      if (node.typeCondition) {
	        var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.typeCondition);
	        if (type && !(0, _definition.isCompositeType)(type)) {
	          context.reportError(new _error.GraphQLError(inlineFragmentOnNonCompositeErrorMessage((0, _printer.print)(node.typeCondition)), [node.typeCondition]));
	        }
	      }
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.typeCondition);
	      if (type && !(0, _definition.isCompositeType)(type)) {
	        context.reportError(new _error.GraphQLError(fragmentOnNonCompositeErrorMessage(node.name.value, (0, _printer.print)(node.typeCondition)), [node.typeCondition]));
	      }
	    }
	  };
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownArgMessage = unknownArgMessage;
	exports.unknownDirectiveArgMessage = unknownDirectiveArgMessage;
	exports.KnownArgumentNames = KnownArgumentNames;
	
	var _error = __webpack_require__(5);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _suggestionList = __webpack_require__(103);
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__(102);
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unknownArgMessage(argName, fieldName, typeName, suggestedArgs) {
	  var message = 'Unknown argument "' + argName + '" on field "' + fieldName + '" of ' + ('type "' + typeName + '".');
	  if (suggestedArgs.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedArgs) + '?';
	  }
	  return message;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function unknownDirectiveArgMessage(argName, directiveName, suggestedArgs) {
	  var message = 'Unknown argument "' + argName + '" on directive "@' + directiveName + '".';
	  if (suggestedArgs.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedArgs) + '?';
	  }
	  return message;
	}
	
	/**
	 * Known argument names
	 *
	 * A GraphQL field is only valid if all supplied arguments are defined by
	 * that field.
	 */
	function KnownArgumentNames(context) {
	  return {
	    Argument: function Argument(node, key, parent, path, ancestors) {
	      var argumentOf = ancestors[ancestors.length - 1];
	      if (argumentOf.kind === Kind.FIELD) {
	        var fieldDef = context.getFieldDef();
	        if (fieldDef) {
	          var fieldArgDef = (0, _find2.default)(fieldDef.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (!fieldArgDef) {
	            var parentType = context.getParentType();
	            !parentType ? (0, _invariant2.default)(0) : void 0;
	            context.reportError(new _error.GraphQLError(unknownArgMessage(node.name.value, fieldDef.name, parentType.name, (0, _suggestionList2.default)(node.name.value, fieldDef.args.map(function (arg) {
	              return arg.name;
	            }))), [node]));
	          }
	        }
	      } else if (argumentOf.kind === Kind.DIRECTIVE) {
	        var directive = context.getDirective();
	        if (directive) {
	          var directiveArgDef = (0, _find2.default)(directive.args, function (arg) {
	            return arg.name === node.name.value;
	          });
	          if (!directiveArgDef) {
	            context.reportError(new _error.GraphQLError(unknownDirectiveArgMessage(node.name.value, directive.name, (0, _suggestionList2.default)(node.name.value, directive.args.map(function (arg) {
	              return arg.name;
	            }))), [node]));
	          }
	        }
	      }
	    }
	  };
	}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownDirectiveMessage = unknownDirectiveMessage;
	exports.misplacedDirectiveMessage = misplacedDirectiveMessage;
	exports.KnownDirectives = KnownDirectives;
	
	var _error = __webpack_require__(5);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _directives = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unknownDirectiveMessage(directiveName) {
	  return 'Unknown directive "' + directiveName + '".';
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function misplacedDirectiveMessage(directiveName, location) {
	  return 'Directive "' + directiveName + '" may not be used on ' + location + '.';
	}
	
	/**
	 * Known directives
	 *
	 * A GraphQL document is only valid if all `@directives` are known by the
	 * schema and legally positioned.
	 */
	function KnownDirectives(context) {
	  return {
	    Directive: function Directive(node, key, parent, path, ancestors) {
	      var directiveDef = (0, _find2.default)(context.getSchema().getDirectives(), function (def) {
	        return def.name === node.name.value;
	      });
	      if (!directiveDef) {
	        context.reportError(new _error.GraphQLError(unknownDirectiveMessage(node.name.value), [node]));
	        return;
	      }
	      var candidateLocation = getDirectiveLocationForASTPath(ancestors);
	      if (!candidateLocation) {
	        context.reportError(new _error.GraphQLError(misplacedDirectiveMessage(node.name.value, node.type), [node]));
	      } else if (directiveDef.locations.indexOf(candidateLocation) === -1) {
	        context.reportError(new _error.GraphQLError(misplacedDirectiveMessage(node.name.value, candidateLocation), [node]));
	      }
	    }
	  };
	}
	
	function getDirectiveLocationForASTPath(ancestors) {
	  var appliedTo = ancestors[ancestors.length - 1];
	  switch (appliedTo.kind) {
	    case Kind.OPERATION_DEFINITION:
	      switch (appliedTo.operation) {
	        case 'query':
	          return _directives.DirectiveLocation.QUERY;
	        case 'mutation':
	          return _directives.DirectiveLocation.MUTATION;
	        case 'subscription':
	          return _directives.DirectiveLocation.SUBSCRIPTION;
	      }
	      break;
	    case Kind.FIELD:
	      return _directives.DirectiveLocation.FIELD;
	    case Kind.FRAGMENT_SPREAD:
	      return _directives.DirectiveLocation.FRAGMENT_SPREAD;
	    case Kind.INLINE_FRAGMENT:
	      return _directives.DirectiveLocation.INLINE_FRAGMENT;
	    case Kind.FRAGMENT_DEFINITION:
	      return _directives.DirectiveLocation.FRAGMENT_DEFINITION;
	    case Kind.SCHEMA_DEFINITION:
	      return _directives.DirectiveLocation.SCHEMA;
	    case Kind.SCALAR_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.SCALAR;
	    case Kind.OBJECT_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.OBJECT;
	    case Kind.FIELD_DEFINITION:
	      return _directives.DirectiveLocation.FIELD_DEFINITION;
	    case Kind.INTERFACE_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.INTERFACE;
	    case Kind.UNION_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.UNION;
	    case Kind.ENUM_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.ENUM;
	    case Kind.ENUM_VALUE_DEFINITION:
	      return _directives.DirectiveLocation.ENUM_VALUE;
	    case Kind.INPUT_OBJECT_TYPE_DEFINITION:
	      return _directives.DirectiveLocation.INPUT_OBJECT;
	    case Kind.INPUT_VALUE_DEFINITION:
	      var parentNode = ancestors[ancestors.length - 3];
	      return parentNode.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION ? _directives.DirectiveLocation.INPUT_FIELD_DEFINITION : _directives.DirectiveLocation.ARGUMENT_DEFINITION;
	  }
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownFragmentMessage = unknownFragmentMessage;
	exports.KnownFragmentNames = KnownFragmentNames;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function unknownFragmentMessage(fragName) {
	  return 'Unknown fragment "' + fragName + '".';
	}
	
	/**
	 * Known fragment names
	 *
	 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
	 * to fragments defined in the same document.
	 */
	function KnownFragmentNames(context) {
	  return {
	    FragmentSpread: function FragmentSpread(node) {
	      var fragmentName = node.name.value;
	      var fragment = context.getFragment(fragmentName);
	      if (!fragment) {
	        context.reportError(new _error.GraphQLError(unknownFragmentMessage(fragmentName), [node.name]));
	      }
	    }
	  };
	}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unknownTypeMessage = unknownTypeMessage;
	exports.KnownTypeNames = KnownTypeNames;
	
	var _error = __webpack_require__(5);
	
	var _suggestionList = __webpack_require__(103);
	
	var _suggestionList2 = _interopRequireDefault(_suggestionList);
	
	var _quotedOrList = __webpack_require__(102);
	
	var _quotedOrList2 = _interopRequireDefault(_quotedOrList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function unknownTypeMessage(type, suggestedTypes) {
	  var message = 'Unknown type "' + String(type) + '".';
	  if (suggestedTypes.length) {
	    message += ' Did you mean ' + (0, _quotedOrList2.default)(suggestedTypes) + '?';
	  }
	  return message;
	}
	
	/**
	 * Known type names
	 *
	 * A GraphQL document is only valid if referenced types (specifically
	 * variable definitions and fragment conditions) are defined by the type schema.
	 */
	function KnownTypeNames(context) {
	  return {
	    // TODO: when validating IDL, re-enable these. Experimental version does not
	    // add unreferenced types, resulting in false-positive errors. Squelched
	    // errors for now.
	    ObjectTypeDefinition: function ObjectTypeDefinition() {
	      return false;
	    },
	    InterfaceTypeDefinition: function InterfaceTypeDefinition() {
	      return false;
	    },
	    UnionTypeDefinition: function UnionTypeDefinition() {
	      return false;
	    },
	    InputObjectTypeDefinition: function InputObjectTypeDefinition() {
	      return false;
	    },
	    NamedType: function NamedType(node) {
	      var schema = context.getSchema();
	      var typeName = node.name.value;
	      var type = schema.getType(typeName);
	      if (!type) {
	        context.reportError(new _error.GraphQLError(unknownTypeMessage(typeName, (0, _suggestionList2.default)(typeName, Object.keys(schema.getTypeMap()))), [node]));
	      }
	    }
	  };
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anonOperationNotAloneMessage = anonOperationNotAloneMessage;
	exports.LoneAnonymousOperation = LoneAnonymousOperation;
	
	var _error = __webpack_require__(5);
	
	var _kinds = __webpack_require__(11);
	
	function anonOperationNotAloneMessage() {
	  return 'This anonymous operation must be the only defined operation.';
	}
	
	/**
	 * Lone anonymous operation
	 *
	 * A GraphQL document is only valid if when it contains an anonymous operation
	 * (the query short-hand) that it contains only that one operation definition.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function LoneAnonymousOperation(context) {
	  var operationCount = 0;
	  return {
	    Document: function Document(node) {
	      operationCount = node.definitions.filter(function (definition) {
	        return definition.kind === _kinds.OPERATION_DEFINITION;
	      }).length;
	    },
	    OperationDefinition: function OperationDefinition(node) {
	      if (!node.name && operationCount > 1) {
	        context.reportError(new _error.GraphQLError(anonOperationNotAloneMessage(), [node]));
	      }
	    }
	  };
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cycleErrorMessage = cycleErrorMessage;
	exports.NoFragmentCycles = NoFragmentCycles;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function cycleErrorMessage(fragName, spreadNames) {
	  var via = spreadNames.length ? ' via ' + spreadNames.join(', ') : '';
	  return 'Cannot spread fragment "' + fragName + '" within itself' + via + '.';
	}
	
	function NoFragmentCycles(context) {
	  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
	  // are not redundantly reported.
	  var visitedFrags = Object.create(null);
	
	  // Array of AST nodes used to produce meaningful errors
	  var spreadPath = [];
	
	  // Position in the spread path
	  var spreadPathIndexByName = Object.create(null);
	
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      if (!visitedFrags[node.name.value]) {
	        detectCycleRecursive(node);
	      }
	      return false;
	    }
	  };
	
	  // This does a straight-forward DFS to find cycles.
	  // It does not terminate when a cycle was found but continues to explore
	  // the graph to find all possible cycles.
	  function detectCycleRecursive(fragment) {
	    var fragmentName = fragment.name.value;
	    visitedFrags[fragmentName] = true;
	
	    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
	    if (spreadNodes.length === 0) {
	      return;
	    }
	
	    spreadPathIndexByName[fragmentName] = spreadPath.length;
	
	    for (var i = 0; i < spreadNodes.length; i++) {
	      var spreadNode = spreadNodes[i];
	      var spreadName = spreadNode.name.value;
	      var cycleIndex = spreadPathIndexByName[spreadName];
	
	      if (cycleIndex === undefined) {
	        spreadPath.push(spreadNode);
	        if (!visitedFrags[spreadName]) {
	          var spreadFragment = context.getFragment(spreadName);
	          if (spreadFragment) {
	            detectCycleRecursive(spreadFragment);
	          }
	        }
	        spreadPath.pop();
	      } else {
	        var cyclePath = spreadPath.slice(cycleIndex);
	        context.reportError(new _error.GraphQLError(cycleErrorMessage(spreadName, cyclePath.map(function (s) {
	          return s.name.value;
	        })), cyclePath.concat(spreadNode)));
	      }
	    }
	
	    spreadPathIndexByName[fragmentName] = undefined;
	  }
	}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.undefinedVarMessage = undefinedVarMessage;
	exports.NoUndefinedVariables = NoUndefinedVariables;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function undefinedVarMessage(varName, opName) {
	  return opName ? 'Variable "$' + varName + '" is not defined by operation "' + opName + '".' : 'Variable "$' + varName + '" is not defined.';
	}
	
	/**
	 * No undefined variables
	 *
	 * A GraphQL operation is only valid if all variables encountered, both directly
	 * and via fragment spreads, are defined by that operation.
	 */
	function NoUndefinedVariables(context) {
	  var variableNameDefined = Object.create(null);
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableNameDefined = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node;
	
	          var varName = node.name.value;
	          if (variableNameDefined[varName] !== true) {
	            context.reportError(new _error.GraphQLError(undefinedVarMessage(varName, operation.name && operation.name.value), [node, operation]));
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      variableNameDefined[node.variable.name.value] = true;
	    }
	  };
	}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedFragMessage = unusedFragMessage;
	exports.NoUnusedFragments = NoUnusedFragments;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function unusedFragMessage(fragName) {
	  return 'Fragment "' + fragName + '" is never used.';
	}
	
	/**
	 * No unused fragments
	 *
	 * A GraphQL document is only valid if all fragment definitions are spread
	 * within operations, or spread within other fragments spread within operations.
	 */
	function NoUnusedFragments(context) {
	  var operationDefs = [];
	  var fragmentDefs = [];
	
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      operationDefs.push(node);
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fragmentDefs.push(node);
	      return false;
	    },
	
	    Document: {
	      leave: function leave() {
	        var fragmentNameUsed = Object.create(null);
	        operationDefs.forEach(function (operation) {
	          context.getRecursivelyReferencedFragments(operation).forEach(function (fragment) {
	            fragmentNameUsed[fragment.name.value] = true;
	          });
	        });
	
	        fragmentDefs.forEach(function (fragmentDef) {
	          var fragName = fragmentDef.name.value;
	          if (fragmentNameUsed[fragName] !== true) {
	            context.reportError(new _error.GraphQLError(unusedFragMessage(fragName), [fragmentDef]));
	          }
	        });
	      }
	    }
	  };
	}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unusedVariableMessage = unusedVariableMessage;
	exports.NoUnusedVariables = NoUnusedVariables;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function unusedVariableMessage(varName, opName) {
	  return opName ? 'Variable "$' + varName + '" is never used in operation "' + opName + '".' : 'Variable "$' + varName + '" is never used.';
	}
	
	/**
	 * No unused variables
	 *
	 * A GraphQL operation is only valid if all variables defined by an operation
	 * are used, either directly or within a spread fragment.
	 */
	function NoUnusedVariables(context) {
	  var variableDefs = [];
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        variableDefs = [];
	      },
	      leave: function leave(operation) {
	        var variableNameUsed = Object.create(null);
	        var usages = context.getRecursiveVariableUsages(operation);
	        var opName = operation.name ? operation.name.value : null;
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node;
	
	          variableNameUsed[node.name.value] = true;
	        });
	
	        variableDefs.forEach(function (variableDef) {
	          var variableName = variableDef.variable.name.value;
	          if (variableNameUsed[variableName] !== true) {
	            context.reportError(new _error.GraphQLError(unusedVariableMessage(variableName, opName), [variableDef]));
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(def) {
	      variableDefs.push(def);
	    }
	  };
	}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldsConflictMessage = fieldsConflictMessage;
	exports.OverlappingFieldsCanBeMerged = OverlappingFieldsCanBeMerged;
	
	var _error = __webpack_require__(5);
	
	var _find = __webpack_require__(44);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _typeFromAST = __webpack_require__(29);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	function fieldsConflictMessage(responseName, reason) {
	  return 'Fields "' + responseName + '" conflict because ' + reasonMessage(reason) + '. Use different aliases on the fields to fetch both if this was ' + 'intentional.';
	}
	
	function reasonMessage(reason) {
	  if (Array.isArray(reason)) {
	    return reason.map(function (_ref) {
	      var responseName = _ref[0],
	          subreason = _ref[1];
	      return 'subfields "' + responseName + '" conflict because ' + reasonMessage(subreason);
	    }).join(' and ');
	  }
	  return reason;
	}
	
	/**
	 * Overlapping fields can be merged
	 *
	 * A selection set is only valid if all fields (including spreading any
	 * fragments) either correspond to distinct response names or can be merged
	 * without ambiguity.
	 */
	function OverlappingFieldsCanBeMerged(context) {
	  // A memoization for when two fragments are compared "between" each other for
	  // conflicts. Two fragments may be compared many times, so memoizing this can
	  // dramatically improve the performance of this validator.
	  var comparedFragments = new PairSet();
	
	  // A cache for the "field map" and list of fragment names found in any given
	  // selection set. Selection sets may be asked for this information multiple
	  // times, so this improves the performance of this validator.
	  var cachedFieldsAndFragmentNames = new Map();
	
	  return {
	    SelectionSet: function SelectionSet(selectionSet) {
	      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragments, context.getParentType(), selectionSet);
	      conflicts.forEach(function (_ref2) {
	        var _ref2$ = _ref2[0],
	            responseName = _ref2$[0],
	            reason = _ref2$[1],
	            fields1 = _ref2[1],
	            fields2 = _ref2[2];
	        return context.reportError(new _error.GraphQLError(fieldsConflictMessage(responseName, reason), fields1.concat(fields2)));
	      });
	    }
	  };
	}
	// Field name and reason.
	
	// Reason is a string, or a nested list of conflicts.
	
	// Tuple defining a field node in a context.
	
	// Map of array of those.
	
	
	/**
	 * Algorithm:
	 *
	 * Conflicts occur when two fields exist in a query which will produce the same
	 * response name, but represent differing values, thus creating a conflict.
	 * The algorithm below finds all conflicts via making a series of comparisons
	 * between fields. In order to compare as few fields as possible, this makes
	 * a series of comparisons "within" sets of fields and "between" sets of fields.
	 *
	 * Given any selection set, a collection produces both a set of fields by
	 * also including all inline fragments, as well as a list of fragments
	 * referenced by fragment spreads.
	 *
	 * A) Each selection set represented in the document first compares "within" its
	 * collected set of fields, finding any conflicts between every pair of
	 * overlapping fields.
	 * Note: This is the *only time* that a the fields "within" a set are compared
	 * to each other. After this only fields "between" sets are compared.
	 *
	 * B) Also, if any fragment is referenced in a selection set, then a
	 * comparison is made "between" the original set of fields and the
	 * referenced fragment.
	 *
	 * C) Also, if multiple fragments are referenced, then comparisons
	 * are made "between" each referenced fragment.
	 *
	 * D) When comparing "between" a set of fields and a referenced fragment, first
	 * a comparison is made between each field in the original set of fields and
	 * each field in the the referenced set of fields.
	 *
	 * E) Also, if any fragment is referenced in the referenced selection set,
	 * then a comparison is made "between" the original set of fields and the
	 * referenced fragment (recursively referring to step D).
	 *
	 * F) When comparing "between" two fragments, first a comparison is made between
	 * each field in the first referenced set of fields and each field in the the
	 * second referenced set of fields.
	 *
	 * G) Also, any fragments referenced by the first must be compared to the
	 * second, and any fragments referenced by the second must be compared to the
	 * first (recursively referring to step F).
	 *
	 * H) When comparing two fields, if both have selection sets, then a comparison
	 * is made "between" both selection sets, first comparing the set of fields in
	 * the first selection set with the set of fields in the second.
	 *
	 * I) Also, if any fragment is referenced in either selection set, then a
	 * comparison is made "between" the other set of fields and the
	 * referenced fragment.
	 *
	 * J) Also, if two fragments are referenced in both selection sets, then a
	 * comparison is made "between" the two fragments.
	 *
	 */
	
	// Find all conflicts found "within" a selection set, including those found
	// via spreading in fragments. Called when visiting each SelectionSet in the
	// GraphQL Document.
	function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragments, parentType, selectionSet) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
	      fieldMap = _getFieldsAndFragment[0],
	      fragmentNames = _getFieldsAndFragment[1];
	
	  // (A) Find find all conflicts "within" the fields of this selection set.
	  // Note: this is the *only place* `collectConflictsWithin` is called.
	
	
	  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, fieldMap);
	
	  // (B) Then collect conflicts between these fields and those represented by
	  // each spread fragment name found.
	  for (var i = 0; i < fragmentNames.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, false, fieldMap, fragmentNames[i]);
	    // (C) Then compare this fragment with all other fragments found in this
	    // selection set to collect conflicts between fragments spread together.
	    // This compares each item in the list of fragment names to every other item
	    // in that same list (except for itself).
	    for (var j = i + 1; j < fragmentNames.length; j++) {
	      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, false, fragmentNames[i], fragmentNames[j]);
	    }
	  }
	  return conflicts;
	}
	
	// Collect all conflicts found between a set of fields and a fragment reference
	// including via spreading in any nested fragments.
	function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fragmentName) {
	  var fragment = context.getFragment(fragmentName);
	  if (!fragment) {
	    return;
	  }
	
	  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
	      fieldMap2 = _getReferencedFieldsA[0],
	      fragmentNames2 = _getReferencedFieldsA[1];
	
	  // (D) First collect any conflicts between the provided collection of fields
	  // and the collection of fields represented by the given fragment.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fieldMap2);
	
	  // (E) Then collect any conflicts between the provided collection of fields
	  // and any fragment names found in the given fragment.
	  for (var i = 0; i < fragmentNames2.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
	  }
	}
	
	// Collect all conflicts found between two fragments, including via spreading in
	// any nested fragments.
	function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentName1, fragmentName2) {
	  var fragment1 = context.getFragment(fragmentName1);
	  var fragment2 = context.getFragment(fragmentName2);
	  if (!fragment1 || !fragment2) {
	    return;
	  }
	
	  // No need to compare a fragment to itself.
	  if (fragment1 === fragment2) {
	    return;
	  }
	
	  // Memoize so two fragments are not compared for conflicts more than once.
	  if (comparedFragments.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
	    return;
	  }
	  comparedFragments.add(fragmentName1, fragmentName2, areMutuallyExclusive);
	
	  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
	      fieldMap1 = _getReferencedFieldsA2[0],
	      fragmentNames1 = _getReferencedFieldsA2[1];
	
	  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
	      fieldMap2 = _getReferencedFieldsA3[0],
	      fragmentNames2 = _getReferencedFieldsA3[1];
	
	  // (F) First, collect all conflicts between these two collections of fields
	  // (not including any nested fragments).
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fieldMap2);
	
	  // (G) Then collect conflicts between the first fragment and any nested
	  // fragments spread in the second fragment.
	  for (var j = 0; j < fragmentNames2.length; j++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
	  }
	
	  // (G) Then collect conflicts between the second fragment and any nested
	  // fragments spread in the first fragment.
	  for (var i = 0; i < fragmentNames1.length; i++) {
	    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
	  }
	}
	
	// Find all conflicts found between two selection sets, including those found
	// via spreading in fragments. Called when determining if conflicts exist
	// between the sub-fields of two overlapping fields.
	function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
	  var conflicts = [];
	
	  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
	      fieldMap1 = _getFieldsAndFragment2[0],
	      fragmentNames1 = _getFieldsAndFragment2[1];
	
	  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
	      fieldMap2 = _getFieldsAndFragment3[0],
	      fragmentNames2 = _getFieldsAndFragment3[1];
	
	  // (H) First, collect all conflicts between these two collections of field.
	
	
	  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fieldMap2);
	
	  // (I) Then collect conflicts between the first collection of fields and
	  // those referenced by each fragment name associated with the second.
	  for (var j = 0; j < fragmentNames2.length; j++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
	  }
	
	  // (I) Then collect conflicts between the second collection of fields and
	  // those referenced by each fragment name associated with the first.
	  for (var i = 0; i < fragmentNames1.length; i++) {
	    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
	  }
	
	  // (J) Also collect conflicts between any fragment names by the first and
	  // fragment names by the second. This compares each item in the first set of
	  // names to each item in the second set of names.
	  for (var _i = 0; _i < fragmentNames1.length; _i++) {
	    for (var _j = 0; _j < fragmentNames2.length; _j++) {
	      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, fragmentNames1[_i], fragmentNames2[_j]);
	    }
	  }
	  return conflicts;
	}
	
	// Collect all Conflicts "within" one collection of fields.
	function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, fieldMap) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For every response name, if there are multiple fields, they
	  // must be compared to find a potential conflict.
	  Object.keys(fieldMap).forEach(function (responseName) {
	    var fields = fieldMap[responseName];
	    // This compares every field in the list to every other field in this list
	    // (except to itself). If the list only has one item, nothing needs to
	    // be compared.
	    if (fields.length > 1) {
	      for (var i = 0; i < fields.length; i++) {
	        for (var j = i + 1; j < fields.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, false, // within one collection is never mutually exclusive
	          responseName, fields[i], fields[j]);
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  });
	}
	
	// Collect all Conflicts between two collections of fields. This is similar to,
	// but different from the `collectConflictsWithin` function above. This check
	// assumes that `collectConflictsWithin` has already been called on each
	// provided collection of fields. This is true because this validator traverses
	// each individual selection set.
	function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
	  // A field map is a keyed collection, where each key represents a response
	  // name and the value at that key is a list of all fields which provide that
	  // response name. For any response name which appears in both provided field
	  // maps, each field from the first field map must be compared to every field
	  // in the second field map to find potential conflicts.
	  Object.keys(fieldMap1).forEach(function (responseName) {
	    var fields2 = fieldMap2[responseName];
	    if (fields2) {
	      var fields1 = fieldMap1[responseName];
	      for (var i = 0; i < fields1.length; i++) {
	        for (var j = 0; j < fields2.length; j++) {
	          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
	          if (conflict) {
	            conflicts.push(conflict);
	          }
	        }
	      }
	    }
	  });
	}
	
	// Determines if there is a conflict between two particular fields, including
	// comparing their sub-fields.
	function findConflict(context, cachedFieldsAndFragmentNames, comparedFragments, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
	  var parentType1 = field1[0],
	      node1 = field1[1],
	      def1 = field1[2];
	  var parentType2 = field2[0],
	      node2 = field2[1],
	      def2 = field2[2];
	
	  // If it is known that two fields could not possibly apply at the same
	  // time, due to the parent types, then it is safe to permit them to diverge
	  // in aliased field or arguments used as they will not present any ambiguity
	  // by differing.
	  // It is known that two parent types could never overlap if they are
	  // different Object types. Interface or Union types might overlap - if not
	  // in the current state of the schema, then perhaps in some future version,
	  // thus may not safely diverge.
	
	  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && parentType1 instanceof _definition.GraphQLObjectType && parentType2 instanceof _definition.GraphQLObjectType;
	
	  // The return type for each field.
	  var type1 = def1 && def1.type;
	  var type2 = def2 && def2.type;
	
	  if (!areMutuallyExclusive) {
	    // Two aliases must refer to the same field.
	    var name1 = node1.name.value;
	    var name2 = node2.name.value;
	    if (name1 !== name2) {
	      return [[responseName, name1 + ' and ' + name2 + ' are different fields'], [node1], [node2]];
	    }
	
	    // Two field calls must have the same arguments.
	    if (!sameArguments(node1.arguments || [], node2.arguments || [])) {
	      return [[responseName, 'they have differing arguments'], [node1], [node2]];
	    }
	  }
	
	  if (type1 && type2 && doTypesConflict(type1, type2)) {
	    return [[responseName, 'they return conflicting types ' + String(type1) + ' and ' + String(type2)], [node1], [node2]];
	  }
	
	  // Collect and compare sub-fields. Use the same "visited fragment names" list
	  // for both collections so fields in a fragment reference are never
	  // compared to themselves.
	  var selectionSet1 = node1.selectionSet;
	  var selectionSet2 = node2.selectionSet;
	  if (selectionSet1 && selectionSet2) {
	    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragments, areMutuallyExclusive, (0, _definition.getNamedType)(type1), selectionSet1, (0, _definition.getNamedType)(type2), selectionSet2);
	    return subfieldConflicts(conflicts, responseName, node1, node2);
	  }
	}
	
	function sameArguments(arguments1, arguments2) {
	  if (arguments1.length !== arguments2.length) {
	    return false;
	  }
	  return arguments1.every(function (argument1) {
	    var argument2 = (0, _find2.default)(arguments2, function (argument) {
	      return argument.name.value === argument1.name.value;
	    });
	    if (!argument2) {
	      return false;
	    }
	    return sameValue(argument1.value, argument2.value);
	  });
	}
	
	function sameValue(value1, value2) {
	  return !value1 && !value2 || (0, _printer.print)(value1) === (0, _printer.print)(value2);
	}
	
	// Two types conflict if both types could not apply to a value simultaneously.
	// Composite types are ignored as their individual field types will be compared
	// later recursively. However List and Non-Null types must match.
	function doTypesConflict(type1, type2) {
	  if (type1 instanceof _definition.GraphQLList) {
	    return type2 instanceof _definition.GraphQLList ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type2 instanceof _definition.GraphQLList) {
	    return type1 instanceof _definition.GraphQLList ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type1 instanceof _definition.GraphQLNonNull) {
	    return type2 instanceof _definition.GraphQLNonNull ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if (type2 instanceof _definition.GraphQLNonNull) {
	    return type1 instanceof _definition.GraphQLNonNull ? doTypesConflict(type1.ofType, type2.ofType) : true;
	  }
	  if ((0, _definition.isLeafType)(type1) || (0, _definition.isLeafType)(type2)) {
	    return type1 !== type2;
	  }
	  return false;
	}
	
	// Given a selection set, return the collection of fields (a mapping of response
	// name to field nodes and definitions) as well as a list of fragment names
	// referenced via fragment spreads.
	function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
	  var cached = cachedFieldsAndFragmentNames.get(selectionSet);
	  if (!cached) {
	    var nodeAndDefs = Object.create(null);
	    var fragmentNames = Object.create(null);
	    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
	    cached = [nodeAndDefs, Object.keys(fragmentNames)];
	    cachedFieldsAndFragmentNames.set(selectionSet, cached);
	  }
	  return cached;
	}
	
	// Given a reference to a fragment, return the represented collection of fields
	// as well as a list of nested fragment names referenced via fragment spreads.
	function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
	  // Short-circuit building a type from the node if possible.
	  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
	  if (cached) {
	    return cached;
	  }
	
	  var fragmentType = (0, _typeFromAST.typeFromAST)(context.getSchema(), fragment.typeCondition);
	  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
	}
	
	function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
	  for (var i = 0; i < selectionSet.selections.length; i++) {
	    var selection = selectionSet.selections[i];
	    switch (selection.kind) {
	      case Kind.FIELD:
	        var fieldName = selection.name.value;
	        var fieldDef = void 0;
	        if (parentType instanceof _definition.GraphQLObjectType || parentType instanceof _definition.GraphQLInterfaceType) {
	          fieldDef = parentType.getFields()[fieldName];
	        }
	        var responseName = selection.alias ? selection.alias.value : fieldName;
	        if (!nodeAndDefs[responseName]) {
	          nodeAndDefs[responseName] = [];
	        }
	        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
	        break;
	      case Kind.FRAGMENT_SPREAD:
	        fragmentNames[selection.name.value] = true;
	        break;
	      case Kind.INLINE_FRAGMENT:
	        var typeCondition = selection.typeCondition;
	        var inlineFragmentType = typeCondition ? (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition) : parentType;
	        _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
	        break;
	    }
	  }
	}
	
	// Given a series of Conflicts which occurred between two sub-fields, generate
	// a single Conflict.
	function subfieldConflicts(conflicts, responseName, node1, node2) {
	  if (conflicts.length > 0) {
	    return [[responseName, conflicts.map(function (_ref3) {
	      var reason = _ref3[0];
	      return reason;
	    })], conflicts.reduce(function (allFields, _ref4) {
	      var fields1 = _ref4[1];
	      return allFields.concat(fields1);
	    }, [node1]), conflicts.reduce(function (allFields, _ref5) {
	      var fields2 = _ref5[2];
	      return allFields.concat(fields2);
	    }, [node2])];
	  }
	}
	
	/**
	 * A way to keep track of pairs of things when the ordering of the pair does
	 * not matter. We do this by maintaining a sort of double adjacency sets.
	 */
	
	var PairSet = function () {
	  function PairSet() {
	    _classCallCheck(this, PairSet);
	
	    this._data = Object.create(null);
	  }
	
	  PairSet.prototype.has = function has(a, b, areMutuallyExclusive) {
	    var first = this._data[a];
	    var result = first && first[b];
	    if (result === undefined) {
	      return false;
	    }
	    // areMutuallyExclusive being false is a superset of being true,
	    // hence if we want to know if this PairSet "has" these two with no
	    // exclusivity, we have to ensure it was added as such.
	    if (areMutuallyExclusive === false) {
	      return result === false;
	    }
	    return true;
	  };
	
	  PairSet.prototype.add = function add(a, b, areMutuallyExclusive) {
	    _pairSetAdd(this._data, a, b, areMutuallyExclusive);
	    _pairSetAdd(this._data, b, a, areMutuallyExclusive);
	  };
	
	  return PairSet;
	}();
	
	function _pairSetAdd(data, a, b, areMutuallyExclusive) {
	  var map = data[a];
	  if (!map) {
	    map = Object.create(null);
	    data[a] = map;
	  }
	  map[b] = areMutuallyExclusive;
	}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeIncompatibleSpreadMessage = typeIncompatibleSpreadMessage;
	exports.typeIncompatibleAnonSpreadMessage = typeIncompatibleAnonSpreadMessage;
	exports.PossibleFragmentSpreads = PossibleFragmentSpreads;
	
	var _error = __webpack_require__(5);
	
	var _typeComparators = __webpack_require__(93);
	
	var _typeFromAST = __webpack_require__(29);
	
	var _definition = __webpack_require__(6);
	
	function typeIncompatibleSpreadMessage(fragName, parentType, fragType) {
	  return 'Fragment "' + fragName + '" cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function typeIncompatibleAnonSpreadMessage(parentType, fragType) {
	  return 'Fragment cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
	}
	
	/**
	 * Possible fragment spread
	 *
	 * A fragment spread is only valid if the type condition could ever possibly
	 * be true: if there is a non-empty intersection of the possible parent types,
	 * and possible types which pass the type condition.
	 */
	function PossibleFragmentSpreads(context) {
	  return {
	    InlineFragment: function InlineFragment(node) {
	      var fragType = context.getType();
	      var parentType = context.getParentType();
	      if ((0, _definition.isCompositeType)(fragType) && (0, _definition.isCompositeType)(parentType) && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _error.GraphQLError(typeIncompatibleAnonSpreadMessage(parentType, fragType), [node]));
	      }
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var fragName = node.name.value;
	      var fragType = getFragmentType(context, fragName);
	      var parentType = context.getParentType();
	      if (fragType && parentType && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
	        context.reportError(new _error.GraphQLError(typeIncompatibleSpreadMessage(fragName, parentType, fragType), [node]));
	      }
	    }
	  };
	}
	
	function getFragmentType(context, name) {
	  var frag = context.getFragment(name);
	  return frag && (0, _typeFromAST.typeFromAST)(context.getSchema(), frag.typeCondition);
	}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.missingFieldArgMessage = missingFieldArgMessage;
	exports.missingDirectiveArgMessage = missingDirectiveArgMessage;
	exports.ProvidedNonNullArguments = ProvidedNonNullArguments;
	
	var _error = __webpack_require__(5);
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _definition = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function missingFieldArgMessage(fieldName, argName, type) {
	  return 'Field "' + fieldName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
	}
	
	function missingDirectiveArgMessage(directiveName, argName, type) {
	  return 'Directive "@' + directiveName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
	}
	
	/**
	 * Provided required arguments
	 *
	 * A field or directive is only valid if all required (non-null) field arguments
	 * have been provided.
	 */
	function ProvidedNonNullArguments(context) {
	  return {
	    Field: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(node) {
	        var fieldDef = context.getFieldDef();
	        if (!fieldDef) {
	          return false;
	        }
	        var argNodes = node.arguments || [];
	
	        var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	          return arg.name.value;
	        });
	        fieldDef.args.forEach(function (argDef) {
	          var argNode = argNodeMap[argDef.name];
	          if (!argNode && argDef.type instanceof _definition.GraphQLNonNull) {
	            context.reportError(new _error.GraphQLError(missingFieldArgMessage(node.name.value, argDef.name, argDef.type), [node]));
	          }
	        });
	      }
	    },
	
	    Directive: {
	      // Validate on leave to allow for deeper errors to appear first.
	      leave: function leave(node) {
	        var directiveDef = context.getDirective();
	        if (!directiveDef) {
	          return false;
	        }
	        var argNodes = node.arguments || [];
	
	        var argNodeMap = (0, _keyMap2.default)(argNodes, function (arg) {
	          return arg.name.value;
	        });
	        directiveDef.args.forEach(function (argDef) {
	          var argNode = argNodeMap[argDef.name];
	          if (!argNode && argDef.type instanceof _definition.GraphQLNonNull) {
	            context.reportError(new _error.GraphQLError(missingDirectiveArgMessage(node.name.value, argDef.name, argDef.type), [node]));
	          }
	        });
	      }
	    }
	  };
	}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noSubselectionAllowedMessage = noSubselectionAllowedMessage;
	exports.requiredSubselectionMessage = requiredSubselectionMessage;
	exports.ScalarLeafs = ScalarLeafs;
	
	var _error = __webpack_require__(5);
	
	var _definition = __webpack_require__(6);
	
	function noSubselectionAllowedMessage(fieldName, type) {
	  return 'Field "' + fieldName + '" must not have a selection since ' + ('type "' + String(type) + '" has no subfields.');
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function requiredSubselectionMessage(fieldName, type) {
	  return 'Field "' + fieldName + '" of type "' + String(type) + '" must have a ' + ('selection of subfields. Did you mean "' + fieldName + ' { ... }"?');
	}
	
	/**
	 * Scalar leafs
	 *
	 * A GraphQL document is valid only if all leaf fields (fields without
	 * sub selections) are of scalar or enum types.
	 */
	function ScalarLeafs(context) {
	  return {
	    Field: function Field(node) {
	      var type = context.getType();
	      if (type) {
	        if ((0, _definition.isLeafType)((0, _definition.getNamedType)(type))) {
	          if (node.selectionSet) {
	            context.reportError(new _error.GraphQLError(noSubselectionAllowedMessage(node.name.value, type), [node.selectionSet]));
	          }
	        } else if (!node.selectionSet) {
	          context.reportError(new _error.GraphQLError(requiredSubselectionMessage(node.name.value, type), [node]));
	        }
	      }
	    }
	  };
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.singleFieldOnlyMessage = singleFieldOnlyMessage;
	exports.SingleFieldSubscriptions = SingleFieldSubscriptions;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function singleFieldOnlyMessage(name) {
	  return (name ? 'Subscription "' + name + '" ' : 'Anonymous Subscription ') + 'must select only one top level field.';
	}
	
	/**
	 * Subscriptions must only include one field.
	 *
	 * A GraphQL subscription is valid only if it contains a single root field.
	 */
	function SingleFieldSubscriptions(context) {
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      if (node.operation === 'subscription') {
	        if (node.selectionSet.selections.length !== 1) {
	          context.reportError(new _error.GraphQLError(singleFieldOnlyMessage(node.name && node.name.value), node.selectionSet.selections.slice(1)));
	        }
	      }
	    }
	  };
	}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateArgMessage = duplicateArgMessage;
	exports.UniqueArgumentNames = UniqueArgumentNames;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function duplicateArgMessage(argName) {
	  return 'There can be only one argument named "' + argName + '".';
	}
	
	/**
	 * Unique argument names
	 *
	 * A GraphQL field or directive is only valid if all supplied arguments are
	 * uniquely named.
	 */
	function UniqueArgumentNames(context) {
	  var knownArgNames = Object.create(null);
	  return {
	    Field: function Field() {
	      knownArgNames = Object.create(null);
	    },
	    Directive: function Directive() {
	      knownArgNames = Object.create(null);
	    },
	    Argument: function Argument(node) {
	      var argName = node.name.value;
	      if (knownArgNames[argName]) {
	        context.reportError(new _error.GraphQLError(duplicateArgMessage(argName), [knownArgNames[argName], node.name]));
	      } else {
	        knownArgNames[argName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateDirectiveMessage = duplicateDirectiveMessage;
	exports.UniqueDirectivesPerLocation = UniqueDirectivesPerLocation;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function duplicateDirectiveMessage(directiveName) {
	  return 'The directive "' + directiveName + '" can only be used once at ' + 'this location.';
	}
	
	/**
	 * Unique directive names per location
	 *
	 * A GraphQL document is only valid if all directives at a given location
	 * are uniquely named.
	 */
	function UniqueDirectivesPerLocation(context) {
	  return {
	    // Many different AST nodes may contain directives. Rather than listing
	    // them all, just listen for entering any node, and check to see if it
	    // defines any directives.
	    enter: function enter(node) {
	      if (node.directives) {
	        var knownDirectives = Object.create(null);
	        node.directives.forEach(function (directive) {
	          var directiveName = directive.name.value;
	          if (knownDirectives[directiveName]) {
	            context.reportError(new _error.GraphQLError(duplicateDirectiveMessage(directiveName), [knownDirectives[directiveName], directive]));
	          } else {
	            knownDirectives[directiveName] = directive;
	          }
	        });
	      }
	    }
	  };
	}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateFragmentNameMessage = duplicateFragmentNameMessage;
	exports.UniqueFragmentNames = UniqueFragmentNames;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function duplicateFragmentNameMessage(fragName) {
	  return 'There can be only one fragment named "' + fragName + '".';
	}
	
	/**
	 * Unique fragment names
	 *
	 * A GraphQL document is only valid if all defined fragments have unique names.
	 */
	function UniqueFragmentNames(context) {
	  var knownFragmentNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      return false;
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      var fragmentName = node.name.value;
	      if (knownFragmentNames[fragmentName]) {
	        context.reportError(new _error.GraphQLError(duplicateFragmentNameMessage(fragmentName), [knownFragmentNames[fragmentName], node.name]));
	      } else {
	        knownFragmentNames[fragmentName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateInputFieldMessage = duplicateInputFieldMessage;
	exports.UniqueInputFieldNames = UniqueInputFieldNames;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function duplicateInputFieldMessage(fieldName) {
	  return 'There can be only one input field named "' + fieldName + '".';
	}
	
	/**
	 * Unique input field names
	 *
	 * A GraphQL input object value is only valid if all supplied fields are
	 * uniquely named.
	 */
	function UniqueInputFieldNames(context) {
	  var knownNameStack = [];
	  var knownNames = Object.create(null);
	
	  return {
	    ObjectValue: {
	      enter: function enter() {
	        knownNameStack.push(knownNames);
	        knownNames = Object.create(null);
	      },
	      leave: function leave() {
	        knownNames = knownNameStack.pop();
	      }
	    },
	    ObjectField: function ObjectField(node) {
	      var fieldName = node.name.value;
	      if (knownNames[fieldName]) {
	        context.reportError(new _error.GraphQLError(duplicateInputFieldMessage(fieldName), [knownNames[fieldName], node.name]));
	      } else {
	        knownNames[fieldName] = node.name;
	      }
	      return false;
	    }
	  };
	}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateOperationNameMessage = duplicateOperationNameMessage;
	exports.UniqueOperationNames = UniqueOperationNames;
	
	var _error = __webpack_require__(5);
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function duplicateOperationNameMessage(operationName) {
	  return 'There can be only one operation named "' + operationName + '".';
	}
	
	/**
	 * Unique operation names
	 *
	 * A GraphQL document is only valid if all defined operations have unique names.
	 */
	function UniqueOperationNames(context) {
	  var knownOperationNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition(node) {
	      var operationName = node.name;
	      if (operationName) {
	        if (knownOperationNames[operationName.value]) {
	          context.reportError(new _error.GraphQLError(duplicateOperationNameMessage(operationName.value), [knownOperationNames[operationName.value], operationName]));
	        } else {
	          knownOperationNames[operationName.value] = operationName;
	        }
	      }
	      return false;
	    },
	
	    FragmentDefinition: function FragmentDefinition() {
	      return false;
	    }
	  };
	}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.duplicateVariableMessage = duplicateVariableMessage;
	exports.UniqueVariableNames = UniqueVariableNames;
	
	var _error = __webpack_require__(5);
	
	function duplicateVariableMessage(variableName) {
	  return 'There can be only one variable named "' + variableName + '".';
	}
	
	/**
	 * Unique variable names
	 *
	 * A GraphQL operation is only valid if all its variables are uniquely named.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function UniqueVariableNames(context) {
	  var knownVariableNames = Object.create(null);
	  return {
	    OperationDefinition: function OperationDefinition() {
	      knownVariableNames = Object.create(null);
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      var variableName = node.variable.name.value;
	      if (knownVariableNames[variableName]) {
	        context.reportError(new _error.GraphQLError(duplicateVariableMessage(variableName), [knownVariableNames[variableName], node.variable.name]));
	      } else {
	        knownVariableNames[variableName] = node.variable.name;
	      }
	    }
	  };
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nonInputTypeOnVarMessage = nonInputTypeOnVarMessage;
	exports.VariablesAreInputTypes = VariablesAreInputTypes;
	
	var _error = __webpack_require__(5);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _typeFromAST = __webpack_require__(29);
	
	function nonInputTypeOnVarMessage(variableName, typeName) {
	  return 'Variable "$' + variableName + '" cannot be non-input type "' + typeName + '".';
	}
	
	/**
	 * Variables are input types
	 *
	 * A GraphQL operation is only valid if all the variables it defines are of
	 * input types (scalar, enum, or input object).
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function VariablesAreInputTypes(context) {
	  return {
	    VariableDefinition: function VariableDefinition(node) {
	      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.type);
	
	      // If the variable type is not an input type, return an error.
	      if (type && !(0, _definition.isInputType)(type)) {
	        var variableName = node.variable.name.value;
	        context.reportError(new _error.GraphQLError(nonInputTypeOnVarMessage(variableName, (0, _printer.print)(node.type)), [node.type]));
	      }
	    }
	  };
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.badVarPosMessage = badVarPosMessage;
	exports.VariablesInAllowedPosition = VariablesInAllowedPosition;
	
	var _error = __webpack_require__(5);
	
	var _definition = __webpack_require__(6);
	
	var _typeComparators = __webpack_require__(93);
	
	var _typeFromAST = __webpack_require__(29);
	
	function badVarPosMessage(varName, varType, expectedType) {
	  return 'Variable "$' + varName + '" of type "' + String(varType) + '" used in ' + ('position expecting type "' + String(expectedType) + '".');
	}
	
	/**
	 * Variables passed to field arguments conform to type
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function VariablesInAllowedPosition(context) {
	  var varDefMap = Object.create(null);
	
	  return {
	    OperationDefinition: {
	      enter: function enter() {
	        varDefMap = Object.create(null);
	      },
	      leave: function leave(operation) {
	        var usages = context.getRecursiveVariableUsages(operation);
	
	        usages.forEach(function (_ref) {
	          var node = _ref.node,
	              type = _ref.type;
	
	          var varName = node.name.value;
	          var varDef = varDefMap[varName];
	          if (varDef && type) {
	            // A var type is allowed if it is the same or more strict (e.g. is
	            // a subtype of) than the expected type. It can be more strict if
	            // the variable type is non-null when the expected type is nullable.
	            // If both are list types, the variable item type can be more strict
	            // than the expected item type (contravariant).
	            var schema = context.getSchema();
	            var varType = (0, _typeFromAST.typeFromAST)(schema, varDef.type);
	            if (varType && !(0, _typeComparators.isTypeSubTypeOf)(schema, effectiveType(varType, varDef), type)) {
	              context.reportError(new _error.GraphQLError(badVarPosMessage(varName, varType, type), [varDef, node]));
	            }
	          }
	        });
	      }
	    },
	    VariableDefinition: function VariableDefinition(node) {
	      varDefMap[node.variable.name.value] = node;
	    }
	  };
	}
	
	// If a variable definition has a default value, it's effectively non-null.
	function effectiveType(varType, varDef) {
	  return !varDef.defaultValue || varType instanceof _definition.GraphQLNonNull ? varType : new _definition.GraphQLNonNull(varType);
	}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specifiedRules = undefined;
	
	var _UniqueOperationNames = __webpack_require__(211);
	
	var _LoneAnonymousOperation = __webpack_require__(197);
	
	var _SingleFieldSubscriptions = __webpack_require__(206);
	
	var _KnownTypeNames = __webpack_require__(196);
	
	var _FragmentsOnCompositeTypes = __webpack_require__(192);
	
	var _VariablesAreInputTypes = __webpack_require__(213);
	
	var _ScalarLeafs = __webpack_require__(205);
	
	var _FieldsOnCorrectType = __webpack_require__(191);
	
	var _UniqueFragmentNames = __webpack_require__(209);
	
	var _KnownFragmentNames = __webpack_require__(195);
	
	var _NoUnusedFragments = __webpack_require__(200);
	
	var _PossibleFragmentSpreads = __webpack_require__(203);
	
	var _NoFragmentCycles = __webpack_require__(198);
	
	var _UniqueVariableNames = __webpack_require__(212);
	
	var _NoUndefinedVariables = __webpack_require__(199);
	
	var _NoUnusedVariables = __webpack_require__(201);
	
	var _KnownDirectives = __webpack_require__(194);
	
	var _UniqueDirectivesPerLocation = __webpack_require__(208);
	
	var _KnownArgumentNames = __webpack_require__(193);
	
	var _UniqueArgumentNames = __webpack_require__(207);
	
	var _ArgumentsOfCorrectType = __webpack_require__(189);
	
	var _ProvidedNonNullArguments = __webpack_require__(204);
	
	var _DefaultValuesOfCorrectType = __webpack_require__(190);
	
	var _VariablesInAllowedPosition = __webpack_require__(214);
	
	var _OverlappingFieldsCanBeMerged = __webpack_require__(202);
	
	var _UniqueInputFieldNames = __webpack_require__(210);
	
	/**
	 * This set includes all validation rules defined by the GraphQL spec.
	 *
	 * The order of the rules in this list has been adjusted to lead to the
	 * most clear output when encountering multiple validation errors.
	 */
	
	
	// Spec Section: "Field Selection Merging"
	
	
	// Spec Section: "Variable Default Values Are Correctly Typed"
	
	
	// Spec Section: "Argument Values Type Correctness"
	
	
	// Spec Section: "Argument Names"
	
	
	// Spec Section: "Directives Are Defined"
	
	
	// Spec Section: "All Variable Used Defined"
	
	
	// Spec Section: "Fragments must not form cycles"
	
	
	// Spec Section: "Fragments must be used"
	
	
	// Spec Section: "Fragment Name Uniqueness"
	
	
	// Spec Section: "Leaf Field Selections"
	
	
	// Spec Section: "Fragments on Composite Types"
	
	
	// Spec Section: "Subscriptions with Single Root Field"
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	// Spec Section: "Operation Name Uniqueness"
	var specifiedRules = exports.specifiedRules = [_UniqueOperationNames.UniqueOperationNames, _LoneAnonymousOperation.LoneAnonymousOperation, _SingleFieldSubscriptions.SingleFieldSubscriptions, _KnownTypeNames.KnownTypeNames, _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes, _VariablesAreInputTypes.VariablesAreInputTypes, _ScalarLeafs.ScalarLeafs, _FieldsOnCorrectType.FieldsOnCorrectType, _UniqueFragmentNames.UniqueFragmentNames, _KnownFragmentNames.KnownFragmentNames, _NoUnusedFragments.NoUnusedFragments, _PossibleFragmentSpreads.PossibleFragmentSpreads, _NoFragmentCycles.NoFragmentCycles, _UniqueVariableNames.UniqueVariableNames, _NoUndefinedVariables.NoUndefinedVariables, _NoUnusedVariables.NoUnusedVariables, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNames, _UniqueArgumentNames.UniqueArgumentNames, _ArgumentsOfCorrectType.ArgumentsOfCorrectType, _ProvidedNonNullArguments.ProvidedNonNullArguments, _DefaultValuesOfCorrectType.DefaultValuesOfCorrectType, _VariablesInAllowedPosition.VariablesInAllowedPosition, _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged, _UniqueInputFieldNames.UniqueInputFieldNames];
	
	// Spec Section: "Input Object Field Uniqueness"
	
	
	// Spec Section: "All Variable Usages Are Allowed"
	
	
	// Spec Section: "Argument Optionality"
	
	
	// Spec Section: "Argument Uniqueness"
	
	
	// Spec Section: "Directives Are Unique Per Location"
	
	
	// Spec Section: "All Variables Used"
	
	
	// Spec Section: "Variable Uniqueness"
	
	
	// Spec Section: "Fragment spread is possible"
	
	
	// Spec Section: "Fragment spread target defined"
	
	
	// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
	
	
	// Spec Section: "Variables are Input Types"
	
	
	// Spec Section: "Fragment Spread Type Existence"
	
	
	// Spec Section: "Lone Anonymous Operation"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationContext = undefined;
	exports.validate = validate;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _error = __webpack_require__(5);
	
	var _visitor = __webpack_require__(67);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	var _schema = __webpack_require__(28);
	
	var _TypeInfo = __webpack_require__(106);
	
	var _specifiedRules = __webpack_require__(215);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * Implements the "Validation" section of the spec.
	 *
	 * Validation runs synchronously, returning an array of encountered errors, or
	 * an empty array if no errors were encountered and the document is valid.
	 *
	 * A list of specific validation rules may be provided. If not provided, the
	 * default list of rules defined by the GraphQL specification will be used.
	 *
	 * Each validation rules is a function which returns a visitor
	 * (see the language/visitor API). Visitor methods are expected to return
	 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
	 *
	 * Optionally a custom TypeInfo instance may be provided. If not provided, one
	 * will be created from the provided schema.
	 */
	function validate(schema, ast, rules, typeInfo) {
	  !schema ? (0, _invariant2.default)(0, 'Must provide schema') : void 0;
	  !ast ? (0, _invariant2.default)(0, 'Must provide document') : void 0;
	  !(schema instanceof _schema.GraphQLSchema) ? (0, _invariant2.default)(0, 'Schema must be an instance of GraphQLSchema. Also ensure that there are ' + 'not multiple versions of GraphQL installed in your node_modules directory.') : void 0;
	  return visitUsingRules(schema, typeInfo || new _TypeInfo.TypeInfo(schema), ast, rules || _specifiedRules.specifiedRules);
	}
	
	/**
	 * This uses a specialized visitor which runs multiple visitors in parallel,
	 * while maintaining the visitor skip and break API.
	 *
	 * @internal
	 */
	function visitUsingRules(schema, typeInfo, documentAST, rules) {
	  var context = new ValidationContext(schema, documentAST, typeInfo);
	  var visitors = rules.map(function (rule) {
	    return rule(context);
	  });
	  // Visit the whole document with each instance of all provided rules.
	  (0, _visitor.visit)(documentAST, (0, _visitor.visitWithTypeInfo)(typeInfo, (0, _visitor.visitInParallel)(visitors)));
	  return context.getErrors();
	}
	
	/**
	 * An instance of this class is passed as the "this" context to all validators,
	 * allowing access to commonly useful contextual information from within a
	 * validation rule.
	 */
	var ValidationContext = exports.ValidationContext = function () {
	  function ValidationContext(schema, ast, typeInfo) {
	    _classCallCheck(this, ValidationContext);
	
	    this._schema = schema;
	    this._ast = ast;
	    this._typeInfo = typeInfo;
	    this._errors = [];
	    this._fragmentSpreads = new Map();
	    this._recursivelyReferencedFragments = new Map();
	    this._variableUsages = new Map();
	    this._recursiveVariableUsages = new Map();
	  }
	
	  ValidationContext.prototype.reportError = function reportError(error) {
	    this._errors.push(error);
	  };
	
	  ValidationContext.prototype.getErrors = function getErrors() {
	    return this._errors;
	  };
	
	  ValidationContext.prototype.getSchema = function getSchema() {
	    return this._schema;
	  };
	
	  ValidationContext.prototype.getDocument = function getDocument() {
	    return this._ast;
	  };
	
	  ValidationContext.prototype.getFragment = function getFragment(name) {
	    var fragments = this._fragments;
	    if (!fragments) {
	      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
	        if (statement.kind === Kind.FRAGMENT_DEFINITION) {
	          frags[statement.name.value] = statement;
	        }
	        return frags;
	      }, Object.create(null));
	    }
	    return fragments[name];
	  };
	
	  ValidationContext.prototype.getFragmentSpreads = function getFragmentSpreads(node) {
	    var spreads = this._fragmentSpreads.get(node);
	    if (!spreads) {
	      spreads = [];
	      var setsToVisit = [node];
	      while (setsToVisit.length !== 0) {
	        var set = setsToVisit.pop();
	        for (var i = 0; i < set.selections.length; i++) {
	          var selection = set.selections[i];
	          if (selection.kind === Kind.FRAGMENT_SPREAD) {
	            spreads.push(selection);
	          } else if (selection.selectionSet) {
	            setsToVisit.push(selection.selectionSet);
	          }
	        }
	      }
	      this._fragmentSpreads.set(node, spreads);
	    }
	    return spreads;
	  };
	
	  ValidationContext.prototype.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
	    var fragments = this._recursivelyReferencedFragments.get(operation);
	    if (!fragments) {
	      fragments = [];
	      var collectedNames = Object.create(null);
	      var nodesToVisit = [operation.selectionSet];
	      while (nodesToVisit.length !== 0) {
	        var _node = nodesToVisit.pop();
	        var spreads = this.getFragmentSpreads(_node);
	        for (var i = 0; i < spreads.length; i++) {
	          var fragName = spreads[i].name.value;
	          if (collectedNames[fragName] !== true) {
	            collectedNames[fragName] = true;
	            var fragment = this.getFragment(fragName);
	            if (fragment) {
	              fragments.push(fragment);
	              nodesToVisit.push(fragment.selectionSet);
	            }
	          }
	        }
	      }
	      this._recursivelyReferencedFragments.set(operation, fragments);
	    }
	    return fragments;
	  };
	
	  ValidationContext.prototype.getVariableUsages = function getVariableUsages(node) {
	    var usages = this._variableUsages.get(node);
	    if (!usages) {
	      var newUsages = [];
	      var typeInfo = new _TypeInfo.TypeInfo(this._schema);
	      (0, _visitor.visit)(node, (0, _visitor.visitWithTypeInfo)(typeInfo, {
	        VariableDefinition: function VariableDefinition() {
	          return false;
	        },
	        Variable: function Variable(variable) {
	          newUsages.push({ node: variable, type: typeInfo.getInputType() });
	        }
	      }));
	      usages = newUsages;
	      this._variableUsages.set(node, usages);
	    }
	    return usages;
	  };
	
	  ValidationContext.prototype.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
	    var usages = this._recursiveVariableUsages.get(operation);
	    if (!usages) {
	      usages = this.getVariableUsages(operation);
	      var fragments = this.getRecursivelyReferencedFragments(operation);
	      for (var i = 0; i < fragments.length; i++) {
	        Array.prototype.push.apply(usages, this.getVariableUsages(fragments[i]));
	      }
	      this._recursiveVariableUsages.set(operation, usages);
	    }
	    return usages;
	  };
	
	  ValidationContext.prototype.getType = function getType() {
	    return this._typeInfo.getType();
	  };
	
	  ValidationContext.prototype.getParentType = function getParentType() {
	    return this._typeInfo.getParentType();
	  };
	
	  ValidationContext.prototype.getInputType = function getInputType() {
	    return this._typeInfo.getInputType();
	  };
	
	  ValidationContext.prototype.getFieldDef = function getFieldDef() {
	    return this._typeInfo.getFieldDef();
	  };
	
	  ValidationContext.prototype.getDirective = function getDirective() {
	    return this._typeInfo.getDirective();
	  };
	
	  ValidationContext.prototype.getArgument = function getArgument() {
	    return this._typeInfo.getArgument();
	  };
	
	  return ValidationContext;
	}();

/***/ }),
/* 217 */,
/* 218 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ramda = __webpack_require__(35);
	
	var _getValidLangKey = __webpack_require__(70);
	
	var _getValidLangKey2 = _interopRequireDefault(_getValidLangKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get current language key from url.
	 * @func
	 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
	 * @param {String} defaultLangKey default browser language key
	 * @param {String} url browser url 
	 * @returns {String} current langKey
	 */
	var getCurrentLangKey = (0, _ramda.curry)(function (langs, defaultLangKey, url) {
	  var langKey = url.split('/')[1];
	  return (0, _getValidLangKey2.default)(langs, defaultLangKey, langKey);
	});
	
	exports.default = getCurrentLangKey;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ramda = __webpack_require__(35);
	
	var defaultPagesPaths = ['/src/pages/'];
	
	var getPagesPaths = function getPagesPaths(options) {
	  return options && options.pagesPaths || defaultPagesPaths;
	};
	
	var getLangKeyDefault = function getLangKeyDefault(options) {
	  return options && options.langKeyDefault || options;
	};
	
	var addSlashStart = function addSlashStart(fileName) {
	  return (0, _ramda.startsWith)('/', fileName) ? fileName : '/' + fileName;
	};
	
	var addSlashEnd = function addSlashEnd(fileName) {
	  return (0, _ramda.endsWith)('/', fileName) ? fileName : fileName + '/';
	};
	
	var addSlash = (0, _ramda.compose)(addSlashStart, addSlashEnd);
	
	/**
	 * Get slug (path) and langKey for a given file path.
	 *
	 * Used by gatsby-plugin-i18n and gatsby-plugin-i18n-tags
	 *
	 * @param {{langKeyDefault: string, pagesPaths: string[] }} options plugin options
	 * @param {String} fileAbsolutePath local file absolute path
	 * @return {{slug: string, langKey: string}} slug and langKey
	 */
	var getSlugAndLang = (0, _ramda.curry)(function (options, fileAbsolutePath) {
	  var slugsAndLangs = getPagesPaths(options).map(function (pagesPath) {
	    var filePath = ('safeStartToSplit-' + fileAbsolutePath).split(pagesPath)[1];
	
	    if ((0, _ramda.isNil)(filePath)) {
	      return null;
	    }
	
	    var fileName = filePath.split('.');
	    var langKey = fileName.length === 3 ? fileName[1] : getLangKeyDefault(options);
	    var slug = addSlash((fileName.length === 3 ? langKey : '') + addSlash(fileName[0].replace('index', '')));
	
	    return {
	      slug: slug,
	      langKey: langKey
	    };
	  });
	
	  return (0, _ramda.head)(slugsAndLangs.filter((0, _ramda.compose)(_ramda.not, _ramda.isNil)));
	});
	
	exports.default = getSlugAndLang;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirectToHome = exports.isHomePage = exports.nPaths = exports.getUrlForLang = exports.getSlugAndLang = exports.getLangs = exports.getI18nBase = exports.getValidLangKey = exports.getUserLangKey = exports.getCurrentLangKey = exports.getBrowserLanguage = undefined;
	
	var _ramda = __webpack_require__(35);
	
	var _getCurrentLangKey = __webpack_require__(223);
	
	var _getCurrentLangKey2 = _interopRequireDefault(_getCurrentLangKey);
	
	var _getValidLangKey = __webpack_require__(70);
	
	var _getValidLangKey2 = _interopRequireDefault(_getValidLangKey);
	
	var _getBrowserLanguage = __webpack_require__(109);
	
	var _getBrowserLanguage2 = _interopRequireDefault(_getBrowserLanguage);
	
	var _redirectToHome = __webpack_require__(226);
	
	var _redirectToHome2 = _interopRequireDefault(_redirectToHome);
	
	var _getUserLangKey = __webpack_require__(110);
	
	var _getUserLangKey2 = _interopRequireDefault(_getUserLangKey);
	
	var _getSlugAndLang = __webpack_require__(224);
	
	var _getSlugAndLang2 = _interopRequireDefault(_getSlugAndLang);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the number of paths in a url
	 * @param {*} url pathName
	 * @returns {Number} number of paths
	 */
	var nPaths = function nPaths(url) {
	  return (url.match(/\//g) || []).length - 1;
	};
	
	/**
	 * Checks if the url is /, /en/ or /pt/
	 * @param {*} url this.props.location
	 * @returns {Boolean} is home or not
	 */
	var isHomePage = function isHomePage(url) {
	  return nPaths(url) <= 1;
	};
	
	/**
	 * Get url to the language
	 * @param {String} homeLink  link for the home page
	 * @param {String} url  browser url
	 * @param {String} langKey default browser language key
	 * @returns {String} new url
	 */
	var getUrlForLang = (0, _ramda.curry)(function (homeLink, url, langKey) {
	  return url === '/' || !(0, _ramda.startsWith)(homeLink, url) ? '/' + langKey + '/' : url.replace(homeLink, '/' + langKey + '/');
	});
	
	/**
	 * Get langs to create Menu
	 * @param {[String]} langs lang keys ['en', 'fr', 'pt']
	 * @param {String} currentLangKey current Lang Key
	 * @param {func} getUrlForLang getUrlForLang curried, waiting for langKey
	 * @returns {Array} langs menu data
	 */
	var getLangs = (0, _ramda.curry)(function (langs, currentLangKey, getUrlForLang) {
	  return langs.map(function (langKey) {
	    return {
	      langKey: langKey,
	      selected: currentLangKey === langKey,
	      link: getUrlForLang(langKey)
	    };
	  });
	});
	
	/**
	 * Get i18n obj for the given langKey or first when not found
	 * @param {*} i18n Translations object
	 * @param {*} langKey langKey
	 * @returns {*} i18n[langKey] or i18n[defaultLangKey]
	 */
	var getI18nBase = (0, _ramda.curry)(function (i18n, langKey) {
	  return i18n[langKey] || Object.values(i18n)[0];
	});
	
	exports.getBrowserLanguage = _getBrowserLanguage2.default;
	exports.getCurrentLangKey = _getCurrentLangKey2.default;
	exports.getUserLangKey = _getUserLangKey2.default;
	exports.getValidLangKey = _getValidLangKey2.default;
	exports.getI18nBase = getI18nBase;
	exports.getLangs = getLangs;
	exports.getSlugAndLang = _getSlugAndLang2.default;
	exports.getUrlForLang = getUrlForLang;
	exports.nPaths = nPaths;
	exports.isHomePage = isHomePage;
	exports.redirectToHome = _redirectToHome2.default;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getUserLangKey = __webpack_require__(110);
	
	var _getUserLangKey2 = _interopRequireDefault(_getUserLangKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Redirect to user language home page, from: / to: /langKey/
	 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
	 * @param {String} defaultLangKey default browser language key
	 * @return {void}
	 */
	var redirectToHome = function redirectToHome(langs, defaultLangKey) {
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var langKey = (0, _getUserLangKey2.default)(langs, defaultLangKey);
	  var newUrl = '/' + langKey + '/';
	  window.location.replace(newUrl);
	};
	
	exports.default = redirectToHome;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(30);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(30);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xall = __webpack_require__(304);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	var max = __webpack_require__(31);
	var pluck = __webpack_require__(41);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	var max = __webpack_require__(31);
	var pluck = __webpack_require__(41);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(287);
	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xaperture = __webpack_require__(305);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var apply = __webpack_require__(114);
	var curryN = __webpack_require__(9);
	var map = __webpack_require__(13);
	var max = __webpack_require__(31);
	var pluck = __webpack_require__(41);
	var reduce = __webpack_require__(19);
	var values = __webpack_require__(164);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @see R.descend
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var nAry = __webpack_require__(60);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @see R.nAry, R.unary
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(54);
	var and = __webpack_require__(112);
	var lift = __webpack_require__(58);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(49);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * [`R.converge`](#converge): the first branch can produce a function while the
	 * remaining branches produce values to be passed to that function as its
	 * arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(128);
	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(58);
	var not = __webpack_require__(148);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(154);
	var reverse = __webpack_require__(63);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry1 = __webpack_require__(2);
	var map = __webpack_require__(13);
	var max = __webpack_require__(31);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var constructN = __webpack_require__(118);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @see R.invoker
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(61);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(47);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @see R.ascend
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isInteger = __webpack_require__(80);
	var assoc = __webpack_require__(48);
	var dissoc = __webpack_require__(123);
	var remove = __webpack_require__(157);
	var update = __webpack_require__(90);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      if (obj[head] == null) {
	        return obj;
	      } else if (_isInteger(path[0])) {
	        return update(head, dissocPath(tail, obj[head]), obj);
	      } else {
	        return assoc(head, dissocPath(tail, obj[head]), obj);
	      }
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _dropLast = __webpack_require__(289);
	var _xdropLast = __webpack_require__(308);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _dropLastWhile = __webpack_require__(290);
	var _xdropLastWhile = __webpack_require__(309);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(7);
	var _xdropRepeatsWith = __webpack_require__(137);
	var dropRepeatsWith = __webpack_require__(125);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xdropWhile = __webpack_require__(310);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isFunction = __webpack_require__(54);
	var lift = __webpack_require__(58);
	var or = __webpack_require__(150);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var equals = __webpack_require__(14);
	var takeLast = __webpack_require__(160);
	
	/**
	 * Checks if a list ends with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} suffix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.endsWith('c', 'abc')                //=> true
	 *      R.endsWith('b', 'abc')                //=> false
	 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
	 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	module.exports = _curry2(function(suffix, list) {
	  return equals(takeLast(suffix.length, list), suffix);
	});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Reports whether two objects have the same value, in [`R.equals`](#equals)
	 * terms, for the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xfind = __webpack_require__(312);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xfindIndex = __webpack_require__(313);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xfindLast = __webpack_require__(314);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xfindLastIndex = __webpack_require__(315);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _makeFlat = __webpack_require__(135);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(36);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(36);
	var _curry2 = __webpack_require__(1);
	var reduceBy = __webpack_require__(61);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all satisfied pairwise comparison according to the provided function.
	 * Only adjacent elements are passed to the comparison function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _has = __webpack_require__(12);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(39);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(47);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(61);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _indexOf = __webpack_require__(132);
	var _isArray = __webpack_require__(21);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(26);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(51);
	var _curry3 = __webpack_require__(3);
	var _filter = __webpack_require__(78);
	
	
	/**
	 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
	 * `xs'` comprising each of the elements of `xs` which is equal to one or more
	 * elements of `ys` according to `pred`.
	 *
	 * `pred` must be a binary function expecting an element from each list.
	 *
	 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
	 * not be significant, but since `xs'` is ordered the implementation guarantees
	 * that its values are in the same order as they appear in `xs`. Duplicates are
	 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Relation
	 * @sig (a -> b -> Boolean) -> [a] -> [b] -> [a]
	 * @param {Function} pred
	 * @param {Array} xs
	 * @param {Array} ys
	 * @return {Array}
	 * @see R.intersection
	 * @example
	 *
	 *      R.innerJoin(
	 *        (record, id) => record.id === id,
	 *        [{id: 824, name: 'Richie Furay'},
	 *         {id: 956, name: 'Dewey Martin'},
	 *         {id: 313, name: 'Bruce Palmer'},
	 *         {id: 456, name: 'Stephen Stills'},
	 *         {id: 177, name: 'Neil Young'}],
	 *        [177, 456, 999]
	 *      );
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function innerJoin(pred, xs, ys) {
	  return _filter(function(x) { return _containsWith(pred, x, ys); }, xs);
	});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Inserts the supplied element into the list, at the specified `index`. _Note that
	
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var take = __webpack_require__(86);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(288);
	var _functionName = __webpack_require__(294);
	var _has = __webpack_require__(12);
	var identical = __webpack_require__(127);
	var keys = __webpack_require__(18);
	var type = __webpack_require__(87);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) &&
	           typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(293);
	var _isArrayLike = __webpack_require__(53);
	var _reduce = __webpack_require__(15);
	var _xfBase = __webpack_require__(8);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(12);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(77);
	var _identity = __webpack_require__(79);
	var _isArrayLike = __webpack_require__(53);
	var _isTransformer = __webpack_require__(82);
	var objOf = __webpack_require__(149);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        _isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (_isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _map = __webpack_require__(56);
	var _quote = __webpack_require__(300);
	var _toISOString = __webpack_require__(302);
	var keys = __webpack_require__(18);
	var reject = __webpack_require__(62);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _flatCat = __webpack_require__(292);
	var map = __webpack_require__(13);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(15);
	var _xfBase = __webpack_require__(8);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(52);
	var _has = __webpack_require__(12);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(22);
	var _xfBase = __webpack_require__(8);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _curry2 = __webpack_require__(1);
	var _filter = __webpack_require__(78);
	var flip = __webpack_require__(50);
	var uniq = __webpack_require__(88);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.innerJoin
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(51);
	var _curry3 = __webpack_require__(3);
	var uniqWith = __webpack_require__(89);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.innerJoin
	 * @deprecated since v0.24.0
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(36);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(128);
	var _curry3 = __webpack_require__(3);
	var _isTransformer = __webpack_require__(82);
	var _reduce = __webpack_require__(15);
	var _stepCat = __webpack_require__(301);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
	 * transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _has = __webpack_require__(12);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
	 * duplicate values by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys in an array.
	 * @see R.invertObj
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var keys = __webpack_require__(18);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @see R.invert
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var empty = __webpack_require__(126);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(38);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @see R.keys, R.valuesIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isArray = __webpack_require__(21);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var lens = __webpack_require__(57);
	var nth = __webpack_require__(39);
	var update = __webpack_require__(90);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var assocPath = __webpack_require__(115);
	var lens = __webpack_require__(57);
	var path = __webpack_require__(40);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var assoc = __webpack_require__(48);
	var lens = __webpack_require__(57);
	var prop = __webpack_require__(84);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * The `mapAccum` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * The `mapAccumRight` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
	 * the right to the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduce = __webpack_require__(15);
	var keys = __webpack_require__(18);
	
	
	/**
	 * An Object-specific version of [`map`](#map). The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * [`map`](#map) instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isInteger = __webpack_require__(80);
	
	
	/**
	 * `mathMod` behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
	 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
	 * arguments, and returns NaN when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @see R.modulo
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var mean = __webpack_require__(145);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.mean
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeWith = __webpack_require__(146);
	var toString = __webpack_require__(42);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoizeWith
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = memoizeWith(function() {
	  return toString(arguments);
	});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(77);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(77);
	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var mergeDeepWithKey = __webpack_require__(59);
	
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the first object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                      { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
	 */
	module.exports = _curry2(function mergeDeepLeft(lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return lVal;
	  }, lObj, rObj);
	});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var mergeDeepWithKey = __webpack_require__(59);
	
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                       { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
	 */
	module.exports = _curry2(function mergeDeepRight(lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return rVal;
	  }, lObj, rObj);
	});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var mergeDeepWithKey = __webpack_require__(59);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to associated values using the
	 *   resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepWith(R.concat,
	 *                      { a: true, c: { values: [10, 20] }},
	 *                      { b: true, c: { values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
	 */
	module.exports = _curry3(function mergeDeepWith(fn, lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return fn(lVal, rVal);
	  }, lObj, rObj);
	});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var mergeWithKey = __webpack_require__(83);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see [`mathMod`](#mathMod).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(130);
	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xany = __webpack_require__(136);
	var any = __webpack_require__(113);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	var nth = __webpack_require__(39);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * `o` is a curried composition function that returns a unary function.
	 * Like [`compose`](#compose), `o` performs right-to-left function composition.
	 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
	 * invoked with only one argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (b -> c) -> (a -> b) -> a -> c
	 * @param {Function} f
	 * @param {Function} g
	 * @return {Function}
	 * @see R.compose, R.pipe
	 * @example
	 *
	 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + lastName
	 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
	 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
	 *
	 * @symb R.o(f, g, x) = f(g(x))
	 */
	module.exports = _curry3(function o(f, g, x) {
	  return f(g(x));
	});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _of = __webpack_require__(297);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _createPartialApplicator = __webpack_require__(131);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _createPartialApplicator = __webpack_require__(131);
	var flip = __webpack_require__(50);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(75);
	var juxt = __webpack_require__(141);
	var reject = __webpack_require__(62);
	
	
	/**
	 * Takes a predicate and a list or other `Filterable` object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var equals = __webpack_require__(14);
	var path = __webpack_require__(40);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * [`R.equals`](#equals) terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var defaultTo = __webpack_require__(120);
	var path = __webpack_require__(40);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var path = __webpack_require__(40);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(117);
	var reverse = __webpack_require__(63);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(147);
	var reduce = __webpack_require__(19);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(56);
	var identity = __webpack_require__(76);
	var pickAll = __webpack_require__(152);
	var useWith = __webpack_require__(163);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var equals = __webpack_require__(14);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in
	 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var is = __webpack_require__(139);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var _has = __webpack_require__(12);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isNumber = __webpack_require__(134);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(52);
	var _reduce = __webpack_require__(15);
	var _reduced = __webpack_require__(22);
	
	
	/**
	 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
	 * through the list, successively calling the iterator function. `reduceWhile`
	 * also takes a predicate that is evaluated before each step. If the predicate
	 * returns `false`, it "short-circuits" the iteration and returns the current
	 * value of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _reduced = __webpack_require__(22);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by
	 * [`reduceRight`](#reduceRight).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *     R.reduce(
	 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
	 *       [],
	 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
	 */
	
	module.exports = _curry1(_reduced);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var always = __webpack_require__(30);
	var times = __webpack_require__(161);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @see R.times
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
	 * reduced values from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @see R.reduce
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var always = __webpack_require__(30);
	var over = __webpack_require__(151);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(38);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var length = __webpack_require__(143);
	var slice = __webpack_require__(26);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var slice = __webpack_require__(26);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var equals = __webpack_require__(14);
	var take = __webpack_require__(86);
	
	/**
	 * Checks if a list starts with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} prefix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.startsWith('a', 'abc')                //=> true
	 *      R.startsWith('b', 'abc')                //=> false
	 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
	 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	module.exports = _curry2(function(prefix, list) {
	  return equals(take(prefix.length, list), prefix);
	});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var concat = __webpack_require__(74);
	var difference = __webpack_require__(121);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var concat = __webpack_require__(74);
	var differenceWith = __webpack_require__(122);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(7);
	var _xtakeWhile = __webpack_require__(319);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(129);
	var _curry2 = __webpack_require__(1);
	var _isRegExp = __webpack_require__(295);
	var toString = __webpack_require__(42);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(38);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _has = __webpack_require__(12);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(38);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(15);
	var _xwrap = __webpack_require__(138);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the [`R.reduced`](#reduced) function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is
	 * [`R.identity`](#identity). The init function can be used to provide an
	 * initial accumulator, but is ignored by transduce.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 *
	 *      var isOdd = (x) => x % 2 === 1;
	 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
	 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 *      // If some of the rows are shorter than the following rows, their elements are skipped:
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	var map = __webpack_require__(13);
	var sequence = __webpack_require__(158);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return typeof traversable['fantasy-land/traverse'] === 'function' ?
	    traversable['fantasy-land/traverse'](f, of) :
	    sequence(of, map(f, traversable));
	});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(17);
	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, `R.unapply` derives a variadic function from a function which
	 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var nAry = __webpack_require__(60);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @see R.binary, R.nAry
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry2 = __webpack_require__(1);
	var compose = __webpack_require__(73);
	var uniq = __webpack_require__(88);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(16);
	var _curry3 = __webpack_require__(3);
	var uniqWith = __webpack_require__(89);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      let safeInc = R.unless(R.isNil, R.inc);
	 *      safeInc(null); //=> null
	 *      safeInc(1); //=> 2
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(79);
	var chain = __webpack_require__(72);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @see R.values, R.keysIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, 'fantasy-land/map': function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var equals = __webpack_require__(14);
	var map = __webpack_require__(13);
	var where = __webpack_require__(165);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in [`R.equals`](#equals) terms) as accessing that property of the
	 * spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(25);
	var _curry2 = __webpack_require__(1);
	var flip = __webpack_require__(50);
	var reject = __webpack_require__(62);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce, R.difference
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(3);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactInfo = function ContactInfo() {
	  return _react2.default.createElement(
	    "ul",
	    { className: "contact" },
	    _react2.default.createElement(
	      "li",
	      { className: "fa-envelope" },
	      _react2.default.createElement(
	        "a",
	        { href: "mailto:info@ewwoconsulting.com" },
	        "info@ewwoconsulting.com"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      { className: "fa-linkedin" },
	      _react2.default.createElement(
	        "a",
	        { href: "https://ar.linkedin.com/company/ewwo-consulting" },
	        "Ewwo Consulting"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      { className: "fa-phone" },
	      "AR + 54 011 5199 4390"
	    ),
	    _react2.default.createElement(
	      "li",
	      { className: "fa-phone" },
	      "US + 1 315 245 8141"
	    )
	  );
	};
	
	exports.default = ContactInfo;
	module.exports = exports["default"];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Copyright = function Copyright() {
	  return _react2.default.createElement(
	    "ul",
	    { className: "copyright" },
	    _react2.default.createElement(
	      "li",
	      null,
	      "\xA9 ",
	      new Date().getFullYear(),
	      " Ewwo Consulting.",
	      " ",
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: "copyright" })
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: "design" }),
	      _react2.default.createElement(
	        "a",
	        { href: "http://html5up.net" },
	        "HTML5 UP"
	      )
	    )
	  );
	};
	
	exports.default = Copyright;
	module.exports = exports["default"];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Copyright = __webpack_require__(438);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	var _ContactInfo = __webpack_require__(437);
	
	var _ContactInfo2 = _interopRequireDefault(_ContactInfo);
	
	var _reactIntl = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    "section",
	    { id: "footer" },
	    _react2.default.createElement(
	      "div",
	      { className: "inner" },
	      _react2.default.createElement(
	        "h2",
	        { className: "major" },
	        props.language === "es" ? "Contacto" : "Contact us"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "footermsg" })
	      ),
	      _react2.default.createElement(_ContactInfo2.default, null),
	      _react2.default.createElement(_Copyright2.default, null)
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var children = _ref.children,
	      closeMenu = _ref.closeMenu;
	
	  return _react2.default.createElement(
	    "nav",
	    { id: "menu", onClick: closeMenu },
	    _react2.default.createElement(
	      "div",
	      { className: "inner" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Menu"
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: "links" },
	        _react2.default.Children.map(children, function (link) {
	          return _react2.default.createElement(
	            "li",
	            { onClick: closeMenu },
	            link
	          );
	        })
	      ),
	      _react2.default.createElement("a", { href: "#close-menu", className: "close", onClick: closeMenu })
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports["default"];

/***/ }),
/* 441 */,
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(482);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(64);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ptzI18n = __webpack_require__(225);
	
	var _reactIntl = __webpack_require__(65);
	
	__webpack_require__(478);
	
	__webpack_require__(480);
	
	var _NavigationBar = __webpack_require__(169);
	
	var _NavigationBar2 = _interopRequireDefault(_NavigationBar);
	
	var _Menu = __webpack_require__(440);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(439);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _favicon = __webpack_require__(455);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Para internacionalización
	
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isMenuOpen: false
	    };
	
	    _this.openMenu = function (e) {
	      e.preventDefault();
	      _this.setState({ isMenuOpen: true });
	    };
	
	    _this.closeMenu = function (e) {
	      e.preventDefault();
	      _this.setState({ isMenuOpen: false });
	    };
	
	    return _this;
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location,
	        i18nMessages = _props.i18nMessages;
	
	    var url = location.pathname;
	    var _data$site$siteMetada = data.site.siteMetadata.languages,
	        langs = _data$site$siteMetada.langs,
	        defaultLangKey = _data$site$siteMetada.defaultLangKey;
	
	    var langKey = (0, _ptzI18n.getCurrentLangKey)(langs, defaultLangKey, url);
	    var homeLink = "/" + langKey + "/";
	    var langsMenu = (0, _ptzI18n.getLangs)(langs, langKey, (0, _ptzI18n.getUrlForLang)(homeLink, url));
	    return _react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: langKey, messages: i18nMessages },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          {
	            title: data.site.siteMetadata.title,
	            meta: [{ name: "Ewwo Consulting", content: "Empresa de desarrollo" }, {
	              name: "keywords",
	              content: "desarrollo, programacion, development, programming, frontend, backend, fullstack, javascript, php, angularjs, react, reactjs, graphql, gatsbyjs, sindicato, sindicatos, obra social, obras sociales, sistema, sistemas, IT, mutual, o.s., hmo, health care, system"
	            }],
	            link: [{ rel: "shortcut icon", type: "image/png", href: "" + _favicon2.default }]
	          },
	          _react2.default.createElement("html", { lang: "en" })
	        ),
	        location.pathname !== "/" && _react2.default.createElement(_NavigationBar2.default, {
	          siteTitle: data.site.siteMetadata.title,
	          openMenu: this.openMenu,
	          langs: langsMenu,
	          language: langKey
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: this.state.isMenuOpen ? "is-menu-visible" : "" },
	          _react2.default.createElement(
	            "div",
	            {
	              id: "page-wrapper",
	              onClick: this.state.isMenuOpen ? this.closeMenu : undefined
	            },
	            children(_extends({}, this.props, {
	              openMenu: this.openMenu,
	              langs: langsMenu,
	              language: langKey
	            })),
	            _react2.default.createElement(_Footer2.default, { langs: langsMenu, language: langKey })
	          ),
	          _react2.default.createElement(
	            _Menu2.default,
	            { closeMenu: this.closeMenu, langs: langsMenu },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" + langKey + "/" },
	              "Home"
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" + langKey + "/About" },
	              langKey === "en" ? "About us" : "Nosotros"
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" + langKey + "/Consulting" },
	              "Consulting"
	            ),
	            langKey === "en" ? null : _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/es/Services" },
	              "Servicios a Sindicatos y O.S."
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" + langKey + "/Outsourcing" },
	              "Outsourcing"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(453);
	var isArguments = __webpack_require__(452);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.396b890d.ico";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatError = formatError;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a GraphQLError, format it according to the rules described by the
	 * Response Format, Errors section of the GraphQL Specification.
	 */
	function formatError(error) {
	  !error ? (0, _invariant2.default)(0, 'Received null or undefined error.') : void 0;
	  return {
	    message: error.message,
	    locations: error.locations,
	    path: error.path
	  };
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syntaxError = syntaxError;
	
	var _location = __webpack_require__(105);
	
	var _GraphQLError = __webpack_require__(43);
	
	/**
	 * Produces a GraphQLError representing a syntax error, containing useful
	 * descriptive information about the syntax error's position in the source.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function syntaxError(source, position, description) {
	  var location = (0, _location.getLocation)(source, position);
	  var line = location.line + source.locationOffset.line - 1;
	  var columnOffset = getColumnOffset(source, location);
	  var column = location.column + columnOffset;
	  var error = new _GraphQLError.GraphQLError('Syntax Error ' + source.name + ' (' + line + ':' + column + ') ' + description + '\n\n' + highlightSourceAtLocation(source, location), undefined, source, [position]);
	  return error;
	}
	
	/**
	 * Render a helpful description of the location of the error in the GraphQL
	 * Source document.
	 */
	function highlightSourceAtLocation(source, location) {
	  var line = location.line;
	  var lineOffset = source.locationOffset.line - 1;
	  var columnOffset = getColumnOffset(source, location);
	  var contextLine = line + lineOffset;
	  var prevLineNum = (contextLine - 1).toString();
	  var lineNum = contextLine.toString();
	  var nextLineNum = (contextLine + 1).toString();
	  var padLen = nextLineNum.length;
	  var lines = source.body.split(/\r\n|[\n\r]/g);
	  lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
	  return (line >= 2 ? lpad(padLen, prevLineNum) + ': ' + lines[line - 2] + '\n' : '') + lpad(padLen, lineNum) + ': ' + lines[line - 1] + '\n' + whitespace(2 + padLen + location.column - 1 + columnOffset) + '^\n' + (line < lines.length ? lpad(padLen, nextLineNum) + ': ' + lines[line] + '\n' : '');
	}
	
	function getColumnOffset(source, location) {
	  return location.line === 1 ? source.locationOffset.column - 1 : 0;
	}
	
	function whitespace(len) {
	  return Array(len + 1).join(' ');
	}
	
	function lpad(len, str) {
	  return whitespace(len - str.length) + str;
	}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _execute = __webpack_require__(99);
	
	Object.defineProperty(exports, 'execute', {
	  enumerable: true,
	  get: function get() {
	    return _execute.execute;
	  }
	});
	Object.defineProperty(exports, 'defaultFieldResolver', {
	  enumerable: true,
	  get: function get() {
	    return _execute.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, 'responsePathAsArray', {
	  enumerable: true,
	  get: function get() {
	    return _execute.responsePathAsArray;
	  }
	});
	
	var _values = __webpack_require__(100);
	
	Object.defineProperty(exports, 'getDirectiveValues', {
	  enumerable: true,
	  get: function get() {
	    return _values.getDirectiveValues;
	  }
	});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.graphql = graphql;
	
	var _parser = __webpack_require__(91);
	
	var _validate = __webpack_require__(216);
	
	var _execute = __webpack_require__(99);
	
	/**
	 * This is the primary entry point function for fulfilling GraphQL operations
	 * by parsing, validating, and executing a GraphQL document along side a
	 * GraphQL schema.
	 *
	 * More sophisticated GraphQL servers, such as those which persist queries,
	 * may wish to separate the validation and execution phases to a static time
	 * tooling step, and a server runtime step.
	 *
	 * Accepts either an object with named arguments, or individual arguments:
	 *
	 * schema:
	 *    The GraphQL type system to use when validating and executing a query.
	 * source:
	 *    A GraphQL language formatted string representing the requested operation.
	 * rootValue:
	 *    The value provided as the first argument to resolver functions on the top
	 *    level type (e.g. the query object type).
	 * variableValues:
	 *    A mapping of variable name to runtime value to use for all variables
	 *    defined in the requestString.
	 * operationName:
	 *    The name of the operation to use if requestString contains multiple
	 *    possible operations. Can be omitted if requestString contains only
	 *    one operation.
	 * fieldResolver:
	 *    A resolver function to use when one is not provided by the schema.
	 *    If not provided, the default field resolver is used (which looks for a
	 *    value or method on the source value with the field's name).
	 */
	
	/* eslint-disable no-redeclare */
	function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // Extract arguments from object args if provided.
	  return arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver);
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function graphqlImpl(schema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  return new Promise(function (resolve) {
	    // Parse
	    var document = void 0;
	    try {
	      document = (0, _parser.parse)(source);
	    } catch (syntaxError) {
	      return resolve({ errors: [syntaxError] });
	    }
	
	    // Validate
	    var validationErrors = (0, _validate.validate)(schema, document);
	    if (validationErrors.length > 0) {
	      return resolve({ errors: validationErrors });
	    }
	
	    // Execute
	    resolve((0, _execute.execute)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver));
	  });
	}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _graphql = __webpack_require__(459);
	
	Object.defineProperty(exports, 'graphql', {
	  enumerable: true,
	  get: function get() {
	    return _graphql.graphql;
	  }
	});
	
	var _type = __webpack_require__(465);
	
	Object.defineProperty(exports, 'GraphQLSchema', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSchema;
	  }
	});
	Object.defineProperty(exports, 'GraphQLScalarType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInterfaceType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLUnionType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLEnumType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInputObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLList', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLList;
	  }
	});
	Object.defineProperty(exports, 'GraphQLNonNull', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLNonNull;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, 'TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeKind;
	  }
	});
	Object.defineProperty(exports, 'DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _type.DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInt', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, 'GraphQLFloat', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, 'GraphQLString', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLString;
	  }
	});
	Object.defineProperty(exports, 'GraphQLBoolean', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, 'GraphQLID', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLID;
	  }
	});
	Object.defineProperty(exports, 'specifiedDirectives', {
	  enumerable: true,
	  get: function get() {
	    return _type.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, 'GraphQLIncludeDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLSkipDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDeprecatedDirective', {
	  enumerable: true,
	  get: function get() {
	    return _type.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, 'DEFAULT_DEPRECATION_REASON', {
	  enumerable: true,
	  get: function get() {
	    return _type.DEFAULT_DEPRECATION_REASON;
	  }
	});
	Object.defineProperty(exports, 'SchemaMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeNameMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _type.TypeNameMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, '__Schema', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Schema;
	  }
	});
	Object.defineProperty(exports, '__Directive', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Directive;
	  }
	});
	Object.defineProperty(exports, '__DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _type.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, '__Type', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Type;
	  }
	});
	Object.defineProperty(exports, '__Field', {
	  enumerable: true,
	  get: function get() {
	    return _type.__Field;
	  }
	});
	Object.defineProperty(exports, '__InputValue', {
	  enumerable: true,
	  get: function get() {
	    return _type.__InputValue;
	  }
	});
	Object.defineProperty(exports, '__EnumValue', {
	  enumerable: true,
	  get: function get() {
	    return _type.__EnumValue;
	  }
	});
	Object.defineProperty(exports, '__TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _type.__TypeKind;
	  }
	});
	Object.defineProperty(exports, 'isType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isType;
	  }
	});
	Object.defineProperty(exports, 'isInputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isInputType;
	  }
	});
	Object.defineProperty(exports, 'isOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isOutputType;
	  }
	});
	Object.defineProperty(exports, 'isLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isLeafType;
	  }
	});
	Object.defineProperty(exports, 'isCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isCompositeType;
	  }
	});
	Object.defineProperty(exports, 'isAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isAbstractType;
	  }
	});
	Object.defineProperty(exports, 'isNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _type.isNamedType;
	  }
	});
	Object.defineProperty(exports, 'assertType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertType;
	  }
	});
	Object.defineProperty(exports, 'assertInputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertInputType;
	  }
	});
	Object.defineProperty(exports, 'assertOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertOutputType;
	  }
	});
	Object.defineProperty(exports, 'assertLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertLeafType;
	  }
	});
	Object.defineProperty(exports, 'assertCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, 'assertAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, 'assertNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _type.assertNamedType;
	  }
	});
	Object.defineProperty(exports, 'getNullableType', {
	  enumerable: true,
	  get: function get() {
	    return _type.getNullableType;
	  }
	});
	Object.defineProperty(exports, 'getNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _type.getNamedType;
	  }
	});
	
	var _language = __webpack_require__(461);
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _language.Source;
	  }
	});
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _language.getLocation;
	  }
	});
	Object.defineProperty(exports, 'parse', {
	  enumerable: true,
	  get: function get() {
	    return _language.parse;
	  }
	});
	Object.defineProperty(exports, 'parseValue', {
	  enumerable: true,
	  get: function get() {
	    return _language.parseValue;
	  }
	});
	Object.defineProperty(exports, 'parseType', {
	  enumerable: true,
	  get: function get() {
	    return _language.parseType;
	  }
	});
	Object.defineProperty(exports, 'print', {
	  enumerable: true,
	  get: function get() {
	    return _language.print;
	  }
	});
	Object.defineProperty(exports, 'visit', {
	  enumerable: true,
	  get: function get() {
	    return _language.visit;
	  }
	});
	Object.defineProperty(exports, 'visitInParallel', {
	  enumerable: true,
	  get: function get() {
	    return _language.visitInParallel;
	  }
	});
	Object.defineProperty(exports, 'visitWithTypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _language.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, 'getVisitFn', {
	  enumerable: true,
	  get: function get() {
	    return _language.getVisitFn;
	  }
	});
	Object.defineProperty(exports, 'Kind', {
	  enumerable: true,
	  get: function get() {
	    return _language.Kind;
	  }
	});
	Object.defineProperty(exports, 'TokenKind', {
	  enumerable: true,
	  get: function get() {
	    return _language.TokenKind;
	  }
	});
	Object.defineProperty(exports, 'BREAK', {
	  enumerable: true,
	  get: function get() {
	    return _language.BREAK;
	  }
	});
	
	var _execution = __webpack_require__(458);
	
	Object.defineProperty(exports, 'execute', {
	  enumerable: true,
	  get: function get() {
	    return _execution.execute;
	  }
	});
	Object.defineProperty(exports, 'defaultFieldResolver', {
	  enumerable: true,
	  get: function get() {
	    return _execution.defaultFieldResolver;
	  }
	});
	Object.defineProperty(exports, 'responsePathAsArray', {
	  enumerable: true,
	  get: function get() {
	    return _execution.responsePathAsArray;
	  }
	});
	Object.defineProperty(exports, 'getDirectiveValues', {
	  enumerable: true,
	  get: function get() {
	    return _execution.getDirectiveValues;
	  }
	});
	
	var _subscription = __webpack_require__(462);
	
	Object.defineProperty(exports, 'subscribe', {
	  enumerable: true,
	  get: function get() {
	    return _subscription.subscribe;
	  }
	});
	Object.defineProperty(exports, 'createSourceEventStream', {
	  enumerable: true,
	  get: function get() {
	    return _subscription.createSourceEventStream;
	  }
	});
	
	var _validation = __webpack_require__(476);
	
	Object.defineProperty(exports, 'validate', {
	  enumerable: true,
	  get: function get() {
	    return _validation.validate;
	  }
	});
	Object.defineProperty(exports, 'ValidationContext', {
	  enumerable: true,
	  get: function get() {
	    return _validation.ValidationContext;
	  }
	});
	Object.defineProperty(exports, 'specifiedRules', {
	  enumerable: true,
	  get: function get() {
	    return _validation.specifiedRules;
	  }
	});
	Object.defineProperty(exports, 'ArgumentsOfCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.ArgumentsOfCorrectTypeRule;
	  }
	});
	Object.defineProperty(exports, 'DefaultValuesOfCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.DefaultValuesOfCorrectTypeRule;
	  }
	});
	Object.defineProperty(exports, 'FieldsOnCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.FieldsOnCorrectTypeRule;
	  }
	});
	Object.defineProperty(exports, 'FragmentsOnCompositeTypesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.FragmentsOnCompositeTypesRule;
	  }
	});
	Object.defineProperty(exports, 'KnownArgumentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownArgumentNamesRule;
	  }
	});
	Object.defineProperty(exports, 'KnownDirectivesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownDirectivesRule;
	  }
	});
	Object.defineProperty(exports, 'KnownFragmentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownFragmentNamesRule;
	  }
	});
	Object.defineProperty(exports, 'KnownTypeNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.KnownTypeNamesRule;
	  }
	});
	Object.defineProperty(exports, 'LoneAnonymousOperationRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.LoneAnonymousOperationRule;
	  }
	});
	Object.defineProperty(exports, 'NoFragmentCyclesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoFragmentCyclesRule;
	  }
	});
	Object.defineProperty(exports, 'NoUndefinedVariablesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUndefinedVariablesRule;
	  }
	});
	Object.defineProperty(exports, 'NoUnusedFragmentsRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUnusedFragmentsRule;
	  }
	});
	Object.defineProperty(exports, 'NoUnusedVariablesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.NoUnusedVariablesRule;
	  }
	});
	Object.defineProperty(exports, 'OverlappingFieldsCanBeMergedRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.OverlappingFieldsCanBeMergedRule;
	  }
	});
	Object.defineProperty(exports, 'PossibleFragmentSpreadsRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.PossibleFragmentSpreadsRule;
	  }
	});
	Object.defineProperty(exports, 'ProvidedNonNullArgumentsRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.ProvidedNonNullArgumentsRule;
	  }
	});
	Object.defineProperty(exports, 'ScalarLeafsRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.ScalarLeafsRule;
	  }
	});
	Object.defineProperty(exports, 'SingleFieldSubscriptionsRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.SingleFieldSubscriptionsRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueArgumentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueArgumentNamesRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueDirectivesPerLocationRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueDirectivesPerLocationRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueFragmentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueFragmentNamesRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueInputFieldNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueInputFieldNamesRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueOperationNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueOperationNamesRule;
	  }
	});
	Object.defineProperty(exports, 'UniqueVariableNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.UniqueVariableNamesRule;
	  }
	});
	Object.defineProperty(exports, 'VariablesAreInputTypesRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.VariablesAreInputTypesRule;
	  }
	});
	Object.defineProperty(exports, 'VariablesInAllowedPositionRule', {
	  enumerable: true,
	  get: function get() {
	    return _validation.VariablesInAllowedPositionRule;
	  }
	});
	
	var _error = __webpack_require__(5);
	
	Object.defineProperty(exports, 'GraphQLError', {
	  enumerable: true,
	  get: function get() {
	    return _error.GraphQLError;
	  }
	});
	Object.defineProperty(exports, 'formatError', {
	  enumerable: true,
	  get: function get() {
	    return _error.formatError;
	  }
	});
	
	var _utilities = __webpack_require__(472);
	
	Object.defineProperty(exports, 'introspectionQuery', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.introspectionQuery;
	  }
	});
	Object.defineProperty(exports, 'getOperationAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.getOperationAST;
	  }
	});
	Object.defineProperty(exports, 'buildClientSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildClientSchema;
	  }
	});
	Object.defineProperty(exports, 'buildASTSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, 'buildSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.buildSchema;
	  }
	});
	Object.defineProperty(exports, 'extendSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.extendSchema;
	  }
	});
	Object.defineProperty(exports, 'printSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printSchema;
	  }
	});
	Object.defineProperty(exports, 'printIntrospectionSchema', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printIntrospectionSchema;
	  }
	});
	Object.defineProperty(exports, 'printType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.printType;
	  }
	});
	Object.defineProperty(exports, 'typeFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.typeFromAST;
	  }
	});
	Object.defineProperty(exports, 'valueFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.valueFromAST;
	  }
	});
	Object.defineProperty(exports, 'astFromValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.astFromValue;
	  }
	});
	Object.defineProperty(exports, 'TypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.TypeInfo;
	  }
	});
	Object.defineProperty(exports, 'isValidJSValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidJSValue;
	  }
	});
	Object.defineProperty(exports, 'isValidLiteralValue', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isValidLiteralValue;
	  }
	});
	Object.defineProperty(exports, 'concatAST', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.concatAST;
	  }
	});
	Object.defineProperty(exports, 'separateOperations', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.separateOperations;
	  }
	});
	Object.defineProperty(exports, 'isEqualType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isEqualType;
	  }
	});
	Object.defineProperty(exports, 'isTypeSubTypeOf', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, 'doTypesOverlap', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.doTypesOverlap;
	  }
	});
	Object.defineProperty(exports, 'assertValidName', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.assertValidName;
	  }
	});
	Object.defineProperty(exports, 'findBreakingChanges', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findBreakingChanges;
	  }
	});
	Object.defineProperty(exports, 'findDangerousChanges', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findDangerousChanges;
	  }
	});
	Object.defineProperty(exports, 'BreakingChangeType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.BreakingChangeType;
	  }
	});
	Object.defineProperty(exports, 'DangerousChangeType', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.DangerousChangeType;
	  }
	});
	Object.defineProperty(exports, 'findDeprecatedUsages', {
	  enumerable: true,
	  get: function get() {
	    return _utilities.findDeprecatedUsages;
	  }
	});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BREAK = exports.getVisitFn = exports.visitWithTypeInfo = exports.visitInParallel = exports.visit = exports.Source = exports.print = exports.parseType = exports.parseValue = exports.parse = exports.TokenKind = exports.createLexer = exports.Kind = exports.getLocation = undefined;
	
	var _location = __webpack_require__(105);
	
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _location.getLocation;
	  }
	});
	
	var _lexer = __webpack_require__(104);
	
	Object.defineProperty(exports, 'createLexer', {
	  enumerable: true,
	  get: function get() {
	    return _lexer.createLexer;
	  }
	});
	Object.defineProperty(exports, 'TokenKind', {
	  enumerable: true,
	  get: function get() {
	    return _lexer.TokenKind;
	  }
	});
	
	var _parser = __webpack_require__(91);
	
	Object.defineProperty(exports, 'parse', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parse;
	  }
	});
	Object.defineProperty(exports, 'parseValue', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseValue;
	  }
	});
	Object.defineProperty(exports, 'parseType', {
	  enumerable: true,
	  get: function get() {
	    return _parser.parseType;
	  }
	});
	
	var _printer = __webpack_require__(24);
	
	Object.defineProperty(exports, 'print', {
	  enumerable: true,
	  get: function get() {
	    return _printer.print;
	  }
	});
	
	var _source = __webpack_require__(186);
	
	Object.defineProperty(exports, 'Source', {
	  enumerable: true,
	  get: function get() {
	    return _source.Source;
	  }
	});
	
	var _visitor = __webpack_require__(67);
	
	Object.defineProperty(exports, 'visit', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visit;
	  }
	});
	Object.defineProperty(exports, 'visitInParallel', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitInParallel;
	  }
	});
	Object.defineProperty(exports, 'visitWithTypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.visitWithTypeInfo;
	  }
	});
	Object.defineProperty(exports, 'getVisitFn', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.getVisitFn;
	  }
	});
	Object.defineProperty(exports, 'BREAK', {
	  enumerable: true,
	  get: function get() {
	    return _visitor.BREAK;
	  }
	});
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.Kind = Kind;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _subscribe = __webpack_require__(464);
	
	Object.defineProperty(exports, 'subscribe', {
	  enumerable: true,
	  get: function get() {
	    return _subscribe.subscribe;
	  }
	});
	Object.defineProperty(exports, 'createSourceEventStream', {
	  enumerable: true,
	  get: function get() {
	    return _subscribe.createSourceEventStream;
	  }
	});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapAsyncIterator;
	
	var _iterall = __webpack_require__(46);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * Copyright (c) 2017-present, Facebook, Inc.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                   */
	
	/**
	 * Given an AsyncIterable and a callback function, return an AsyncIterator
	 * which produces values mapped via calling the callback function.
	 */
	function mapAsyncIterator(iterable, callback, rejectCallback) {
	  var iterator = (0, _iterall.getAsyncIterator)(iterable);
	  var $return = void 0;
	  var abruptClose = void 0;
	  if (typeof iterator.return === 'function') {
	    $return = iterator.return;
	    abruptClose = function abruptClose(error) {
	      var rethrow = function rethrow() {
	        return Promise.reject(error);
	      };
	      return $return.call(iterator).then(rethrow, rethrow);
	    };
	  }
	
	  function mapResult(result) {
	    return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
	  }
	
	  var mapReject = void 0;
	  if (rejectCallback) {
	    // Capture rejectCallback to ensure it cannot be null.
	    var reject = rejectCallback;
	    mapReject = function mapReject(error) {
	      return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
	    };
	  }
	
	  /* TODO: Flow doesn't support symbols as keys:
	     https://github.com/facebook/flow/issues/3258 */
	  return _defineProperty({
	    next: function next() {
	      return iterator.next().then(mapResult, mapReject);
	    },
	    return: function _return() {
	      return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({ value: undefined, done: true });
	    },
	    throw: function _throw(error) {
	      if (typeof iterator.throw === 'function') {
	        return iterator.throw(error).then(mapResult, mapReject);
	      }
	      return Promise.reject(error).catch(abruptClose);
	    }
	  }, _iterall.$$asyncIterator, function () {
	    return this;
	  });
	}
	
	function asyncMapValue(value, callback) {
	  return new Promise(function (resolve) {
	    return resolve(callback(value));
	  });
	}
	
	function iteratorResult(value) {
	  return { value: value, done: false };
	}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subscribe = subscribe;
	exports.createSourceEventStream = createSourceEventStream;
	
	var _iterall = __webpack_require__(46);
	
	var _GraphQLError = __webpack_require__(43);
	
	var _locatedError = __webpack_require__(185);
	
	var _execute = __webpack_require__(99);
	
	var _schema = __webpack_require__(28);
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _mapAsyncIterator = __webpack_require__(463);
	
	var _mapAsyncIterator2 = _interopRequireDefault(_mapAsyncIterator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Implements the "Subscribe" algorithm described in the GraphQL specification.
	 *
	 * Returns a Promise which resolves to either an AsyncIterator (if successful)
	 * or an ExecutionResult (client error). The promise will be rejected if a
	 * server error occurs.
	 *
	 * If the client-provided arguments to this function do not result in a
	 * compliant subscription, a GraphQL Response (ExecutionResult) with
	 * descriptive errors and no data will be returned.
	 *
	 * If the the source stream could not be created due to faulty subscription
	 * resolver logic or underlying systems, the promise will resolve to a single
	 * ExecutionResult containing `errors` and no `data`.
	 *
	 * If the operation succeeded, the promise resolves to an AsyncIterator, which
	 * yields a stream of ExecutionResults representing the response stream.
	 *
	 * Accepts either an object with named arguments, or individual arguments.
	 */
	
	/* eslint-disable no-redeclare */
	function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
	  // Extract arguments from object args if provided.
	  var args = arguments.length === 1 ? argsOrSchema : undefined;
	  var schema = args ? args.schema : argsOrSchema;
	
	  return args ? subscribeImpl(schema, args.document, args.rootValue, args.contextValue, args.variableValues, args.operationName, args.fieldResolver, args.subscribeFieldResolver) : subscribeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver);
	}
	
	/**
	 * This function checks if the error is a GraphQLError. If it is, report it as
	 * an ExecutionResult, containing only errors and no data. Otherwise treat the
	 * error as a system-class error and re-throw it.
	 */
	/**
	 * Copyright (c) 2017-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function reportGraphQLError(error) {
	  if (error instanceof _GraphQLError.GraphQLError) {
	    return { errors: [error] };
	  }
	  throw error;
	}
	
	function subscribeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
	  var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver);
	
	  // For each payload yielded from a subscription, map it over the normal
	  // GraphQL `execute` function, with `payload` as the rootValue.
	  // This implements the "MapSourceToResponseEvent" algorithm described in
	  // the GraphQL specification. The `execute` function provides the
	  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
	  // "ExecuteQuery" algorithm, for which `execute` is also used.
	  var mapSourceToResponse = function mapSourceToResponse(payload) {
	    return (0, _execute.execute)(schema, document, payload, contextValue, variableValues, operationName, fieldResolver);
	  };
	
	  // Resolve the Source Stream, then map every source value to a
	  // ExecutionResult value as described above.
	  return sourcePromise.then(function (sourceStream) {
	    return (0, _mapAsyncIterator2.default)(sourceStream, mapSourceToResponse, reportGraphQLError);
	  }, reportGraphQLError);
	}
	
	/**
	 * Implements the "CreateSourceEventStream" algorithm described in the
	 * GraphQL specification, resolving the subscription source event stream.
	 *
	 * Returns a Promise<AsyncIterable>.
	 *
	 * If the client-provided invalid arguments, the source stream could not be
	 * created, or the resolver did not return an AsyncIterable, this function will
	 * will throw an error, which should be caught and handled by the caller.
	 *
	 * A Source Event Stream represents a sequence of events, each of which triggers
	 * a GraphQL execution for that event.
	 *
	 * This may be useful when hosting the stateful subscription service in a
	 * different process or machine than the stateless GraphQL execution engine,
	 * or otherwise separating these two steps. For more on this, see the
	 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
	 */
	function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
	  // If arguments are missing or incorrectly typed, this is an internal
	  // developer mistake which should throw an early error.
	  (0, _execute.assertValidExecutionArguments)(schema, document, variableValues);
	
	  return new Promise(function (resolve, reject) {
	    // If a valid context cannot be created due to incorrect arguments,
	    // this will throw an error.
	    var exeContext = (0, _execute.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
	
	    var type = (0, _execute.getOperationRootType)(schema, exeContext.operation);
	    var fields = (0, _execute.collectFields)(exeContext, type, exeContext.operation.selectionSet, Object.create(null), Object.create(null));
	    var responseNames = Object.keys(fields);
	    var responseName = responseNames[0];
	    var fieldNodes = fields[responseName];
	    var fieldNode = fieldNodes[0];
	    var fieldDef = (0, _execute.getFieldDef)(schema, type, fieldNode.name.value);
	    !fieldDef ? (0, _invariant2.default)(0, 'This subscription is not defined by the schema.') : void 0;
	
	    // Call the `subscribe()` resolver or the default resolver to produce an
	    // AsyncIterable yielding raw payloads.
	    var resolveFn = fieldDef.subscribe || exeContext.fieldResolver;
	
	    var path = (0, _execute.addPath)(undefined, responseName);
	
	    var info = (0, _execute.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path);
	
	    // resolveFieldValueOrError implements the "ResolveFieldEventStream"
	    // algorithm from GraphQL specification. It differs from
	    // "ResolveFieldValue" due to providing a different `resolveFn`.
	    Promise.resolve((0, _execute.resolveFieldValueOrError)(exeContext, fieldDef, fieldNodes, resolveFn, rootValue, info)).then(function (subscription) {
	      // Reject with a located GraphQLError if subscription source fails
	      // to resolve.
	      if (subscription instanceof Error) {
	        var error = (0, _locatedError.locatedError)(subscription, fieldNodes, (0, _execute.responsePathAsArray)(path));
	        reject(error);
	      }
	
	      if (!(0, _iterall.isAsyncIterable)(subscription)) {
	        reject(new Error('Subscription must return Async Iterable. ' + 'Received: ' + String(subscription)));
	      }
	
	      resolve(subscription);
	    }).catch(reject);
	  });
	}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _schema = __webpack_require__(28);
	
	Object.defineProperty(exports, 'GraphQLSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schema.GraphQLSchema;
	  }
	});
	
	var _definition = __webpack_require__(6);
	
	Object.defineProperty(exports, 'isType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isType;
	  }
	});
	Object.defineProperty(exports, 'isInputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isInputType;
	  }
	});
	Object.defineProperty(exports, 'isOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isOutputType;
	  }
	});
	Object.defineProperty(exports, 'isLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isLeafType;
	  }
	});
	Object.defineProperty(exports, 'isCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isCompositeType;
	  }
	});
	Object.defineProperty(exports, 'isAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isAbstractType;
	  }
	});
	Object.defineProperty(exports, 'isNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.isNamedType;
	  }
	});
	Object.defineProperty(exports, 'assertType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertType;
	  }
	});
	Object.defineProperty(exports, 'assertInputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertInputType;
	  }
	});
	Object.defineProperty(exports, 'assertOutputType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertOutputType;
	  }
	});
	Object.defineProperty(exports, 'assertLeafType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertLeafType;
	  }
	});
	Object.defineProperty(exports, 'assertCompositeType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertCompositeType;
	  }
	});
	Object.defineProperty(exports, 'assertAbstractType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertAbstractType;
	  }
	});
	Object.defineProperty(exports, 'assertNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.assertNamedType;
	  }
	});
	Object.defineProperty(exports, 'getNullableType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNullableType;
	  }
	});
	Object.defineProperty(exports, 'getNamedType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.getNamedType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLScalarType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLScalarType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInterfaceType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInterfaceType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLUnionType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLUnionType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLEnumType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLEnumType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLInputObjectType', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLInputObjectType;
	  }
	});
	Object.defineProperty(exports, 'GraphQLList', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLList;
	  }
	});
	Object.defineProperty(exports, 'GraphQLNonNull', {
	  enumerable: true,
	  get: function get() {
	    return _definition.GraphQLNonNull;
	  }
	});
	
	var _directives = __webpack_require__(27);
	
	Object.defineProperty(exports, 'DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _directives.DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDirective;
	  }
	});
	Object.defineProperty(exports, 'specifiedDirectives', {
	  enumerable: true,
	  get: function get() {
	    return _directives.specifiedDirectives;
	  }
	});
	Object.defineProperty(exports, 'GraphQLIncludeDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLIncludeDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLSkipDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLSkipDirective;
	  }
	});
	Object.defineProperty(exports, 'GraphQLDeprecatedDirective', {
	  enumerable: true,
	  get: function get() {
	    return _directives.GraphQLDeprecatedDirective;
	  }
	});
	Object.defineProperty(exports, 'DEFAULT_DEPRECATION_REASON', {
	  enumerable: true,
	  get: function get() {
	    return _directives.DEFAULT_DEPRECATION_REASON;
	  }
	});
	
	var _scalars = __webpack_require__(32);
	
	Object.defineProperty(exports, 'GraphQLInt', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLInt;
	  }
	});
	Object.defineProperty(exports, 'GraphQLFloat', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLFloat;
	  }
	});
	Object.defineProperty(exports, 'GraphQLString', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLString;
	  }
	});
	Object.defineProperty(exports, 'GraphQLBoolean', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLBoolean;
	  }
	});
	Object.defineProperty(exports, 'GraphQLID', {
	  enumerable: true,
	  get: function get() {
	    return _scalars.GraphQLID;
	  }
	});
	
	var _introspection = __webpack_require__(34);
	
	Object.defineProperty(exports, 'TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeKind;
	  }
	});
	Object.defineProperty(exports, '__Schema', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Schema;
	  }
	});
	Object.defineProperty(exports, '__Directive', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Directive;
	  }
	});
	Object.defineProperty(exports, '__DirectiveLocation', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__DirectiveLocation;
	  }
	});
	Object.defineProperty(exports, '__Type', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Type;
	  }
	});
	Object.defineProperty(exports, '__Field', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__Field;
	  }
	});
	Object.defineProperty(exports, '__InputValue', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__InputValue;
	  }
	});
	Object.defineProperty(exports, '__EnumValue', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__EnumValue;
	  }
	});
	Object.defineProperty(exports, '__TypeKind', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.__TypeKind;
	  }
	});
	Object.defineProperty(exports, 'SchemaMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.SchemaMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeMetaFieldDef;
	  }
	});
	Object.defineProperty(exports, 'TypeNameMetaFieldDef', {
	  enumerable: true,
	  get: function get() {
	    return _introspection.TypeNameMetaFieldDef;
	  }
	});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildClientSchema = buildClientSchema;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _keyValMap = __webpack_require__(101);
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _parser = __webpack_require__(91);
	
	var _schema = __webpack_require__(28);
	
	var _definition = __webpack_require__(6);
	
	var _introspection = __webpack_require__(34);
	
	var _scalars = __webpack_require__(32);
	
	var _directives = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Build a GraphQLSchema for use by client tools.
	 *
	 * Given the result of a client running the introspection query, creates and
	 * returns a GraphQLSchema instance which can be then used with all graphql-js
	 * tools, but cannot be used to execute a query, as introspection does not
	 * represent the "resolver", "parse" or "serialize" functions or any other
	 * server-internal mechanisms.
	 */
	function buildClientSchema(introspection) {
	
	  // Get the schema from the introspection result.
	  var schemaIntrospection = introspection.__schema;
	
	  // Converts the list of types into a keyMap based on the type names.
	  var typeIntrospectionMap = (0, _keyMap2.default)(schemaIntrospection.types, function (type) {
	    return type.name;
	  });
	
	  // A cache to use to store the actual GraphQLType definition objects by name.
	  // Initialize to the GraphQL built in scalars. All functions below are inline
	  // so that this type def cache is within the scope of the closure.
	  var typeDefCache = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  // Given a type reference in introspection, return the GraphQLType instance.
	  // preferring cached instances before building new instances.
	  function getType(typeRef) {
	    if (typeRef.kind === _introspection.TypeKind.LIST) {
	      var itemRef = typeRef.ofType;
	      if (!itemRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	      return new _definition.GraphQLList(getType(itemRef));
	    }
	    if (typeRef.kind === _introspection.TypeKind.NON_NULL) {
	      var nullableRef = typeRef.ofType;
	      if (!nullableRef) {
	        throw new Error('Decorated type deeper than introspection query.');
	      }
	      var nullableType = getType(nullableRef);
	      !!(nullableType instanceof _definition.GraphQLNonNull) ? (0, _invariant2.default)(0, 'No nesting nonnull.') : void 0;
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getNamedType(typeRef.name);
	  }
	
	  function getNamedType(typeName) {
	    if (typeDefCache[typeName]) {
	      return typeDefCache[typeName];
	    }
	    var typeIntrospection = typeIntrospectionMap[typeName];
	    if (!typeIntrospection) {
	      throw new Error('Invalid or incomplete schema, unknown type: ' + typeName + '. Ensure ' + 'that a full introspection query is used in order to build a ' + 'client schema.');
	    }
	    var typeDef = buildType(typeIntrospection);
	    typeDefCache[typeName] = typeDef;
	    return typeDef;
	  }
	
	  function getInputType(typeRef) {
	    var type = getType(typeRef);
	    !(0, _definition.isInputType)(type) ? (0, _invariant2.default)(0, 'Introspection must provide input type for arguments.') : void 0;
	    return type;
	  }
	
	  function getOutputType(typeRef) {
	    var type = getType(typeRef);
	    !(0, _definition.isOutputType)(type) ? (0, _invariant2.default)(0, 'Introspection must provide output type for fields.') : void 0;
	    return type;
	  }
	
	  function getObjectType(typeRef) {
	    var type = getType(typeRef);
	    !(type instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Introspection must provide object type for possibleTypes.') : void 0;
	    return type;
	  }
	
	  function getInterfaceType(typeRef) {
	    var type = getType(typeRef);
	    !(type instanceof _definition.GraphQLInterfaceType) ? (0, _invariant2.default)(0, 'Introspection must provide interface type for interfaces.') : void 0;
	    return type;
	  }
	
	  // Given a type's introspection result, construct the correct
	  // GraphQLType instance.
	  function buildType(type) {
	    switch (type.kind) {
	      case _introspection.TypeKind.SCALAR:
	        return buildScalarDef(type);
	      case _introspection.TypeKind.OBJECT:
	        return buildObjectDef(type);
	      case _introspection.TypeKind.INTERFACE:
	        return buildInterfaceDef(type);
	      case _introspection.TypeKind.UNION:
	        return buildUnionDef(type);
	      case _introspection.TypeKind.ENUM:
	        return buildEnumDef(type);
	      case _introspection.TypeKind.INPUT_OBJECT:
	        return buildInputObjectDef(type);
	      default:
	        throw new Error('Invalid or incomplete schema, unknown kind: ' + type.kind + '. Ensure ' + 'that a full introspection query is used in order to build a ' + 'client schema.');
	    }
	  }
	
	  function buildScalarDef(scalarIntrospection) {
	    return new _definition.GraphQLScalarType({
	      name: scalarIntrospection.name,
	      description: scalarIntrospection.description,
	      serialize: function serialize(id) {
	        return id;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function buildObjectDef(objectIntrospection) {
	    return new _definition.GraphQLObjectType({
	      name: objectIntrospection.name,
	      description: objectIntrospection.description,
	      interfaces: objectIntrospection.interfaces.map(getInterfaceType),
	      fields: function fields() {
	        return buildFieldDefMap(objectIntrospection);
	      }
	    });
	  }
	
	  function buildInterfaceDef(interfaceIntrospection) {
	    return new _definition.GraphQLInterfaceType({
	      name: interfaceIntrospection.name,
	      description: interfaceIntrospection.description,
	      fields: function fields() {
	        return buildFieldDefMap(interfaceIntrospection);
	      },
	      resolveType: cannotExecuteClientSchema
	    });
	  }
	
	  function buildUnionDef(unionIntrospection) {
	    return new _definition.GraphQLUnionType({
	      name: unionIntrospection.name,
	      description: unionIntrospection.description,
	      types: unionIntrospection.possibleTypes.map(getObjectType),
	      resolveType: cannotExecuteClientSchema
	    });
	  }
	
	  function buildEnumDef(enumIntrospection) {
	    return new _definition.GraphQLEnumType({
	      name: enumIntrospection.name,
	      description: enumIntrospection.description,
	      values: (0, _keyValMap2.default)(enumIntrospection.enumValues, function (valueIntrospection) {
	        return valueIntrospection.name;
	      }, function (valueIntrospection) {
	        return {
	          description: valueIntrospection.description,
	          deprecationReason: valueIntrospection.deprecationReason
	        };
	      })
	    });
	  }
	
	  function buildInputObjectDef(inputObjectIntrospection) {
	    return new _definition.GraphQLInputObjectType({
	      name: inputObjectIntrospection.name,
	      description: inputObjectIntrospection.description,
	      fields: function fields() {
	        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
	      }
	    });
	  }
	
	  function buildFieldDefMap(typeIntrospection) {
	    return (0, _keyValMap2.default)(typeIntrospection.fields, function (fieldIntrospection) {
	      return fieldIntrospection.name;
	    }, function (fieldIntrospection) {
	      return {
	        description: fieldIntrospection.description,
	        deprecationReason: fieldIntrospection.deprecationReason,
	        type: getOutputType(fieldIntrospection.type),
	        args: buildInputValueDefMap(fieldIntrospection.args)
	      };
	    });
	  }
	
	  function buildInputValueDefMap(inputValueIntrospections) {
	    return (0, _keyValMap2.default)(inputValueIntrospections, function (inputValue) {
	      return inputValue.name;
	    }, buildInputValue);
	  }
	
	  function buildInputValue(inputValueIntrospection) {
	    var type = getInputType(inputValueIntrospection.type);
	    var defaultValue = inputValueIntrospection.defaultValue ? (0, _valueFromAST.valueFromAST)((0, _parser.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
	    return {
	      name: inputValueIntrospection.name,
	      description: inputValueIntrospection.description,
	      type: type,
	      defaultValue: defaultValue
	    };
	  }
	
	  function buildDirective(directiveIntrospection) {
	    // Support deprecated `on****` fields for building `locations`, as this
	    // is used by GraphiQL which may need to support outdated servers.
	    var locations = directiveIntrospection.locations ? directiveIntrospection.locations.slice() : [].concat(!directiveIntrospection.onField ? [] : [_directives.DirectiveLocation.FIELD], !directiveIntrospection.onOperation ? [] : [_directives.DirectiveLocation.QUERY, _directives.DirectiveLocation.MUTATION, _directives.DirectiveLocation.SUBSCRIPTION], !directiveIntrospection.onFragment ? [] : [_directives.DirectiveLocation.FRAGMENT_DEFINITION, _directives.DirectiveLocation.FRAGMENT_SPREAD, _directives.DirectiveLocation.INLINE_FRAGMENT]);
	    return new _directives.GraphQLDirective({
	      name: directiveIntrospection.name,
	      description: directiveIntrospection.description,
	      locations: locations,
	      args: buildInputValueDefMap(directiveIntrospection.args)
	    });
	  }
	
	  // Iterate through all types, getting the type definition for each, ensuring
	  // that any type not directly referenced by a field will get created.
	  var types = schemaIntrospection.types.map(function (typeIntrospection) {
	    return getNamedType(typeIntrospection.name);
	  });
	
	  // Get the root Query, Mutation, and Subscription types.
	  var queryType = getObjectType(schemaIntrospection.queryType);
	
	  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
	
	  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null;
	
	  // Get the directives supported by Introspection, assuming empty-set if
	  // directives were not queried for.
	  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : [];
	
	  // Then produce and return a Schema with these types.
	  return new _schema.GraphQLSchema({
	    query: queryType,
	    mutation: mutationType,
	    subscription: subscriptionType,
	    types: types,
	    directives: directives
	  });
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	function cannotExecuteClientSchema() {
	  throw new Error('Client Schema cannot use Interface or Union types for execution.');
	}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.concatAST = concatAST;
	
	
	/**
	 * Provided a collection of ASTs, presumably each from different files,
	 * concatenate the ASTs together into batched AST, useful for validating many
	 * GraphQL source files which together represent one conceptual application.
	 */
	function concatAST(asts) {
	  var batchDefinitions = [];
	  for (var i = 0; i < asts.length; i++) {
	    var definitions = asts[i].definitions;
	    for (var j = 0; j < definitions.length; j++) {
	      batchDefinitions.push(definitions[j]);
	    }
	  }
	  return {
	    kind: 'Document',
	    definitions: batchDefinitions
	  };
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendSchema = extendSchema;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _keyMap = __webpack_require__(45);
	
	var _keyMap2 = _interopRequireDefault(_keyMap);
	
	var _keyValMap = __webpack_require__(101);
	
	var _keyValMap2 = _interopRequireDefault(_keyValMap);
	
	var _buildASTSchema = __webpack_require__(187);
	
	var _valueFromAST = __webpack_require__(68);
	
	var _GraphQLError = __webpack_require__(43);
	
	var _schema = __webpack_require__(28);
	
	var _definition = __webpack_require__(6);
	
	var _directives = __webpack_require__(27);
	
	var _introspection = __webpack_require__(34);
	
	var _scalars = __webpack_require__(32);
	
	var _kinds = __webpack_require__(11);
	
	var Kind = _interopRequireWildcard(_kinds);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Produces a new schema given an existing schema and a document which may
	 * contain GraphQL type extensions and definitions. The original schema will
	 * remain unaltered.
	 *
	 * Because a schema represents a graph of references, a schema cannot be
	 * extended without effectively making an entire copy. We do not know until it's
	 * too late if subgraphs remain unchanged.
	 *
	 * This algorithm copies the provided schema, applying extensions while
	 * producing the copy. The original schema remains unaltered.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function extendSchema(schema, documentAST) {
	  !(schema instanceof _schema.GraphQLSchema) ? (0, _invariant2.default)(0, 'Must provide valid GraphQLSchema') : void 0;
	
	  !(documentAST && documentAST.kind === Kind.DOCUMENT) ? (0, _invariant2.default)(0, 'Must provide valid Document AST') : void 0;
	
	  // Collect the type definitions and extensions found in the document.
	  var typeDefinitionMap = Object.create(null);
	  var typeExtensionsMap = Object.create(null);
	
	  // New directives and types are separate because a directives and types can
	  // have the same name. For example, a type named "skip".
	  var directiveDefinitions = [];
	
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var def = documentAST.definitions[i];
	    switch (def.kind) {
	      case Kind.OBJECT_TYPE_DEFINITION:
	      case Kind.INTERFACE_TYPE_DEFINITION:
	      case Kind.ENUM_TYPE_DEFINITION:
	      case Kind.UNION_TYPE_DEFINITION:
	      case Kind.SCALAR_TYPE_DEFINITION:
	      case Kind.INPUT_OBJECT_TYPE_DEFINITION:
	        // Sanity check that none of the defined types conflict with the
	        // schema's existing types.
	        var typeName = def.name.value;
	        if (schema.getType(typeName)) {
	          throw new _GraphQLError.GraphQLError('Type "' + typeName + '" already exists in the schema. It cannot also ' + 'be defined in this type definition.', [def]);
	        }
	        typeDefinitionMap[typeName] = def;
	        break;
	      case Kind.TYPE_EXTENSION_DEFINITION:
	        // Sanity check that this type extension exists within the
	        // schema's existing types.
	        var extendedTypeName = def.definition.name.value;
	        var existingType = schema.getType(extendedTypeName);
	        if (!existingType) {
	          throw new _GraphQLError.GraphQLError('Cannot extend type "' + extendedTypeName + '" because it does not ' + 'exist in the existing schema.', [def.definition]);
	        }
	        if (!(existingType instanceof _definition.GraphQLObjectType)) {
	          throw new _GraphQLError.GraphQLError('Cannot extend non-object type "' + extendedTypeName + '".', [def.definition]);
	        }
	        var extensions = typeExtensionsMap[extendedTypeName];
	        if (extensions) {
	          extensions.push(def);
	        } else {
	          extensions = [def];
	        }
	        typeExtensionsMap[extendedTypeName] = extensions;
	        break;
	      case Kind.DIRECTIVE_DEFINITION:
	        var directiveName = def.name.value;
	        var existingDirective = schema.getDirective(directiveName);
	        if (existingDirective) {
	          throw new _GraphQLError.GraphQLError('Directive "' + directiveName + '" already exists in the schema. It ' + 'cannot be redefined.', [def]);
	        }
	        directiveDefinitions.push(def);
	        break;
	    }
	  }
	
	  // If this document contains no new types, extensions, or directives then
	  // return the same unmodified GraphQLSchema instance.
	  if (Object.keys(typeExtensionsMap).length === 0 && Object.keys(typeDefinitionMap).length === 0 && directiveDefinitions.length === 0) {
	    return schema;
	  }
	
	  // A cache to use to store the actual GraphQLType definition objects by name.
	  // Initialize to the GraphQL built in scalars and introspection types. All
	  // functions below are inline so that this type def cache is within the scope
	  // of the closure.
	  var typeDefCache = {
	    String: _scalars.GraphQLString,
	    Int: _scalars.GraphQLInt,
	    Float: _scalars.GraphQLFloat,
	    Boolean: _scalars.GraphQLBoolean,
	    ID: _scalars.GraphQLID,
	    __Schema: _introspection.__Schema,
	    __Directive: _introspection.__Directive,
	    __DirectiveLocation: _introspection.__DirectiveLocation,
	    __Type: _introspection.__Type,
	    __Field: _introspection.__Field,
	    __InputValue: _introspection.__InputValue,
	    __EnumValue: _introspection.__EnumValue,
	    __TypeKind: _introspection.__TypeKind
	  };
	
	  // Get the root Query, Mutation, and Subscription object types.
	  var queryType = getTypeFromDef(schema.getQueryType());
	
	  var existingMutationType = schema.getMutationType();
	  var mutationType = existingMutationType ? getTypeFromDef(existingMutationType) : null;
	
	  var existingSubscriptionType = schema.getSubscriptionType();
	  var subscriptionType = existingSubscriptionType ? getTypeFromDef(existingSubscriptionType) : null;
	
	  // Iterate through all types, getting the type definition for each, ensuring
	  // that any type not directly referenced by a field will get created.
	  var typeMap = schema.getTypeMap();
	  var types = Object.keys(typeMap).map(function (typeName) {
	    return getTypeFromDef(typeMap[typeName]);
	  });
	
	  // Do the same with new types, appending to the list of defined types.
	  Object.keys(typeDefinitionMap).forEach(function (typeName) {
	    types.push(getTypeFromAST(typeDefinitionMap[typeName]));
	  });
	
	  // Then produce and return a Schema with these types.
	  return new _schema.GraphQLSchema({
	    query: queryType,
	    mutation: mutationType,
	    subscription: subscriptionType,
	    types: types,
	    directives: getMergedDirectives(),
	    astNode: schema.astNode
	  });
	
	  // Below are functions used for producing this schema that have closed over
	  // this scope and have access to the schema, cache, and newly defined types.
	
	  function getMergedDirectives() {
	    var existingDirectives = schema.getDirectives();
	    !existingDirectives ? (0, _invariant2.default)(0, 'schema must have default directives') : void 0;
	
	    var newDirectives = directiveDefinitions.map(function (directiveNode) {
	      return getDirective(directiveNode);
	    });
	    return existingDirectives.concat(newDirectives);
	  }
	
	  function getTypeFromDef(typeDef) {
	    var type = _getNamedType(typeDef.name);
	    !type ? (0, _invariant2.default)(0, 'Missing type from schema') : void 0;
	    return type;
	  }
	
	  function getTypeFromAST(node) {
	    var type = _getNamedType(node.name.value);
	    if (!type) {
	      throw new _GraphQLError.GraphQLError('Unknown type: "' + node.name.value + '". Ensure that this type exists ' + 'either in the original schema, or is added in a type definition.', [node]);
	    }
	    return type;
	  }
	
	  function getObjectTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    !(type instanceof _definition.GraphQLObjectType) ? (0, _invariant2.default)(0, 'Must be Object type.') : void 0;
	    return type;
	  }
	
	  function getInterfaceTypeFromAST(node) {
	    var type = getTypeFromAST(node);
	    !(type instanceof _definition.GraphQLInterfaceType) ? (0, _invariant2.default)(0, 'Must be Interface type.') : void 0;
	    return type;
	  }
	
	  function getInputTypeFromAST(node) {
	    return (0, _definition.assertInputType)(getTypeFromAST(node));
	  }
	
	  function getOutputTypeFromAST(node) {
	    return (0, _definition.assertOutputType)(getTypeFromAST(node));
	  }
	
	  // Given a name, returns a type from either the existing schema or an
	  // added type.
	  function _getNamedType(typeName) {
	    var cachedTypeDef = typeDefCache[typeName];
	    if (cachedTypeDef) {
	      return cachedTypeDef;
	    }
	
	    var existingType = schema.getType(typeName);
	    if (existingType) {
	      var typeDef = extendType(existingType);
	      typeDefCache[typeName] = typeDef;
	      return typeDef;
	    }
	
	    var typeNode = typeDefinitionMap[typeName];
	    if (typeNode) {
	      var _typeDef = buildType(typeNode);
	      typeDefCache[typeName] = _typeDef;
	      return _typeDef;
	    }
	  }
	
	  // Given a type's introspection result, construct the correct
	  // GraphQLType instance.
	  function extendType(type) {
	    if (type instanceof _definition.GraphQLObjectType) {
	      return extendObjectType(type);
	    }
	    if (type instanceof _definition.GraphQLInterfaceType) {
	      return extendInterfaceType(type);
	    }
	    if (type instanceof _definition.GraphQLUnionType) {
	      return extendUnionType(type);
	    }
	    return type;
	  }
	
	  function extendObjectType(type) {
	    var name = type.name;
	    var extensionASTNodes = type.extensionASTNodes;
	    if (typeExtensionsMap[name]) {
	      extensionASTNodes = extensionASTNodes.concat(typeExtensionsMap[name]);
	    }
	
	    return new _definition.GraphQLObjectType({
	      name: name,
	      description: type.description,
	      interfaces: function interfaces() {
	        return extendImplementedInterfaces(type);
	      },
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      astNode: type.astNode,
	      extensionASTNodes: extensionASTNodes,
	      isTypeOf: type.isTypeOf
	    });
	  }
	
	  function extendInterfaceType(type) {
	    return new _definition.GraphQLInterfaceType({
	      name: type.name,
	      description: type.description,
	      fields: function fields() {
	        return extendFieldMap(type);
	      },
	      astNode: type.astNode,
	      resolveType: type.resolveType
	    });
	  }
	
	  function extendUnionType(type) {
	    return new _definition.GraphQLUnionType({
	      name: type.name,
	      description: type.description,
	      types: type.getTypes().map(getTypeFromDef),
	      astNode: type.astNode,
	      resolveType: type.resolveType
	    });
	  }
	
	  function extendImplementedInterfaces(type) {
	    var interfaces = type.getInterfaces().map(getTypeFromDef);
	
	    // If there are any extensions to the interfaces, apply those here.
	    var extensions = typeExtensionsMap[type.name];
	    if (extensions) {
	      extensions.forEach(function (extension) {
	        extension.definition.interfaces.forEach(function (namedType) {
	          var interfaceName = namedType.name.value;
	          if (interfaces.some(function (def) {
	            return def.name === interfaceName;
	          })) {
	            throw new _GraphQLError.GraphQLError('Type "' + type.name + '" already implements "' + interfaceName + '". ' + 'It cannot also be implemented in this type extension.', [namedType]);
	          }
	          interfaces.push(getInterfaceTypeFromAST(namedType));
	        });
	      });
	    }
	
	    return interfaces;
	  }
	
	  function extendFieldMap(type) {
	    var newFieldMap = Object.create(null);
	    var oldFieldMap = type.getFields();
	    Object.keys(oldFieldMap).forEach(function (fieldName) {
	      var field = oldFieldMap[fieldName];
	      newFieldMap[fieldName] = {
	        description: field.description,
	        deprecationReason: field.deprecationReason,
	        type: extendFieldType(field.type),
	        args: (0, _keyMap2.default)(field.args, function (arg) {
	          return arg.name;
	        }),
	        astNode: field.astNode,
	        resolve: field.resolve
	      };
	    });
	
	    // If there are any extensions to the fields, apply those here.
	    var extensions = typeExtensionsMap[type.name];
	    if (extensions) {
	      extensions.forEach(function (extension) {
	        extension.definition.fields.forEach(function (field) {
	          var fieldName = field.name.value;
	          if (oldFieldMap[fieldName]) {
	            throw new _GraphQLError.GraphQLError('Field "' + type.name + '.' + fieldName + '" already exists in the ' + 'schema. It cannot also be defined in this type extension.', [field]);
	          }
	          newFieldMap[fieldName] = {
	            description: (0, _buildASTSchema.getDescription)(field),
	            type: buildOutputFieldType(field.type),
	            args: buildInputValues(field.arguments),
	            deprecationReason: (0, _buildASTSchema.getDeprecationReason)(field),
	            astNode: field
	          };
	        });
	      });
	    }
	
	    return newFieldMap;
	  }
	
	  function extendFieldType(typeDef) {
	    if (typeDef instanceof _definition.GraphQLList) {
	      return new _definition.GraphQLList(extendFieldType(typeDef.ofType));
	    }
	    if (typeDef instanceof _definition.GraphQLNonNull) {
	      return new _definition.GraphQLNonNull(extendFieldType(typeDef.ofType));
	    }
	    return getTypeFromDef(typeDef);
	  }
	
	  function buildType(typeNode) {
	    switch (typeNode.kind) {
	      case Kind.OBJECT_TYPE_DEFINITION:
	        return buildObjectType(typeNode);
	      case Kind.INTERFACE_TYPE_DEFINITION:
	        return buildInterfaceType(typeNode);
	      case Kind.UNION_TYPE_DEFINITION:
	        return buildUnionType(typeNode);
	      case Kind.SCALAR_TYPE_DEFINITION:
	        return buildScalarType(typeNode);
	      case Kind.ENUM_TYPE_DEFINITION:
	        return buildEnumType(typeNode);
	      case Kind.INPUT_OBJECT_TYPE_DEFINITION:
	        return buildInputObjectType(typeNode);
	    }
	    throw new TypeError('Unknown type kind ' + typeNode.kind);
	  }
	
	  function buildObjectType(typeNode) {
	    return new _definition.GraphQLObjectType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      interfaces: function interfaces() {
	        return buildImplementedInterfaces(typeNode);
	      },
	      fields: function fields() {
	        return buildFieldMap(typeNode);
	      },
	      astNode: typeNode
	    });
	  }
	
	  function buildInterfaceType(typeNode) {
	    return new _definition.GraphQLInterfaceType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      fields: function fields() {
	        return buildFieldMap(typeNode);
	      },
	      astNode: typeNode,
	      resolveType: cannotExecuteExtendedSchema
	    });
	  }
	
	  function buildUnionType(typeNode) {
	    return new _definition.GraphQLUnionType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      types: typeNode.types.map(getObjectTypeFromAST),
	      astNode: typeNode,
	      resolveType: cannotExecuteExtendedSchema
	    });
	  }
	
	  function buildScalarType(typeNode) {
	    return new _definition.GraphQLScalarType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      astNode: typeNode,
	      serialize: function serialize(id) {
	        return id;
	      },
	      // Note: validation calls the parse functions to determine if a
	      // literal value is correct. Returning null would cause use of custom
	      // scalars to always fail validation. Returning false causes them to
	      // always pass validation.
	      parseValue: function parseValue() {
	        return false;
	      },
	      parseLiteral: function parseLiteral() {
	        return false;
	      }
	    });
	  }
	
	  function buildEnumType(typeNode) {
	    return new _definition.GraphQLEnumType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      values: (0, _keyValMap2.default)(typeNode.values, function (enumValue) {
	        return enumValue.name.value;
	      }, function (enumValue) {
	        return {
	          description: (0, _buildASTSchema.getDescription)(enumValue),
	          deprecationReason: (0, _buildASTSchema.getDeprecationReason)(enumValue),
	          astNode: enumValue
	        };
	      }),
	      astNode: typeNode
	    });
	  }
	
	  function buildInputObjectType(typeNode) {
	    return new _definition.GraphQLInputObjectType({
	      name: typeNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(typeNode),
	      fields: function fields() {
	        return buildInputValues(typeNode.fields);
	      },
	      astNode: typeNode
	    });
	  }
	
	  function getDirective(directiveNode) {
	    return new _directives.GraphQLDirective({
	      name: directiveNode.name.value,
	      description: (0, _buildASTSchema.getDescription)(directiveNode),
	      locations: directiveNode.locations.map(function (node) {
	        return node.value;
	      }),
	      args: directiveNode.arguments && buildInputValues(directiveNode.arguments),
	      astNode: directiveNode
	    });
	  }
	
	  function buildImplementedInterfaces(typeNode) {
	    return typeNode.interfaces && typeNode.interfaces.map(getInterfaceTypeFromAST);
	  }
	
	  function buildFieldMap(typeNode) {
	    return (0, _keyValMap2.default)(typeNode.fields, function (field) {
	      return field.name.value;
	    }, function (field) {
	      return {
	        type: buildOutputFieldType(field.type),
	        description: (0, _buildASTSchema.getDescription)(field),
	        args: buildInputValues(field.arguments),
	        deprecationReason: (0, _buildASTSchema.getDeprecationReason)(field),
	        astNode: field
	      };
	    });
	  }
	
	  function buildInputValues(values) {
	    return (0, _keyValMap2.default)(values, function (value) {
	      return value.name.value;
	    }, function (value) {
	      var type = buildInputFieldType(value.type);
	      return {
	        type: type,
	        description: (0, _buildASTSchema.getDescription)(value),
	        defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type),
	        astNode: value
	      };
	    });
	  }
	
	  function buildInputFieldType(typeNode) {
	    if (typeNode.kind === Kind.LIST_TYPE) {
	      return new _definition.GraphQLList(buildInputFieldType(typeNode.type));
	    }
	    if (typeNode.kind === Kind.NON_NULL_TYPE) {
	      var nullableType = buildInputFieldType(typeNode.type);
	      !!(nullableType instanceof _definition.GraphQLNonNull) ? (0, _invariant2.default)(0, 'Must be nullable') : void 0;
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getInputTypeFromAST(typeNode);
	  }
	
	  function buildOutputFieldType(typeNode) {
	    if (typeNode.kind === Kind.LIST_TYPE) {
	      return new _definition.GraphQLList(buildOutputFieldType(typeNode.type));
	    }
	    if (typeNode.kind === Kind.NON_NULL_TYPE) {
	      var nullableType = buildOutputFieldType(typeNode.type);
	      !!(nullableType instanceof _definition.GraphQLNonNull) ? (0, _invariant2.default)(0, 'Must be nullable') : void 0;
	      return new _definition.GraphQLNonNull(nullableType);
	    }
	    return getOutputTypeFromAST(typeNode);
	  }
	}
	
	function cannotExecuteExtendedSchema() {
	  throw new Error('Extended Schema cannot use Interface or Union types for execution.');
	}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DangerousChangeType = exports.BreakingChangeType = undefined;
	exports.findBreakingChanges = findBreakingChanges;
	exports.findDangerousChanges = findDangerousChanges;
	exports.findRemovedTypes = findRemovedTypes;
	exports.findTypesThatChangedKind = findTypesThatChangedKind;
	exports.findArgChanges = findArgChanges;
	exports.findFieldsThatChangedType = findFieldsThatChangedType;
	exports.findFieldsThatChangedTypeOnInputObjectTypes = findFieldsThatChangedTypeOnInputObjectTypes;
	exports.findTypesRemovedFromUnions = findTypesRemovedFromUnions;
	exports.findTypesAddedToUnions = findTypesAddedToUnions;
	exports.findValuesRemovedFromEnums = findValuesRemovedFromEnums;
	exports.findValuesAddedToEnums = findValuesAddedToEnums;
	exports.findInterfacesRemovedFromObjectTypes = findInterfacesRemovedFromObjectTypes;
	
	var _definition = __webpack_require__(6);
	
	var _schema = __webpack_require__(28);
	
	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var BreakingChangeType = exports.BreakingChangeType = {
	  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
	  FIELD_REMOVED: 'FIELD_REMOVED',
	  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
	  TYPE_REMOVED: 'TYPE_REMOVED',
	  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
	  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
	  ARG_REMOVED: 'ARG_REMOVED',
	  ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
	  NON_NULL_ARG_ADDED: 'NON_NULL_ARG_ADDED',
	  NON_NULL_INPUT_FIELD_ADDED: 'NON_NULL_INPUT_FIELD_ADDED',
	  INTERFACE_REMOVED_FROM_OBJECT: 'INTERFACE_REMOVED_FROM_OBJECT'
	};
	
	var DangerousChangeType = exports.DangerousChangeType = {
	  ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE',
	  VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
	  TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION'
	};
	
	/**
	 * Given two schemas, returns an Array containing descriptions of all the types
	 * of breaking changes covered by the other functions down below.
	 */
	function findBreakingChanges(oldSchema, newSchema) {
	  return [].concat(findRemovedTypes(oldSchema, newSchema), findTypesThatChangedKind(oldSchema, newSchema), findFieldsThatChangedType(oldSchema, newSchema), findTypesRemovedFromUnions(oldSchema, newSchema), findValuesRemovedFromEnums(oldSchema, newSchema), findArgChanges(oldSchema, newSchema).breakingChanges, findInterfacesRemovedFromObjectTypes(oldSchema, newSchema));
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of all the types
	 * of potentially dangerous changes covered by the other functions down below.
	 */
	function findDangerousChanges(oldSchema, newSchema) {
	  return [].concat(findArgChanges(oldSchema, newSchema).dangerousChanges, findValuesAddedToEnums(oldSchema, newSchema), findTypesAddedToUnions(oldSchema, newSchema));
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing an entire type.
	 */
	function findRemovedTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    if (!newTypeMap[typeName]) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_REMOVED,
	        description: typeName + ' was removed.'
	      });
	    }
	  });
	  return breakingChanges;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to changing the type of a type.
	 */
	function findTypesThatChangedKind(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    if (!newTypeMap[typeName]) {
	      return;
	    }
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof newType.constructor)) {
	      breakingChanges.push({
	        type: BreakingChangeType.TYPE_CHANGED_KIND,
	        description: typeName + ' changed from ' + (typeKindName(oldType) + ' to ' + typeKindName(newType) + '.')
	      });
	    }
	  });
	  return breakingChanges;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any
	 * breaking or dangerous changes in the newSchema related to arguments
	 * (such as removal or change of type of an argument, or a change in an
	 * argument's default value).
	 */
	function findArgChanges(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingChanges = [];
	  var dangerousChanges = [];
	
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLObjectType || oldType instanceof _definition.GraphQLInterfaceType) || !(newType instanceof oldType.constructor)) {
	      return;
	    }
	
	    var oldTypeFields = oldType.getFields();
	    var newTypeFields = newType.getFields();
	
	    Object.keys(oldTypeFields).forEach(function (fieldName) {
	      if (!newTypeFields[fieldName]) {
	        return;
	      }
	
	      oldTypeFields[fieldName].args.forEach(function (oldArgDef) {
	        var newArgs = newTypeFields[fieldName].args;
	        var newArgDef = newArgs.find(function (arg) {
	          return arg.name === oldArgDef.name;
	        });
	
	        // Arg not present
	        if (!newArgDef) {
	          breakingChanges.push({
	            type: BreakingChangeType.ARG_REMOVED,
	            description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' was removed')
	          });
	        } else {
	          var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldArgDef.type, newArgDef.type);
	          if (!isSafe) {
	            breakingChanges.push({
	              type: BreakingChangeType.ARG_CHANGED_KIND,
	              description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' has changed type from ') + (oldArgDef.type.toString() + ' to ' + newArgDef.type.toString())
	            });
	          } else if (oldArgDef.defaultValue !== undefined && oldArgDef.defaultValue !== newArgDef.defaultValue) {
	            dangerousChanges.push({
	              type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
	              description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' has changed defaultValue')
	            });
	          }
	        }
	      });
	      // Check if a non-null arg was added to the field
	      newTypeFields[fieldName].args.forEach(function (newArgDef) {
	        var oldArgs = oldTypeFields[fieldName].args;
	        var oldArgDef = oldArgs.find(function (arg) {
	          return arg.name === newArgDef.name;
	        });
	        if (!oldArgDef && newArgDef.type instanceof _definition.GraphQLNonNull) {
	          breakingChanges.push({
	            type: BreakingChangeType.NON_NULL_ARG_ADDED,
	            description: 'A non-null arg ' + newArgDef.name + ' on ' + (newType.name + '.' + fieldName + ' was added')
	          });
	        }
	      });
	    });
	  });
	
	  return {
	    breakingChanges: breakingChanges,
	    dangerousChanges: dangerousChanges
	  };
	}
	
	function typeKindName(type) {
	  if (type instanceof _definition.GraphQLScalarType) {
	    return 'a Scalar type';
	  }
	  if (type instanceof _definition.GraphQLObjectType) {
	    return 'an Object type';
	  }
	  if (type instanceof _definition.GraphQLInterfaceType) {
	    return 'an Interface type';
	  }
	  if (type instanceof _definition.GraphQLUnionType) {
	    return 'a Union type';
	  }
	  if (type instanceof _definition.GraphQLEnumType) {
	    return 'an Enum type';
	  }
	  if (type instanceof _definition.GraphQLInputObjectType) {
	    return 'an Input type';
	  }
	  throw new TypeError('Unknown type ' + type.constructor.name);
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to the fields on a type. This includes if
	 * a field has been removed from a type, if a field has changed type, or if
	 * a non-null field is added to an input type.
	 */
	function findFieldsThatChangedType(oldSchema, newSchema) {
	  return [].concat(findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema));
	}
	
	function findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingFieldChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLObjectType || oldType instanceof _definition.GraphQLInterfaceType) || !(newType instanceof oldType.constructor)) {
	      return;
	    }
	
	    var oldTypeFieldsDef = oldType.getFields();
	    var newTypeFieldsDef = newType.getFields();
	    Object.keys(oldTypeFieldsDef).forEach(function (fieldName) {
	      // Check if the field is missing on the type in the new schema.
	      if (!(fieldName in newTypeFieldsDef)) {
	        breakingFieldChanges.push({
	          type: BreakingChangeType.FIELD_REMOVED,
	          description: typeName + '.' + fieldName + ' was removed.'
	        });
	      } else {
	        var oldFieldType = oldTypeFieldsDef[fieldName].type;
	        var newFieldType = newTypeFieldsDef[fieldName].type;
	        var isSafe = isChangeSafeForObjectOrInterfaceField(oldFieldType, newFieldType);
	        if (!isSafe) {
	          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
	          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
	          breakingFieldChanges.push({
	            type: BreakingChangeType.FIELD_CHANGED_KIND,
	            description: typeName + '.' + fieldName + ' changed type from ' + (oldFieldTypeString + ' to ' + newFieldTypeString + '.')
	          });
	        }
	      }
	    });
	  });
	  return breakingFieldChanges;
	}
	
	function findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var breakingFieldChanges = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLInputObjectType) || !(newType instanceof _definition.GraphQLInputObjectType)) {
	      return;
	    }
	
	    var oldTypeFieldsDef = oldType.getFields();
	    var newTypeFieldsDef = newType.getFields();
	    Object.keys(oldTypeFieldsDef).forEach(function (fieldName) {
	      // Check if the field is missing on the type in the new schema.
	      if (!(fieldName in newTypeFieldsDef)) {
	        breakingFieldChanges.push({
	          type: BreakingChangeType.FIELD_REMOVED,
	          description: typeName + '.' + fieldName + ' was removed.'
	        });
	      } else {
	        var oldFieldType = oldTypeFieldsDef[fieldName].type;
	        var newFieldType = newTypeFieldsDef[fieldName].type;
	
	        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldFieldType, newFieldType);
	        if (!isSafe) {
	          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
	          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
	          breakingFieldChanges.push({
	            type: BreakingChangeType.FIELD_CHANGED_KIND,
	            description: typeName + '.' + fieldName + ' changed type from ' + (oldFieldTypeString + ' to ' + newFieldTypeString + '.')
	          });
	        }
	      }
	    });
	    // Check if a non-null field was added to the input object type
	    Object.keys(newTypeFieldsDef).forEach(function (fieldName) {
	      if (!(fieldName in oldTypeFieldsDef) && newTypeFieldsDef[fieldName].type instanceof _definition.GraphQLNonNull) {
	        breakingFieldChanges.push({
	          type: BreakingChangeType.NON_NULL_INPUT_FIELD_ADDED,
	          description: 'A non-null field ' + fieldName + ' on ' + ('input type ' + newType.name + ' was added.')
	        });
	      }
	    });
	  });
	  return breakingFieldChanges;
	}
	
	function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
	  if ((0, _definition.isNamedType)(oldType)) {
	    return (
	      // if they're both named types, see if their names are equivalent
	      (0, _definition.isNamedType)(newType) && oldType.name === newType.name ||
	      // moving from nullable to non-null of the same underlying type is safe
	      newType instanceof _definition.GraphQLNonNull && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
	    );
	  } else if (oldType instanceof _definition.GraphQLList) {
	    return (
	      // if they're both lists, make sure the underlying types are compatible
	      newType instanceof _definition.GraphQLList && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) ||
	      // moving from nullable to non-null of the same underlying type is safe
	      newType instanceof _definition.GraphQLNonNull && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
	    );
	  } else if (oldType instanceof _definition.GraphQLNonNull) {
	    // if they're both non-null, make sure the underlying types are compatible
	    return newType instanceof _definition.GraphQLNonNull && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
	  }
	  return false;
	}
	
	function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
	  if ((0, _definition.isNamedType)(oldType)) {
	    // if they're both named types, see if their names are equivalent
	    return (0, _definition.isNamedType)(newType) && oldType.name === newType.name;
	  } else if (oldType instanceof _definition.GraphQLList) {
	    // if they're both lists, make sure the underlying types are compatible
	    return newType instanceof _definition.GraphQLList && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
	  } else if (oldType instanceof _definition.GraphQLNonNull) {
	    return (
	      // if they're both non-null, make sure the underlying types are
	      // compatible
	      newType instanceof _definition.GraphQLNonNull && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) ||
	      // moving from non-null to nullable of the same underlying type is safe
	      !(newType instanceof _definition.GraphQLNonNull) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType)
	    );
	  }
	  return false;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing types from a union type.
	 */
	function findTypesRemovedFromUnions(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var typesRemovedFromUnion = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLUnionType) || !(newType instanceof _definition.GraphQLUnionType)) {
	      return;
	    }
	    var typeNamesInNewUnion = Object.create(null);
	    newType.getTypes().forEach(function (type) {
	      typeNamesInNewUnion[type.name] = true;
	    });
	    oldType.getTypes().forEach(function (type) {
	      if (!typeNamesInNewUnion[type.name]) {
	        typesRemovedFromUnion.push({
	          type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
	          description: type.name + ' was removed from union type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return typesRemovedFromUnion;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any dangerous
	 * changes in the newSchema related to adding types to a union type.
	 */
	function findTypesAddedToUnions(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var typesAddedToUnion = [];
	  Object.keys(newTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLUnionType) || !(newType instanceof _definition.GraphQLUnionType)) {
	      return;
	    }
	    var typeNamesInOldUnion = Object.create(null);
	    oldType.getTypes().forEach(function (type) {
	      typeNamesInOldUnion[type.name] = true;
	    });
	    newType.getTypes().forEach(function (type) {
	      if (!typeNamesInOldUnion[type.name]) {
	        typesAddedToUnion.push({
	          type: DangerousChangeType.TYPE_ADDED_TO_UNION,
	          description: type.name + ' was added to union type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return typesAddedToUnion;
	}
	/**
	 * Given two schemas, returns an Array containing descriptions of any breaking
	 * changes in the newSchema related to removing values from an enum type.
	 */
	function findValuesRemovedFromEnums(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var valuesRemovedFromEnums = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLEnumType) || !(newType instanceof _definition.GraphQLEnumType)) {
	      return;
	    }
	    var valuesInNewEnum = Object.create(null);
	    newType.getValues().forEach(function (value) {
	      valuesInNewEnum[value.name] = true;
	    });
	    oldType.getValues().forEach(function (value) {
	      if (!valuesInNewEnum[value.name]) {
	        valuesRemovedFromEnums.push({
	          type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
	          description: value.name + ' was removed from enum type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return valuesRemovedFromEnums;
	}
	
	/**
	 * Given two schemas, returns an Array containing descriptions of any dangerous
	 * changes in the newSchema related to adding values to an enum type.
	 */
	function findValuesAddedToEnums(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	
	  var valuesAddedToEnums = [];
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLEnumType) || !(newType instanceof _definition.GraphQLEnumType)) {
	      return;
	    }
	
	    var valuesInOldEnum = Object.create(null);
	    oldType.getValues().forEach(function (value) {
	      valuesInOldEnum[value.name] = true;
	    });
	    newType.getValues().forEach(function (value) {
	      if (!valuesInOldEnum[value.name]) {
	        valuesAddedToEnums.push({
	          type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
	          description: value.name + ' was added to enum type ' + typeName + '.'
	        });
	      }
	    });
	  });
	  return valuesAddedToEnums;
	}
	
	function findInterfacesRemovedFromObjectTypes(oldSchema, newSchema) {
	  var oldTypeMap = oldSchema.getTypeMap();
	  var newTypeMap = newSchema.getTypeMap();
	  var breakingChanges = [];
	
	  Object.keys(oldTypeMap).forEach(function (typeName) {
	    var oldType = oldTypeMap[typeName];
	    var newType = newTypeMap[typeName];
	    if (!(oldType instanceof _definition.GraphQLObjectType) || !(newType instanceof _definition.GraphQLObjectType)) {
	      return;
	    }
	
	    var oldInterfaces = oldType.getInterfaces();
	    var newInterfaces = newType.getInterfaces();
	    oldInterfaces.forEach(function (oldInterface) {
	      if (!newInterfaces.some(function (int) {
	        return int.name === oldInterface.name;
	      })) {
	        breakingChanges.push({
	          type: BreakingChangeType.INTERFACE_REMOVED_FROM_OBJECT,
	          description: typeName + ' no longer implements interface ' + (oldInterface.name + '.')
	        });
	      }
	    });
	  });
	  return breakingChanges;
	}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findDeprecatedUsages = findDeprecatedUsages;
	
	var _GraphQLError = __webpack_require__(43);
	
	var _visitor = __webpack_require__(67);
	
	var _definition = __webpack_require__(6);
	
	var _schema = __webpack_require__(28);
	
	var _TypeInfo = __webpack_require__(106);
	
	/**
	 * A validation rule which reports deprecated usages.
	 *
	 * Returns a list of GraphQLError instances describing each deprecated use.
	 */
	function findDeprecatedUsages(schema, ast) {
	  var errors = [];
	  var typeInfo = new _TypeInfo.TypeInfo(schema);
	
	  (0, _visitor.visit)(ast, (0, _visitor.visitWithTypeInfo)(typeInfo, {
	    Field: function Field(node) {
	      var fieldDef = typeInfo.getFieldDef();
	      if (fieldDef && fieldDef.isDeprecated) {
	        var parentType = typeInfo.getParentType();
	        if (parentType) {
	          var reason = fieldDef.deprecationReason;
	          errors.push(new _GraphQLError.GraphQLError('The field ' + parentType.name + '.' + fieldDef.name + ' is deprecated.' + (reason ? ' ' + reason : ''), [node]));
	        }
	      }
	    },
	    EnumValue: function EnumValue(node) {
	      var enumVal = typeInfo.getEnumValue();
	      if (enumVal && enumVal.isDeprecated) {
	        var type = (0, _definition.getNamedType)(typeInfo.getInputType());
	        if (type) {
	          var reason = enumVal.deprecationReason;
	          errors.push(new _GraphQLError.GraphQLError('The enum value ' + type.name + '.' + enumVal.name + ' is deprecated.' + (reason ? ' ' + reason : ''), [node]));
	        }
	      }
	    }
	  }));
	
	  return errors;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOperationAST = getOperationAST;
	
	var _kinds = __webpack_require__(11);
	
	/**
	 * Returns an operation AST given a document AST and optionally an operation
	 * name. If a name is not provided, an operation is only returned if only one is
	 * provided in the document.
	 */
	function getOperationAST(documentAST, operationName) {
	  var operation = null;
	  for (var i = 0; i < documentAST.definitions.length; i++) {
	    var definition = documentAST.definitions[i];
	    if (definition.kind === _kinds.OPERATION_DEFINITION) {
	      if (!operationName) {
	        // If no operation name was provided, only return an Operation if there
	        // is one defined in the document. Upon encountering the second, return
	        // null.
	        if (operation) {
	          return null;
	        }
	        operation = definition;
	      } else if (definition.name && definition.name.value === operationName) {
	        return definition;
	      }
	    }
	  }
	  return operation;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _introspectionQuery = __webpack_require__(473);
	
	Object.defineProperty(exports, 'introspectionQuery', {
	  enumerable: true,
	  get: function get() {
	    return _introspectionQuery.introspectionQuery;
	  }
	});
	
	var _getOperationAST = __webpack_require__(471);
	
	Object.defineProperty(exports, 'getOperationAST', {
	  enumerable: true,
	  get: function get() {
	    return _getOperationAST.getOperationAST;
	  }
	});
	
	var _buildClientSchema = __webpack_require__(466);
	
	Object.defineProperty(exports, 'buildClientSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildClientSchema.buildClientSchema;
	  }
	});
	
	var _buildASTSchema = __webpack_require__(187);
	
	Object.defineProperty(exports, 'buildASTSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildASTSchema;
	  }
	});
	Object.defineProperty(exports, 'buildSchema', {
	  enumerable: true,
	  get: function get() {
	    return _buildASTSchema.buildSchema;
	  }
	});
	
	var _extendSchema = __webpack_require__(468);
	
	Object.defineProperty(exports, 'extendSchema', {
	  enumerable: true,
	  get: function get() {
	    return _extendSchema.extendSchema;
	  }
	});
	
	var _schemaPrinter = __webpack_require__(474);
	
	Object.defineProperty(exports, 'printSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printSchema;
	  }
	});
	Object.defineProperty(exports, 'printType', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printType;
	  }
	});
	Object.defineProperty(exports, 'printIntrospectionSchema', {
	  enumerable: true,
	  get: function get() {
	    return _schemaPrinter.printIntrospectionSchema;
	  }
	});
	
	var _typeFromAST = __webpack_require__(29);
	
	Object.defineProperty(exports, 'typeFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _typeFromAST.typeFromAST;
	  }
	});
	
	var _valueFromAST = __webpack_require__(68);
	
	Object.defineProperty(exports, 'valueFromAST', {
	  enumerable: true,
	  get: function get() {
	    return _valueFromAST.valueFromAST;
	  }
	});
	
	var _astFromValue = __webpack_require__(108);
	
	Object.defineProperty(exports, 'astFromValue', {
	  enumerable: true,
	  get: function get() {
	    return _astFromValue.astFromValue;
	  }
	});
	
	var _TypeInfo = __webpack_require__(106);
	
	Object.defineProperty(exports, 'TypeInfo', {
	  enumerable: true,
	  get: function get() {
	    return _TypeInfo.TypeInfo;
	  }
	});
	
	var _isValidJSValue = __webpack_require__(188);
	
	Object.defineProperty(exports, 'isValidJSValue', {
	  enumerable: true,
	  get: function get() {
	    return _isValidJSValue.isValidJSValue;
	  }
	});
	
	var _isValidLiteralValue = __webpack_require__(92);
	
	Object.defineProperty(exports, 'isValidLiteralValue', {
	  enumerable: true,
	  get: function get() {
	    return _isValidLiteralValue.isValidLiteralValue;
	  }
	});
	
	var _concatAST = __webpack_require__(467);
	
	Object.defineProperty(exports, 'concatAST', {
	  enumerable: true,
	  get: function get() {
	    return _concatAST.concatAST;
	  }
	});
	
	var _separateOperations = __webpack_require__(475);
	
	Object.defineProperty(exports, 'separateOperations', {
	  enumerable: true,
	  get: function get() {
	    return _separateOperations.separateOperations;
	  }
	});
	
	var _typeComparators = __webpack_require__(93);
	
	Object.defineProperty(exports, 'isEqualType', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isEqualType;
	  }
	});
	Object.defineProperty(exports, 'isTypeSubTypeOf', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.isTypeSubTypeOf;
	  }
	});
	Object.defineProperty(exports, 'doTypesOverlap', {
	  enumerable: true,
	  get: function get() {
	    return _typeComparators.doTypesOverlap;
	  }
	});
	
	var _assertValidName = __webpack_require__(107);
	
	Object.defineProperty(exports, 'assertValidName', {
	  enumerable: true,
	  get: function get() {
	    return _assertValidName.assertValidName;
	  }
	});
	
	var _findBreakingChanges = __webpack_require__(469);
	
	Object.defineProperty(exports, 'BreakingChangeType', {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.BreakingChangeType;
	  }
	});
	Object.defineProperty(exports, 'DangerousChangeType', {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.DangerousChangeType;
	  }
	});
	Object.defineProperty(exports, 'findBreakingChanges', {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.findBreakingChanges;
	  }
	});
	Object.defineProperty(exports, 'findDangerousChanges', {
	  enumerable: true,
	  get: function get() {
	    return _findBreakingChanges.findDangerousChanges;
	  }
	});
	
	var _findDeprecatedUsages = __webpack_require__(470);
	
	Object.defineProperty(exports, 'findDeprecatedUsages', {
	  enumerable: true,
	  get: function get() {
	    return _findDeprecatedUsages.findDeprecatedUsages;
	  }
	});

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var introspectionQuery = exports.introspectionQuery = '\n  query IntrospectionQuery {\n    __schema {\n      queryType { name }\n      mutationType { name }\n      subscriptionType { name }\n      types {\n        ...FullType\n      }\n      directives {\n        name\n        description\n        locations\n        args {\n          ...InputValue\n        }\n      }\n    }\n  }\n\n  fragment FullType on __Type {\n    kind\n    name\n    description\n    fields(includeDeprecated: true) {\n      name\n      description\n      args {\n        ...InputValue\n      }\n      type {\n        ...TypeRef\n      }\n      isDeprecated\n      deprecationReason\n    }\n    inputFields {\n      ...InputValue\n    }\n    interfaces {\n      ...TypeRef\n    }\n    enumValues(includeDeprecated: true) {\n      name\n      description\n      isDeprecated\n      deprecationReason\n    }\n    possibleTypes {\n      ...TypeRef\n    }\n  }\n\n  fragment InputValue on __InputValue {\n    name\n    description\n    type { ...TypeRef }\n    defaultValue\n  }\n\n  fragment TypeRef on __Type {\n    kind\n    name\n    ofType {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n'; /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printSchema = printSchema;
	exports.printIntrospectionSchema = printIntrospectionSchema;
	exports.printType = printType;
	
	var _invariant = __webpack_require__(10);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isNullish = __webpack_require__(33);
	
	var _isNullish2 = _interopRequireDefault(_isNullish);
	
	var _isInvalid = __webpack_require__(66);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _astFromValue = __webpack_require__(108);
	
	var _printer = __webpack_require__(24);
	
	var _definition = __webpack_require__(6);
	
	var _scalars = __webpack_require__(32);
	
	var _directives = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function printSchema(schema) {
	  return printFilteredSchema(schema, function (n) {
	    return !isSpecDirective(n);
	  }, isDefinedType);
	}
	
	function printIntrospectionSchema(schema) {
	  return printFilteredSchema(schema, isSpecDirective, isIntrospectionType);
	}
	
	function isSpecDirective(directiveName) {
	  return directiveName === 'skip' || directiveName === 'include' || directiveName === 'deprecated';
	}
	
	function isDefinedType(typename) {
	  return !isIntrospectionType(typename) && !isBuiltInScalar(typename);
	}
	
	function isIntrospectionType(typename) {
	  return typename.indexOf('__') === 0;
	}
	
	function isBuiltInScalar(typename) {
	  return typename === 'String' || typename === 'Boolean' || typename === 'Int' || typename === 'Float' || typename === 'ID';
	}
	
	function printFilteredSchema(schema, directiveFilter, typeFilter) {
	  var directives = schema.getDirectives().filter(function (directive) {
	    return directiveFilter(directive.name);
	  });
	  var typeMap = schema.getTypeMap();
	  var types = Object.keys(typeMap).filter(typeFilter).sort(function (name1, name2) {
	    return name1.localeCompare(name2);
	  }).map(function (typeName) {
	    return typeMap[typeName];
	  });
	
	  return [printSchemaDefinition(schema)].concat(directives.map(printDirective), types.map(printType)).filter(Boolean).join('\n\n') + '\n';
	}
	
	function printSchemaDefinition(schema) {
	  if (isSchemaOfCommonNames(schema)) {
	    return;
	  }
	
	  var operationTypes = [];
	
	  var queryType = schema.getQueryType();
	  if (queryType) {
	    operationTypes.push('  query: ' + queryType.name);
	  }
	
	  var mutationType = schema.getMutationType();
	  if (mutationType) {
	    operationTypes.push('  mutation: ' + mutationType.name);
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	  if (subscriptionType) {
	    operationTypes.push('  subscription: ' + subscriptionType.name);
	  }
	
	  return 'schema {\n' + operationTypes.join('\n') + '\n}';
	}
	
	/**
	 * GraphQL schema define root types for each type of operation. These types are
	 * the same as any other type and can be named in any manner, however there is
	 * a common naming convention:
	 *
	 *   schema {
	 *     query: Query
	 *     mutation: Mutation
	 *   }
	 *
	 * When using this naming convention, the schema description can be omitted.
	 */
	function isSchemaOfCommonNames(schema) {
	  var queryType = schema.getQueryType();
	  if (queryType && queryType.name !== 'Query') {
	    return false;
	  }
	
	  var mutationType = schema.getMutationType();
	  if (mutationType && mutationType.name !== 'Mutation') {
	    return false;
	  }
	
	  var subscriptionType = schema.getSubscriptionType();
	  if (subscriptionType && subscriptionType.name !== 'Subscription') {
	    return false;
	  }
	
	  return true;
	}
	
	function printType(type) {
	  if (type instanceof _definition.GraphQLScalarType) {
	    return printScalar(type);
	  } else if (type instanceof _definition.GraphQLObjectType) {
	    return printObject(type);
	  } else if (type instanceof _definition.GraphQLInterfaceType) {
	    return printInterface(type);
	  } else if (type instanceof _definition.GraphQLUnionType) {
	    return printUnion(type);
	  } else if (type instanceof _definition.GraphQLEnumType) {
	    return printEnum(type);
	  }
	  !(type instanceof _definition.GraphQLInputObjectType) ? (0, _invariant2.default)(0) : void 0;
	  return printInputObject(type);
	}
	
	function printScalar(type) {
	  return printDescription(type) + ('scalar ' + type.name);
	}
	
	function printObject(type) {
	  var interfaces = type.getInterfaces();
	  var implementedInterfaces = interfaces.length ? ' implements ' + interfaces.map(function (i) {
	    return i.name;
	  }).join(', ') : '';
	  return printDescription(type) + ('type ' + type.name + implementedInterfaces + ' {\n') + printFields(type) + '\n' + '}';
	}
	
	function printInterface(type) {
	  return printDescription(type) + ('interface ' + type.name + ' {\n') + printFields(type) + '\n' + '}';
	}
	
	function printUnion(type) {
	  return printDescription(type) + ('union ' + type.name + ' = ' + type.getTypes().join(' | '));
	}
	
	function printEnum(type) {
	  return printDescription(type) + ('enum ' + type.name + ' {\n') + printEnumValues(type.getValues()) + '\n' + '}';
	}
	
	function printEnumValues(values) {
	  return values.map(function (value, i) {
	    return printDescription(value, '  ', !i) + '  ' + value.name + printDeprecated(value);
	  }).join('\n');
	}
	
	function printInputObject(type) {
	  var fieldMap = type.getFields();
	  var fields = Object.keys(fieldMap).map(function (fieldName) {
	    return fieldMap[fieldName];
	  });
	  return printDescription(type) + ('input ' + type.name + ' {\n') + fields.map(function (f, i) {
	    return printDescription(f, '  ', !i) + '  ' + printInputValue(f);
	  }).join('\n') + '\n' + '}';
	}
	
	function printFields(type) {
	  var fieldMap = type.getFields();
	  var fields = Object.keys(fieldMap).map(function (fieldName) {
	    return fieldMap[fieldName];
	  });
	  return fields.map(function (f, i) {
	    return printDescription(f, '  ', !i) + '  ' + f.name + printArgs(f.args, '  ') + ': ' + String(f.type) + printDeprecated(f);
	  }).join('\n');
	}
	
	function printArgs(args) {
	  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  if (args.length === 0) {
	    return '';
	  }
	
	  // If every arg does not have a description, print them on one line.
	  if (args.every(function (arg) {
	    return !arg.description;
	  })) {
	    return '(' + args.map(printInputValue).join(', ') + ')';
	  }
	
	  return '(\n' + args.map(function (arg, i) {
	    return printDescription(arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
	  }).join('\n') + '\n' + indentation + ')';
	}
	
	function printInputValue(arg) {
	  var argDecl = arg.name + ': ' + String(arg.type);
	  if (!(0, _isInvalid2.default)(arg.defaultValue)) {
	    argDecl += ' = ' + (0, _printer.print)((0, _astFromValue.astFromValue)(arg.defaultValue, arg.type));
	  }
	  return argDecl;
	}
	
	function printDirective(directive) {
	  return printDescription(directive) + 'directive @' + directive.name + printArgs(directive.args) + ' on ' + directive.locations.join(' | ');
	}
	
	function printDeprecated(fieldOrEnumVal) {
	  var reason = fieldOrEnumVal.deprecationReason;
	  if ((0, _isNullish2.default)(reason)) {
	    return '';
	  }
	  if (reason === '' || reason === _directives.DEFAULT_DEPRECATION_REASON) {
	    return ' @deprecated';
	  }
	  return ' @deprecated(reason: ' + (0, _printer.print)((0, _astFromValue.astFromValue)(reason, _scalars.GraphQLString)) + ')';
	}
	
	function printDescription(def) {
	  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var firstInBlock = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!def.description) {
	    return '';
	  }
	  var lines = def.description.split('\n');
	  var description = indentation && !firstInBlock ? '\n' : '';
	  for (var i = 0; i < lines.length; i++) {
	    if (lines[i] === '') {
	      description += indentation + '#\n';
	    } else {
	      // For > 120 character long lines, cut at space boundaries into sublines
	      // of ~80 chars.
	      var sublines = breakLine(lines[i], 120 - indentation.length);
	      for (var j = 0; j < sublines.length; j++) {
	        description += indentation + '# ' + sublines[j] + '\n';
	      }
	    }
	  }
	  return description;
	}
	
	function breakLine(line, len) {
	  if (line.length < len + 5) {
	    return [line];
	  }
	  var parts = line.split(new RegExp('((?: |^).{15,' + (len - 40) + '}(?= |$))'));
	  if (parts.length < 4) {
	    return [line];
	  }
	  var sublines = [parts[0] + parts[1] + parts[2]];
	  for (var i = 3; i < parts.length; i += 2) {
	    sublines.push(parts[i].slice(1) + parts[i + 1]);
	  }
	  return sublines;
	}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.separateOperations = separateOperations;
	
	var _visitor = __webpack_require__(67);
	
	/**
	 * separateOperations accepts a single AST document which may contain many
	 * operations and fragments and returns a collection of AST documents each of
	 * which contains a single operation as well the fragment definitions it
	 * refers to.
	 */
	function separateOperations(documentAST) {
	  var operations = [];
	  var fragments = Object.create(null);
	  var positions = new Map();
	  var depGraph = Object.create(null);
	  var fromName = void 0;
	  var idx = 0;
	
	  // Populate metadata and build a dependency graph.
	  (0, _visitor.visit)(documentAST, {
	    OperationDefinition: function OperationDefinition(node) {
	      fromName = opName(node);
	      operations.push(node);
	      positions.set(node, idx++);
	    },
	    FragmentDefinition: function FragmentDefinition(node) {
	      fromName = node.name.value;
	      fragments[fromName] = node;
	      positions.set(node, idx++);
	    },
	    FragmentSpread: function FragmentSpread(node) {
	      var toName = node.name.value;
	      (depGraph[fromName] || (depGraph[fromName] = Object.create(null)))[toName] = true;
	    }
	  });
	
	  // For each operation, produce a new synthesized AST which includes only what
	  // is necessary for completing that operation.
	  var separatedDocumentASTs = Object.create(null);
	  operations.forEach(function (operation) {
	    var operationName = opName(operation);
	    var dependencies = Object.create(null);
	    collectTransitiveDependencies(dependencies, depGraph, operationName);
	
	    // The list of definition nodes to be included for this operation, sorted
	    // to retain the same order as the original document.
	    var definitions = [operation];
	    Object.keys(dependencies).forEach(function (name) {
	      definitions.push(fragments[name]);
	    });
	    definitions.sort(function (n1, n2) {
	      return (positions.get(n1) || 0) - (positions.get(n2) || 0);
	    });
	
	    separatedDocumentASTs[operationName] = {
	      kind: 'Document',
	      definitions: definitions
	    };
	  });
	
	  return separatedDocumentASTs;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	// Provides the empty string for anonymous operations.
	function opName(operation) {
	  return operation.name ? operation.name.value : '';
	}
	
	// From a dependency graph, collects a list of transitive dependencies by
	// recursing through a dependency graph.
	function collectTransitiveDependencies(collected, depGraph, fromName) {
	  var immediateDeps = depGraph[fromName];
	  if (immediateDeps) {
	    Object.keys(immediateDeps).forEach(function (toName) {
	      if (!collected[toName]) {
	        collected[toName] = true;
	        collectTransitiveDependencies(collected, depGraph, toName);
	      }
	    });
	  }
	}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validate = __webpack_require__(216);
	
	Object.defineProperty(exports, 'validate', {
	  enumerable: true,
	  get: function get() {
	    return _validate.validate;
	  }
	});
	Object.defineProperty(exports, 'ValidationContext', {
	  enumerable: true,
	  get: function get() {
	    return _validate.ValidationContext;
	  }
	});
	
	var _specifiedRules = __webpack_require__(215);
	
	Object.defineProperty(exports, 'specifiedRules', {
	  enumerable: true,
	  get: function get() {
	    return _specifiedRules.specifiedRules;
	  }
	});
	
	var _ArgumentsOfCorrectType = __webpack_require__(189);
	
	Object.defineProperty(exports, 'ArgumentsOfCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _ArgumentsOfCorrectType.ArgumentsOfCorrectType;
	  }
	});
	
	var _DefaultValuesOfCorrectType = __webpack_require__(190);
	
	Object.defineProperty(exports, 'DefaultValuesOfCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _DefaultValuesOfCorrectType.DefaultValuesOfCorrectType;
	  }
	});
	
	var _FieldsOnCorrectType = __webpack_require__(191);
	
	Object.defineProperty(exports, 'FieldsOnCorrectTypeRule', {
	  enumerable: true,
	  get: function get() {
	    return _FieldsOnCorrectType.FieldsOnCorrectType;
	  }
	});
	
	var _FragmentsOnCompositeTypes = __webpack_require__(192);
	
	Object.defineProperty(exports, 'FragmentsOnCompositeTypesRule', {
	  enumerable: true,
	  get: function get() {
	    return _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes;
	  }
	});
	
	var _KnownArgumentNames = __webpack_require__(193);
	
	Object.defineProperty(exports, 'KnownArgumentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _KnownArgumentNames.KnownArgumentNames;
	  }
	});
	
	var _KnownDirectives = __webpack_require__(194);
	
	Object.defineProperty(exports, 'KnownDirectivesRule', {
	  enumerable: true,
	  get: function get() {
	    return _KnownDirectives.KnownDirectives;
	  }
	});
	
	var _KnownFragmentNames = __webpack_require__(195);
	
	Object.defineProperty(exports, 'KnownFragmentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _KnownFragmentNames.KnownFragmentNames;
	  }
	});
	
	var _KnownTypeNames = __webpack_require__(196);
	
	Object.defineProperty(exports, 'KnownTypeNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _KnownTypeNames.KnownTypeNames;
	  }
	});
	
	var _LoneAnonymousOperation = __webpack_require__(197);
	
	Object.defineProperty(exports, 'LoneAnonymousOperationRule', {
	  enumerable: true,
	  get: function get() {
	    return _LoneAnonymousOperation.LoneAnonymousOperation;
	  }
	});
	
	var _NoFragmentCycles = __webpack_require__(198);
	
	Object.defineProperty(exports, 'NoFragmentCyclesRule', {
	  enumerable: true,
	  get: function get() {
	    return _NoFragmentCycles.NoFragmentCycles;
	  }
	});
	
	var _NoUndefinedVariables = __webpack_require__(199);
	
	Object.defineProperty(exports, 'NoUndefinedVariablesRule', {
	  enumerable: true,
	  get: function get() {
	    return _NoUndefinedVariables.NoUndefinedVariables;
	  }
	});
	
	var _NoUnusedFragments = __webpack_require__(200);
	
	Object.defineProperty(exports, 'NoUnusedFragmentsRule', {
	  enumerable: true,
	  get: function get() {
	    return _NoUnusedFragments.NoUnusedFragments;
	  }
	});
	
	var _NoUnusedVariables = __webpack_require__(201);
	
	Object.defineProperty(exports, 'NoUnusedVariablesRule', {
	  enumerable: true,
	  get: function get() {
	    return _NoUnusedVariables.NoUnusedVariables;
	  }
	});
	
	var _OverlappingFieldsCanBeMerged = __webpack_require__(202);
	
	Object.defineProperty(exports, 'OverlappingFieldsCanBeMergedRule', {
	  enumerable: true,
	  get: function get() {
	    return _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged;
	  }
	});
	
	var _PossibleFragmentSpreads = __webpack_require__(203);
	
	Object.defineProperty(exports, 'PossibleFragmentSpreadsRule', {
	  enumerable: true,
	  get: function get() {
	    return _PossibleFragmentSpreads.PossibleFragmentSpreads;
	  }
	});
	
	var _ProvidedNonNullArguments = __webpack_require__(204);
	
	Object.defineProperty(exports, 'ProvidedNonNullArgumentsRule', {
	  enumerable: true,
	  get: function get() {
	    return _ProvidedNonNullArguments.ProvidedNonNullArguments;
	  }
	});
	
	var _ScalarLeafs = __webpack_require__(205);
	
	Object.defineProperty(exports, 'ScalarLeafsRule', {
	  enumerable: true,
	  get: function get() {
	    return _ScalarLeafs.ScalarLeafs;
	  }
	});
	
	var _SingleFieldSubscriptions = __webpack_require__(206);
	
	Object.defineProperty(exports, 'SingleFieldSubscriptionsRule', {
	  enumerable: true,
	  get: function get() {
	    return _SingleFieldSubscriptions.SingleFieldSubscriptions;
	  }
	});
	
	var _UniqueArgumentNames = __webpack_require__(207);
	
	Object.defineProperty(exports, 'UniqueArgumentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueArgumentNames.UniqueArgumentNames;
	  }
	});
	
	var _UniqueDirectivesPerLocation = __webpack_require__(208);
	
	Object.defineProperty(exports, 'UniqueDirectivesPerLocationRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation;
	  }
	});
	
	var _UniqueFragmentNames = __webpack_require__(209);
	
	Object.defineProperty(exports, 'UniqueFragmentNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueFragmentNames.UniqueFragmentNames;
	  }
	});
	
	var _UniqueInputFieldNames = __webpack_require__(210);
	
	Object.defineProperty(exports, 'UniqueInputFieldNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueInputFieldNames.UniqueInputFieldNames;
	  }
	});
	
	var _UniqueOperationNames = __webpack_require__(211);
	
	Object.defineProperty(exports, 'UniqueOperationNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueOperationNames.UniqueOperationNames;
	  }
	});
	
	var _UniqueVariableNames = __webpack_require__(212);
	
	Object.defineProperty(exports, 'UniqueVariableNamesRule', {
	  enumerable: true,
	  get: function get() {
	    return _UniqueVariableNames.UniqueVariableNames;
	  }
	});
	
	var _VariablesAreInputTypes = __webpack_require__(213);
	
	Object.defineProperty(exports, 'VariablesAreInputTypesRule', {
	  enumerable: true,
	  get: function get() {
	    return _VariablesAreInputTypes.VariablesAreInputTypes;
	  }
	});
	
	var _VariablesInAllowedPosition = __webpack_require__(214);
	
	Object.defineProperty(exports, 'VariablesInAllowedPositionRule', {
	  enumerable: true,
	  get: function get() {
	    return _VariablesInAllowedPosition.VariablesInAllowedPosition;
	  }
	});

/***/ }),
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(479);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(487);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 481 */,
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(484);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(451);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(483);
	
	var _HelmetConstants = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(481);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(4);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(454));
	var shallowEqual = _interopDefault(__webpack_require__(485));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports) {

	module.exports = {"data":{"siglas03":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAB80lEQVQoz12Sa2sTURCG819FW7/4QX+MIFTF/gtRpNq0IEppDbY0tE2INGmyt7O3c919nLNpLXhgmPu7M/PuaPfgNa++7/N8vMeTgzc8G78dZOfoHbvH70VEiz34/4vknx7usfNtj5fjfV4cf2DUbBQEwG+lt6BLt/XluaajSOoh/u/1UqOs5MK2t9vGvLSNMlXSGIuqG1SlcMHhJBP6QKNbkjxntV5jnCV0fhAXPHepxJMcF4EEcNO2nCZ/GKVZjrGeqm6Jtg+Bru8Jop1xFGVFWVVY52i1xlpLazxWLeiSE0I2QS9/0i7G1KuJTJirAbAWwFoVj2vJJOsqE8CSVil0VRKskRU9vUxULM6pLz7jFj/w6Tl+c4bJrraAVgBTVfNrtmKW1sxFbpKKj9Mbppuci0RxXbbMG8tCB5Zy3+TqGnV6ipvN8eKbKLL/KC9KtDYss4pPv2/5ennH4fSOLxcrjqZrrrKGk0xzlhsmhRnsSWFJb5dk00vy+Uxu35CXNYVombBAiRNXDkbLRpHq/pHQrnuk9iF+rx+qwn2NFXaGlbUcv2kNRaGom1ZGFyYFuBHmYm8kw1g3kBXtCKBFd0JcVheyrkNLnzeGUZwuMhxBI0gvTT50dPdNw5eFWScsD/+l6JjzUhv1qs2xwlKyTlEy3F9VI+2tIRgQiQAAAABJRU5ErkJggg==","aspectRatio":1.9129979035639413,"src":"/static/siglas03-801226a3882ace3cee49732df6632fde-b504d.png","srcSet":"/static/siglas03-801226a3882ace3cee49732df6632fde-8b884.png 400w,\n/static/siglas03-801226a3882ace3cee49732df6632fde-6db78.png 800w,\n/static/siglas03-801226a3882ace3cee49732df6632fde-b504d.png 1600w,\n/static/siglas03-801226a3882ace3cee49732df6632fde-2581e.png 1825w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"site":{"siteMetadata":{"title":"Ewwo Consulting","languages":{"defaultLangKey":"es","langs":["es","en"]}}},"sindicatos02":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGgABAAMAAwAAAAAAAAAAAAAAAAIDBAEFBv/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAGeWqpIMwfUcg9SK//EABsQAAMBAAMBAAAAAAAAAAAAAAECAwAEESEi/9oACAEBAAEFAkWRFPhBTzjug1COujmmhycSQ1VCv//EABURAQEAAAAAAAAAAAAAAAAAACAh/9oACAEDAQE/AaP/xAAVEQEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAgEBPwGD/8QAHBAAAQQDAQAAAAAAAAAAAAAAAgABETEQEiGR/9oACAEBAAY/AtZRNbYky7SgCd5vGugwqf1QLcX/xAAbEAEBAQADAQEAAAAAAAAAAAABEQAhQVExYf/aAAgBAQABPyFgIUc4aw4XBB5hKeCCPePAR9Y8nS0SeiYdaP7j+Qb/2gAMAwEAAgADAAAAEPTgPv/EABcRAAMBAAAAAAAAAAAAAAAAAAABECH/2gAIAQMBAT8QxWf/xAAXEQADAQAAAAAAAAAAAAAAAAAAEBEx/9oACAECAQE/ENFf/8QAHRABAAMAAwADAAAAAAAAAAAAAQARITFhkUGBsf/aAAgBAQABPxCwCq6RANb6uFYRGhR4eIXdgJQEdosG75HiyLDn2h8xJjHUHMBbe9JTBFBTPIcAlAb+z//Z","aspectRatio":1,"src":"/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-381d6.jpg","srcSet":"/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-62f05.jpg 200w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-dc2b4.jpg 400w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-381d6.jpg 800w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-e5d70.jpg 1200w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-d14e0.jpg 1600w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-9e67f.jpg 2400w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-4cd78.jpg 3648w","srcWebp":"/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-fefde.webp","srcSetWebp":"/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-5eed2.webp 200w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-68e3c.webp 400w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-fefde.webp 800w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-300fe.webp 1200w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-ed5bd.webp 1600w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-b51d3.webp 2400w,\n/static/02sindicatos-a8adfa623bd46b952f13bea786aa1867-51e50.webp 3648w","sizes":"(max-width: 800px) 100vw, 800px"}}},"outsourcing03":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABzq4w2tbx5RKDf//EABsQAAICAwEAAAAAAAAAAAAAAAABAhEDEjEz/9oACAEBAAEFAtXkm8dGjY50bouA+y9Jd//EABgRAAIDAAAAAAAAAAAAAAAAAAACEBFB/9oACAEDAQE/AdKGj//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEh/9oACAECAQE/AdLFH//EABoQAAIDAQEAAAAAAAAAAAAAAAERAAIQITH/2gAIAQEABj8CJjjrbmMmerFn/8QAHRABAAICAgMAAAAAAAAAAAAAAQARIVExQWFxgf/aAAgBAQABPyG0CFVHyVBFjTHF8BC4wCFWH4DO3cXouYR//9oADAMBAAIAAwAAABD418D/xAAYEQEAAwEAAAAAAAAAAAAAAAABABAxEf/aAAgBAwEBPxAc1HMhP//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxAU3//EAB4QAQEAAgICAwAAAAAAAAAAAAERACExQVFhgZGh/9oACAEBAAE/ELABRac+A/MbBvcdecWqiSNPVDDja4IbbveJ7vgcuM0T0j6cMY5G/lMskEoCesOosnFc/9k=","aspectRatio":1,"src":"/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-381d6.jpg","srcSet":"/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-62f05.jpg 200w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-dc2b4.jpg 400w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-381d6.jpg 800w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-e5d70.jpg 1200w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-d14e0.jpg 1600w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-9e67f.jpg 2400w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-0c8ca.jpg 4000w","srcWebp":"/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-fefde.webp","srcSetWebp":"/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-5eed2.webp 200w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-68e3c.webp 400w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-fefde.webp 800w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-300fe.webp 1200w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-ed5bd.webp 1600w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-b51d3.webp 2400w,\n/static/03outsourcing-e1065ecab50685e726b79b58aebb943d-d8e0f.webp 4000w","sizes":"(max-width: 800px) 100vw, 800px"}}},"bg":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAeU+d0grF//EABkQAAMAAwAAAAAAAAAAAAAAAAABAhESMf/aAAgBAQABBQKWZk2Yh8P/xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8BgX//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAVEAEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAQAGPwKr/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEhEBExUWH/2gAIAQEAAT8hvOMDRs5GQ7o//9oADAMBAAIAAwAAABBIz//EABcRAAMBAAAAAAAAAAAAAAAAAAABITH/2gAIAQMBAT8QbtIf/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EKV//8QAGBABAQEBAQAAAAAAAAAAAAAAAREAMWH/2gAIAQEAAT8QWYCOhzEUpnAy7YPDNgrNMb5lb3f/2Q==","aspectRatio":1.8299475753604193,"src":"/static/bg-1f205f122764de63a24160b7f86ccc60-381d6.jpg","srcSet":"/static/bg-1f205f122764de63a24160b7f86ccc60-62f05.jpg 200w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-dc2b4.jpg 400w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-381d6.jpg 800w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-e5d70.jpg 1200w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-d14e0.jpg 1600w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-9e67f.jpg 2400w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-66310.jpg 5585w","srcWebp":"/static/bg-1f205f122764de63a24160b7f86ccc60-fefde.webp","srcSetWebp":"/static/bg-1f205f122764de63a24160b7f86ccc60-5eed2.webp 200w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-68e3c.webp 400w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-fefde.webp 800w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-300fe.webp 1200w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-ed5bd.webp 1600w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-b51d3.webp 2400w,\n/static/bg-1f205f122764de63a24160b7f86ccc60-71a03.webp 5585w","sizes":"(max-width: 800px) 100vw, 800px"}}},"about":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAABy5Y+HFEH/8QAHRAAAQIHAAAAAAAAAAAAAAAAAQIRAAMEEBITFP/aAAgBAQABBQIWp1BKGGPMW1zBH//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEv/aAAgBAgEBPwGj/8QAHBAAAQMFAAAAAAAAAAAAAAAAAAEQERIxMlGh/9oACAEBAAY/AmWdl1qM+N//xAAcEAEAAgEFAAAAAAAAAAAAAAABABEhEEFhkfD/2gAIAQEAAT8h0CHipeK4qYmSgULh2HTP/9oADAMBAAIAAwAAABDPD//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxAkx//EABYRAQEBAAAAAAAAAAAAAAAAAAERAP/aAAgBAgEBPxCMtbv/xAAaEAEBAAMBAQAAAAAAAAAAAAABEQAhMUGh/9oACAEBAAE/ED3PceoG3l8YF720kF20yq6sMDrluJxZd6Y/c//Z","aspectRatio":1.3333333333333333,"src":"/static/about-3eb63b7e3666dd66228e081d2848fa4b-381d6.jpg","srcSet":"/static/about-3eb63b7e3666dd66228e081d2848fa4b-62f05.jpg 200w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-dc2b4.jpg 400w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-381d6.jpg 800w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-e5d70.jpg 1200w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-d14e0.jpg 1600w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-9e67f.jpg 2400w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-0c8ca.jpg 4000w","srcWebp":"/static/about-3eb63b7e3666dd66228e081d2848fa4b-fefde.webp","srcSetWebp":"/static/about-3eb63b7e3666dd66228e081d2848fa4b-5eed2.webp 200w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-68e3c.webp 400w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-fefde.webp 800w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-300fe.webp 1200w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-ed5bd.webp 1600w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-b51d3.webp 2400w,\n/static/about-3eb63b7e3666dd66228e081d2848fa4b-d8e0f.webp 4000w","sizes":"(max-width: 800px) 100vw, 800px"}}},"outsourcing":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABQADBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAA//aAAwDAQACEAMQAAABzcBWxfRHwv/EABoQAQACAwEAAAAAAAAAAAAAAAEAAwIEERP/2gAIAQEAAQUC106WdPQlGI2MQn//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwFH/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAIBERP/2gAIAQIBAT8BZqNJP//EABkQAAIDAQAAAAAAAAAAAAAAAAABECExgf/aAAgBAQAGPwJp8mzDD//EABsQAAMAAgMAAAAAAAAAAAAAAAABESExcbHR/9oACAEBAAE/IZQy4+QpLJb7HBJYqQ1oV+z/2gAMAwEAAgADAAAAEHvP/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIVH/2gAIAQMBAT8QWqMjh//EABgRAAIDAAAAAAAAAAAAAAAAAAARIWGh/9oACAECAQE/EH4LsP/EABoQAQEBAQADAAAAAAAAAAAAAAERACFBUWH/2gAIAQEAAT8QM2bEQgueBHyLMsgL8GlazdnaZlsgzajp7b//2Q==","aspectRatio":1.49800796812749,"src":"/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-381d6.jpg","srcSet":"/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-62f05.jpg 200w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-dc2b4.jpg 400w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-381d6.jpg 800w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-e5d70.jpg 1200w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-d14e0.jpg 1600w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-9e67f.jpg 2400w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-c07a8.jpg 6016w","srcWebp":"/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-fefde.webp","srcSetWebp":"/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-5eed2.webp 200w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-68e3c.webp 400w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-fefde.webp 800w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-300fe.webp 1200w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-ed5bd.webp 1600w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-b51d3.webp 2400w,\n/static/outsourcing-611c45baaa33c63e6cb3e173c7b4d123-01d45.webp 6016w","sizes":"(max-width: 800px) 100vw, 800px"}}},"siglas01":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABxElEQVQoz41QTW/TQBD1P+WEIESIQw9c+RUgFVL1A1DvcOAAoq1I0sKllVoRReqFpJDUir1re7+8Xj9mNqZUPXVWT5qPnTdvJnl8+Aob3/fQGw7w4MtLPDzaRG+0RfEW+uNtPPo2iOgfb+PJuAP7w9fojwboUfyU8PzkPZ4d7yIpUwm2rynwYmLQ5gqwlAgxjbf7n7H37hPlKOHx34ZvgIsDBP7bdrkGSFaygHUOl1LjB5GLqoKuHSpjoazF2c8pTs8nsL6OsbIGpgkwyylE+gsLKXAtMkirIYwmwkxAmZqmtLhaVdjYP8F1mqMJLWpqLHOB9OoPPMVCCMxmMxRFwWKgXIP5aoFlmSFzJXKjkGS5hDYODTX/lgabBxMIWRJhiJClwnIlqN7AE4wx8N7TfFLJW9BGLfXy2t6HNaGxNUplkRMRf9JdrGgQD6v02o8x1Xgj9gtlUFaaoIhjXU9yUUBxA0HTdEN3igroSbqr9w0CrRtIbehU//MDnam9BVd7Viggi4rYbUyy8We28eiS7qaj395pvgu2mobf3NDVTbwTF/mebB8/nGE+z7oh9yRkdXwH63xUdptwd2eM6XRxo/o+hH8BPlbvEZSjleUAAAAASUVORK5CYII=","aspectRatio":1.9129979035639413,"src":"/static/siglas01-f125024665337249f52d4d76418d6a21-b504d.png","srcSet":"/static/siglas01-f125024665337249f52d4d76418d6a21-8b884.png 400w,\n/static/siglas01-f125024665337249f52d4d76418d6a21-6db78.png 800w,\n/static/siglas01-f125024665337249f52d4d76418d6a21-b504d.png 1600w,\n/static/siglas01-f125024665337249f52d4d76418d6a21-2581e.png 1825w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"siglas02":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAd0lEQVQoz+WPzQqAIBCEff/3qjeoW4cuEkXkoVDC3ckiRETp79gHg8suDjMCCZj50I4xBn0/QGsNSxTckUQgA/sfDLsagGy0f2AYJuzUgnacD8lp9vuc8aVhLRWKZkDpVLk5vt+unEvxuTK5l+hUUPdVwjf80HADrfwZ3qlx94EAAAAASUVORK5CYII=","aspectRatio":1.928721174004193,"src":"/static/siglas02-56378aefce8a39c26804d05970534f76-b504d.png","srcSet":"/static/siglas02-56378aefce8a39c26804d05970534f76-8b884.png 400w,\n/static/siglas02-56378aefce8a39c26804d05970534f76-6db78.png 800w,\n/static/siglas02-56378aefce8a39c26804d05970534f76-b504d.png 1600w,\n/static/siglas02-56378aefce8a39c26804d05970534f76-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"consulting01":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAUE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwEC/9oADAMBAAIQAxAAAAFRj7pJSqwmaYIVUEv/xAAaEAACAwEBAAAAAAAAAAAAAAABAgMSEyME/9oACAEBAAEFAprvNG9lltpAO2nQ0JcBfErsHVdF/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPwExX//EABYRAAMAAAAAAAAAAAAAAAAAAAAQIf/aAAgBAgEBPwEr/8QAHhAAAgICAgMAAAAAAAAAAAAAAAECIRESMUFRYZH/2gAIAQEABj8Cejz6I557GbOS1uzWLTsvPwpcSE0KTbWfB//EABsQAQADAQEBAQAAAAAAAAAAAAEAESExYXEQ/9oACAEBAAE/IbElc8S63qp9TMLQ5OiFTXH2FxY8V8/EFRAi6FI5DVAcwT//2gAMAwEAAgADAAAAENzvfv/EABgRAAMBAQAAAAAAAAAAAAAAAAABETFB/9oACAEDAQE/EINjtOoWH//EABgRAAMBAQAAAAAAAAAAAAAAAAABQREx/9oACAECAQE/EGzUhB9P/8QAHBABAAMBAQEBAQAAAAAAAAAAAQARITFBYVGB/9oACAEBAAE/EFsQ7cHyMyAK+B2GgPUuZBLRkwKM1XfIQJAEalL39z3sakJMPiAqQU1ra9f7KVbqq6liwy9FZh5yf//Z","aspectRatio":1,"src":"/static/01consulting-efd01c402da539b227dfca9e847d771c-381d6.jpg","srcSet":"/static/01consulting-efd01c402da539b227dfca9e847d771c-62f05.jpg 200w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-dc2b4.jpg 400w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-381d6.jpg 800w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-e5d70.jpg 1200w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-d14e0.jpg 1600w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-29a19.jpg 1843w","srcWebp":"/static/01consulting-efd01c402da539b227dfca9e847d771c-fefde.webp","srcSetWebp":"/static/01consulting-efd01c402da539b227dfca9e847d771c-5eed2.webp 200w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-68e3c.webp 400w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-fefde.webp 800w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-300fe.webp 1200w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-ed5bd.webp 1600w,\n/static/01consulting-efd01c402da539b227dfca9e847d771c-cdf72.webp 1843w","sizes":"(max-width: 800px) 100vw, 800px"}}},"siglas04":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABG0lEQVQoz6WS6XKDMAyEef+n7JEGgw8Z33iSbBanPztNpvXMNwJZrLXIUzERuAJoQPUZPTb0wJfG5H57mUu9IIcdkwsBee+wIeJjWfC5KEaFdzXDxggpGS6ngfzAyLNGx4Q3I5is89j7BRsTp3nGWakHFDXOwYjAev8rjhx1s3GYtLYopcGHBMXn1cqIi7GYV8PCDZH7qe5PCbnSsnjU1uFp77SeMVs1UHaBCQ4uysC+gNnkIZjZgbDDr9WOtrUEihTE2hGOk58QieSGk0u0TIFAMU8BLYkWE7SLI1pO/VUM0ZKPDjeU2uh/x8oT9PfGIf4XpkVrWOs45QK3FVr/H9O2BXiSM/8ZB5NSwvXGy8p1Y3zGsXrv49tSCu56Mv+d1078CwAAAABJRU5ErkJggg==","aspectRatio":1.928721174004193,"src":"/static/siglas04-7907a450b14ccdf04fef5148bb20bbd7-b504d.png","srcSet":"/static/siglas04-7907a450b14ccdf04fef5148bb20bbd7-8b884.png 400w,\n/static/siglas04-7907a450b14ccdf04fef5148bb20bbd7-6db78.png 800w,\n/static/siglas04-7907a450b14ccdf04fef5148bb20bbd7-b504d.png 1600w,\n/static/siglas04-7907a450b14ccdf04fef5148bb20bbd7-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"boleta01":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABWUlEQVQoz41STU8CMRDlr3vaIBsP/gPjyZteVeLFiHhAEyN4UDTCASJsti371e32MVPsAhKMk7y86Xbm5XV2GlprMMqyRFEUyPPc5QxjjGOlFLIs20CONEuR5Rl8v0cDG8FiURQ5Ec69QFVV+G80rLVgcJSlhhACcRw7txU5NCTOglzD7MSpPNMpetMeZCFdr9fZEuRiJSVkkkJTH6MwFbFFSSUJPTUvjctT4vliDm30tqA/1IJqgTyaoZqNYcU3QE1QhEVETJAzIJ46WLM247meof/AcXLaRdC8RHjURiu8RkgIwhsErTaah1cIDi5wfny27tt45Y5Dnt3TUOK2L3A3kDU6Az4LdF7pjs6PHwnsz2x3HP5+MizPhf+s+RO8CX4D9j6Z+XmocE8OH8hRl8B552XFPu9/JrQVZr/D1SisW+bRROJtJDAcS7w7+HzFfPc1UfU6+V6OJQh7/6q3Fm/OAAAAAElFTkSuQmCC","aspectRatio":1.9129979035639413,"src":"/static/boleta01-7a6ff568c8158ff21f572a4c24586218-b504d.png","srcSet":"/static/boleta01-7a6ff568c8158ff21f572a4c24586218-8b884.png 400w,\n/static/boleta01-7a6ff568c8158ff21f572a4c24586218-6db78.png 800w,\n/static/boleta01-7a6ff568c8158ff21f572a4c24586218-b504d.png 1600w,\n/static/boleta01-7a6ff568c8158ff21f572a4c24586218-2581e.png 1825w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"boleta02":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABQUlEQVQoz32ST0+EMBDF+f5fx8STHo2JIV5MjInuScm6wELpHygt5TlT0rUcdpu8QKfTX990WjjnwPLeY55njOMY//O4MQZSSlhro6ZpiuL8PJdVIBuc0Pc9QghY1zUqHyl+mcecXQqKfCOfVjcNtNYXd+yE513XoaoqDMOAZVkinJCkDZo4O+BKSbPR8ZvcsGul1LbOudHZ5uZwslDT8r/GwDThIWePsjX47iUM3dkwyHh37EoSVA4CTtdE9FjWgPL3DedRIGfsgJbcHDuBniAjNcJkUlS2lgLq5xVKNDDaoO2OcMFdB/LdTLSZy8w7msq2ll6BXSAox9UNPl8eoIO9DkxPhAFJDOUGpTgfKEm+afHxfA8VpttA7mgOZIcJGB0m4KnB+9MdAcfbJfPDZgDD8i/H0wER2J7xVT5SyXuHf4VvDO+vQFbtAAAAAElFTkSuQmCC","aspectRatio":1.9129979035639413,"src":"/static/boleta02-d9ab4890c2a56528f067b3a887f3a503-b504d.png","srcSet":"/static/boleta02-d9ab4890c2a56528f067b3a887f3a503-8b884.png 400w,\n/static/boleta02-d9ab4890c2a56528f067b3a887f3a503-6db78.png 800w,\n/static/boleta02-d9ab4890c2a56528f067b3a887f3a503-b504d.png 1600w,\n/static/boleta02-d9ab4890c2a56528f067b3a887f3a503-2581e.png 1825w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"boleta03":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABV0lEQVQoz62Rb0/CMBDG9/2/iUJEojGMCIq8gBf+4yUGZCAMt9FuYxsd3djjdYCMBI0vvOSXu2t7T69XDQXL0gSxx7H2XZXhr1Y8qWVZBoUyK1rjrD9H+e0TpYGNthVCn/qojl1UDY7ah4eH+RIViq9oTXlHyK3oTudIkNGmbizQmDDUyHdmLtqmhxaJ3JlLdKwAT06IJsVqrWn6cOPkWHCfKHNWEpcDC9fvDirkm2MH9QlHnbpU3TVmProkqk893FKsPCsI5k8uJkyscTO0oI/svLjHBbp2iHtz26ESe3TCb0F1Ef9N0KYOSwMn53zI0CKRquGiPOK4INTMTn5Klp3+lECmeF5EeCFUJ31PoMeifG6KV4rlJsOGzqebLfv6oxn+p2lJkqDIWiaQUnkJIWKshNgR58TxgYhmrkjTQ70WhiF+IgiCkzDGwIm5vYBhc4hVhGBX8wXFrPuPxIBTZQAAAABJRU5ErkJggg==","aspectRatio":1.928721174004193,"src":"/static/boleta03-f05f8167f4d34d1bf1f3340eef9d486c-b504d.png","srcSet":"/static/boleta03-f05f8167f4d34d1bf1f3340eef9d486c-8b884.png 400w,\n/static/boleta03-f05f8167f4d34d1bf1f3340eef9d486c-6db78.png 800w,\n/static/boleta03-f05f8167f4d34d1bf1f3340eef9d486c-b504d.png 1600w,\n/static/boleta03-f05f8167f4d34d1bf1f3340eef9d486c-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"boleta04":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABRElEQVQoz32RTXKDMAyFuf+Zsko7k10P0BUEEloCCf7HNvAqO3ED01AxbyRh60MSGRbmhgHfeYG2LMnnMLcbbN/DMgbHObyQ8MZhUga8v+AjP0AYFmtneoJl80zhfE88AfuiACOp0wmCwPx4hKgqyPoL8lxBfB7AqwKm7YBeUdEUUYmzAjrvIbWOGumdnyYYa2M8OAfrLAZ2hjYKShscWQXt9b3DBExJ7NA7SCFgjMFEsJE+oAN8HDFQ957yie5ZggvGsct3aHSDJWMNpItSyieQQCn+BQY4dS24wFv5jk53/wDDyA9gsAAMHa6AFMdJCLgv92h1uwYud5g6umuIeQCE8+Sd86hvGtZ6XOQV1tu/O1xaOgiALXPjvHmWhTG2FMZ8JfvwkqZQcZJnTRZ2tiVBf/yVuq7DlVQ3LfLmCqMVxKPmB3bjC3hoiK+wAAAAAElFTkSuQmCC","aspectRatio":1.928721174004193,"src":"/static/boleta04-553336d3fc0008068c9ad7169647c69b-b504d.png","srcSet":"/static/boleta04-553336d3fc0008068c9ad7169647c69b-8b884.png 400w,\n/static/boleta04-553336d3fc0008068c9ad7169647c69b-6db78.png 800w,\n/static/boleta04-553336d3fc0008068c9ad7169647c69b-b504d.png 1600w,\n/static/boleta04-553336d3fc0008068c9ad7169647c69b-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"aportes01":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAxUlEQVQoz61SQQ7CIBDkDb7Qkzdf4sHEN/gPTY/Giwc9eDLGM420mNYCY4G2WahtNLrJBHYHZndZGIgZY1CWJYqigFIVnjAQDaeU6qC1drB7e4caswEKL+zJ7eqE6WyN427j/Nv1gjyXXfJ2pWChUENo7yfzBMvJAuf9wflpencdxELUZ0PZrNWNoXoov69bpE/zTtC1PFZ+J1CLxdyoIA3EQ3LxPtU7NziUX8HwZ/uqwvb/xQgqlFLiUwghwDkPkGVZcOYFJo4RhEGQcp4AAAAASUVORK5CYII=","aspectRatio":1.928721174004193,"src":"/static/aportes01-217adb868009923f4abef54b66914e56-b504d.png","srcSet":"/static/aportes01-217adb868009923f4abef54b66914e56-8b884.png 400w,\n/static/aportes01-217adb868009923f4abef54b66914e56-6db78.png 800w,\n/static/aportes01-217adb868009923f4abef54b66914e56-b504d.png 1600w,\n/static/aportes01-217adb868009923f4abef54b66914e56-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"aportes02":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABXElEQVQoz42RW0/CQBCF+b+aiIrGKPGBqA++GRMv8f+goAQ0XnjRQukNKAVaEbrt7nF2paQFY5zky57Z3TmdzuaQijhi8L0uePhJWQQSgGCk2U8uEYmO56tIWyAnhIBERhgz6MMudM+G5lqwRw4M0q2BpeiQlnv6qA/Td2GM+wgjpmoTH2XI54aaP8Nu1cRRw8HevYXrpqt0sWbjoGbh+NHBFe3tVA2U6jYKFQNaEKpanhgmiYx3Mty4baP4YCBP6/mLo/TWnY5NQuqzZwfr5Tb2Sa+VW6om7ZEx/KDDQqWDw5qp1su3HnViqmJJqW7h4rWL7YqOk4aFPH1E+8tQHspOTp9sZXjT7MFnMQazSDEMI4zDGO40gke5SzAuFjNceZRpzFWXOs1F/orzxfCfSDwWM8TK46cvL4Esy5FLu3NqP+Z8ASey5/xXMh1OJhP8F9/34XlehiAIMne+AY0P8seI4Z7xAAAAAElFTkSuQmCC","aspectRatio":1.928721174004193,"src":"/static/aportes02-9eabc934444cfb8b9ae81801c2319818-b504d.png","srcSet":"/static/aportes02-9eabc934444cfb8b9ae81801c2319818-8b884.png 400w,\n/static/aportes02-9eabc934444cfb8b9ae81801c2319818-6db78.png 800w,\n/static/aportes02-9eabc934444cfb8b9ae81801c2319818-b504d.png 1600w,\n/static/aportes02-9eabc934444cfb8b9ae81801c2319818-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"aportes03":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6ElEQVQoz62Q22rDMAyG/f4POMZ2MwZr0yS4wY6dSD78VZJmcdguPJjgQz5In4UVigiB0XcN7rpHioycWDKt+ZscpDJurOtcKqByzlhYIidC9F8ANWB/BbkLYujBU4NZ1iQ5zDdE6pB4Y3lk7X16TsKUEt4+O7x8tBg9wVqDy+s7nB5E4kH3VqQeMSYY5zERHcPswn2zC/thRKstiFggDNcbZjPKXRTpJLKAKHVmmuGJN1Hh+CE0o4ceLDgEVEc+/lE9T1CKj7pcRdmraptqUfjn+NOEyx//xmlC5xxqMcZAa33CWnuqeQCJWxNdBy0bgwAAAABJRU5ErkJggg==","aspectRatio":1.928721174004193,"src":"/static/aportes03-17e2571acf3f6a7863a99a69fa0b4a32-b504d.png","srcSet":"/static/aportes03-17e2571acf3f6a7863a99a69fa0b4a32-8b884.png 400w,\n/static/aportes03-17e2571acf3f6a7863a99a69fa0b4a32-6db78.png 800w,\n/static/aportes03-17e2571acf3f6a7863a99a69fa0b4a32-b504d.png 1600w,\n/static/aportes03-17e2571acf3f6a7863a99a69fa0b4a32-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}},"aportes04":{"childImageSharp":{"sizes":{"base64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABAElEQVQoz41R7W6DMAzs+79aVW2vMO3HNEIgXxBIArfYwGTWdavRKbFlzufLBSJyzuj7HnGa8DBmw4eKCi/NDSEFztf6UVzWtV7XLUkpwRhbYfgukXOBNxr+/YYxWExTRgiJmHBwEO4Im6aB1prVSixLge462BC5Vw8R149+0yZILyx3J6Qf27aFtbYSLCdQD9W9d9xrYsKr2tZdhKg7QqUU+0g1IiqlMCinunMbYTfOuH66fwjryl1dizyMMfKAg5jOcRwZA/k3J7y5uK8sCKWhEocqCR5a68pNKDSE7NjrJw+fjYP0r3io8Df8fCj5YN8Kh2HAs6AHIY8lvPenni9yLxE9N+w4vAAAAABJRU5ErkJggg==","aspectRatio":1.928721174004193,"src":"/static/aportes04-b69d4eb5399557da37661846466d911f-b504d.png","srcSet":"/static/aportes04-b69d4eb5399557da37661846466d911f-8b884.png 400w,\n/static/aportes04-b69d4eb5399557da37661846466d911f-6db78.png 800w,\n/static/aportes04-b69d4eb5399557da37661846466d911f-b504d.png 1600w,\n/static/aportes04-b69d4eb5399557da37661846466d911f-c4e01.png 1840w","sizes":"(max-width: 1600px) 100vw, 1600px"}}}},"layoutContext":{}}

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _es = __webpack_require__(598);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _layoutEs = __webpack_require__(533);
	
	var _layoutEs2 = _interopRequireDefault(_layoutEs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_es2.default, _extends({}, props, _layoutEs2.default));
	};
	
	module.exports = exports["default"];

/***/ }),
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  selectLanguage: "Cambiar lenguaje",
	  aboutp1: "Ewwo Consulting es una empresa especializada en proveer soluciones integrales en el desarrollo, implementación y mantenimiento de sistemas para entidades tales como Obras Sociales y Sindicatos.",
	  aboutp2: "Nuestro equipo ha llevado a cabo un elevado número de proyectos de naturalezas y complejidades diversas, siempre logrando altísimos niveles de satisfacción en nuestros clientes.",
	  aboutp3: "Esto nos permite ofrecer soluciones específicas a cada necesidad, cualquiera fuera la naturaleza, complejidad o tamaño de la misma.",
	  aboutp4: "Nuestra experiencia en el sector nos permite ofrecer respuestas ágiles, adaptadas a nuestros clientes y una organización eficiente, aportando un gran conocimiento sectorial y alta capacidad tecnológica.",
	  aboutp5: "Es responsabilidad de nuestro equipo el cumplimiento y seguimiento del trabajo realizado en base a los requerimientos del cliente.",
	  aboutp6: "Nos enfocamos en brindar la mejor atención antes, durante y después del desarrollo del sistema que se deba realizar. Nos debemos en un 100 % a que una vez desarrollado el sistema, el cliente sea acompañado y asistido durante el mantenimiento del mismo, con capacitaciones y un contacto constante.",
	  consultingp1: "En Ewwo Consulting logramos otorgar un valor extra a nuestros clientes asegurándoles que trabajaremos de la manera más óptima mediante la consultoría estratégica que ayudará a los ejecutivos a lograr gran valor en el mercado a corto y largo plazo, a través de la identificación de áreas de mejora del negocio.",
	  consultingp2: "Se logra esto por medio de la planificación y toma de soluciones operacionales, fijando objetivos concretos y centrados en la satisfacción de las necesidades del cliente.",
	  consultingp3: "En Ewwo ponemos nuestras capacidades de trabajo a disposición de su empresa. Contamos con accesibilidad y análisis de datos a modelación predictiva, pronosticación y un sofisticado reporte estadístico.",
	  consultingp4: "Poseemos una dinámica de trabajo especialmente flexible, requisito necesario y fundamental para una rápida adaptación y capacidad de respuesta.",
	  servicestxt: "Hace más de 7 años brindamos soluciones y servicios a Sindicatos y Obras Sociales. Poseemos 3 productos principales para administrar y gestionar todo lo relacionado a los afiliados, afiliaciones, recaudaciones de los sindicatos y recaudaciones de la AFIP u Obra Social, entre otras cosas.",
	  siglastxt: "SiGlAS (Sistema Global de Actividad Sindical) permite gestionar y administrar los afiliados de su sindicato, obra social sindical y mutual sindical. Posee múltiples módulos para otorgaciones de servicios, autorizaciones, reintegros, etc.",
	  boletatxt: "En esta aplicación el usuario (logueado como empresa) carga sus DDJJ, la aplicación calcula y pone a disposición del usuario las boletas para ser generadas y descargadas. Por otro lado el usuario(logueado como sindicato) tiene las herramientas necesarias para hacer un seguimiento de las deudas y de los pagos realizados por las empresas ya que el sistema se nutre de rendiciones de pago suministradas por distintas entidades(ej.Pago Facil). A su vez al sindicato le permite llevar a cabo acciones como ser una intimación de pago sobre una deuda y notificar a la empresa sin salir de la aplicación.",
	  aportestxt: "Esta aplicación tiene como principal fin el indicar a la obra social cuanto de sus aportes recibidos deberán ir a las distintas mandatarias. Para ello se apoya en los datos suministrados directamente de AFIP (con ello sabe las nominas de los trabajadores en régimen general y sus transferencias realizadas por sus empleadores) y del sitio Boleta sindical, de este ultimo obtiene el padrón de personas afiliadas entre otros datos. También se cuenta con herramientas de fiscalización (reportes de deudas e ingreso de trasferencias externas y subsidios) ademas de otras como el registro de discapacidad y la posibilidad de realizar intimaciones e incluso realizar panes de pago sobre esas actas.",
	  outsourcingtxt1p1: "Outsourcing de procesos de negocio (BPO) es una estrategia de negocios que utilizan las compañías que buscan nuevas formas para aumentar su desempeño como el control de los costos, la reducción del riesgo y el fomento de la colaboración, entre otros.",
	  outsourcingtxt1p2: "Lo importante, sin embargo, es encontrar un proveedor de servicios BPO con reputación y experiencia funcional y sectorial documentada como Ewwo Consulting.",
	  outsourcingtxt1p3: "Prestamos atención al detalle y utilizamos mecanismos para mejorar la eficiencia y rendimiento, reduciendo los costes asociados, facilitando que las empresas se concentren en su negocio.",
	  outsourcingtxt2: "Nuestra misión es ayudar a su empresa optimizar su rendimiento operativo y de mercado. De esta manera nos concentraremos en ofrecerles valor a través de la reducción de costos y optimización del personal, proporcionando un trabajo de excelencia brindado por profesionales en numerosas áreas.",
	  footermsg: "Si desea ponerse en contacto con nosotros, puede hacerlo mediante cualquiera de las siguientes vías de contacto:",
	  copyright: "Todos los derechos reservados.",
	  design: "Diseño: "
	};

/***/ }),
/* 597 */,
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(460);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _index = __webpack_require__(442);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactIntl = __webpack_require__(65);
	
	var _es = __webpack_require__(596);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _es3 = __webpack_require__(780);
	
	var _es4 = _interopRequireDefault(_es3);
	
	__webpack_require__(758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactIntl.addLocaleData)(_es4.default);
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, { i18nMessages: _es2.default }));
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */
/***/ (function(module, exports) {

	IntlPolyfill.__addLocaleData({locale:"es",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:false,formats:{short:"{1} {0}",medium:"{1} {0}",full:"{1}, {0}",long:"{1}, {0}",availableFormats:{"d":"d","E":"ccc",Ed:"E d",Ehm:"E, h:mm a",EHm:"E, H:mm",Ehms:"E, h:mm:ss a",EHms:"E, H:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"d MMM y G",GyMMMEd:"E, d MMM y G",GyMMMM:"MMMM 'de' y G",GyMMMMd:"d 'de' MMMM 'de' y G",GyMMMMEd:"E, d 'de' MMMM 'de' y G","h":"h a","H":"H",hm:"h:mm a",Hm:"H:mm",hms:"h:mm:ss a",Hms:"H:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"H:mm:ss v",hmsvvvv:"h:mm:ss a (vvvv)",Hmsvvvv:"H:mm:ss (vvvv)",hmv:"h:mm a v",Hmv:"H:mm v","M":"L",Md:"d/M",MEd:"E, d/M",MMd:"d/M",MMdd:"d/M",MMM:"LLL",MMMd:"d MMM",MMMEd:"E, d MMM",MMMMd:"d 'de' MMMM",MMMMEd:"E, d 'de' MMMM",ms:"mm:ss","y":"y",yM:"M/y",yMd:"d/M/y",yMEd:"EEE, d/M/y",yMM:"M/y",yMMM:"MMM y",yMMMd:"d MMM y",yMMMEd:"EEE, d MMM y",yMMMM:"MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMMEd:"EEE, d 'de' MMMM 'de' y",yQQQ:"QQQ y",yQQQQ:"QQQQ 'de' y"},dateFormats:{yMMMMEEEEd:"EEEE, d 'de' MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMd:"d MMM y",yMd:"d/M/yy"},timeFormats:{hmmsszzzz:"H:mm:ss (zzzz)",hmsz:"H:mm:ss z",hms:"H:mm:ss",hm:"H:mm"}},calendars:{buddhist:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"a. m.",pm:"p. m."}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},dayPeriods:{am:"a. m.",pm:"p. m."}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},dayPeriods:{am:"a. m.",pm:"p. m."}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"a. m.",pm:"p. m."}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},gregory:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["a. C.","d. C.","a. e. c.","e. c."],short:["a. C.","d. C.","a. e. c.","e. c."],long:["antes de Cristo","después de Cristo","antes de la era común","era común"]},dayPeriods:{am:"a. m.",pm:"p. m."}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"a. m.",pm:"p. m."}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"a. m.",pm:"p. m."}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"a. m.",pm:"p. m."}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"a. m.",pm:"p. m."}},japanese:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"a. m.",pm:"p. m."}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"a. m.",pm:"p. m."}},roc:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["antes de R.O.C.","R.O.C."],short:["antes de R.O.C.","R.O.C."],long:["antes de R.O.C.","R.O.C."]},dayPeriods:{am:"a. m.",pm:"p. m."}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{number} {currency}",negativePattern:"{minusSign}{number} {currency}"},percent:{positivePattern:"{number} {percentSign}",negativePattern:"{minusSign}{number} {percentSign}"}},symbols:{latn:{decimal:",",group:".",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{CAD:"CA$",ESP:"₧",EUR:"€",THB:"฿",USD:"$",VND:"₫",XPF:"CFPF"}}});

/***/ }),
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ })
]);


// WEBPACK FOOTER //
// component---src-layouts-es-js-064d16c5c35ebdd05f59.js